import { Injectable, Inject, EventEmitter, Component, Input, Output, ViewChild, HostBinding, NgModule, ContentChild, TemplateRef, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, forwardRef, ɵɵdefineInjectable, ViewEncapsulation, ɵɵinject, Pipe, HostListener, InjectionToken, Directive, ElementRef } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, FormBuilder } from '@angular/forms';
import { InputModule, SelectModule, RadioModule, InfoBoxModule, ButtonModule, TitleModule, IconModule, ScCurrencyPipe, ScPipesModule, SimpleDatePickerModule, TooltipCustomModule, emailValidator, CheckboxModule, PhoneModule, ModalModule, LateralMenuService, LateralMenuModule, LoadingModule, TooltipInputDecoratorModule, ValidatePassword as ValidatePassword$1, PasswordRulesModule, fadeInOut as fadeInOut$1, ProgressBarModule, ActionItem, UploaderModule, ChipModule } from '@sc/portal.fe.lib.ui-core-components';
import { map, distinctUntilChanged, debounceTime, finalize, switchMap as switchMap$1, catchError as catchError$1, tap, filter, takeUntil, mergeMap } from 'rxjs/operators';
import { __assign, __read, __spread, __values, __extends } from 'tslib';
import { isEqual, keys, cloneDeep } from 'lodash/fp';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { debounceTime as debounceTime$1, distinctUntilChanged as distinctUntilChanged$1, map as map$1, retry, catchError, debounce, switchMap } from 'rxjs/internal/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { BehaviorSubject as BehaviorSubject$1, throwError, of, forkJoin, AsyncSubject, timer, pipe, Subject, Subscription, fromEvent } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { addDays, addMonths } from 'date-fns';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { saveAs } from 'file-saver';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/insured-info.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InsuredInfoService = /** @class */ (function () {
    function InsuredInfoService(config, http) {
        this.config = config;
        this.http = http;
    }
    /**
     * @param {?} postalCode
     * @return {?}
     */
    InsuredInfoService.prototype.getCitiesFromDDBB = /**
     * @param {?} postalCode
     * @return {?}
     */
    function (postalCode) {
        /** @type {?} */
        var url = this.config.environment.server.api.typeList + "/api/cities?postalCode=" + postalCode;
        return this.http.get(url);
    };
    /**
     * @param {?} taxId
     * @param {?} officialIdTypeCode
     * @param {?=} validateContact
     * @param {?=} policyProduct
     * @return {?}
     */
    InsuredInfoService.prototype.getPersonsByDocumentNumber = /**
     * @param {?} taxId
     * @param {?} officialIdTypeCode
     * @param {?=} validateContact
     * @param {?=} policyProduct
     * @return {?}
     */
    function (taxId, officialIdTypeCode, validateContact, policyProduct) {
        if (validateContact === void 0) { validateContact = false; }
        if (policyProduct === void 0) { policyProduct = ''; }
        /** @type {?} */
        var url = this.config.environment.server.api.portalpasProxy +
            ("/api/Contacts?idNumber=" + taxId + "&officialIdTypeCode=" + officialIdTypeCode + "&validateContact=" + validateContact + "&policyProduct=" + policyProduct);
        return this.http.get(url)
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            response.contacts.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.cuit = item.cuit && item.cuit.replace(/[-]*/g, '');
            }));
            return response.contacts;
        })));
    };
    InsuredInfoService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InsuredInfoService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] },
        { type: HttpClient }
    ]; };
    return InsuredInfoService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    InsuredInfoService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/state.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var State = /** @class */ (function () {
    function State(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    return State;
}());
if (false) {
    /** @type {?} */
    State.prototype.key;
    /** @type {?} */
    State.prototype.name;
    /** @type {?} */
    State.prototype.code;
    /** @type {?} */
    State.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/city.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var City = /** @class */ (function () {
    function City(data) {
        this.key = null;
        this.name = null;
        this.postalCode = null;
        this.state = new State();
        if (data) {
            Object.assign(this, data);
        }
    }
    return City;
}());
if (false) {
    /** @type {?} */
    City.prototype.key;
    /** @type {?} */
    City.prototype.name;
    /** @type {?} */
    City.prototype.code;
    /** @type {?} */
    City.prototype.description;
    /** @type {?} */
    City.prototype.postalCode;
    /** @type {?} */
    City.prototype.state;
    /** @type {?} */
    City.prototype.postalSynonym;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/tax-iva.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TaxIVA = /** @class */ (function () {
    function TaxIVA(data) {
        this.key = '';
        this.name = '';
        if (data) {
            Object.assign(this, data);
        }
    }
    return TaxIVA;
}());
if (false) {
    /** @type {?} */
    TaxIVA.prototype.key;
    /** @type {?} */
    TaxIVA.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/insured.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Insured = /** @class */ (function () {
    function Insured(data) {
        this.accountNumber = null;
        this.cuit = null;
        this.documentNumber = null;
        this.documentType = null;
        this.email = null;
        this.firstName = null;
        this.fullName = null;
        this.gender = null;
        this.lastName = null;
        this.personType = null;
        this.phoneNumber = null;
        this.isValid = null;
        this.taxIVA = new TaxIVA();
        if (data) {
            Object.assign(this, data);
        }
    }
    return Insured;
}());
if (false) {
    /** @type {?} */
    Insured.prototype.accountNumber;
    /** @type {?} */
    Insured.prototype.cuit;
    /** @type {?} */
    Insured.prototype.documentNumber;
    /** @type {?} */
    Insured.prototype.documentType;
    /** @type {?} */
    Insured.prototype.email;
    /** @type {?} */
    Insured.prototype.firstName;
    /** @type {?} */
    Insured.prototype.fullName;
    /** @type {?} */
    Insured.prototype.gender;
    /** @type {?} */
    Insured.prototype.lastName;
    /** @type {?} */
    Insured.prototype.personType;
    /** @type {?} */
    Insured.prototype.phoneNumber;
    /** @type {?} */
    Insured.prototype.taxIVA;
    /** @type {?} */
    Insured.prototype.electronicDocuments;
    /** @type {?} */
    Insured.prototype.changeGrain;
    /** @type {?} */
    Insured.prototype.isValid;
    /** @type {?} */
    Insured.prototype.invalidMessage;
    /** @type {?} */
    Insured.prototype.birthDate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/document-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DocumentTypeCode = {
    DNI: "ext_dni96",
    CUIT: "ext_cuit80",
    CUIL: "ext_cuil86",
};
/** @enum {string} */
var DocumentTypeName = {
    DNI: "DNI",
    CUIT: "CUIT",
    CUIL: "CUIL",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/insured-info/insured-info.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InsuredInfoComponent = /** @class */ (function () {
    function InsuredInfoComponent(insuredInfoService) {
        this.insuredInfoService = insuredInfoService;
        this.title = true;
        this.taxIVA = true;
        this.editModeOnSubmit = false;
        this.clearPostalCodeValueOnPersonChange = true;
        this.btnLabel = 'Comenzar a cotizar';
        this.validateContact = false;
        this.formCompleted = new EventEmitter();
        this.formChanges = new EventEmitter();
        this.insuredVerified = false;
        this.someField = true;
        this.postalCodeOptions$ = new BehaviorSubject([]);
    }
    /**
     * @return {?}
     */
    InsuredInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.locationData) {
            this.locationDataFormated = this.formatPostalCodeOption(this.locationData);
            this.postalCodeOptions$.next([this.locationDataFormated]);
            if (typeof this.editMode !== 'boolean') {
                this.editMode = true;
            }
        }
        this.formGroup = new FormGroup({
            postalCode: new FormControl(this.locationDataFormated, [Validators.required])
        });
        this.personInfoSelected = this.insuredData || {};
        this.formGroup.valueChanges
            .pipe(distinctUntilChanged((/**
         * @param {?} prev
         * @param {?} curr
         * @return {?}
         */
        function (prev, curr) { return isEqual(prev, curr); })))
            .subscribe((/**
         * @return {?}
         */
        function () { _this.sendFormData(); }));
    };
    /**
     * @return {?}
     */
    InsuredInfoComponent.prototype.sendFormData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var insuredInfo = this.getFormData();
        this.formChanges.emit(insuredInfo);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InsuredInfoComponent.prototype.getCitiesOnKeyUp = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var keyCode = event.keyCode;
        /** @type {?} */
        var postalCode = event.target.value.split(' - ')[0];
        // no arrow up/down/left/rigth or enter key
        if ([37, 38, 39, 40, 13].indexOf(keyCode) < 0) {
            if (postalCode.length === 4 && postalCode !== this.lastPostalCode) {
                this.getCitiesFromDDBB(postalCode);
            }
        }
    };
    /**
     * @param {?} postalCode
     * @return {?}
     */
    InsuredInfoComponent.prototype.getCitiesFromDDBB = /**
     * @param {?} postalCode
     * @return {?}
     */
    function (postalCode) {
        var _this = this;
        this.loadingPostalCode = true;
        if (this.gettingCities$) {
            this.gettingCities$.unsubscribe();
        }
        this.gettingCities$ = this.insuredInfoService.getCitiesFromDDBB(postalCode)
            .pipe(debounceTime(500), map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.data; })), map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data && data.items && data.items.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return _this.formatPostalCodeOption(item); })); })))
            .subscribe((/**
         * @param {?} cities
         * @return {?}
         */
        function (cities) {
            _this.postalCodeOptions$.next(cities);
            _this.lastPostalCode = postalCode;
            if (cities.length === 1) {
                _this.formGroup.controls['postalCode'].setValue(cities[0]);
            }
            _this.loadingPostalCode = false;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return _this.loadingPostalCode = false; }));
    };
    /**
     * @return {?}
     */
    InsuredInfoComponent.prototype.getFormData = /**
     * @return {?}
     */
    function () {
        return __assign({}, this.personInfoSelected, this.formGroup.value);
    };
    /**
     * @return {?}
     */
    InsuredInfoComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var insuredInfo = this.getFormData();
        this.editMode = this.editModeOnSubmit;
        this.formCompleted.emit(insuredInfo);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    InsuredInfoComponent.prototype.formatPostalCodeOption = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return { key: item, name: item.postalCode + " - " + item.name };
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InsuredInfoComponent.prototype.handlePersonInfoSelected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.clearPostalCodeValueOnPersonChange) {
            this.clearPostalCodeIfNotInitializedOnInput();
        }
        this.personInfoSelected = __assign({}, event, this.formGroup.value);
        this.formChanges.emit(this.personInfoSelected);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    InsuredInfoComponent.prototype.handleInsuredVerification = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.insuredVerified = event;
    };
    /**
     * @private
     * @return {?}
     */
    InsuredInfoComponent.prototype.clearPostalCodeIfNotInitializedOnInput = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.locationDataFormated) {
            this.locationDataFormated = null;
        }
        else {
            this.formGroup.controls['postalCode'].setValue(null);
        }
    };
    InsuredInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-insured-info',
                    template: "<sc-title *ngIf=\"title\" type=\"h2\" content=\"Informaci\u00F3n de tu cliente\" color=\"black\"></sc-title>\n<p *ngIf=\"editMode && title\" class=\"section-subtitle\">Con datos b\u00E1sicos de tu cliente podemos lograr una mejor propuesta</p>\n<form [formGroup]=\"formGroup\" *ngIf=\"editMode\">\n  <div class=\"fields-block\">\n    <sc-person-search\n      [insuredData]=\"insuredData\"\n      [documentTypeOptions]=\"documentTypeOptions\"\n      [defaultDocumentTypeOption]=\"defaultDocumentTypeOption\"\n      [validateContact]=\"validateContact\"\n      [policyProduct]=\"policyProduct\"\n      [customNotFoundMessage]=\"'No pudimos encontrar en nuestros registros una persona para el %documentType% ingresado. Comunicate con la <a href=https://serviciospas.sancristobal.com.ar/portal/6/create/182 target=_blank>mesa de ayuda</a> para poder realizar la cotizaci\u00F3n.'\"\n      (personInfoSelected)=\"handlePersonInfoSelected($event)\"\n      (insuredVerified)=\"handleInsuredVerification($event)\"\n      ></sc-person-search>\n    <div class=\"row\" [hidden]=\"!personInfoSelected.insured\">\n      <div class=\"col-md-9 col-12 postal-code-wrapper\">\n        <sc-select\n          #postalCodeControl\n          formControlName=\"postalCode\"\n          label=\"C\u00F3digo postal\"\n          placeholder=\"Ej: 2000\"\n          enableSearch=\"true\"\n          objectValue=\"name\"\n          [itemsAsync$]=\"postalCodeOptions$\"\n          [loading]=\"loadingPostalCode\"\n          (keyup)=\"getCitiesOnKeyUp($event)\"\n        ></sc-select>\n      </div>\n    </div>\n  </div>\n  <div class=\"buttons-block\" *ngIf=\"formGroup.valid && (insuredVerified || insuredData)\">\n    <div class=\"row\">\n      <div class=\"col-md-5 col-12\">\n        <sc-button type=\"primary\" class=\"submit-btn\" size=\"large\" (onClick)=\"onSubmit()\" id=\"begin-to-quote\">{{ btnLabel }}</sc-button>\n      </div>\n    </div>\n  </div>\n</form>\n<div *ngIf=\"!editMode && personInfoSelected?.insured\" class=\"section-submitted-data\">\n  <div class=\"\">\n    <span>{{personInfoSelected.insured.firstName}} {{personInfoSelected.insured.lastName}}</span>\n    <br>\n    <span>{{personInfoSelected.documentType.value}}: {{personInfoSelected.idNumber}}</span>\n    <br>\n    <ng-container *ngIf=\"taxIVA\">\n      <span >{{ ['N/D',''].indexOf(personInfoSelected.insured.taxIVA.name) > -1 ? 'Consumidor final' : personInfoSelected.insured.taxIVA.name }}</span>\n      <br>\n    </ng-container>\n    <span>{{formGroup.value.postalCode?.name}}</span>\n  </div>\n</div>\n",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", "::ng-deep .icon-check{color:#3dcc98}.insured-message{font-size:14px;line-height:24px}:host(.insured-full-width) .postal-code-wrapper{-webkit-box-flex:0;flex:0 0 100%;max-width:100%}:host(.insured-full-width) .fields-block{padding:0}:host(.insured-full-width) .dni{margin-bottom:.8rem}@media (min-width:768px){:host(.insured-full-width) .dni{margin-bottom:24px}:host(.insured-full-width) .person{margin-bottom:23px!important}}:host(.hide-submit) .submit-btn{display:none}"]
                }] }
    ];
    /** @nocollapse */
    InsuredInfoComponent.ctorParameters = function () { return [
        { type: InsuredInfoService }
    ]; };
    InsuredInfoComponent.propDecorators = {
        insuredData: [{ type: Input }],
        title: [{ type: Input }],
        locationData: [{ type: Input }],
        editMode: [{ type: Input }],
        documentTypeOptions: [{ type: Input }],
        defaultDocumentTypeOption: [{ type: Input }],
        taxIVA: [{ type: Input }],
        editModeOnSubmit: [{ type: Input }],
        clearPostalCodeValueOnPersonChange: [{ type: Input }],
        btnLabel: [{ type: Input }],
        validateContact: [{ type: Input }],
        policyProduct: [{ type: Input }],
        formCompleted: [{ type: Output }],
        formChanges: [{ type: Output }],
        postalCodeControl: [{ type: ViewChild, args: ['postalCodeControl', { static: false },] }],
        someField: [{ type: HostBinding, args: ['class.sc-insured-info',] }]
    };
    return InsuredInfoComponent;
}());
if (false) {
    /** @type {?} */
    InsuredInfoComponent.prototype.insuredData;
    /** @type {?} */
    InsuredInfoComponent.prototype.title;
    /** @type {?} */
    InsuredInfoComponent.prototype.locationData;
    /** @type {?} */
    InsuredInfoComponent.prototype.editMode;
    /** @type {?} */
    InsuredInfoComponent.prototype.documentTypeOptions;
    /** @type {?} */
    InsuredInfoComponent.prototype.defaultDocumentTypeOption;
    /** @type {?} */
    InsuredInfoComponent.prototype.taxIVA;
    /** @type {?} */
    InsuredInfoComponent.prototype.editModeOnSubmit;
    /** @type {?} */
    InsuredInfoComponent.prototype.clearPostalCodeValueOnPersonChange;
    /** @type {?} */
    InsuredInfoComponent.prototype.btnLabel;
    /** @type {?} */
    InsuredInfoComponent.prototype.validateContact;
    /** @type {?} */
    InsuredInfoComponent.prototype.policyProduct;
    /** @type {?} */
    InsuredInfoComponent.prototype.formCompleted;
    /** @type {?} */
    InsuredInfoComponent.prototype.formChanges;
    /** @type {?} */
    InsuredInfoComponent.prototype.formGroup;
    /** @type {?} */
    InsuredInfoComponent.prototype.postalCodeOptions$;
    /** @type {?} */
    InsuredInfoComponent.prototype.loadingPostalCode;
    /** @type {?} */
    InsuredInfoComponent.prototype.producer;
    /** @type {?} */
    InsuredInfoComponent.prototype.personInfoSelected;
    /** @type {?} */
    InsuredInfoComponent.prototype.insuredVerified;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoComponent.prototype.gettingCities$;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoComponent.prototype.lastPostalCode;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoComponent.prototype.locationDataFormated;
    /** @type {?} */
    InsuredInfoComponent.prototype.postalCodeControl;
    /** @type {?} */
    InsuredInfoComponent.prototype.someField;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoComponent.prototype.insuredInfoService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/person-search/person-search.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PersonSearchComponent = /** @class */ (function () {
    function PersonSearchComponent(insuredInfoService) {
        this.insuredInfoService = insuredInfoService;
        this.validateContact = false;
        this.policyProduct = '';
        this.customNotFoundMessage = 'No se encontraron registros.';
        this.personInfoSelected = new EventEmitter();
        this.insuredVerified = new EventEmitter();
        this.DNI_MAX_LENGTH = 8;
        this.CUIT_MAX_LENGTH = 11;
        this.defaultPaymentOptions = [DocumentTypeName.DNI, DocumentTypeName.CUIT];
    }
    /**
     * @return {?}
     */
    PersonSearchComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.documentTypeOptions = (this.documentTypeOptions && this.documentTypeOptions.length)
            ? this.documentTypeOptions
            : this.defaultPaymentOptions.map((/**
             * @param {?} method
             * @return {?}
             */
            function (method) { return ({ key: method, value: method }); }));
        this.numberMaxLength = (this.defaultDocumentTypeOption === DocumentTypeName.CUIT) ? this.CUIT_MAX_LENGTH : this.DNI_MAX_LENGTH;
        this.numberPlaceholder = (this.defaultDocumentTypeOption === DocumentTypeName.CUIT) ? 'Ej: 20311617422 ' : 'Ej: 31161742';
        this.notFoundMessage = this.customNotFoundMessage.replace('%documentType%', this.defaultDocumentTypeOption);
        this.formGroup = new FormGroup({
            documentType: new FormControl(this.documentTypeOptions.find((/**
             * @param {?} option
             * @return {?}
             */
            function (option) { return option.key === _this.defaultDocumentTypeOption; })) || this.documentTypeOptions[0], [Validators.required]),
            idNumber: new FormControl(this.insuredData && (this.insuredData.documentType === DocumentTypeName.DNI
                ? this.insuredData.documentNumber
                : this.insuredData.cuit), [Validators.required]),
            insured: new FormControl(this.insuredData, [Validators.required]),
        });
        if (this.insuredData) {
            /** @type {?} */
            var docOp = this.documentTypeOptions.find((/**
             * @param {?} op
             * @return {?}
             */
            function (op) { return op.key === _this.insuredData.documentType; }));
            this.defaultDocumentTypeOption = DocumentTypeName[this.insuredData.documentType];
            this.insuredOptions = [this.insuredData];
            this.formGroup.controls['documentType'].setValue(docOp);
            this.handleOptionSelected(docOp, false);
            this.sendPersonData();
            this.formGroup.controls['insured'].setValue(this.insuredOptions[0]);
        }
        else {
            this.insuredOptions = [];
        }
        this.formGroup.controls['idNumber']
            .valueChanges
            .pipe(debounceTime$1(500), distinctUntilChanged$1())
            .subscribe((/**
         * @param {?} dni
         * @return {?}
         */
        function (dni) {
            _this.getInsuredOptions(dni);
        }));
        this.formGroup.controls['insured']
            .valueChanges
            .pipe(debounceTime$1(10), distinctUntilChanged$1())
            .subscribe((/**
         * @param {?} person
         * @return {?}
         */
        function (person) {
            _this.sendPersonData();
        }));
        this.formGroup.controls['documentType']
            .valueChanges
            .pipe(debounceTime$1(10), distinctUntilChanged$1())
            .subscribe((/**
         * @param {?} person
         * @return {?}
         */
        function (person) {
            _this.sendPersonData();
        }));
    };
    /**
     * @return {?}
     */
    PersonSearchComponent.prototype.sendPersonData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var personInfo = this.formGroup.value;
        if (personInfo) {
            this.personInfoSelected.emit(personInfo);
        }
    };
    /**
     * @param {?} dni
     * @return {?}
     */
    PersonSearchComponent.prototype.getInsuredOptions = /**
     * @param {?} dni
     * @return {?}
     */
    function (dni) {
        var _this = this;
        if (!!dni) {
            this.notFoundMessage = this.customNotFoundMessage.replace('%documentType%', this.formGroup.value['documentType'].key);
            /** @type {?} */
            var dniAsString = dni.toString();
            /** @type {?} */
            var maxLength = (this.formGroup.value['documentType'].key === DocumentTypeName.DNI) ? this.DNI_MAX_LENGTH : this.CUIT_MAX_LENGTH;
            /** @type {?} */
            var numberLength = (this.formGroup.value['documentType'].key === DocumentTypeName.DNI)
                ? this.DNI_MAX_LENGTH - 1
                : this.CUIT_MAX_LENGTH;
            if (this.insuredSubscription) {
                this.insuredSubscription.unsubscribe();
            }
            if (dniAsString.length >= numberLength && dniAsString.length <= maxLength) {
                this.resetOptions();
                this.loadingDocumentNumber = true;
                this.insuredSubscription = this.getPersonsByDocumentNumber(dniAsString).subscribe((/**
                 * @param {?} persons
                 * @return {?}
                 */
                function (persons) { return _this.handleInsuredInfo(persons); }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) { return _this.resetOptions(); }));
            }
            else {
                this.resetOptions();
            }
        }
        else {
            this.resetOptions();
        }
    };
    /**
     * @param {?} items
     * @return {?}
     */
    PersonSearchComponent.prototype.handleInsuredInfo = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        this.insuredOptions = items || [];
        this.loadingDocumentNumber = false;
        this.insuredChecked = true;
        this.insuredVerified.emit(true);
        if (this.insuredOptions.filter((/**
         * @param {?} insured
         * @return {?}
         */
        function (insured) { return insured.isValid || insured.isValid === null; })).length === 1) {
            this.formGroup.controls['insured'].setValue(this.insuredOptions.find((/**
             * @param {?} insured
             * @return {?}
             */
            function (insured) { return insured.isValid || insured.isValid === null; })));
            this.sendPersonData();
        }
    };
    /**
     * @param {?} taxId
     * @return {?}
     */
    PersonSearchComponent.prototype.getPersonsByDocumentNumber = /**
     * @param {?} taxId
     * @return {?}
     */
    function (taxId) {
        /** @type {?} */
        var officialIdTypeCode = (this.formGroup.controls.documentType.value.key === DocumentTypeName.DNI)
            ? DocumentTypeCode.DNI
            : DocumentTypeCode.CUIT;
        return this.insuredInfoService.getPersonsByDocumentNumber(taxId, officialIdTypeCode, this.validateContact, this.policyProduct);
    };
    /**
     * @param {?=} shouldResetInput
     * @return {?}
     */
    PersonSearchComponent.prototype.resetOptions = /**
     * @param {?=} shouldResetInput
     * @return {?}
     */
    function (shouldResetInput) {
        if (shouldResetInput === void 0) { shouldResetInput = false; }
        this.loadingDocumentNumber = false;
        this.insuredChecked = false;
        if (this.insuredSubscription) {
            this.insuredSubscription.unsubscribe();
        }
        if (this.insuredOptions) {
            this.insuredOptions.length = 0;
        }
        this.formGroup.controls['insured'].setValue(null);
        if (shouldResetInput) {
            this.formGroup.controls['idNumber'].setValue(null);
        }
    };
    /**
     * @param {?} option
     * @param {?=} shouldResetOptions
     * @return {?}
     */
    PersonSearchComponent.prototype.handleOptionSelected = /**
     * @param {?} option
     * @param {?=} shouldResetOptions
     * @return {?}
     */
    function (option, shouldResetOptions) {
        if (shouldResetOptions === void 0) { shouldResetOptions = true; }
        if (shouldResetOptions) {
            this.resetOptions(true);
        }
        if (option && option.key === DocumentTypeName.DNI) {
            this.numberMaxLength = this.DNI_MAX_LENGTH;
            this.numberPlaceholder = 'Ej: 31161742';
        }
        else {
            this.numberMaxLength = this.CUIT_MAX_LENGTH;
            this.numberPlaceholder = 'Ej: 20311617422';
        }
    };
    PersonSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-person-search',
                    template: "<form [formGroup]=\"formGroup\">\n  <div class=\"fields-block\" style=\"padding:0;\">\n    <div class=\"row mt-1 dni\">\n      <div class=\"col-md-5 col-12\">\n        <sc-select\n          formControlName=\"documentType\"\n          label=\"Tipo de documento\"\n          objectValue=\"value\"\n          [items]=\"documentTypeOptions\"\n          (optionSelected)=\"handleOptionSelected($event)\"\n         ></sc-select>\n      </div>\n      <div class=\"col-md-7 col-12\">\n        <sc-input\n          formControlName=\"idNumber\"\n          label=\"N\u00FAmero\"\n          type=\"number\"\n          size=\"large-fluid\"\n          [maxlength]=\"numberMaxLength\"\n          [icon]=\"loadingDocumentNumber?'loading':(insuredChecked && insuredOptions.length?'check':'')\"\n          [placeholder]=\"numberPlaceholder\"\n        ></sc-input>\n      </div>\n    </div>\n    <div class=\"row mb-1 person\">\n      <div *ngIf=\"!insuredOptions.length && insuredChecked\" class=\"insured-message col-12\">\n        <sc-info-box>\n          <span [innerHTML]=\"notFoundMessage\"></span>\n        </sc-info-box>\n      </div>\n      <ng-container *ngIf=\"insuredOptions.length\">\n        <p *ngIf=\"insuredOptions.length > 1\" class=\"insured-message col-12\">\n          Se encontraron {{insuredOptions.length}} personas que tienen el mismo DNI, seleccione la correcta.\n        </p>\n        <sc-radio-group formControlName=\"insured\" class=\"col-12\">\n          <div *ngFor=\"let item of insuredOptions; let i=index\">\n            <sc-radio-item type=\"boxed\" [value]=\"item\" [isDisabled]=\"item.isValid === false\" class=\"radio-item\">\n              <div >\n                {{item.fullName}}\n              </div>\n            </sc-radio-item>\n            <div *ngIf=\"item.isValid === false\" class=\"invalid-message\">\n              <span [innerHTML]=\"item.invalidMessage\"></span>\n            </div>\n          </div>\n        </sc-radio-group>\n      </ng-container>\n    </div>\n  </div>\n</form>\n",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", "::ng-deep .icon-check{color:#3dcc98}::ng-deep .sc-radio-item--boxed{margin-bottom:0!important;margin-top:16px!important}.insured-message{font-size:14px;line-height:24px}.invalid-message{color:#8993a4;opacity:.5;font-size:14px;text-align:right}"]
                }] }
    ];
    /** @nocollapse */
    PersonSearchComponent.ctorParameters = function () { return [
        { type: InsuredInfoService }
    ]; };
    PersonSearchComponent.propDecorators = {
        insuredData: [{ type: Input }],
        documentTypeOptions: [{ type: Input }],
        defaultDocumentTypeOption: [{ type: Input }],
        validateContact: [{ type: Input }],
        policyProduct: [{ type: Input }],
        customNotFoundMessage: [{ type: Input }],
        personInfoSelected: [{ type: Output }],
        insuredVerified: [{ type: Output }]
    };
    return PersonSearchComponent;
}());
if (false) {
    /** @type {?} */
    PersonSearchComponent.prototype.insuredData;
    /** @type {?} */
    PersonSearchComponent.prototype.documentTypeOptions;
    /** @type {?} */
    PersonSearchComponent.prototype.defaultDocumentTypeOption;
    /** @type {?} */
    PersonSearchComponent.prototype.validateContact;
    /** @type {?} */
    PersonSearchComponent.prototype.policyProduct;
    /** @type {?} */
    PersonSearchComponent.prototype.customNotFoundMessage;
    /** @type {?} */
    PersonSearchComponent.prototype.personInfoSelected;
    /** @type {?} */
    PersonSearchComponent.prototype.insuredVerified;
    /** @type {?} */
    PersonSearchComponent.prototype.formGroup;
    /** @type {?} */
    PersonSearchComponent.prototype.insuredOptions;
    /** @type {?} */
    PersonSearchComponent.prototype.loadingDocumentNumber;
    /** @type {?} */
    PersonSearchComponent.prototype.insuredChecked;
    /** @type {?} */
    PersonSearchComponent.prototype.numberMaxLength;
    /** @type {?} */
    PersonSearchComponent.prototype.DNI_MAX_LENGTH;
    /** @type {?} */
    PersonSearchComponent.prototype.CUIT_MAX_LENGTH;
    /** @type {?} */
    PersonSearchComponent.prototype.numberPlaceholder;
    /** @type {?} */
    PersonSearchComponent.prototype.insuredSubscription;
    /** @type {?} */
    PersonSearchComponent.prototype.postalCodeOptions$;
    /** @type {?} */
    PersonSearchComponent.prototype.notFoundMessage;
    /** @type {?} */
    PersonSearchComponent.prototype.defaultPaymentOptions;
    /**
     * @type {?}
     * @private
     */
    PersonSearchComponent.prototype.insuredInfoService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/person-search/person-search.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PersonSearchModule = /** @class */ (function () {
    function PersonSearchModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    PersonSearchModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: PersonSearchModule,
            providers: [
                InsuredInfoService,
                {
                    provide: 'envConfig',
                    useValue: config
                }
            ]
        };
    };
    PersonSearchModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        ReactiveFormsModule,
                        InputModule,
                        SelectModule,
                        RadioModule,
                        InfoBoxModule
                    ],
                    declarations: [PersonSearchComponent],
                    exports: [PersonSearchComponent],
                    providers: [InsuredInfoService]
                },] }
    ];
    return PersonSearchModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/insured-info/insured-info.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InsuredInfoModule = /** @class */ (function () {
    function InsuredInfoModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    InsuredInfoModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: InsuredInfoModule,
            providers: [
                InsuredInfoService,
                {
                    provide: 'envConfig',
                    useValue: config
                }
            ]
        };
    };
    InsuredInfoModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule,
                        InputModule,
                        TitleModule,
                        SelectModule,
                        RadioModule,
                        PersonSearchModule
                    ],
                    declarations: [
                        InsuredInfoComponent
                    ],
                    exports: [InsuredInfoComponent],
                    providers: [
                        InsuredInfoService
                    ]
                },] }
    ];
    return InsuredInfoModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu-wrapper/lateral-menu-wrapper.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuWrapperComponent = /** @class */ (function () {
    function LateralMenuWrapperComponent() {
        this.isOpen = true;
        this.fullScreen = false;
        this.closeImageUrl = './assets/images/cerrar.png';
        this.closeModal = new EventEmitter();
        this.classes = {};
    }
    /**
     * @return {?}
     */
    LateralMenuWrapperComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    LateralMenuWrapperComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        this.setClass();
    };
    /**
     * @return {?}
     */
    LateralMenuWrapperComponent.prototype.setClass = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var classes = {};
        classes['lateral-menu-wrapper'] = true;
        classes['lateral-menu-wrapper_open'] = this.isOpen;
        classes['lateral-menu-wrapper_close'] = !this.isOpen;
        classes['lateral-menu-wrapper_expanded'] = this.loading || this.fullScreen;
        classes['lateral-menu-wrapper_expanded-close'] = this.fullScreen && !this.isOpen;
        this.classes = classes;
    };
    /**
     * @return {?}
     */
    LateralMenuWrapperComponent.prototype.closeLateralMenuWrapper = /**
     * @return {?}
     */
    function () {
        this.closeModal.emit();
    };
    LateralMenuWrapperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-lateral-menu-wrapper',
                    template: "<div class=\"lateral-menu-wrapper\" [ngClass]=\"classes\">\n  <img src=\"{{closeImageUrl}}\" alt=\"\" *ngIf=\"!loading\" (click)=\"closeLateralMenuWrapper()\" class=\"close-button\">\n  <div class=\"lateral-menu--content\">\n      <ng-content></ng-content>\n  </div>\n</div>\n",
                    styles: [".lateral-menu-wrapper{background-color:#0070cc;border-color:#ccd2dd;box-sizing:border-box;height:100%;padding:2rem 0 2rem 2rem;position:absolute;width:400px;top:0}.lateral-menu-wrapper .close-button{color:#fff;font-size:25px;position:absolute;cursor:pointer;right:12px}.lateral-menu-wrapper .lateral-menu--content{margin:1.5rem 0 0}.lateral-menu-wrapper_open{right:0;-webkit-transition:.25s ease-out;transition:.25s ease-out}.lateral-menu-wrapper_close{right:-400px;-webkit-transition:.25s ease-out;transition:.25s ease-out}.lateral-menu-wrapper_expanded{width:100%;-webkit-transition:.5s ease-out;transition:.5s ease-out}.lateral-menu-wrapper_expanded-close{right:0;top:100%;-webkit-transition:.75s ease-out;transition:.75s ease-out;display:none}@media (max-width:768px){.lateral-menu-wrapper{width:100%;padding:0}.lateral-menu-wrapper_close{left:100%}}:host(.white-lateral-panel) .lateral-menu-wrapper{overflow:auto;background-color:#fff;box-shadow:0 2px 6px 0 rgba(0,0,0,.08);padding:0}@media only screen and (min-width:768px){:host(.white-lateral-panel) .lateral-menu-wrapper{width:532px}}:host(.white-lateral-panel) .lateral-menu-wrapper img.close-button{height:16px;width:16px;margin:1rem 1.5rem}:host(.white-lateral-panel) .lateral-menu-wrapper_close{right:-532px}:host(.white-lateral-panel).large .lateral-menu-wrapper{padding:2rem 95px 0 2rem;width:950px}:host(.white-lateral-panel).large .lateral-menu-wrapper .lateral-menu--content{height:100%;margin:0}@media only screen and (max-width:768px){:host(.white-lateral-panel).large .lateral-menu-wrapper{padding:1rem;width:100%}:host(.white-lateral-panel).large .lateral-menu-wrapper .lateral-menu--content{height:auto}}"]
                }] }
    ];
    /** @nocollapse */
    LateralMenuWrapperComponent.ctorParameters = function () { return []; };
    LateralMenuWrapperComponent.propDecorators = {
        isOpen: [{ type: Input }],
        loading: [{ type: Input }],
        fullScreen: [{ type: Input }],
        closeImageUrl: [{ type: Input }],
        closeModal: [{ type: Output }]
    };
    return LateralMenuWrapperComponent;
}());
if (false) {
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.isOpen;
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.loading;
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.fullScreen;
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.closeImageUrl;
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.closeModal;
    /** @type {?} */
    LateralMenuWrapperComponent.prototype.classes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/lateral-menu-wrapper/lateral-menu-wrapper.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LateralMenuWrapperModule = /** @class */ (function () {
    function LateralMenuWrapperModule() {
    }
    LateralMenuWrapperModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [LateralMenuWrapperComponent],
                    exports: [LateralMenuWrapperComponent],
                    providers: []
                },] }
    ];
    return LateralMenuWrapperModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/animations/slide-horizontal.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var slideHorizontal = trigger('slideHorizontal', [
    state('void', style({
        overflow: 'hidden',
        marginLeft: 100,
        opacity: 0
    })),
    state('out', style({
        marginLeft: 100,
        overflow: 'hidden',
        zIndex: -1,
        opacity: 0
    })),
    state('in', style({
        zIndex: 100,
        opacity: 1
    })),
    transition('* => in', animate('250ms {{delay}}ms ease-in'), { params: { delay: 0 } }),
    transition('in => *', animate('250ms')),
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/list-set/list-set.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListSetComponent = /** @class */ (function () {
    function ListSetComponent() {
        // tslint:disable-next-line:no-output-on-prefix
        this.onClick = new EventEmitter();
        // tslint:disable-next-line:no-output-on-prefix
        this.onToggleSB = new EventEmitter();
        this.rowSelected = new EventEmitter();
        this.searchPattern = '';
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ListSetComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.rowData) {
            this.filteredRowData = this.rowData;
        }
    };
    /**
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    ListSetComponent.prototype.handleClick = /**
     * @param {?} row
     * @param {?} index
     * @return {?}
     */
    function (row, index) {
        this.onClick.emit({ row: row, index: index });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ListSetComponent.prototype.handleOnKeyup = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        this.searchPattern = event.target.value.toLowerCase();
        /** @type {?} */
        var searchParameters = '';
        this.filteredRowData = this.rowData.filter((/**
         * @param {?} row
         * @return {?}
         */
        function (row) {
            searchParameters = row.name.concat(row.number, row.organizer.name, row.organizer.number).toLowerCase();
            return searchParameters.indexOf(_this.searchPattern) > -1;
        }));
    };
    ListSetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-list-set',
                    template: "<div class=\"list-set\" [class.list-set_fullscreen]=\"fullscreen\">\n    <h2 class=\"list-set--title\">{{title}}</h2>\n    <input\n        class=\"list-set--filter\"\n        *ngIf=\"showFilter && rowData.length > 4\"\n        (keyup)=\"handleOnKeyup($event)\"\n        placeholder=\"Filtrar por nombre o n\u00FAmero de productor\"\n    >\n    <div class=\"list-set--items sc-scroll-bar\">\n        <div *ngFor=\"let row of filteredRowData; let index = index; let last = last\" [ngClass]=\"{'list-row': true, 'disabled': row.disabled}\"\n             [class.last]=\"last\">\n            <div [@slideHorizontal]=\"{value: (runAnimation?'in':'out'), params:{delay:(50*index)+150}}\"\n                 (click)=\"handleClick(row, index)\">\n                <ng-template [ngTemplateOutlet]=\"template\"\n                             [ngTemplateOutletContext]=\"{ row: row, index: index }\"></ng-template>\n            </div>\n        </div>\n    </div>\n</div>\n",
                    animations: [slideHorizontal],
                    styles: [".list-set{color:#ccd2dd}.list-set_fullscreen{width:50%;margin:0 auto}.list-set--title{color:#fff}.list-set--filter{background-color:transparent;border:0;border-bottom:1px solid #ccd2dd;color:#fff;font-size:16px;padding:0!important;line-height:48px;width:100%}.list-set--filter::-webkit-input-placeholder{color:#4393d4}.list-set--filter::-moz-placeholder{color:#4393d4}.list-set--filter:-ms-input-placeholder{color:#4393d4}.list-set--filter::-ms-input-placeholder{color:#4393d4}.list-set--filter::placeholder{color:#4393d4}.list-set--filter:focus{border-bottom:1px solid #e0e5ed}.list-set--items{padding-top:1rem;height:calc(100vh - 220px);overflow-x:hidden;overflow-y:scroll}.list-set ::ng-deep .list-row{padding:1rem 0;border-bottom:1px solid #ccd2dd;cursor:pointer;position:relative}.list-set ::ng-deep .list-row.last{border-bottom:none}.list-set ::ng-deep .list-row div>span{display:inline-block;vertical-align:super;margin-left:20px}.list-set ::ng-deep .list-row--icon{font-size:25px;width:35px;text-align:center;margin-right:10px}.list-set ::ng-deep .list-row--title:hover{color:#fff}.list-set ::ng-deep .list-row [class*=\" icon-\"]:before,.list-set ::ng-deep .list-row [class^=icon-]:before{width:auto;line-height:2rem}.list-set ::ng-deep .list-row::before{content:\"\";position:absolute;width:8px;height:8px;top:50%;left:calc(100% - 50px);background:url(/assets/images/arrow-menu_down.png);-webkit-transform:rotate(180deg);transform:rotate(180deg);opacity:0;-webkit-transition:.2s ease-in;transition:.2s ease-in}.list-set ::ng-deep .list-row:hover::before{left:calc(100% - 30px);opacity:1}.list-set ::ng-deep .list-row.disabled{cursor:default}.list-set ::ng-deep .list-row.disabled::before{display:none}@media (max-width:768px){.list-set{width:90%}}"]
                }] }
    ];
    /** @nocollapse */
    ListSetComponent.ctorParameters = function () { return []; };
    ListSetComponent.propDecorators = {
        insuranceCoreName: [{ type: Input }],
        listMaxHeight: [{ type: Input }],
        rowData: [{ type: Input }],
        rowsData: [{ type: Input }],
        runAnimation: [{ type: Input }],
        title: [{ type: Input }],
        showFilter: [{ type: Input }],
        fullscreen: [{ type: Input }],
        onClick: [{ type: Output }],
        onToggleSB: [{ type: Output }],
        rowSelected: [{ type: Output }],
        template: [{ type: ContentChild, args: [TemplateRef, { static: false },] }]
    };
    return ListSetComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ListSetComponent.prototype.searchPattern;
    /** @type {?} */
    ListSetComponent.prototype.filteredRowData;
    /** @type {?} */
    ListSetComponent.prototype.insuranceCoreName;
    /** @type {?} */
    ListSetComponent.prototype.listMaxHeight;
    /** @type {?} */
    ListSetComponent.prototype.rowData;
    /** @type {?} */
    ListSetComponent.prototype.rowsData;
    /** @type {?} */
    ListSetComponent.prototype.runAnimation;
    /** @type {?} */
    ListSetComponent.prototype.title;
    /** @type {?} */
    ListSetComponent.prototype.showFilter;
    /** @type {?} */
    ListSetComponent.prototype.fullscreen;
    /** @type {?} */
    ListSetComponent.prototype.onClick;
    /** @type {?} */
    ListSetComponent.prototype.onToggleSB;
    /** @type {?} */
    ListSetComponent.prototype.rowSelected;
    /** @type {?} */
    ListSetComponent.prototype.template;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/list-set/list-set.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ListSetModule = /** @class */ (function () {
    function ListSetModule() {
    }
    ListSetModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ListSetComponent
                    ],
                    exports: [ListSetComponent],
                    providers: []
                },] }
    ];
    return ListSetModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pas-selector/pas-selector.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasSelectorComponent = /** @class */ (function () {
    function PasSelectorComponent() {
        this.title = 'Nueva cotización';
        this.disabledMessage = 'Este item no esta disponible';
        this.onClick = new EventEmitter();
        this.backToBranchClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PasSelectorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PasSelectorComponent.prototype.handleOnClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.selectedIndex = this.selectedIndex === event.index ? -1 : event.index;
        if (!event.row.disabled) {
            this.onClick.emit(event.row);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PasSelectorComponent.prototype.handleBackToBranchClick = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.backToBranchClick.emit(event);
    };
    /**
     * @private
     * @param {?} string
     * @param {?} maxLength
     * @param {?} padString
     * @return {?}
     */
    PasSelectorComponent.prototype.formatPadString = /**
     * @private
     * @param {?} string
     * @param {?} maxLength
     * @param {?} padString
     * @return {?}
     */
    function (string, maxLength, padString) {
        return string.toString().padStart(maxLength, padString);
    };
    /**
     * @param {?} row
     * @return {?}
     */
    PasSelectorComponent.prototype.getPasNumber = /**
     * @param {?} row
     * @return {?}
     */
    function (row) {
        /** @type {?} */
        var pasNumber;
        if (row.branchOffice) {
            pasNumber = this.formatPadString(row.branchOffice, 2, '0') + "-" + this.formatPadString(row.number, 6, '0');
        }
        else {
            pasNumber = row.code;
        }
        return pasNumber;
    };
    PasSelectorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-pas-selector',
                    template: "<div class=\"pas-selector\">\n    <div\n        class=\"pas-selector--back-to-branch-button\"\n        [class.pas-selector--back-to-branch-button_fullscreen]=\"fullscreen\"\n        (click)=\"handleBackToBranchClick($event)\"\n    >\n        <img *ngIf=\"backToBranchClick && backToBranchClick.observers.length\" src=\"./assets/images/arrow-menu_down.png\" class=\"back-to-branch-button--icon\">\n        <img [src]=\"backToBranchIconSrc\" class=\"branch-icon\">\n        <span>{{backToBranchLabel}}</span>\n    </div>\n    <div class=\"pas-selector-list\">\n        <div *ngIf=\"!rowData?.length\" class=\"pas-selector__loading\">\n            <sc-icon icon=\"loading\" size=\"2\"></sc-icon>\n        </div>\n        <sc-list-set\n            *ngIf=\"rowData?.length\"\n            [fullscreen]=\"fullscreen\"\n            [listMaxHeight]=\"listMaxHeight\"\n            [rowData]=\"rowData\"\n            [runAnimation]=\"runAnimation\"\n            [showFilter]=\"true\"\n            [title]=\"title\"\n            (onClick)=\"handleOnClick($event)\">\n            <ng-template let-row=\"row\" let-index=\"index\">\n                <div [ngClass]=\"{'disabled': row.disabled, 'selected': selectedIndex === index}\">\n                    <div [ngClass]=\"{'list-row--pas-name': true, 'list-row--pas-name__disabled': row.disabled}\">\n                        {{getPasNumber(row)}} {{row.name}}\n                    </div>\n                    <div class=\"list-row--organizer-name\">{{getPasNumber(row.organizer)}} {{row.organizer.name}}</div>\n                    <div class=\"list-row--disabled-message\" *ngIf=\"row.disabled\">\n                        <sc-icon class=\"warning-icon\" icon=\"alert-elipse-copy\"></sc-icon>\n                        <span class=\"text\">{{disabledMessage}}</span>\n                    </div>\n                </div>\n            </ng-template>\n        </sc-list-set>\n    </div>\n</div>\n",
                    styles: [".pas-selector{position:relative}.pas-selector__loading{text-align:center;color:#fff;padding:1rem 0}.pas-selector--back-to-branch-button{color:#fff;font-family:Roboto,sans-serif;font-size:12px;line-height:24px;cursor:pointer;position:absolute;top:-1.5rem;left:-14px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.pas-selector--back-to-branch-button_fullscreen{position:initial;margin:0 auto;width:51%}.pas-selector--back-to-branch-button .back-to-branch-button{width:50%;margin:0 auto}.pas-selector--back-to-branch-button .back-to-branch-button--arrow{display:inline-block;padding:6px 0;vertical-align:middle}.pas-selector--back-to-branch-button .back-to-branch-button--icon{display:inline-block;padding:6px;vertical-align:middle;margin:0 -.7rem}.pas-selector--back-to-branch-button .branch-icon{display:inline-block;padding:6px 6px 6px 0;margin-left:15px;vertical-align:middle;max-width:calc(1rem + 6px)}.pas-selector--back-to-branch-button .branch-icon+span{display:inline-block;vertical-align:middle}.pas-selector-list{padding-top:10px}.pas-selector-list .list-row--pas-name{height:24px;color:#fff;font-family:Roboto,sans-serif;font-size:16px;line-height:24px}.pas-selector-list .list-row--pas-name__disabled{color:#000}.pas-selector-list .list-row--organizer-name{height:16px;color:#bdbdbd;font-family:Roboto,sans-serif;font-size:12px;line-height:16px}.pas-selector-list .list-row--disabled-message{-webkit-transition:.15s ease-out;transition:.15s ease-out;padding:0 1rem;border:none;margin:0;border-radius:4px;font-size:13px;display:-webkit-box;display:flex;line-height:18px;height:0;overflow:hidden}.pas-selector-list .list-row--disabled-message .warning-icon{color:#fba344;margin:auto}.pas-selector-list .list-row--disabled-message .text{width:90%}@media (min-width:768px){.pas-selector-list .disabled:hover .list-row--disabled-message{-webkit-transition:.25s ease-out;transition:.25s ease-out;border:2px solid #4393d4;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:.75rem 1rem;margin:1rem .5rem .5rem 0}}@media (max-width:768px){.pas-selector--back-to-branch-button_fullscreen{width:93%}.pas-selector-list .disabled.selected .list-row--disabled-message{-webkit-transition:.25s ease-out;transition:.25s ease-out;border:2px solid #4393d4;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:.75rem 1rem;margin:1rem .5rem .5rem 0}}"]
                }] }
    ];
    /** @nocollapse */
    PasSelectorComponent.ctorParameters = function () { return []; };
    PasSelectorComponent.propDecorators = {
        backToBranchIconSrc: [{ type: Input }],
        backToBranchLabel: [{ type: Input }],
        listMaxHeight: [{ type: Input }],
        rowData: [{ type: Input }],
        runAnimation: [{ type: Input }],
        fullscreen: [{ type: Input }],
        title: [{ type: Input }],
        disabledMessage: [{ type: Input }],
        backToBranchClick: [{ type: Output }],
        onClick: [{ type: Output }]
    };
    return PasSelectorComponent;
}());
if (false) {
    /** @type {?} */
    PasSelectorComponent.prototype.selectedIndex;
    /** @type {?} */
    PasSelectorComponent.prototype.backToBranchIconSrc;
    /** @type {?} */
    PasSelectorComponent.prototype.backToBranchLabel;
    /** @type {?} */
    PasSelectorComponent.prototype.listMaxHeight;
    /** @type {?} */
    PasSelectorComponent.prototype.rowData;
    /** @type {?} */
    PasSelectorComponent.prototype.runAnimation;
    /** @type {?} */
    PasSelectorComponent.prototype.fullscreen;
    /** @type {?} */
    PasSelectorComponent.prototype.title;
    /** @type {?} */
    PasSelectorComponent.prototype.disabledMessage;
    /** @type {?} */
    PasSelectorComponent.prototype.backToBranchClick;
    /** @type {?} */
    PasSelectorComponent.prototype.onClick;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/pas-selector/pas-selector.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasSelectorModule = /** @class */ (function () {
    function PasSelectorModule() {
    }
    PasSelectorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        IconModule,
                        ListSetModule
                    ],
                    declarations: [
                        PasSelectorComponent
                    ],
                    exports: [PasSelectorComponent],
                    providers: [],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                },] }
    ];
    return PasSelectorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/accessory.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Accessory = /** @class */ (function () {
    function Accessory(key, name, statedAmount) {
        if (key === void 0) { key = ''; }
        if (name === void 0) { name = ''; }
        if (statedAmount === void 0) { statedAmount = 0; }
        this.key = null;
        this.name = null;
        this.statedAmount = 0;
        this.key = key;
        this.name = name;
        this.statedAmount = statedAmount;
    }
    return Accessory;
}());
if (false) {
    /** @type {?} */
    Accessory.prototype.key;
    /** @type {?} */
    Accessory.prototype.name;
    /** @type {?} */
    Accessory.prototype.statedAmount;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/accessories-list.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccessoriesListService = /** @class */ (function () {
    function AccessoriesListService(config, http) {
        this.config = config;
        this.http = http;
        this.isDefaultEmptyAccessory = (/**
         * @param {?} accessory
         * @param {?} index
         * @return {?}
         */
        function (accessory, index) {
            return (index === 0 && accessory && accessory.key === '' && accessory.statedAmount === 0);
        });
    }
    /**
     * @return {?}
     */
    AccessoriesListService.prototype.getAccessories = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.config.environment.server.api.typeList + '/api/accessories')
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.data.items; })));
    };
    /**
     * @param {?} accessories
     * @param {?} index
     * @param {?=} mustKeepArrayEmpty
     * @return {?}
     */
    AccessoriesListService.prototype.remove = /**
     * @param {?} accessories
     * @param {?} index
     * @param {?=} mustKeepArrayEmpty
     * @return {?}
     */
    function (accessories, index, mustKeepArrayEmpty) {
        if (mustKeepArrayEmpty === void 0) { mustKeepArrayEmpty = false; }
        // Remove the accessory
        accessories.splice(index, 1);
        // If accessories array must not keep empty then add empty accessory if is needed
        if (!mustKeepArrayEmpty && accessories.length === 0) {
            this.add(accessories);
        }
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccessoriesListService.prototype.add = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        if (this.canAdd(accessories)) {
            accessories.push(new Accessory());
        }
    };
    /**
     * @param {?} accessories
     * @param {?} selected
     * @param {?} index
     * @return {?}
     */
    AccessoriesListService.prototype.updateAccessory = /**
     * @param {?} accessories
     * @param {?} selected
     * @param {?} index
     * @return {?}
     */
    function (accessories, selected, index) {
        accessories[index] = selected;
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccessoriesListService.prototype.canAdd = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        if (!accessories.length) {
            return true;
        }
        return this.areAccessoriesValid(accessories);
    };
    /**
     * @param {?} accessory
     * @param {?} index
     * @return {?}
     */
    AccessoriesListService.prototype.isRemovable = /**
     * @param {?} accessory
     * @param {?} index
     * @return {?}
     */
    function (accessory, index) {
        return !this.isDefaultEmptyAccessory(accessory, index);
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccessoriesListService.prototype.isOnlyDefaultEmptyAccessoryAdded = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        /** @type {?} */
        var invalidAccessory = accessories.find((/**
         * @param {?} accessory
         * @return {?}
         */
        function (accessory) { return accessory.key === '' || accessory.statedAmount <= 0; }));
        return invalidAccessory && accessories.length === 1;
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccessoriesListService.prototype.areAccessoriesValid = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        /** @type {?} */
        var invalidAccessory = accessories.find((/**
         * @param {?} accessory
         * @return {?}
         */
        function (accessory) { return accessory.key === '' || accessory.statedAmount <= 0; }));
        // If there is an invalid accessory but it is the
        // default empty one then these are valid accessories
        if (invalidAccessory && !this.areAccessoriesAdded(accessories)) {
            return true;
        }
        // If there is an invalid accessory but it isn't the
        // default empty one then these are invalid accessories
        if (invalidAccessory) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} accessories
     * @param {?=} avoidDefaultAccessory
     * @return {?}
     */
    AccessoriesListService.prototype.areAccessoriesAdded = /**
     * @param {?} accessories
     * @param {?=} avoidDefaultAccessory
     * @return {?}
     */
    function (accessories, avoidDefaultAccessory) {
        if (avoidDefaultAccessory === void 0) { avoidDefaultAccessory = true; }
        if (!accessories.length) {
            return false;
        }
        // If there is only one accessory added and
        // it's the empty one added by default then there's no accessories added
        if (avoidDefaultAccessory && accessories.length === 1 && this.isDefaultEmptyAccessory(accessories[0], 0)) {
            return false;
        }
        return true;
    };
    AccessoriesListService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AccessoriesListService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] },
        { type: HttpClient }
    ]; };
    return AccessoriesListService;
}());
if (false) {
    /** @type {?} */
    AccessoriesListService.prototype.isDefaultEmptyAccessory;
    /**
     * @type {?}
     * @private
     */
    AccessoriesListService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    AccessoriesListService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accessories-list/accessories-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccesoriesListComponent = /** @class */ (function () {
    function AccesoriesListComponent(scCurrency, accessoriesListService) {
        var _this = this;
        this.scCurrency = scCurrency;
        this.accessoriesListService = accessoriesListService;
        this.accessoryOptions$ = new BehaviorSubject$1([]);
        this.vehicleAccessories = [];
        this.isDefaultEmptyAccessory = (/**
         * @param {?} accessory
         * @param {?} index
         * @return {?}
         */
        function (accessory, index) {
            return (index === 0 && accessory && accessory.key === '' && accessory.statedAmount === 0);
        });
        this.isAddAnotherEnabled = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var areAccessoriesValid = _this.areAccessoriesValid(_this.vehicleAccessories);
            /** @type {?} */
            var isOnlyDefaultEmptyAccessoryAdded = _this.isOnlyDefaultEmptyAccessoryAdded(_this.vehicleAccessories);
            return areAccessoriesValid && !isOnlyDefaultEmptyAccessoryAdded;
        });
        this.addEmpty();
    }
    /**
     * @return {?}
     */
    AccesoriesListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.accessoriesListService
            .getAccessories()
            .subscribe((/**
         * @param {?} accessoriesList
         * @return {?}
         */
        function (accessoriesList) {
            _this.accessoryOptions$.next(accessoriesList);
        }));
    };
    /**
     * @return {?}
     */
    AccesoriesListComponent.prototype.addEmpty = /**
     * @return {?}
     */
    function () {
        if (!this.vehicleAccessories.length) {
            this.add();
        }
    };
    /**
     * @return {?}
     */
    AccesoriesListComponent.prototype.add = /**
     * @return {?}
     */
    function () {
        if (this.canAdd(this.vehicleAccessories) && this.isAddAnotherEnabled()) {
            this.vehicleAccessories.push(new Accessory());
        }
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccesoriesListComponent.prototype.canAdd = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        if (!accessories.length) {
            return true;
        }
        return this.areAccessoriesValid(accessories);
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccesoriesListComponent.prototype.areAccessoriesValid = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        /** @type {?} */
        var invalidAccessory = accessories.find((/**
         * @param {?} accessory
         * @return {?}
         */
        function (accessory) { return accessory.key === '' || accessory.statedAmount <= 0; }));
        // If there is an invalid accessory but it is the
        // default empty one then these are valid accessories
        if (invalidAccessory && !this.areAccessoriesAdded(accessories)) {
            return true;
        }
        // If there is an invalid accessory but it isn't the
        // default empty one then these are invalid accessories
        if (invalidAccessory) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} accessories
     * @param {?=} avoidDefaultAccessory
     * @return {?}
     */
    AccesoriesListComponent.prototype.areAccessoriesAdded = /**
     * @param {?} accessories
     * @param {?=} avoidDefaultAccessory
     * @return {?}
     */
    function (accessories, avoidDefaultAccessory) {
        if (avoidDefaultAccessory === void 0) { avoidDefaultAccessory = true; }
        if (!accessories.length) {
            return false;
        }
        // If there is only one accessory added and
        // it's the empty one added by default then there's no accessories added
        if (avoidDefaultAccessory && accessories.length === 1 && this.isDefaultEmptyAccessory(accessories[0], 0)) {
            return false;
        }
        return true;
    };
    /**
     * @param {?} accessories
     * @return {?}
     */
    AccesoriesListComponent.prototype.isOnlyDefaultEmptyAccessoryAdded = /**
     * @param {?} accessories
     * @return {?}
     */
    function (accessories) {
        /** @type {?} */
        var invalidAccessory = accessories.find((/**
         * @param {?} accessory
         * @return {?}
         */
        function (accessory) { return accessory.key === '' || accessory.statedAmount <= 0; }));
        return invalidAccessory && accessories.length === 1;
    };
    AccesoriesListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-accessories-list',
                    template: "<div class=\"list\">\n  <div class=\"row\">\n    <div class=\"col-md-5 col-xs-12\">\n      <label for=\"\">Accesorio</label>\n    </div>\n    <div class=\"col-md-2 col-xs-6\">\n      <label for=\"\">Suma asegurada</label>\n    </div>\n  </div>\n  <sc-accessory-item  *ngFor=\"let accessory of vehicleAccessories; index as i;\"\n    [selectedAccessory]=\"accessory\"\n    [accessoryOptions]=\"accessoryOptions$\"\n    [accessories]=\"vehicleAccessories\"\n    [index]=\"i\">\n  </sc-accessory-item>\n</div>\n\n<span (click)=\"add()\" class=\"add-row\">\n    <span class=\"sc-icon icon-more-elipse\"></span>\n    <span style=\"text-decoration: underline;\">Agregar otro accesorio</span>\n</span>",
                    providers: [ScCurrencyPipe],
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ".add-row{-webkit-box-align:center;align-items:center;background-color:transparent;border:none;color:#0070cc;display:-webkit-box;display:flex;font-size:14px;margin-left:-1rem;padding:1px 16px;max-width:300px}.add-row:hover{cursor:pointer}.add-row:disabled{color:#aeb7c8}.sc-icon{font-family:sancristobal-iconfont;font-style:normal;font-weight:400;font-size:16px;display:inline-block;text-decoration:inherit;height:48px;width:48px;line-height:48px;text-align:center;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}"]
                }] }
    ];
    /** @nocollapse */
    AccesoriesListComponent.ctorParameters = function () { return [
        { type: ScCurrencyPipe },
        { type: AccessoriesListService }
    ]; };
    AccesoriesListComponent.propDecorators = {
        vehicleAccessories: [{ type: Input }]
    };
    return AccesoriesListComponent;
}());
if (false) {
    /** @type {?} */
    AccesoriesListComponent.prototype.accessoryForm;
    /** @type {?} */
    AccesoriesListComponent.prototype.accessoryOptions$;
    /** @type {?} */
    AccesoriesListComponent.prototype.vehicleAccessories;
    /** @type {?} */
    AccesoriesListComponent.prototype.isDefaultEmptyAccessory;
    /** @type {?} */
    AccesoriesListComponent.prototype.isAddAnotherEnabled;
    /** @type {?} */
    AccesoriesListComponent.prototype.scCurrency;
    /**
     * @type {?}
     * @private
     */
    AccesoriesListComponent.prototype.accessoriesListService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accessories-list/accessory-item/accessory-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccessoryItemComponent = /** @class */ (function () {
    function AccessoryItemComponent(scCurrency, accessoriesService) {
        this.scCurrency = scCurrency;
        this.accessoriesService = accessoriesService;
    }
    /**
     * @return {?}
     */
    AccessoryItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.accessoryForm = new FormGroup({
            selectedAccesory: new FormControl(this.selectedAccessory),
            statedAmount: new FormControl(this.selectedAccessory.statedAmount)
        });
        this.accessoryForm.controls.selectedAccesory.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.selectedAccessory.key = (value && value.key) || '';
            _this.selectedAccessory.name = (value && value.name) || '';
            _this.selectedAccessory.statedAmount = _this.accessoryForm.controls.statedAmount.value;
            _this.accessoriesService.updateAccessory(_this.accessories, _this.selectedAccessory, _this.index);
        }));
        this.accessoryForm.controls.statedAmount.valueChanges.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.selectedAccessory.statedAmount = _this.accessoryForm.controls.statedAmount.value;
            _this.accessoriesService.updateAccessory(_this.accessories, _this.selectedAccessory, _this.index);
        }));
    };
    /**
     * @return {?}
     */
    AccessoryItemComponent.prototype.isRemovable = /**
     * @return {?}
     */
    function () {
        return !!(this.accessoriesService.isRemovable(this.selectedAccessory, this.index) &&
            this.accessories.length > 1);
    };
    /**
     * @return {?}
     */
    AccessoryItemComponent.prototype.remove = /**
     * @return {?}
     */
    function () {
        this.accessoriesService.remove(this.accessories, this.index);
    };
    AccessoryItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-accessory-item',
                    template: "<div class=\"row item\" [formGroup]=\"accessoryForm\">\n    <div class=\"col-md-5 col-xs-12\">\n        <sc-select formControlName=\"selectedAccesory\" label=\"\" placeholder=\"Seleccion\u00E1 un accesorio\" enableSearch=\"true\"\n            objectValue=\"name\" [itemsAsync$]=\"accessoryOptions\"></sc-select>\n    </div>\n    <div class=\"col-md-2 col-xs-12\">\n        <sc-input formControlName=\"statedAmount\" [pipes]=\"[{pipe: scCurrency}]\" label=\"\" placeholder=\"\"></sc-input>\n    </div>\n    <div class=\"col-md-2 col-xs-12 item__actions\" *ngIf=\"isRemovable()\">\n        <a class=\"link\" (click)=\"remove()\">Eliminar</a>\n    </div>\n</div>",
                    providers: [ScCurrencyPipe],
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ".item__actions{-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:start;justify-content:flex-start;display:-webkit-box;display:flex;padding-top:.5rem}@media (max-width:768px){div:not(:first-child){margin-top:1rem}}.link{text-decoration:underline!important;cursor:pointer!important;color:#0070cc!important}"]
                }] }
    ];
    /** @nocollapse */
    AccessoryItemComponent.ctorParameters = function () { return [
        { type: ScCurrencyPipe },
        { type: AccessoriesListService }
    ]; };
    AccessoryItemComponent.propDecorators = {
        selectedAccessory: [{ type: Input }],
        accessoryOptions: [{ type: Input }],
        index: [{ type: Input }],
        accessories: [{ type: Input }]
    };
    return AccessoryItemComponent;
}());
if (false) {
    /** @type {?} */
    AccessoryItemComponent.prototype.accessoryForm;
    /** @type {?} */
    AccessoryItemComponent.prototype.selectedAccessory;
    /** @type {?} */
    AccessoryItemComponent.prototype.accessoryOptions;
    /** @type {?} */
    AccessoryItemComponent.prototype.index;
    /** @type {?} */
    AccessoryItemComponent.prototype.accessories;
    /** @type {?} */
    AccessoryItemComponent.prototype.scCurrency;
    /**
     * @type {?}
     * @private
     */
    AccessoryItemComponent.prototype.accessoriesService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/accessories-list/accessories-list.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AccessoriesListModule = /** @class */ (function () {
    function AccessoriesListModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    AccessoriesListModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: AccessoriesListModule,
            providers: [
                AccessoriesListService,
                {
                    provide: 'envConfig',
                    useValue: config
                }
            ]
        };
    };
    AccessoriesListModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule,
                        InputModule,
                        TitleModule,
                        SelectModule,
                        RadioModule,
                    ],
                    declarations: [
                        AccesoriesListComponent,
                        AccessoryItemComponent
                    ],
                    exports: [AccesoriesListComponent, AccessoryItemComponent],
                    providers: [
                        AccessoriesListService
                    ]
                },] }
    ];
    return AccessoriesListModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/policy.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Policy = /** @class */ (function () {
    function Policy() {
        this.automaticAdjustmentKey = null;
        this.coverages = null;
        this.effectiveDate = null;
        this.expirationDate = null;
        this.policyNumber = null;
        this.premiumDiscountKey = null;
        this.premiumDiscountName = null;
        this.term = null;
        this.totalCost = 0;
    }
    return Policy;
}());
if (false) {
    /** @type {?} */
    Policy.prototype.automaticAdjustmentKey;
    /** @type {?} */
    Policy.prototype.coverages;
    /** @type {?} */
    Policy.prototype.effectiveDate;
    /** @type {?} */
    Policy.prototype.expirationDate;
    /** @type {?} */
    Policy.prototype.policyNumber;
    /** @type {?} */
    Policy.prototype.premiumDiscountKey;
    /** @type {?} */
    Policy.prototype.premiumDiscountName;
    /** @type {?} */
    Policy.prototype.term;
    /** @type {?} */
    Policy.prototype.totalCost;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/policy.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolicyService = /** @class */ (function () {
    function PolicyService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @param {?=} subBranch
     * @param {?=} commercialAlternativeKey
     * @return {?}
     */
    PolicyService.prototype.getPremiumDiscounts = /**
     * @param {?=} subBranch
     * @param {?=} commercialAlternativeKey
     * @return {?}
     */
    function (subBranch, commercialAlternativeKey) {
        if (subBranch === void 0) { subBranch = ''; }
        /** @type {?} */
        var commercialAlternativeKeyUrl = commercialAlternativeKey ? "&commercialAlternativeKey=" + commercialAlternativeKey : '';
        /** @type {?} */
        var baseUrl = this.config.environment.server.api.portalpas;
        return this.http.get(baseUrl + "/PremiumDiscounts?subBranch=" + subBranch + commercialAlternativeKeyUrl)
            .pipe(map$1((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            return response.premiumDiscounts.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return {
                    key: String(item.key),
                    name: item.name
                };
            }));
        })));
    };
    /**
     * @param {?} publicId
     * @param {?} branch
     * @param {?} subBranch
     * @return {?}
     */
    PolicyService.prototype.getPremiumDiscountsBasedOnAG = /**
     * @param {?} publicId
     * @param {?} branch
     * @param {?} subBranch
     * @return {?}
     */
    function (publicId, branch, subBranch) {
        /** @type {?} */
        var url = this.config.environment.server.api.portalpas + "/affinitygroup/" + publicId + "/commercial-alternative" +
            ("?branch=" + branch + "&subbranch=" + subBranch);
        return this.http.get(url).pipe(retry(3), map$1((/**
         * @param {?} items
         * @return {?}
         */
        function (items) { return items; })), catchError((/**
         * @return {?}
         */
        function () { return throwError(null); })));
    };
    /**
     * @param {?=} filter
     * @return {?}
     */
    PolicyService.prototype.getAutomaticAdjustments = /**
     * @param {?=} filter
     * @return {?}
     */
    function (filter) {
        /** @type {?} */
        var urlBase = this.config.environment.server.api.portalpasProxy;
        if (isNullOrUndefined(filter)) {
            filter = 'combinedfilter';
        }
        return this.http.get(urlBase + "/policycenter-typelist/api/typelists/Ext_AutomaticAdjustSum/search-by-filter?filter=" + filter)
            .pipe(map$1((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.typeListValues; })));
    };
    /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    PolicyService.prototype.getAffinityGroups = /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    function (policyPeriodId) {
        /** @type {?} */
        var url = this.config.environment.server.api.portalpas + "/Policy/" + policyPeriodId + "/AffinityGroups";
        return this.http.get(url).pipe(retry(3), map$1((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.affinityGroups; })));
    };
    /**
     * @param {?} id
     * @return {?}
     */
    PolicyService.prototype.getOpportunityById = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get(this.config.environment.server.api.marketing + "/Opportunity/GetOpportunityById/" + id);
    };
    /**
     * @param {?} opportunityId
     * @return {?}
     */
    PolicyService.prototype.getOportunityAffinityGroup = /**
     * @param {?} opportunityId
     * @return {?}
     */
    function (opportunityId) {
        return this.getOpportunityById(opportunityId).pipe(map$1((/**
         * @param {?} opportunity
         * @return {?}
         */
        function (opportunity) {
            return opportunity.affinityGroup;
        })));
    };
    /**
     * @param {?} policyPeriodId
     * @param {?} opportunityId
     * @return {?}
     */
    PolicyService.prototype.getAllAffinityGroups = /**
     * @param {?} policyPeriodId
     * @param {?} opportunityId
     * @return {?}
     */
    function (policyPeriodId, opportunityId) {
        /** @type {?} */
        var httpCalls = opportunityId
            ? [this.getAffinityGroups(policyPeriodId), this.getOportunityAffinityGroup(opportunityId)]
            : [this.getAffinityGroups(policyPeriodId), of(null)];
        return forkJoin(httpCalls);
    };
    /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    PolicyService.prototype.sendApprovalRequestProxy = /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    function (policyPeriodId) {
        /** @type {?} */
        var url = this.config.environment.server.api.portalpasProxy +
            ("/policycenter-policy/api/Policies/" + policyPeriodId + "/underwriting-issues/approval-request");
        return this.http.put(url, null);
    };
    PolicyService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PolicyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] }
    ]; };
    return PolicyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PolicyService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    PolicyService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/affinity-group.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AffinityGroupType = /** @class */ (function () {
    function AffinityGroupType() {
    }
    return AffinityGroupType;
}());
if (false) {
    /** @type {?} */
    AffinityGroupType.prototype.code;
    /** @type {?} */
    AffinityGroupType.prototype.description;
}
var AffinityGroupOrigin = /** @class */ (function () {
    function AffinityGroupOrigin() {
    }
    return AffinityGroupOrigin;
}());
if (false) {
    /** @type {?} */
    AffinityGroupOrigin.prototype.code;
    /** @type {?} */
    AffinityGroupOrigin.prototype.description;
}
var AffinityGroup = /** @class */ (function () {
    function AffinityGroup(affinityGroup) {
        Object.assign(this, affinityGroup);
    }
    /**
     * @param {?} affinityGroups
     * @return {?}
     */
    AffinityGroup.prototype.getAffinityGroupWithoutOrigin = /**
     * @param {?} affinityGroups
     * @return {?}
     */
    function (affinityGroups) {
        return affinityGroups.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !item.origins || !item.origins.length; }));
    };
    return AffinityGroup;
}());
if (false) {
    /** @type {?} */
    AffinityGroup.prototype.affinityGroupType;
    /** @type {?} */
    AffinityGroup.prototype.displayName;
    /** @type {?} */
    AffinityGroup.prototype.publicId;
    /** @type {?} */
    AffinityGroup.prototype.origins;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/opportunity-affinity-group.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OpportunityAffinityGroup = /** @class */ (function () {
    function OpportunityAffinityGroup(opportunityAffinityGroup) {
        Object.assign(this, opportunityAffinityGroup);
    }
    /**
     * @param {?} affinityGroupByOpportunity
     * @param {?} affinityGroups
     * @param {?} opportunityOrigin
     * @return {?}
     */
    OpportunityAffinityGroup.prototype.getItems = /**
     * @param {?} affinityGroupByOpportunity
     * @param {?} affinityGroups
     * @param {?} opportunityOrigin
     * @return {?}
     */
    function (affinityGroupByOpportunity, affinityGroups, opportunityOrigin) {
        /** @type {?} */
        var items = [];
        if (affinityGroupByOpportunity) {
            /** @type {?} */
            var sameAffinityGroup = affinityGroups.find((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.publicId === affinityGroupByOpportunity.publicID;
            }));
            items = sameAffinityGroup
                ? [sameAffinityGroup, this.initializeNoOption()]
                : this.filterOportunityAffinityGroups(affinityGroups, opportunityOrigin);
        }
        else {
            items = this.filterOportunityAffinityGroups(affinityGroups, opportunityOrigin);
        }
        return items;
    };
    /**
     * @private
     * @return {?}
     */
    OpportunityAffinityGroup.prototype.initializeNoOption = /**
     * @private
     * @return {?}
     */
    function () {
        return new AffinityGroup({
            displayName: 'Sin grupo de afinidad',
            publicId: '',
        });
    };
    /**
     * @param {?} affinityGroups
     * @param {?} opportunityOrigin
     * @return {?}
     */
    OpportunityAffinityGroup.prototype.filterOportunityAffinityGroups = /**
     * @param {?} affinityGroups
     * @param {?} opportunityOrigin
     * @return {?}
     */
    function (affinityGroups, opportunityOrigin) {
        return affinityGroups.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            return !item.origins ||
                !item.origins.length ||
                item.origins.some((/**
                 * @param {?} originAF
                 * @return {?}
                 */
                function (originAF) { return originAF.code === opportunityOrigin; }));
        }));
    };
    return OpportunityAffinityGroup;
}());
if (false) {
    /** @type {?} */
    OpportunityAffinityGroup.prototype.affinityGroupId;
    /** @type {?} */
    OpportunityAffinityGroup.prototype.origin;
    /** @type {?} */
    OpportunityAffinityGroup.prototype.publicID;
    /** @type {?} */
    OpportunityAffinityGroup.prototype.displayName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/policy-info/policy-info.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolicyInfoComponent = /** @class */ (function () {
    function PolicyInfoComponent(policyService, changeDetectorRef) {
        this.policyService = policyService;
        this.changeDetectorRef = changeDetectorRef;
        this.backwardDays = 7;
        this.DIFFERENCE_FORWARD = 45;
        this.noPremiumDiscountOption = { key: '0', name: 'Sin modificaciones en la prima' };
        this.loading = true;
        this.affinityGroups$ = new AsyncSubject();
        this.automaticAdjustmentOptions$ = new AsyncSubject();
        this.premiumDiscountOptions$ = new BehaviorSubject$1([]);
        this.premiumDiscountsLoading = false;
        this.formCompleted = new EventEmitter();
        this.affinityGroupSelected = new EventEmitter();
        this.valuesChanged = new EventEmitter();
        this.hasUnderWriting = new EventEmitter();
        this.hasUnderWritingFlag = false;
    }
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.ngAfterViewChecked = /**
     * @return {?}
     */
    function () {
        this.changeDetectorRef.detectChanges();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    PolicyInfoComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this.form) {
            if (changes.hideAffinityGroups) {
                this.hideAffinityGroupsChanged(changes.hideAffinityGroups.currentValue);
            }
            if (changes.hideAutomaticAdjustment) {
                this.hideAutomaticAdjustmentChanged(changes.hideAutomaticAdjustment.currentValue);
            }
            if (changes.hidePremiumDiscount) {
                this.hidePremiumDiscountChanged(changes.hidePremiumDiscount.currentValue);
            }
        }
    };
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initForm();
        this.setUnderWritingMessage();
        if (isNullOrUndefined(this.editMode)) {
            this.editMode = true;
        }
        if (isNullOrUndefined(this.canContinue)) {
            this.canContinue = true;
        }
        if (this.hideAffinityGroups) {
            this.loading = false;
        }
        this.hideAffinityGroupsChanged(this.hideAffinityGroups);
        this.hideAutomaticAdjustmentChanged(this.hideAutomaticAdjustment);
        this.hidePremiumDiscountChanged(this.hidePremiumDiscount);
    };
    /**
     * @private
     * @return {?}
     */
    PolicyInfoComponent.prototype.initForm = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var initialTerm = this.setInitialTerm();
        this.effectiveDateDefault = this.policyData && this.policyData.effectiveDate || new Date();
        this.expirationDateDefault = this.calculateExpirationDate(this.effectiveDateDefault, initialTerm.key);
        this.expirationDateDisabled = initialTerm.key > 0;
        this.form = new FormGroup({
            affinityGroupsFormControl: new FormControl(null),
            term: new FormControl(initialTerm, Validators.required),
            effectiveDate: new FormControl(new Date(this.effectiveDateDefault), Validators.required),
            expirationDate: new FormControl(this.expirationDateDefault, Validators.required),
            automaticAdjustment: new FormControl(null),
            premiumDiscount: new FormControl(null),
        });
        this.form.valueChanges
            .pipe(distinctUntilChanged((/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        function (a, b) { return JSON.stringify(a) === JSON.stringify(b); })))
            .subscribe((/**
         * @param {?} newValues
         * @return {?}
         */
        function (newValues) {
            if (!(_this.loading || _this.premiumDiscountsLoading)) {
                _this.valuesChanged.emit(newValues);
            }
        }));
        this.form.controls['effectiveDate'].valueChanges
            .subscribe((/**
         * @param {?} newDate
         * @return {?}
         */
        function (newDate) {
            _this.setExpirationDate(newDate, _this.form.get('term').value.key);
        }));
    };
    /**
     * @private
     * @return {?}
     */
    PolicyInfoComponent.prototype.setInitialTerm = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        return this.termOptions.find((/**
         * @param {?} t
         * @return {?}
         */
        function (t) { return t.key === _this.initialTermKey; })) || this.termOptions[0];
    };
    /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    PolicyInfoComponent.prototype.hideAffinityGroupsChanged = /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    function (hide) {
        if (hide) {
            this.form.controls['affinityGroupsFormControl'].setValidators(null);
            this.form.controls['affinityGroupsFormControl'].disable();
        }
        else {
            this.form.controls['affinityGroupsFormControl'].setValidators(Validators.required);
            this.form.controls['affinityGroupsFormControl'].enable();
            this.getAffinityGroups(this.policyPeriodId);
        }
    };
    /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    PolicyInfoComponent.prototype.hideAutomaticAdjustmentChanged = /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    function (hide) {
        if (hide) {
            this.form.controls['automaticAdjustment'].setValidators(null);
            this.form.controls['automaticAdjustment'].disable();
        }
        else {
            this.form.controls['automaticAdjustment'].setValidators(Validators.required);
            this.form.controls['automaticAdjustment'].enable();
            this.getAutomaticAdjustments();
        }
    };
    /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    PolicyInfoComponent.prototype.hidePremiumDiscountChanged = /**
     * @private
     * @param {?} hide
     * @return {?}
     */
    function (hide) {
        if (hide) {
            this.form.controls['premiumDiscount'].setValidators(null);
            this.form.controls['premiumDiscount'].disable();
        }
        else {
            this.form.controls['premiumDiscount'].setValidators(Validators.required);
            this.form.controls['premiumDiscount'].enable();
            /** @type {?} */
            var groupId = this.form.get('affinityGroupsFormControl').value && this.form.get('affinityGroupsFormControl').value.publicId;
            this.getPremiumDiscounts(groupId);
        }
    };
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.setUnderWritingMessage = /**
     * @return {?}
     */
    function () {
        this.underWritingMessage = "\n            Seleccionando un descuento mayor al " + Math.abs(this.premiumDiscountLimit) + "% deber\u00E1s pedir aprobaci\u00F3n al momento de emitir\n        ";
    };
    /**
     * @param {?} date
     * @param {?} term
     * @return {?}
     */
    PolicyInfoComponent.prototype.calculateExpirationDate = /**
     * @param {?} date
     * @param {?} term
     * @return {?}
     */
    function (date, term) {
        /** @type {?} */
        var newDate = date ? new Date(date) : new Date();
        return (newDate.getMonth() === 1 && term === 1) ? new Date(addDays(newDate, 30)) : new Date(addMonths(newDate, term));
    };
    /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    PolicyInfoComponent.prototype.getAffinityGroups = /**
     * @param {?} policyPeriodId
     * @return {?}
     */
    function (policyPeriodId) {
        var _this = this;
        /** @type {?} */
        var noOption = this.initializeNoOption();
        /** @type {?} */
        var allOptions;
        /** @type {?} */
        var settedOption;
        this.affinityGroups$ = new AsyncSubject();
        this.policyService.getAllAffinityGroups(policyPeriodId, this.opportunityId)
            .pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.updateAffinityGroups(allOptions);
            _this.updateAffinityGroupFormControl(allOptions, settedOption);
            _this.loading = false;
        })))
            .subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var _b = __read(_a, 2), affinityGroups = _b[0], opportunityAffinityGroup = _b[1];
            if (affinityGroups && affinityGroups.length) {
                allOptions = _this.opportunityId
                    ? __spread(_this.setAffinityGroupItemsForOpportunity(affinityGroups, opportunityAffinityGroup)) : __spread(_this.setAffinityGroupItemsWithoutOpportunity(affinityGroups));
            }
            else {
                allOptions = [noOption];
            }
            /** @type {?} */
            var publicId = _this.initialAffinityGroupId || '';
            settedOption = allOptions.find((/**
             * @param {?} group
             * @return {?}
             */
            function (group) { return group.publicId === publicId; })) || noOption;
        }), (/**
         * @return {?}
         */
        function () {
            allOptions = [noOption];
            settedOption = noOption;
            _this.form.controls['affinityGroupsFormControl'].disable();
        }));
    };
    /**
     * @private
     * @param {?} affinityGroups
     * @return {?}
     */
    PolicyInfoComponent.prototype.updateAffinityGroups = /**
     * @private
     * @param {?} affinityGroups
     * @return {?}
     */
    function (affinityGroups) {
        this.affinityGroups$.next(affinityGroups);
        this.affinityGroups$.complete();
    };
    /**
     * @private
     * @param {?} affinityGroups
     * @param {?} settedOption
     * @return {?}
     */
    PolicyInfoComponent.prototype.updateAffinityGroupFormControl = /**
     * @private
     * @param {?} affinityGroups
     * @param {?} settedOption
     * @return {?}
     */
    function (affinityGroups, settedOption) {
        this.form.get('affinityGroupsFormControl').setValue(settedOption);
        if (affinityGroups && affinityGroups.length === 1) {
            this.form.controls['affinityGroupsFormControl'].disable();
        }
        this.handleAffinityGroupsSelect(settedOption);
    };
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.initializeNoOption = /**
     * @return {?}
     */
    function () {
        return new AffinityGroup({
            displayName: 'Sin grupo de afinidad',
            publicId: '',
        });
    };
    /**
     * @param {?} allItems
     * @param {?} affinityGroupByOpportunity
     * @return {?}
     */
    PolicyInfoComponent.prototype.setAffinityGroupItemsForOpportunity = /**
     * @param {?} allItems
     * @param {?} affinityGroupByOpportunity
     * @return {?}
     */
    function (allItems, affinityGroupByOpportunity) {
        /** @type {?} */
        var opportunityAffinityGroup = new OpportunityAffinityGroup();
        // Business rule: If the opporturnity doesn't have an Affinity Group, its origin is MktDigital
        /** @type {?} */
        var opportunityOrigin = affinityGroupByOpportunity
            ? affinityGroupByOpportunity.origin
            : 'MktDigital';
        return opportunityAffinityGroup.getItems(affinityGroupByOpportunity, allItems, opportunityOrigin);
    };
    /**
     * @param {?} allItems
     * @return {?}
     */
    PolicyInfoComponent.prototype.setAffinityGroupItemsWithoutOpportunity = /**
     * @param {?} allItems
     * @return {?}
     */
    function (allItems) {
        /** @type {?} */
        var affinityGroup = new AffinityGroup();
        return affinityGroup.getAffinityGroupWithoutOrigin(allItems);
    };
    /**
     * @param {?=} affinityGroupId
     * @return {?}
     */
    PolicyInfoComponent.prototype.getPremiumDiscounts = /**
     * @param {?=} affinityGroupId
     * @return {?}
     */
    function (affinityGroupId) {
        var _this = this;
        this.resetPremiumDiscountField();
        this.premiumDiscountsLoading = true;
        /** @type {?} */
        var serviceCall$ = (affinityGroupId)
            ? this.policyService.getPremiumDiscountsBasedOnAG(affinityGroupId, this.branch, this.subBranch)
            : this.policyService.getPremiumDiscounts(this.subBranch);
        serviceCall$.pipe(finalize((/**
         * @return {?}
         */
        function () { return _this.premiumDiscountsLoading = false; })))
            .subscribe((/**
         * @param {?} items
         * @return {?}
         */
        function (items) { return _this.setPremiumDiscounts(items); }), (/**
         * @return {?}
         */
        function () {
            _this.setPremiumDiscounts();
            _this.form.controls['premiumDiscount'].disable();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    PolicyInfoComponent.prototype.resetPremiumDiscountField = /**
     * @private
     * @return {?}
     */
    function () {
        this.form.controls['premiumDiscount'].enable();
        this.form.get('premiumDiscount').setValue(this.noPremiumDiscountOption);
    };
    /**
     * @private
     * @param {?=} items
     * @return {?}
     */
    PolicyInfoComponent.prototype.setPremiumDiscounts = /**
     * @private
     * @param {?=} items
     * @return {?}
     */
    function (items) {
        /** @type {?} */
        var settedOptionKey = (this.policyData && this.policyData.premiumDiscountKey || this.initialPremiumDiscountKey);
        if (!(items && items.length)) {
            items = [this.noPremiumDiscountOption];
            settedOptionKey = '0';
        }
        /** @type {?} */
        var settedOption = items.find((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.key === settedOptionKey || item.key === '0'; }));
        this.premiumDiscountOptions$.next(items);
        if (items && items.length === 1) {
            this.form.get('premiumDiscount').setValue(items[0]);
            this.form.get('premiumDiscount').disable();
        }
        else {
            this.form.get('premiumDiscount').setValue(settedOption);
        }
    };
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.getAutomaticAdjustments = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var noOption = { code: 'percZero', name: '0%' };
        /** @type {?} */
        var settedOption;
        /** @type {?} */
        var allOptions;
        this.automaticAdjustmentOptions$ = new AsyncSubject();
        this.policyService.getAutomaticAdjustments()
            .pipe(finalize((/**
         * @return {?}
         */
        function () {
            _this.form.get('automaticAdjustment').setValue(settedOption);
            _this.automaticAdjustmentOptions$.next(allOptions);
            _this.automaticAdjustmentOptions$.complete();
        })))
            .subscribe((/**
         * @param {?} items
         * @return {?}
         */
        function (items) {
            /** @type {?} */
            var code = (_this.policyData && _this.policyData.automaticAdjustmentKey) || _this.initialAutomaticAdjustment;
            settedOption = items.find((/**
             * @param {?} option
             * @return {?}
             */
            function (option) { return option.code === code; }));
            allOptions = items;
        }), (/**
         * @return {?}
         */
        function () {
            settedOption = noOption;
            allOptions = [noOption];
            _this.form.controls['automaticAdjustment'].disable();
        }));
    };
    /**
     * @param {?} newDate
     * @param {?} term
     * @return {?}
     */
    PolicyInfoComponent.prototype.setExpirationDate = /**
     * @param {?} newDate
     * @param {?} term
     * @return {?}
     */
    function (newDate, term) {
        if (!newDate) {
            newDate = this.form && this.form.get('effectiveDate').value;
        }
        if (newDate) {
            this.form.controls['expirationDate'].setValue(this.calculateExpirationDate(newDate, term));
        }
    };
    /**
     * @return {?}
     */
    PolicyInfoComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.formCompleted.emit((/** @type {?} */ (this.form.getRawValue())));
        this.editMode = false;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PolicyInfoComponent.prototype.handleAffinityGroupsSelect = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event) {
            if (!this.hidePremiumDiscount) {
                /** @type {?} */
                var publicId = event.publicId;
                this.getPremiumDiscounts(publicId);
                if (publicId) {
                    this.handleUnderWriting(this.noPremiumDiscountOption);
                }
            }
            this.affinityGroupSelected.emit(event);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PolicyInfoComponent.prototype.handlePremiumDiscountOptionSelected = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.handleUnderWriting(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PolicyInfoComponent.prototype.handleUnderWriting = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (this.premiumDiscountLimit) {
            /** @type {?} */
            var hasAffinityGroupSelected = this.form && this.form.controls['affinityGroupsFormControl'].value.publicId;
            this.hasUnderWritingFlag = (Number(event.key) < this.premiumDiscountLimit) && !hasAffinityGroupSelected;
            this.hasUnderWriting.emit(this.hasUnderWritingFlag);
        }
    };
    PolicyInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-policy-info',
                    template: "<div class=\"sc-policy-info\">\n  <sc-title type=\"h2\" content=\"Informaci\u00F3n de la p\u00F3liza\" color=\"black\"></sc-title>\n  <p class=\"section-subtitle\">Pod\u00E9s completar el resto de la informaci\u00F3n a la hora de emitir</p>\n  <ng-container *ngIf=\"!loading\">\n    <form [formGroup]=\"form\" *ngIf=\"editMode\">\n      <div class=\"fields-block\">\n        <div class=\"row\">\n          <div class=\"col-12\">\n            <sc-select\n              *ngIf=\"!hideAffinityGroups\"\n              formControlName=\"affinityGroupsFormControl\"\n              label=\"Grupos de afinidad\"\n              objectKey=\"publicId\"\n              objectValue=\"displayName\"\n              [itemsAsync$]=\"affinityGroups$\"\n              (optionSelected)=\"handleAffinityGroupsSelect($event)\"\n            ></sc-select>\n            <sc-select\n              formControlName=\"term\"\n              label=\"Vigencia\"\n              [items]=\"termOptions\"\n              [isDisabled]=\"termOptionsDisabled\"\n              (optionSelected)=\"setExpirationDate(null, $event.key)\"></sc-select>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-6 col-12\">\n            <sc-simple-date-picker\n              formControlName=\"effectiveDate\"\n              label=\"Inicio\"\n              [minLimitDateFromNow]=\"backwardDays\"\n              [maxLimitDateFromNow]=\"DIFFERENCE_FORWARD\"\n            ></sc-simple-date-picker>\n          </div>\n          <div class=\"col-md-6 col-12\">\n            <sc-simple-date-picker formControlName=\"expirationDate\" label=\"Fin\" [readonly]=\"true\"></sc-simple-date-picker>\n          </div>\n        </div>\n        <div class=\"row\" *ngIf=\"!hideAutomaticAdjustment\">\n          <div class=\"col-md-6 col-12\">\n            <sc-select  formControlName=\"automaticAdjustment\"\n                        label=\"Ajuste autom\u00E1tico\"\n                        objectKey=\"code\"\n                        objectValue=\"name\"\n                        [itemsAsync$]=\"automaticAdjustmentOptions$\"></sc-select>\n          </div>\n        </div>\n        <div class=\"row\" *ngIf=\"!hidePremiumDiscount\">\n          <div class=\"premium-discount-wrapper col-md-9 col-12\">\n            <sc-select  formControlName=\"premiumDiscount\"\n                        label=\"Alternativa comercial\"\n                        objectValue=\"name\"\n                        placeholder=\"Sin modificaci\u00F3n en la prima\"\n                        [loading]=\"premiumDiscountsLoading\"\n                        [itemsAsync$]=\"premiumDiscountOptions$\"\n                        (optionSelected)=\"handlePremiumDiscountOptionSelected($event)\"></sc-select>\n            <sc-tooltip\n              *ngIf=\"premiumDiscountLimit && hasUnderWritingFlag\"\n              class=\"under-writing-indicator\"\n              title=\"Este descuento requiere aprobaci\u00F3n\"\n              [externallyOpen]=\"hasUnderWritingFlag\"\n              [description]=\"underWritingMessage\"\n            >\n              <sc-icon class=\"under-writing-indicator__icon\" icon=\"alert-elipse-copy\"></sc-icon>\n            </sc-tooltip>\n          </div>\n        </div>\n      </div>\n      <div class=\"buttons-block\">\n        <sc-button\n          id=\"policy-info-calculate-price\"\n          size=\"small\"\n          type=\"primary\"\n          text=\"Calcular precio\"\n          (onClick)=\"onSubmit()\"\n          [disabled]=\"form.invalid\"\n          [loading]=\"!canContinue || premiumDiscountsLoading\"\n        ></sc-button>\n      </div>\n    </form>\n  </ng-container>\n  <div class=\"loader\" *ngIf=\"loading\">\n    <sc-icon icon=\"loading\" size=\"2\"></sc-icon>\n  </div>\n</div>\n",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ".fields-block{max-width:344px}.sc-policy-info ::ng-deep .sc-select--disabled sc-icon{display:none}.loader{max-width:390px;text-align:center;margin-top:50px}.premium-discount-wrapper{width:330px;display:-webkit-box;display:flex}.premium-discount-wrapper .under-writing-indicator{margin:30px 0 0 10px}.premium-discount-wrapper .under-writing-indicator__icon{color:#fba344}"]
                }] }
    ];
    /** @nocollapse */
    PolicyInfoComponent.ctorParameters = function () { return [
        { type: PolicyService },
        { type: ChangeDetectorRef }
    ]; };
    PolicyInfoComponent.propDecorators = {
        policyData: [{ type: Input }],
        canContinue: [{ type: Input }],
        editMode: [{ type: Input }],
        termOptions: [{ type: Input }],
        initialAutomaticAdjustment: [{ type: Input }],
        initialPremiumDiscountKey: [{ type: Input }],
        initialTermKey: [{ type: Input }],
        initialAffinityGroupId: [{ type: Input }],
        termOptionsDisabled: [{ type: Input }],
        policyPeriodId: [{ type: Input }],
        hideAffinityGroups: [{ type: Input }],
        hideAutomaticAdjustment: [{ type: Input }],
        hidePremiumDiscount: [{ type: Input }],
        branch: [{ type: Input }],
        subBranch: [{ type: Input }],
        opportunityId: [{ type: Input }],
        premiumDiscountLimit: [{ type: Input }],
        backwardDays: [{ type: Input }],
        formCompleted: [{ type: Output }],
        affinityGroupSelected: [{ type: Output }],
        valuesChanged: [{ type: Output }],
        hasUnderWriting: [{ type: Output }]
    };
    return PolicyInfoComponent;
}());
if (false) {
    /** @type {?} */
    PolicyInfoComponent.prototype.policyData;
    /** @type {?} */
    PolicyInfoComponent.prototype.canContinue;
    /** @type {?} */
    PolicyInfoComponent.prototype.editMode;
    /** @type {?} */
    PolicyInfoComponent.prototype.termOptions;
    /** @type {?} */
    PolicyInfoComponent.prototype.initialAutomaticAdjustment;
    /** @type {?} */
    PolicyInfoComponent.prototype.initialPremiumDiscountKey;
    /** @type {?} */
    PolicyInfoComponent.prototype.initialTermKey;
    /** @type {?} */
    PolicyInfoComponent.prototype.initialAffinityGroupId;
    /** @type {?} */
    PolicyInfoComponent.prototype.termOptionsDisabled;
    /** @type {?} */
    PolicyInfoComponent.prototype.policyPeriodId;
    /** @type {?} */
    PolicyInfoComponent.prototype.hideAffinityGroups;
    /** @type {?} */
    PolicyInfoComponent.prototype.hideAutomaticAdjustment;
    /** @type {?} */
    PolicyInfoComponent.prototype.hidePremiumDiscount;
    /** @type {?} */
    PolicyInfoComponent.prototype.branch;
    /** @type {?} */
    PolicyInfoComponent.prototype.subBranch;
    /** @type {?} */
    PolicyInfoComponent.prototype.opportunityId;
    /** @type {?} */
    PolicyInfoComponent.prototype.premiumDiscountLimit;
    /** @type {?} */
    PolicyInfoComponent.prototype.backwardDays;
    /** @type {?} */
    PolicyInfoComponent.prototype.formCompleted;
    /** @type {?} */
    PolicyInfoComponent.prototype.affinityGroupSelected;
    /** @type {?} */
    PolicyInfoComponent.prototype.valuesChanged;
    /** @type {?} */
    PolicyInfoComponent.prototype.hasUnderWriting;
    /** @type {?} */
    PolicyInfoComponent.prototype.DIFFERENCE_FORWARD;
    /** @type {?} */
    PolicyInfoComponent.prototype.effectiveDateDefault;
    /** @type {?} */
    PolicyInfoComponent.prototype.expirationDateDefault;
    /** @type {?} */
    PolicyInfoComponent.prototype.form;
    /** @type {?} */
    PolicyInfoComponent.prototype.affinityGroups$;
    /** @type {?} */
    PolicyInfoComponent.prototype.automaticAdjustmentOptions$;
    /** @type {?} */
    PolicyInfoComponent.prototype.premiumDiscountOptions$;
    /** @type {?} */
    PolicyInfoComponent.prototype.expirationDateDisabled;
    /** @type {?} */
    PolicyInfoComponent.prototype.loading;
    /** @type {?} */
    PolicyInfoComponent.prototype.premiumDiscountsLoading;
    /**
     * @type {?}
     * @private
     */
    PolicyInfoComponent.prototype.noPremiumDiscountOption;
    /** @type {?} */
    PolicyInfoComponent.prototype.hasUnderWritingFlag;
    /** @type {?} */
    PolicyInfoComponent.prototype.underWritingMessage;
    /**
     * @type {?}
     * @private
     */
    PolicyInfoComponent.prototype.policyService;
    /**
     * @type {?}
     * @private
     */
    PolicyInfoComponent.prototype.changeDetectorRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/policy-info/policy-info.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PolicyInfoModule = /** @class */ (function () {
    function PolicyInfoModule() {
    }
    PolicyInfoModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule,
                        InputModule,
                        TitleModule,
                        SelectModule,
                        IconModule,
                        ScPipesModule,
                        SimpleDatePickerModule,
                        HttpClientModule,
                        TooltipCustomModule
                    ],
                    declarations: [PolicyInfoComponent],
                    exports: [PolicyInfoComponent]
                },] }
    ];
    return PolicyInfoModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-load/address-load.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressLoadComponent = /** @class */ (function () {
    function AddressLoadComponent() {
        this.formCompleted = new EventEmitter();
        this.addressLoadFormGroup = new FormGroup({
            streetName: new FormControl('', Validators.required),
            number: new FormControl('', Validators.required),
            floor: new FormControl(''),
            department: new FormControl('')
        });
    }
    /**
     * @return {?}
     */
    AddressLoadComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.addressData) {
            this.addressLoadFormGroup.patchValue(this.addressData);
        }
    };
    /**
     * @return {?}
     */
    AddressLoadComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.formCompleted.emit(this.addressLoadFormGroup.value);
    };
    AddressLoadComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-address-load',
                    template: "<div class=\"sc-address-load section-container\">\n  <sc-title\n    [content]=\"title\"\n    type=\"h3\"\n    [class.sc-color-grey-2]=\"!editMode\"\n  ></sc-title>\n  <ng-container *ngIf=\"editMode\">\n    <div class=\"address\">Direcci\u00F3n</div>\n    <form [formGroup]=\"addressLoadFormGroup\">\n      <div class=\"address__street\">\n        <sc-input formControlName=\"streetName\" label=\"Calle\" placeholder=\"Montevideo\"></sc-input>\n      </div>\n      <div class=\"address__number\">\n        <sc-input formControlName=\"number\" label=\"N\u00FAmero\" placeholder=\"1123\"></sc-input>\n      </div>\n      <div class=\"address__floor\">\n        <sc-input formControlName=\"floor\" type=\"number\" label=\"Piso (Opcional)\" placeholder=\"Ej: 3\"></sc-input>\n      </div>\n      <div class=\"address__department\">\n        <sc-input formControlName=\"department\" label=\"Dpto (Opcional)\" placeholder=\"Ej: D\"></sc-input>\n      </div>\n    </form>\n    <sc-button (onClick)=\"onSubmit()\" [disabled]=\"addressLoadFormGroup.status !== 'VALID'\" id=\"address-load-next-step\">Siguiente</sc-button>\n  </ng-container>\n  <div class=\"section-submitted-data\" *ngIf=\"!editMode\">\n    <div>\n      <div>\n        Calle<br>\n        <strong>{{addressLoadFormGroup.value['streetName'] || '-'}}</strong>\n      </div>\n      <div>\n        N\u00FAmero<br>\n        <strong>{{addressLoadFormGroup.value['number'] || '-'}}</strong>\n      </div>\n      <div>\n        <span>Piso (Opcional)</span><br>\n        <strong>{{addressLoadFormGroup.value['floor'] || '-'}}</strong>\n      </div>\n      <div>\n        <span>Dpto (Opcional)</span><br>\n        <strong>{{addressLoadFormGroup.value['department'] || '-'}}</strong>\n      </div>\n    </div>\n  </div>\n</div>\n\n",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ".sc-address-load{padding-bottom:40px;border-bottom:1px solid #dfe1e5}.sc-address-load form{max-width:499px;margin-bottom:10px}.sc-address-load .address{margin:27px 0 10px;color:#536279;font-family:Roboto;font-size:16px;font-weight:700}.sc-address-load .address__street{width:328px;margin-right:15px;display:inline-block;vertical-align:top}.sc-address-load .address__number{width:156px;display:inline-block}.sc-address-load .address__floor{margin-right:15px}.sc-address-load .address__department,.sc-address-load .address__floor{width:156px;display:inline-block}@media (max-width:768px){.sc-address-load .address__number,.sc-address-load .address__street{width:100%}.sc-address-load .address__department,.sc-address-load .address__floor{width:47%;display:inline-block}.sc-address-load .address__department{margin:0 0 0 2px}}"]
                }] }
    ];
    /** @nocollapse */
    AddressLoadComponent.ctorParameters = function () { return []; };
    AddressLoadComponent.propDecorators = {
        editMode: [{ type: Input }],
        title: [{ type: Input }],
        addressData: [{ type: Input }],
        formCompleted: [{ type: Output }]
    };
    return AddressLoadComponent;
}());
if (false) {
    /** @type {?} */
    AddressLoadComponent.prototype.editMode;
    /** @type {?} */
    AddressLoadComponent.prototype.title;
    /** @type {?} */
    AddressLoadComponent.prototype.addressData;
    /** @type {?} */
    AddressLoadComponent.prototype.formCompleted;
    /** @type {?} */
    AddressLoadComponent.prototype.addressLoadFormGroup;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-load/address-load.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressLoadModule = /** @class */ (function () {
    function AddressLoadModule() {
    }
    AddressLoadModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule,
                        InputModule,
                        TitleModule
                    ],
                    declarations: [AddressLoadComponent],
                    exports: [AddressLoadComponent],
                    providers: []
                },] }
    ];
    return AddressLoadModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/insured-info-emision/insured-info-emision.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InsuredInfoEmisionComponent = /** @class */ (function () {
    function InsuredInfoEmisionComponent(http, config) {
        this.http = http;
        this.config = config;
        this.formCompleted = new EventEmitter();
        this.showElectronicDocuments = false;
        this.errorMessages = {
            required: 'Este campo es obligatorio',
            pattern: (/**
             * @param {?} validator
             * @return {?}
             */
            function (validator) {
                /** @type {?} */
                var patterns = {
                    areCode: '^[0-9]{2,4}$',
                    phoneNumber: '^[0-9]{6,8}$'
                };
                /** @type {?} */
                var message = '';
                switch (validator.requiredPattern.toString()) {
                    case patterns.areCode:
                        message = 'El formato de área no es correcto (mínimo 2, máximo 4 dígitos).';
                        break;
                    case patterns.phoneNumber:
                        message = 'El formato de teléfono no es correcto (mínimo 6, máximo 8 dígitos).';
                        break;
                    default:
                        message = 'Formato Incorrecto';
                        break;
                }
                return message;
            }),
            totalmaxlength: 'Ambos campos no deben superar los 10 dígitos'
        };
    }
    /**
     * @return {?}
     */
    InsuredInfoEmisionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setFormGroup();
        if (this.contactData) {
            this.formGroup.patchValue(this.contactData);
        }
    };
    /**
     * @return {?}
     */
    InsuredInfoEmisionComponent.prototype.setFormGroup = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var formGroupObject = {
            'electronicDocuments': new FormControl(false),
            'email': new FormControl(null, [Validators.required, emailValidator]),
            'areaCode': new FormControl(null, [
                Validators.required,
                Validators.maxLength(4),
                Validators.pattern('[0-9]{2,4}')
            ]),
            'phoneNumber': new FormControl(null, [
                Validators.required,
                Validators.maxLength(8),
                Validators.pattern('[0-9]{6,8}')
            ])
        };
        if (this.showAddress) {
            formGroupObject = Object.assign({}, formGroupObject, {
                'street': new FormControl(''),
                'streetNumber': new FormControl(''),
                'floor': new FormControl(''),
                'department': new FormControl(''),
            });
        }
        this.formGroup = new FormGroup(formGroupObject);
    };
    /**
     * @return {?}
     */
    InsuredInfoEmisionComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        if (!this.showAddress) {
            if (this.formGroup.value.areaCode.startsWith('0')) {
                this.formGroup.get('areaCode').setValue(this.formGroup.value.areaCode.slice(1));
            }
            if (this.formGroup.value.phoneNumber.startsWith('15')) {
                this.formGroup.get('phoneNumber').setValue(this.formGroup.value.phoneNumber.slice(2));
            }
        }
        this.formCompleted.emit(this.formGroup.value);
    };
    /**
     * @param {?} control
     * @return {?}
     */
    InsuredInfoEmisionComponent.prototype.verifyEmailAsync = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        var _this = this;
        return timer(0)
            .pipe(debounce((/**
         * @return {?}
         */
        function () { return timer(2000); })), switchMap((/**
         * @return {?}
         */
        function () {
            return _this.http.get(_this.config.environment.server.api.dynamo + "/Contact/IsValidEmail?emailAddress=" + control.value);
        })), map$1((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            return response.data.isValid ? null : { emailInvalido: true };
        })));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    InsuredInfoEmisionComponent.prototype.handleElectronicDocumentsChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.formGroup.get('electronicDocuments').setValue(value);
    };
    InsuredInfoEmisionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-insured-info-emision',
                    template: "<div class=\"section-container\">\n  <sc-title content=\"Informaci\u00F3n del cliente\" type=\"h3\" [class.sc-color-grey-2]=\"!editMode\"></sc-title>\n  <p class=\"section-description\">\n    <ng-container *ngIf=\"showAddress\">Datos para el env\u00EDo de papeleria</ng-container>\n  </p>\n  <form [formGroup]=\"formGroup\" *ngIf=\"editMode\">\n    <div class=\"form-container\">\n      <ng-container *ngIf=\"showAddress\">\n        <div class=\"row\">\n          <div class=\"col-8\">\n            <sc-input label=\"Calle\" formControlName=\"street\" placeholder=\"Montevideo\"></sc-input>\n          </div>\n          <div class=\"col-4\">\n            <sc-input label=\"N\u00FAmero\" formControlName=\"streetNumber\" placeholder=\"1123\"></sc-input>\n          </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-4\">\n              <sc-input label=\"Piso\" formControlName=\"floor\" placeholder=\"Ej.: 3\"></sc-input>\n            </div>\n            <div class=\"col-4\">\n              <sc-input label=\"Dpto\" formControlName=\"department\" placeholder=\"Ej.: D\"></sc-input>\n            </div>\n        </div>\n      </ng-container>\n      <div class=\"row\">\n        <div class=\"col-8\">\n          <sc-input\n            formControlName=\"email\"\n            label=\"Email\"\n            placeholder=\"Escribe el email\"\n            [errorMessages]=\"errorMessages\"\n            [icon]=\"formGroup.get('email').pending ? 'loading' : (formGroup.get('email').valid) ? 'check' : null\"\n          ></sc-input>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"showElectronicDocuments\">\n        <div class=\"col-12\">\n          <sc-electronic-documents-adhesion\n            [adhered]=\"contactData.electronicDocuments\"\n            (change)=\"handleElectronicDocumentsChange($event)\">\n          </sc-electronic-documents-adhesion>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-8\">\n          <sc-phone\n            label=\"Tel\u00E9fono\"\n            formControlNameAreaCode=\"areaCode\"\n            formControlNamePhoneNumber=\"phoneNumber\"\n            areaCodePrefix=\"0\"\n            phoneNumberPrefix=\"15\"\n            placeholderAreaCode=\"341\"\n            placeholderPhoneNumber=\"5414180\"\n            [errorMessages]=\"errorMessages\"\n          ></sc-phone>\n        </div>\n      </div>\n      <div class=\"row\" *ngIf=\"showElectronicDocuments\">\n        <div class=\"col-12 electronic-documents-message\">\n          <sc-info-box>\n            Adhiriendo tu cliente a p\u00F3liza digital garantiz\u00E1s la entrega de la papeler\u00EDa en formato digital y sum\u00E1s puntos para el PIP.\n          </sc-info-box>\n        </div>\n      </div>\n    </div>\n    <div class=\"buttons-block\">\n      <sc-button (onClick)=\"onSubmit()\" [disabled]=\"formGroup.invalid || formGroup.get('email').pending\" id=\"insured-info-emission-next-step\">Siguiente</sc-button>\n    </div>\n  </form>\n  <div class=\"section-submitted-data\" *ngIf=\"!editMode\">\n    <div *ngIf=\"formGroup.value.email\">\n      <ng-container *ngIf=\"showAddress\">\n        <div>\n          Calle<br>\n          <strong>{{formGroup.value.street || '-'}}</strong>\n        </div>\n        <div>\n          Numero<br>\n          <strong>{{formGroup.value.streetNumber || '-'}}</strong>\n        </div>\n        <div>\n          Piso<br>\n          <strong>{{formGroup.value.floor || '-'}}</strong>\n        </div>\n        <div>\n          Departamento<br>\n          <strong>{{formGroup.value.department || '-'}}</strong>\n        </div>\n      </ng-container>\n      <div>\n        Email<br>\n        <strong>{{formGroup.value.email || '-'}}</strong>\n      </div>\n      <div>\n        C\u00F3d. \u00C1rea<br>\n        <strong>{{formGroup.value.areaCode || '-'}}</strong>\n      </div>\n      <div>\n        Tel\u00E9fono celular<br>\n        <strong>{{formGroup.value.phoneNumber || '-'}}</strong>\n      </div>\n    </div>\n</div>\n",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ".form-container{max-width:489px}p.section-description{margin-bottom:2.5rem}.buttons-block{margin-top:1.5rem}::ng-deep .icon-check{color:#3dcc98}.electronic-documents-message{margin:1rem 0 2rem}@media (max-width:768px){::ng-deep .sc-icon{margin-top:.2rem}}"]
                }] }
    ];
    /** @nocollapse */
    InsuredInfoEmisionComponent.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] }
    ]; };
    InsuredInfoEmisionComponent.propDecorators = {
        editMode: [{ type: Input }],
        contactData: [{ type: Input }],
        showAddress: [{ type: Input }],
        showElectronicDocuments: [{ type: Input }],
        formCompleted: [{ type: Output }]
    };
    return InsuredInfoEmisionComponent;
}());
if (false) {
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.editMode;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.contactData;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.showAddress;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.showElectronicDocuments;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.formCompleted;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.formGroup;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.errorMessages;
    /** @type {?} */
    InsuredInfoEmisionComponent.prototype.coreEmailValidation$;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoEmisionComponent.prototype.http;
    /**
     * @type {?}
     * @private
     */
    InsuredInfoEmisionComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/insured-info-emision/electronic-documents-adhesion/electronic-documents-adhesion.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ElectronicDocumentsAdhesionComponent = /** @class */ (function () {
    function ElectronicDocumentsAdhesionComponent() {
        var _this = this;
        this.change = new EventEmitter();
        this.formGroup = new FormGroup({
            adhered: new FormControl(null)
        });
        this.formGroup.valueChanges.subscribe((/**
         * @param {?} newValues
         * @return {?}
         */
        function (newValues) {
            _this.change.emit(newValues.adhered);
        }));
    }
    /**
     * @return {?}
     */
    ElectronicDocumentsAdhesionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.title = (this.adhered) ? 'El cliente se encuentra adherido a póliza digital' : 'Adherir cliente a póliza digital';
        this.formGroup.setValue({ adhered: true });
    };
    ElectronicDocumentsAdhesionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-electronic-documents-adhesion',
                    template: "<div class=\"electronic-documents-adhesion\">\n    <div class=\"electronic-documents-adhesion__wrapper\">\n        <form [formGroup]=\"formGroup\">\n            <sc-checkbox\n                class=\"checkbox\"\n                formControlName=\"adhered\"\n                [isReadOnly]=\"adhered\">\n                <span class=\"electronic-documents-adhesion__title\">\n                    {{ title }}\n                </span>\n            </sc-checkbox>\n        </form>\n        <p class=\"electronic-documents-adhesion__description\">\n            Asegurate que el email de tu cliente sea v\u00E1lido para que pueda recibir su p\u00F3liza.\n        </p>\n    </div>\n    <div *ngIf=\"formGroup.value.adhered === false\">\n        <sc-info-box class=\"error\">\n            <b>Si destild\u00E1s \"Adherir a p\u00F3liza digital\" tu cliente recibir\u00E1 la documentaci\u00F3n f\u00EDsica dentro de los pr\u00F3ximos 10 a 15 d\u00EDas.</b> \n        </sc-info-box>\n    </div>\n</div>",
                    styles: [":host{display:block;margin-bottom:1.5rem}:host .checkbox{display:block;margin-bottom:-.5rem}.electronic-documents-adhesion form{padding:0 .5rem;margin-right:.25rem;display:inline-block;vertical-align:top}.electronic-documents-adhesion__title{font-family:Roboto,sans-serif;font-weight:700;font-size:.875rem;line-height:1.5rem;color:#424f66;margin:0}.electronic-documents-adhesion__description{width:100%;color:#aeb7c8;font-size:.75rem;font-family:Roboto,sans-serif;font-weight:400;line-height:1.5rem;padding-left:2.5rem}.electronic-documents-adhesion sc-info-box{display:block;margin-bottom:3rem}"]
                }] }
    ];
    /** @nocollapse */
    ElectronicDocumentsAdhesionComponent.ctorParameters = function () { return []; };
    ElectronicDocumentsAdhesionComponent.propDecorators = {
        adhered: [{ type: Input }],
        change: [{ type: Output }]
    };
    return ElectronicDocumentsAdhesionComponent;
}());
if (false) {
    /** @type {?} */
    ElectronicDocumentsAdhesionComponent.prototype.adhered;
    /** @type {?} */
    ElectronicDocumentsAdhesionComponent.prototype.change;
    /** @type {?} */
    ElectronicDocumentsAdhesionComponent.prototype.title;
    /** @type {?} */
    ElectronicDocumentsAdhesionComponent.prototype.formGroup;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/insured-info-emision/insured-info-emision.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InsuredInfoEmisionModule = /** @class */ (function () {
    function InsuredInfoEmisionModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    InsuredInfoEmisionModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: InsuredInfoEmisionModule,
            providers: [
                {
                    provide: 'envConfig',
                    useValue: config
                }
            ]
        };
    };
    InsuredInfoEmisionModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TitleModule,
                        InputModule,
                        ButtonModule,
                        CheckboxModule,
                        PhoneModule,
                        InfoBoxModule
                    ],
                    declarations: [InsuredInfoEmisionComponent, ElectronicDocumentsAdhesionComponent],
                    exports: [InsuredInfoEmisionComponent, ElectronicDocumentsAdhesionComponent]
                },] }
    ];
    return InsuredInfoEmisionModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/payment-type-ids.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var PaymentTypeId = {
    Cash: "1",
    Credit: "2",
    Debit: "3",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/payment.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentService = /** @class */ (function () {
    function PaymentService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @return {?}
     */
    PaymentService.prototype.getCreditCardTypes = /**
     * @return {?}
     */
    function () {
        return this.http.get(this.config.environment.server.api.typeList + "/api/CreditCard")
            .pipe(map$1((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return response.data.items; })));
    };
    /**
     * @param {?} accountNumber
     * @param {?} policyPeriodId
     * @return {?}
     */
    PaymentService.prototype.getPaymentMethodsByUser = /**
     * @param {?} accountNumber
     * @param {?} policyPeriodId
     * @return {?}
     */
    function (accountNumber, policyPeriodId) {
        /** @type {?} */
        var url = this.config.environment.server.api.portalpas +
            ("/account/" + accountNumber + "/payment-instruments?policyPeriodId=" + policyPeriodId);
        return this.http.get(url)
            .pipe(map$1((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var paymentInstruments = _a.paymentInstruments;
            return paymentInstruments;
        })));
    };
    /**
     * @param {?} paymentInstruments
     * @return {?}
     */
    PaymentService.prototype.paymentInstrumentsMapper = /**
     * @param {?} paymentInstruments
     * @return {?}
     */
    function (paymentInstruments) {
        return paymentInstruments.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            /** @type {?} */
            var isCreditCard = item.paymentMethodKey === PaymentTypeId.Credit;
            return (/** @type {?} */ ({
                id: item.paymentInstrumentId,
                label: isCreditCard ? item.creditCardNumber : item.cbu,
                creditCardTypeKey: isCreditCard ? item.entity.code : null,
                creditCardTypeName: isCreditCard ? item.entity.description : null
            }));
        }));
    };
    PaymentService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PaymentService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] }
    ]; };
    return PaymentService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    PaymentService.prototype.config;
}
/**
 * @record
 */
function CreditCardResponse() { }
if (false) {
    /** @type {?} */
    CreditCardResponse.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-selector/payment-method-selector.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function paymentMethodSelectorValidator() {
    return (/**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var isValid = control && control.value && control.value.isValid;
        return isValid ? null : { invalid: true };
    });
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-info/send-coupons-by-options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var sendCouponsByOptions = [
    {
        key: 'email',
        value: 'Correo electrónico'
    },
    {
        key: 'mail',
        value: 'Correo postal'
    },
    {
        key: 'sms',
        value: 'SMS'
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-info/collector-options.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var collectorOptions = [
    {
        key: 'producer',
        value: 'Agente'
    },
    {
        key: 'direct',
        value: 'Directo'
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-methods.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var paymentMethodsConfig = [
    {
        paymentTypeId: '1',
        title: 'Efectivo / Cheque',
        icon: 'efetivo'
    },
    {
        paymentTypeId: '2',
        title: 'Tarjeta de crédito',
        icon: 'creditcard'
    },
    {
        paymentTypeId: '3',
        title: 'Débito en cuenta',
        icon: 'money-elipse'
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-methods-modal/payment-methods-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodsModalComponent = /** @class */ (function () {
    function PaymentMethodsModalComponent() {
        this.disableRecalculate = false;
        this.internalPaymentMethods = [];
        this.initialPaymentMethods = [];
        this.formGroup = new FormGroup({
            commercialDiscount: new FormControl(),
            paymentFee: new FormControl(),
            paymentMethod: new FormControl(null, Validators.required),
            paymentTypeId: new FormControl(null, Validators.required)
        });
        this.recalculate = new EventEmitter();
        this.applyChanges = new EventEmitter();
        this.cancelChanges = new EventEmitter();
        this.hasUnderWriting = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.partialLoading = false;
        this.setFormGroup();
        this.setUnderWritingMessage();
        this.paymentMethods$.subscribe((/**
         * @param {?} newValues
         * @return {?}
         */
        function (newValues) {
            newValues.forEach((/**
             * @param {?} method
             * @return {?}
             */
            function (method) {
                _this.setMethodUiValues(method);
            }));
            _this.internalPaymentMethods = JSON.parse(JSON.stringify(newValues));
            // En la 1era carga se setea la variable para reset
            if (!_this.initialPaymentMethods.length) {
                _this.setInitialPaymentMethods(_this.internalPaymentMethods);
            }
            if (_this.formGroup && _this.formGroup.get('paymentTypeId').value) {
                _this.formGroup.get('paymentMethod').setValue(_this.internalPaymentMethods.find((/**
                 * @param {?} p
                 * @return {?}
                 */
                function (p) { return p.paymentTypeId === _this.formGroup.get('paymentTypeId').value; })));
            }
            _this.partialLoading = false;
        }));
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.setFormGroup = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var formGroupConfig = {
            commercialDiscount: null,
            paymentFee: null,
            paymentMethod: null,
            // RadioButton solo reconoce typos nativos
            paymentTypeId: this.defaultPaymentTypeId
        };
        if (this.commercialDiscounts && !this.hideCommercialDiscount) {
            /** @type {?} */
            var defaultCommercialDiscount = this.commercialDiscounts.find((/**
             * @param {?} discount
             * @return {?}
             */
            function (discount) { return discount.key === _this.defaultCommercialDiscountId || discount.key === '0'; }));
            formGroupConfig.commercialDiscount = defaultCommercialDiscount;
            this.handlePremiumDiscountSelect(defaultCommercialDiscount);
        }
        if (this.feeOptions) {
            /** @type {?} */
            var defaultFee = this.feeOptions.find((/**
             * @param {?} feeAmout
             * @return {?}
             */
            function (feeAmout) { return Number(feeAmout.key) === Number(_this.defaultFeeKey); }))
                || this.feeOptions[0];
            formGroupConfig.paymentFee = defaultFee;
        }
        if (this.internalPaymentMethods.length) {
            /** @type {?} */
            var defaultPaymentMethod = this.internalPaymentMethods.find((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return p.paymentTypeId === _this.defaultPaymentTypeId; }));
            formGroupConfig.paymentMethod = defaultPaymentMethod;
        }
        this.formGroup.patchValue(formGroupConfig);
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.setUnderWritingMessage = /**
     * @return {?}
     */
    function () {
        this.underWritingMessage = "\n            Seleccionando un descuento mayor al " + Math.abs(this.premiumDiscountLimit) + "% deber\u00E1s pedir aprobaci\u00F3n al momento de emitir\n        ";
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.open = /**
     * @return {?}
     */
    function () {
        this.modal.open();
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.modal.close();
    };
    /**
     * @param {?} paymentMethods
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.setInitialPaymentMethods = /**
     * @param {?} paymentMethods
     * @return {?}
     */
    function (paymentMethods) {
        this.initialPaymentMethods = JSON.parse(JSON.stringify(paymentMethods));
    };
    /**
     * @param {?=} method
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.handleRecalculate = /**
     * @param {?=} method
     * @return {?}
     */
    function (method) {
        var _this = this;
        if (this.disableRecalculate) { // En vez de este atributo y el evento deberiamos usar una strategy de recalculo.
            return;
        }
        this.partialLoading = true;
        if (method) {
            method.loading = true;
        }
        else {
            this.internalPaymentMethods.map((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                item.finalAmount = null;
                item.totalAmount = null;
                item.quoteAmount = null;
                if (item.paymentTypeId === _this.formGroup.get('paymentMethod').value.paymentTypeId) {
                    item.loading = true;
                }
            }));
        }
        /** @type {?} */
        var fn = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var data = Object.assign({}, _this.formGroup.value);
            if (method) {
                data.recalculatePaymentMethod = method;
            }
            else {
                data.recalculatePaymentMethod = data.paymentMethod;
            }
            _this.recalculate.emit(data);
        });
        // El timeout es para obtener los valores de los selects ya actualizados
        setTimeout(fn, 0);
    };
    /**
     * @param {?} method
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.handlePaymentMethodSelected = /**
     * @param {?} method
     * @return {?}
     */
    function (method) {
        this.formGroup.get('paymentMethod').setValue(method);
        if (!method.finalAmount) {
            this.handleRecalculate(method);
        }
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.handleApplyChanges = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var paymentDataResponse = {
            commercialDiscount: this.formGroup.get('commercialDiscount').value,
            paymentFee: this.formGroup.get('paymentFee').value,
            paymentMethod: __assign({}, this.formGroup.get('paymentMethod').value, { quoteNro: this.formGroup.get('paymentFee').value.key })
        };
        this.applyChanges.emit(paymentDataResponse);
        this.close();
    };
    /**
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.handleCancelChanges = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var paymentDataResponse = {
            commercialDiscount: this.formGroup.get('commercialDiscount').value,
            paymentFee: this.formGroup.get('paymentFee').value,
            paymentMethod: __assign({}, this.formGroup.get('paymentMethod').value, { quoteNro: this.formGroup.get('paymentFee').value.key })
        };
        this.setFormGroup();
        this.internalPaymentMethods = JSON.parse(JSON.stringify(this.initialPaymentMethods));
        this.cancelChanges.emit(paymentDataResponse);
        this.close();
    };
    /**
     * @private
     * @param {?} method
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.setMethodUiValues = /**
     * @private
     * @param {?} method
     * @return {?}
     */
    function (method) {
        /** @type {?} */
        var config = paymentMethodsConfig.find((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.paymentTypeId === method.paymentTypeId; }));
        method.title = config.title;
        method.icon = config.icon;
    };
    /**
     * @param {?} discount
     * @return {?}
     */
    PaymentMethodsModalComponent.prototype.handlePremiumDiscountSelect = /**
     * @param {?} discount
     * @return {?}
     */
    function (discount) {
        if (this.premiumDiscountLimit) {
            this.hasUnderWritingFlag = (Number(discount.key) < this.premiumDiscountLimit) && !this.hasAffinityGroupSelected;
            this.hasUnderWriting.emit(this.hasUnderWritingFlag);
        }
        this.handleRecalculate();
    };
    PaymentMethodsModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-methods-modal',
                    template: "<sc-modal class=\"payment-methods-modal\" #modal [closeButton]=\"false\">\n\t<div class=\"modal__container\" *ngIf=\"!loading\">\n\t\t<div class=\"title\"><sc-title content=\"Tarifas y formas de pago\" type=\"h3\"></sc-title></div>\n\t\t<form [formGroup]=\"formGroup\">\n\t\t\t<div class=\"modal__comercial-alternative\" *ngIf=\"!hideCommercialDiscount && commercialDiscounts\">\n\t\t\t\t<sc-select\n\t\t\t\t\tformControlName=\"commercialDiscount\"\n\t\t\t\t\tlabel=\"Alternativa comercial\"\n\t\t\t\t\tobjectValue=\"name\"\n\t\t\t\t\t[items]=\"commercialDiscounts\"\n\t\t\t\t\t[hideError]=\"true\"\n\t\t\t\t\t[isDisabled]=\"partialLoading\"\n\t\t\t\t\t(optionSelected)=\"handlePremiumDiscountSelect($event)\"\n\t\t\t\t></sc-select>\n\t\t\t\t<div class=\"under-writing-indicator\" *ngIf=\"premiumDiscountLimit && hasUnderWritingFlag\">\n\t\t\t\t\t<sc-info-box icon=\"alert-elipse-copy\" class=\"under-writing\">\n\t\t\t\t\t\t{{ underWritingMessage }}\n\t\t\t\t\t</sc-info-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"modal__fees\">\n\t\t\t\t<sc-select\n\t\t\t\t\tformControlName=\"paymentFee\"\n\t\t\t\t\tlabel=\"Cuotas\"\n\t\t\t\t\t[items]=\"feeOptions\"\n\t\t\t\t\t[isDisabled]=\"partialLoading\"\n\t\t\t\t\t[hideError]=\"true\"\n\t\t\t\t\t(optionSelected)=\"handleRecalculate()\"\n\t\t\t\t></sc-select>\n\t\t\t</div>\n\t\t\t<div class=\"modal__payment-method-selection\">\n\t\t\t\t<span>Formas de pago</span>\n\t\t\t\t<div class=\"payment-method-selection\">\n\t\t\t\t\t<sc-radio-group formControlName=\"paymentTypeId\" [isReadOnly]=\"partialLoading\">\n\t\t\t\t\t\t<div class=\"payment-method-selection__item\" *ngFor=\"let method of internalPaymentMethods\">\n\t\t\t\t\t\t\t<sc-radio-item [value]=\"method.paymentTypeId\" (check)=\"handlePaymentMethodSelected(method)\">\n\t\t\t\t\t\t\t\t<span class=\"payment-method-selection__item-text\">{{ method.title }}</span>\n\t\t\t\t\t\t\t</sc-radio-item>\n\t\t\t\t\t\t\t<span class=\"total-cost\" *ngIf=\"!method.loading && method.finalAmount && !method.hideAmount\">\n\t\t\t\t\t\t\t\t{{ (method.finalAmount / formGroup.get('paymentFee').value.key) | scCurrency }}\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<sc-button \n\t\t\t\t\t\t\t\t*ngIf=\"!method.loading && !method.finalAmount && !method.hideAmount\" \n\t\t\t\t\t\t\t\ttype=\"link\" \n\t\t\t\t\t\t\t\t[disabled]=\"partialLoading\"\n\t\t\t\t\t\t\t\t(onClick)=\"handleRecalculate(method)\">\n\t\t\t\t\t\t\t\tCalcular\n\t\t\t\t\t\t\t</sc-button>\n\t\t\t\t\t\t\t<sc-icon icon=\"loading\" *ngIf=\"method.loading\"></sc-icon>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</sc-radio-group>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"modal__submit-block\">\n\t\t\t\t<sc-button (onClick)=\"handleApplyChanges()\" [disabled]=\"formGroup.invalid || partialLoading\" id=\"payment-method-modal-aplicar\">Aplicar</sc-button>\n\t\t\t\t<sc-button (onClick)=\"handleCancelChanges()\" type=\"secondary\" [disabled]=\"formGroup.invalid || partialLoading\" id=\"payment-method-modal-cancelar\">Cancelar</sc-button>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div *ngIf=\"loading\">\n\t\t<sc-icon icon=\"loading\"></sc-icon>\n\t</div>\n</sc-modal>\n",
                    styles: [".payment-methods-modal .title{margin:20px 0 30px}.payment-methods-modal .modal__container{margin:0 17px}.payment-methods-modal .modal__container .modal__comercial-alternative{padding-bottom:1rem}.payment-methods-modal .modal__container .under-writing-indicator{margin-top:2rem;width:24rem;border-radius:3px;overflow:hidden}.payment-methods-modal .modal__fees{max-width:100px}.payment-methods-modal .modal__payment-method-selection{font-family:Roboto,sans-serif;font-size:14px;margin-bottom:1.5rem}.payment-methods-modal .modal__payment-method-selection .payment-method-selection{border:2px solid #ccd2dd;border-radius:2px}.payment-methods-modal .modal__payment-method-selection .payment-method-selection__item{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;border-bottom:1px solid #ccd2dd;padding:8px 16px}.payment-methods-modal .modal__payment-method-selection .payment-method-selection__item-text{font-size:14px}.payment-methods-modal .modal__payment-method-selection .payment-method-selection__item:last-child{border-bottom:0}.payment-methods-modal .modal__payment-method-selection .payment-method-selection__item .total-cost{font-weight:700}.payment-methods-modal .modal__submit-block{display:-webkit-box;display:flex;justify-content:space-around;margin-bottom:25px}.payment-methods-modal::ng-deep .sc-modal__body,.payment-methods-modal::ng-deep .sc-modal__header-wrapper{padding:0 1rem}"]
                }] }
    ];
    /** @nocollapse */
    PaymentMethodsModalComponent.ctorParameters = function () { return []; };
    PaymentMethodsModalComponent.propDecorators = {
        commercialDiscounts: [{ type: Input }],
        feeOptions: [{ type: Input }],
        paymentMethods$: [{ type: Input }],
        defaultCommercialDiscountId: [{ type: Input }],
        defaultFeeKey: [{ type: Input }],
        defaultPaymentTypeId: [{ type: Input }],
        hideCommercialDiscount: [{ type: Input }],
        disableRecalculate: [{ type: Input }],
        premiumDiscountLimit: [{ type: Input }],
        hasAffinityGroupSelected: [{ type: Input }],
        recalculate: [{ type: Output }],
        applyChanges: [{ type: Output }],
        cancelChanges: [{ type: Output }],
        hasUnderWriting: [{ type: Output }],
        modal: [{ type: ViewChild, args: ['modal', { static: true },] }]
    };
    return PaymentMethodsModalComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.commercialDiscounts;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.feeOptions;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.paymentMethods$;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.defaultCommercialDiscountId;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.defaultFeeKey;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.defaultPaymentTypeId;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.hideCommercialDiscount;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.disableRecalculate;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.premiumDiscountLimit;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.hasAffinityGroupSelected;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.recalculate;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.applyChanges;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.cancelChanges;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.hasUnderWriting;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.modal;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.formGroup;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.loading;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.internalPaymentMethods;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.initialPaymentMethods;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.partialLoading;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.hasUnderWritingFlag;
    /** @type {?} */
    PaymentMethodsModalComponent.prototype.underWritingMessage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/type-list.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TypeListService = /** @class */ (function () {
    function TypeListService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @param {?} type
     * @param {?} number
     * @return {?}
     */
    TypeListService.prototype.validateCreditCard = /**
     * @param {?} type
     * @param {?} number
     * @return {?}
     */
    function (type, number) {
        return this.validatePaymentMethod((/** @type {?} */ ({
            PaymentMethodKey: '02',
            CreditCardNumber: number,
            CreditCardTypeKey: type,
        })));
    };
    /**
     * @param {?} cbu
     * @return {?}
     */
    TypeListService.prototype.validateCBU = /**
     * @param {?} cbu
     * @return {?}
     */
    function (cbu) {
        return this.validatePaymentMethod((/** @type {?} */ ({
            PaymentMethodKey: '03',
            CBU: cbu
        })));
    };
    /**
     * @param {?} data
     * @return {?}
     */
    TypeListService.prototype.validatePaymentMethod = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.post(this.config.environment.server.api.typeList + "/api/PaymentMethods/Validate", data);
    };
    /**
     * @param {?} postalCode
     * @param {?=} countryCode
     * @return {?}
     */
    TypeListService.prototype.getCitiesByPostalCode = /**
     * @param {?} postalCode
     * @param {?=} countryCode
     * @return {?}
     */
    function (postalCode, countryCode) {
        if (countryCode === void 0) { countryCode = 'ar'; }
        /** @type {?} */
        var baseUrl = this.config.environment.server.api.portalpasProxy;
        return this.http.get(baseUrl + "/policycenter-typelist/api/Locations/cities-by-postal-code?countryCode=" + countryCode + "&postalCode=" + postalCode);
    };
    TypeListService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TypeListService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: ['envConfig',] }] }
    ]; };
    return TypeListService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TypeListService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    TypeListService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/credit-card-async.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CreditCardAsyncValidator = /** @class */ (function () {
    function CreditCardAsyncValidator(service) {
        this.service = service;
    }
    /**
     * @param {?} creditCardTypeControl
     * @return {?}
     */
    CreditCardAsyncValidator.prototype.create = /**
     * @param {?} creditCardTypeControl
     * @return {?}
     */
    function (creditCardTypeControl) {
        var _this = this;
        /** @type {?} */
        var validator = (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            /** @type {?} */
            var creditCardType = creditCardTypeControl && creditCardTypeControl.value && creditCardTypeControl.value.key;
            if (!/[0-9]+/.test(control.value)) {
                return of({ required: true });
            }
            return of(null)
                .pipe(map((/**
             * @return {?}
             */
            function () { return control.value && control.value.length === _this.getValidLength(creditCardType); })), switchMap$1((/**
             * @param {?} lengthOk
             * @return {?}
             */
            function (lengthOk) {
                return lengthOk
                    ? _this.service.validateCreditCard(creditCardType, control.value)
                        .pipe(map((/**
                     * @param {?} response
                     * @return {?}
                     */
                    function (response) { return _this.handleValidateResponse(response); })))
                    : of({ minlength: true });
            })), catchError$1((/**
             * @param {?} error
             * @return {?}
             */
            function (error) { return of(null); })));
        });
        return validator;
    };
    /**
     * @param {?} code
     * @return {?}
     */
    CreditCardAsyncValidator.prototype.getValidLength = /**
     * @param {?} code
     * @return {?}
     */
    function (code) {
        /** @type {?} */
        var americanExpress = 'default_data:10001';
        /** @type {?} */
        var favaCard = 'bc:1001';
        /** @type {?} */
        var validLength;
        switch (code) {
            case americanExpress:
                validLength = 15;
                break;
            case favaCard:
                validLength = 18;
                break;
            default:
                validLength = 16;
                break;
        }
        return validLength;
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    CreditCardAsyncValidator.prototype.handleValidateResponse = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        return response.data.isValid ? null : { invalid: true };
    };
    CreditCardAsyncValidator.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CreditCardAsyncValidator.ctorParameters = function () { return [
        { type: TypeListService }
    ]; };
    return CreditCardAsyncValidator;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CreditCardAsyncValidator.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/direct-debit-async.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DirectDebitAsyncValidator = /** @class */ (function () {
    function DirectDebitAsyncValidator(service) {
        this.service = service;
    }
    /**
     * @return {?}
     */
    DirectDebitAsyncValidator.prototype.create = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var validator = (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (!control.value) {
                return of({ required: true });
            }
            return of(null)
                .pipe(map((/**
             * @return {?}
             */
            function () { return control.value && control.value.length === 22; })), switchMap$1((/**
             * @param {?} lengthOk
             * @return {?}
             */
            function (lengthOk) {
                return lengthOk
                    ? _this.service.validateCBU(control.value)
                        .pipe(map((/**
                     * @param {?} response
                     * @return {?}
                     */
                    function (response) { return _this.handleValidateResponse(response); })))
                    : of({ minlength: true });
            })), catchError$1((/**
             * @param {?} error
             * @return {?}
             */
            function (error) { return of(null); })));
        });
        return validator;
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    DirectDebitAsyncValidator.prototype.handleValidateResponse = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        return response.data.isValid ? null : { invalid: true };
    };
    DirectDebitAsyncValidator.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    DirectDebitAsyncValidator.ctorParameters = function () { return [
        { type: TypeListService }
    ]; };
    return DirectDebitAsyncValidator;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DirectDebitAsyncValidator.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-info/payment-info.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentInfoComponent = /** @class */ (function () {
    function PaymentInfoComponent(paymentService, creditCardValidator, directDebitValidator) {
        this.paymentService = paymentService;
        this.creditCardValidator = creditCardValidator;
        this.directDebitValidator = directDebitValidator;
        this.canContinue = true;
        this.hasElectronicDocument = false;
        this.recalculate = new EventEmitter();
        this.applyModal = new EventEmitter();
        this.cancelModal = new EventEmitter();
        this.formCompleted = new EventEmitter();
        this.creditCardTypes$ = new AsyncSubject();
        this.paymentMethodsModal$ = new BehaviorSubject$1([]);
        this.errorMessages = {
            invalid: 'Número inválido',
            minlength: 'Cantidad de caracteres incorrecto'
        };
        this.collectorReadonly = true;
        this.loadingPaymentMethodsByUser = true;
        this.paymentTypeId = PaymentTypeId;
        this.sendCouponsByOptions = sendCouponsByOptions;
        this.collectorOptions = collectorOptions;
        this.buildForm();
    }
    /**
     * @return {?}
     */
    PaymentInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.getCreditCardTypes();
        this.paymentMethods$.subscribe((/**
         * @param {?} items
         * @return {?}
         */
        function (items) {
            items.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                item.quoteNro = item.quoteNro || _this.defaultFeeKey;
            }));
            _this.paymentMethodsModal$.next(items.slice());
            /** @type {?} */
            var paymentMethod = Object.assign({}, items.find((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return p.paymentTypeId === _this.defaultPaymentTypeId; })));
            _this.formGroup.get('paymentMethod').setValue(paymentMethod);
        }));
        this.getPaymentMethodsByUser();
        if (this.hasElectronicDocument) {
            this.sendCouponsByOptions = sendCouponsByOptions.filter((/**
             * @param {?} option
             * @return {?}
             */
            function (option) { return option.key !== 'mail'; }));
        }
    };
    /**
     * @return {?}
     */
    PaymentInfoComponent.prototype.getPaymentMethodsByUser = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.paymentMethodsByUser && this.accountNumber && this.policyPeriodId) {
            this.paymentService.getPaymentMethodsByUser(this.accountNumber, this.policyPeriodId)
                .subscribe((/**
             * @param {?} paymentInstruments
             * @return {?}
             */
            function (paymentInstruments) {
                _this.paymentMethodsByUser = _this.paymentService.paymentInstrumentsMapper(paymentInstruments);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                _this.paymentMethodsByUser = [];
            })).add((/**
             * @return {?}
             */
            function () {
                _this.cbuOptions = _this.paymentMethodsByUser.filter((/**
                 * @param {?} option
                 * @return {?}
                 */
                function (option) { return !option.creditCardTypeKey; }));
                _this.creditCardOptions = _this.paymentMethodsByUser.filter((/**
                 * @param {?} option
                 * @return {?}
                 */
                function (option) { return option.creditCardTypeKey && option.creditCardTypeKey.length; }));
                _this.updateFormValidators();
                _this.loadingPaymentMethodsByUser = false;
            }));
        }
        else {
            this.loadingPaymentMethodsByUser = false;
            this.cbuOptions = [];
            this.creditCardOptions = [];
        }
    };
    /**
     * @private
     * @return {?}
     */
    PaymentInfoComponent.prototype.buildForm = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = new FormGroup({
            'paymentMethod': new FormControl(null),
            'paymentMethodByUser': new FormControl(null),
            'collector': new FormControl(collectorOptions.find((/**
             * @param {?} i
             * @return {?}
             */
            function (i) { return i.key === 'direct'; }))),
            'sendCouponsBy': new FormControl(this.sendCouponsByOptions.find((/**
             * @param {?} i
             * @return {?}
             */
            function (i) { return i.key === 'email'; }))),
            'cbuNumber': new FormControl(null),
            'creditCardType': new FormControl(null),
            'creditCardNumber': new FormControl(null)
        });
        this.selectedPaymentMethod = this.formGroup.get('paymentMethod');
        this.formGroup.get('paymentMethod').valueChanges
            .pipe(distinctUntilChanged((/**
         * @param {?} prev
         * @param {?} curr
         * @return {?}
         */
        function (prev, curr) { return isEqual(prev, curr); })))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.updateFormValidators();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    PaymentInfoComponent.prototype.updateFormValidators = /**
     * @private
     * @return {?}
     */
    function () {
        var e_1, _a;
        if (this.formGroup) {
            if (this.selectedPaymentMethod.value.paymentTypeId) {
                this.updateCollectorStatus(this.selectedPaymentMethod.value.paymentTypeId);
                switch (this.selectedPaymentMethod.value.paymentTypeId) {
                    case PaymentTypeId.Credit:
                        this.setCreditMethodValidators();
                        break;
                    case PaymentTypeId.Debit:
                        this.setDebitMethodValidators();
                        break;
                    default:
                        this.formGroup.get('cbuNumber').setValidators(null);
                        this.formGroup.get('cbuNumber').setAsyncValidators(null);
                        this.formGroup.get('creditCardNumber').setValidators(null);
                        this.formGroup.get('creditCardNumber').setAsyncValidators(null);
                        this.formGroup.get('paymentMethodByUser').setValidators(null);
                        break;
                }
                /** @type {?} */
                var field = void 0;
                try {
                    for (var _b = __values(Object.keys(this.formGroup.value)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        field = _c.value;
                        if (field !== 'paymentMethod') {
                            this.formGroup.controls[field].updateValueAndValidity();
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    PaymentInfoComponent.prototype.setDebitMethodValidators = /**
     * @private
     * @return {?}
     */
    function () {
        this.formGroup.get('creditCardNumber').setValidators(null);
        this.formGroup.get('creditCardNumber').setAsyncValidators(null);
        if (this.cbuOptions && this.cbuOptions.length) {
            this.formGroup.get('cbuNumber').setValidators(null);
            this.formGroup.get('cbuNumber').setAsyncValidators(null);
            this.formGroup.get('paymentMethodByUser').setValidators(paymentMethodSelectorValidator());
        }
        else {
            this.formGroup.get('cbuNumber').setValidators([Validators.required, Validators.minLength(22)]);
            this.formGroup.get('cbuNumber').setAsyncValidators(this.directDebitValidator.create());
            this.formGroup.get('paymentMethodByUser').setValidators(null);
        }
    };
    /**
     * @private
     * @return {?}
     */
    PaymentInfoComponent.prototype.setCreditMethodValidators = /**
     * @private
     * @return {?}
     */
    function () {
        this.formGroup.get('cbuNumber').setValidators(null);
        this.formGroup.get('cbuNumber').setAsyncValidators(null);
        if (this.creditCardOptions && this.creditCardOptions.length) {
            this.formGroup.get('creditCardNumber').setValidators(null);
            this.formGroup.get('creditCardNumber').setAsyncValidators(null);
            this.formGroup.get('paymentMethodByUser').setValidators(paymentMethodSelectorValidator());
        }
        else {
            this.formGroup.get('creditCardNumber').setValidators([Validators.required, Validators.minLength(15)]);
            this.formGroup.get('creditCardNumber')
                .setAsyncValidators(this.creditCardValidator.create(this.formGroup.get('creditCardType')));
            this.formGroup.get('paymentMethodByUser').setValidators(null);
        }
    };
    /**
     * @param {?} control
     * @return {?}
     */
    PaymentInfoComponent.prototype.setNumberFieldIcon = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var icon = null;
        if (!control.pristine) {
            icon = control.pending ? 'loading' : (control.valid ? 'check' : null);
        }
        return icon;
    };
    /**
     * @return {?}
     */
    PaymentInfoComponent.prototype.getCreditCardTypes = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.paymentService.getCreditCardTypes().subscribe((/**
         * @param {?} items
         * @return {?}
         */
        function (items) {
            _this.creditCardTypes = items;
            _this.creditCardTypes$.next(items);
            _this.creditCardTypes$.complete();
        }));
    };
    /**
     * @param {?} type
     * @return {?}
     */
    PaymentInfoComponent.prototype.updateCollectorStatus = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        switch (type) {
            case PaymentTypeId.Cash:
                this.collectorReadonly = false;
                break;
            case PaymentTypeId.Credit:
            case PaymentTypeId.Debit:
                this.formGroup.get('collector').setValue(collectorOptions.find((/**
                 * @param {?} i
                 * @return {?}
                 */
                function (i) { return i.key === 'direct'; })));
                this.collectorReadonly = true;
                break;
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    PaymentInfoComponent.prototype.onlyNumbers = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.target.value = e.target.value.replace(/[^0-9]/gi, '');
    };
    /**
     * @return {?}
     */
    PaymentInfoComponent.prototype.handleShowModal = /**
     * @return {?}
     */
    function () {
        this.modalElement.open();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    PaymentInfoComponent.prototype.handleRecalculate = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.recalculate.emit(data);
    };
    /**
     * @param {?} modalData
     * @return {?}
     */
    PaymentInfoComponent.prototype.handleApplyModalChanges = /**
     * @param {?} modalData
     * @return {?}
     */
    function (modalData) {
        this.formGroup.get('paymentMethod').setValue(modalData.paymentMethod);
        this.applyModal.emit(modalData);
    };
    /**
     * @param {?} modalData
     * @return {?}
     */
    PaymentInfoComponent.prototype.handleCancelModalChanges = /**
     * @param {?} modalData
     * @return {?}
     */
    function (modalData) {
        this.cancelModal.emit(modalData);
    };
    /**
     * @return {?}
     */
    PaymentInfoComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var formData = JSON.parse(JSON.stringify(this.formGroup.value));
        /** @type {?} */
        var paymentMethodByUser = this.formGroup.controls.paymentMethodByUser.value;
        if (paymentMethodByUser) {
            formData.paymentInstrumentId = paymentMethodByUser.id;
            switch (formData.paymentMethod.paymentTypeId) {
                case PaymentTypeId.Debit:
                    formData.cbuNumber = paymentMethodByUser.number;
                    formData.creditCardNumber = null;
                    formData.creditCardType = null;
                    break;
                case PaymentTypeId.Credit:
                    formData.cbuNumber = null;
                    formData.creditCardNumber = paymentMethodByUser.number;
                    formData.creditCardType = {
                        key: paymentMethodByUser.creditCardTypeKey,
                        name: paymentMethodByUser.creditCardTypeName
                    };
                    break;
                default:
                    formData.cbuNumber = null;
                    formData.creditCardNumber = null;
                    formData.creditCardType = null;
                    formData.paymentInstrumentId = null;
                    break;
            }
        }
        else {
            formData.paymentInstrumentId = null;
        }
        delete formData.paymentMethodByUser;
        this.formCompleted.emit((/** @type {?} */ (formData)));
    };
    /**
     * @param {?} paymentMethods
     * @return {?}
     */
    PaymentInfoComponent.prototype.setInitialPaymentMethods = /**
     * @param {?} paymentMethods
     * @return {?}
     */
    function (paymentMethods) {
        var _this = this;
        this.selectedPaymentMethod.setValue(paymentMethods.find((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.paymentTypeId === _this.selectedPaymentMethod.value.paymentTypeId; })));
        this.modalElement.setInitialPaymentMethods(paymentMethods);
    };
    /**
     * @param {?} cardTypecode
     * @return {?}
     */
    PaymentInfoComponent.prototype.getCreditCardValidLength = /**
     * @param {?} cardTypecode
     * @return {?}
     */
    function (cardTypecode) {
        return this.creditCardValidator.getValidLength(cardTypecode);
    };
    PaymentInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-info',
                    template: "<div class=\"section-container\">\n    <sc-title content=\"Forma de pago\" type=\"h3\" [class.sc-color-grey-2]=\"!editMode\"></sc-title>\n    <ng-container *ngIf=\"editMode\">\n        <form [formGroup]=\"formGroup\" *ngIf=\"formGroup && selectedPaymentMethod.value; else loadingTemplate\">\n            <div class=\"fields-block\">\n                <div class=\"row payment-method-selector\" *ngIf=\"selectedPaymentMethod.value\">\n                    <sc-payment-method-confirm\n                        [loading]=\"loading || loadingPaymentMethodsByUser\"\n                        [disabled]=\"loadingPaymentMethodsByUser\"\n                        [paymentFee]=\"selectedPaymentMethod.value.quoteNro\"\n                        [paymentTypeId]=\"selectedPaymentMethod.value.paymentTypeId\"\n                        [finalAmount]=\"selectedPaymentMethod.value.finalAmount\"\n                        (changeMethodClicked)=\"handleShowModal()\"></sc-payment-method-confirm>\n                </div>\n                <!-- D\u00E9bito -->\n                <div class=\"row\" *ngIf=\"selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Debit\">\n                    <ng-container *ngIf=\"!loadingPaymentMethodsByUser\">\n                        <div class=\"col-12\" *ngIf=\"cbuOptions?.length > 0\">\n                            <sc-payment-method-selector\n                                formControlName=\"paymentMethodByUser\"\n                                [type]=\"'cbu'\"\n                                [options]=\"cbuOptions\"></sc-payment-method-selector>\n                        </div>\n                        <div class=\"col-md-6 col-12\" *ngIf=\"cbuOptions?.length === 0\">\n                            <sc-input\n                                label=\"CBU\"\n                                formControlName=\"cbuNumber\"\n                                placeholder=\"1234567890123456789012\"\n                                maxlength=\"22\"\n                                [errorMessages]=\"errorMessages\"\n                                [icon]=\"setNumberFieldIcon(formGroup.get('cbuNumber'))\"\n                                (input)=\"onlyNumbers($event)\">\n                            </sc-input>\n                        </div>\n                    </ng-container>\n                </div>\n                <!-- Tarjeta de Cr\u00E9dito -->\n                <div class=\"row\" *ngIf=\"selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Credit\">\n                    <ng-container *ngIf=\"!loadingPaymentMethodsByUser && creditCardTypes?.length\">\n                        <div class=\"col-12\" *ngIf=\"creditCardOptions?.length > 0\">\n                            <sc-payment-method-selector\n                                formControlName=\"paymentMethodByUser\"\n                                [type]=\"'credit'\"\n                                [creditCardTypeOptions]=\"creditCardTypes\"\n                                [options]=\"creditCardOptions\">\n                            </sc-payment-method-selector>\n                        </div>\n                        <ng-container *ngIf=\"creditCardOptions?.length === 0\">\n                            <div class=\"col-md-6 col-12\">\n                                <sc-select\n                                    label=\"Selecciona la tarjeta\"\n                                    formControlName=\"creditCardType\"\n                                    placeholder=\"---\"\n                                    objectValue=\"name\"\n                                    [itemsAsync$]=\"creditCardTypes$\"\n                                    (optionSelected)=\"formGroup.get('creditCardNumber').setValue(null)\"></sc-select>\n                            </div>\n                            <div class=\"col-md-6 col-12\">\n                                <sc-input label=\"N\u00FAmero de tarjeta\"\n                                    formControlName=\"creditCardNumber\"\n                                    placeholder=\"2000 3000 4000 5000\"\n                                    [isDisabled]=\"!formGroup.get('creditCardType').value\"\n                                    [errorMessages]=\"errorMessages\"\n                                    [maxlength]=\"getCreditCardValidLength(formGroup.get('creditCardType').value?.key)\"\n                                    [icon]=\"setNumberFieldIcon(formGroup.get('creditCardNumber'))\"\n                                    (input)=\"onlyNumbers($event)\"></sc-input>\n                            </div>\n                        </ng-container>\n                    </ng-container>\n                </div>\n                <!-- Cobradores -->\n                <div class=\"row\">\n                    <div class=\"col-md-6 col-12\"\n                        [ngStyle]=\"(selectedPaymentMethod.value.paymentTypeId !== paymentTypeId.Cash) ? {'display': 'none'} : null\">\n                        <sc-select\n                            label=\"Cobrador\"\n                            formControlName=\"collector\"\n                            [items]=\"collectorOptions\"\n                            [isReadonly]=\"collectorReadonly\"\n                            [isDisabled]=\"loading\"></sc-select>\n                    </div>\n                    <div class=\"col-md-6 col-12\" *ngIf=\"selectedPaymentMethod.value.paymentTypeId === paymentTypeId.Cash\">\n                        <sc-select\n                            label=\"Env\u00EDo de cupones\"\n                            formControlName=\"sendCouponsBy\"\n                            [items]=\"sendCouponsByOptions\"\n                            [isDisabled]=\"loading\"></sc-select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons-block\">\n                <sc-button (onClick)=\"onSubmit()\" [disabled]=\"loading || !canContinue || !formGroup.valid\" id=\"payment-method-to-emit\">Emitir</sc-button>\n            </div>\n        </form>\n    </ng-container>\n    <ng-container *ngIf=\"!editMode\">\n        <div class=\"section-submitted-data\">\n            <div>\n                <div>\n                    <span>Forma de pago</span><br>\n                    <strong>{{ selectedPaymentMethod.value.title }}</strong>\n                </div>\n                <div>\n                    <span>Cuotas</span><br>\n                    <strong>{{ selectedPaymentMethod.value.quoteNro }}</strong>\n                </div>\n            </div>\n        </div>\n    </ng-container>\n    <ng-template #loadingTemplate>\n        <div class=\"loading-block\">\n            <sc-icon icon=\"loading\" size=\"2\"></sc-icon>\n        </div>\n    </ng-template>\n    <sc-payment-methods-modal #modalElement\n        [paymentMethods$]=\"paymentMethods$\"\n        [feeOptions]=\"feeOptions\"\n        [defaultPaymentTypeId]=\"selectedPaymentMethod.value.paymentTypeId\"\n        [defaultFeeKey]=\"selectedPaymentMethod.value.quoteNro\"\n        [defaultCommercialDiscountId]=\"defaultCommercialDiscountId\"\n        [hideCommercialDiscount]=\"true\"\n        (recalculate)=\"handleRecalculate($event)\"\n        (applyChanges)=\"handleApplyModalChanges($event)\"\n        (cancelChanges)=\"handleCancelModalChanges($event)\"></sc-payment-methods-modal>\n</div>",
                    styles: [".section-subtitle{color:#aeb7c8;font-family:Roboto,\"Open Sans\",sans-serif;font-size:14px;line-height:24px;margin:.25rem 0 0}.fields-block{padding:2rem 0;max-width:470px}.buttons-block{padding:0}.section-submitted-data{padding-top:1.5rem;color:#8993a4;font-size:.875rem;line-height:1.5rem}.section-submitted-data>div{max-width:500px}.section-submitted-data>div>div{margin-bottom:1rem;display:inline-block;vertical-align:top;padding-right:2rem}", ":host{display:block}.fields-block{max-width:500px}::ng-deep .icon-check{color:#3dcc98}.loading-block{width:100%;text-align:center;padding:1rem 0}.payment-method-selector{padding:1rem 1rem 2rem}.payment-method-selector sc-card{width:156px;margin-bottom:1rem;position:relative}.payment-method-selector sc-card:nth-child(2){margin-left:1rem;margin-right:1rem}.payment-method-selector sc-card .mejor-opcion{position:absolute;display:block;color:#fff;text-transform:uppercase;font-size:10px;line-height:11px;text-align:center;-webkit-transform:rotate(38.28deg);transform:rotate(38.28deg);border-left:32px solid transparent;border-bottom:25px solid #424f66;border-right:19px solid transparent;top:8px;right:-28px;padding-right:4px;font-weight:700}.payment-method-selector sc-card .mejor-opcion span{display:block;margin:11px auto -18px}.payment-method-selector sc-card .mejor-opcion::after,.payment-method-selector sc-card .mejor-opcion::before{content:\"\";display:block;position:absolute;-webkit-transform:rotate(-38.28deg);transform:rotate(-38.28deg)}.payment-method-selector sc-card .mejor-opcion::before{bottom:-28px;left:-31px;border-top:6px solid transparent;border-left:8px solid #383f4b}.payment-method-selector sc-card .mejor-opcion::after{bottom:-27px;right:-18px;border-top:4px solid transparent;border-left:5px solid #383f4b}::ng-deep .sc-card__description p{margin-bottom:0}::ng-deep .sc-card__description p span{display:block}@media (max-width:768px){::ng-deep .sc-icon{margin-top:.2rem}.payment-method-selector sc-card{width:100%}.payment-method-selector sc-card:nth-child(2){margin-left:0;margin-right:0}::ng-deep .sc-card{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}::ng-deep .sc-card .sc-card__description p span{display:inline-block}::ng-deep .sc-card .sc-card__description p span:first-of-type::after{content:\"\";display:block;background-color:#8993a4;width:1px;height:10px;position:relative;float:right;margin:6px 6px 0}}"]
                }] }
    ];
    /** @nocollapse */
    PaymentInfoComponent.ctorParameters = function () { return [
        { type: PaymentService },
        { type: CreditCardAsyncValidator },
        { type: DirectDebitAsyncValidator }
    ]; };
    PaymentInfoComponent.propDecorators = {
        editMode: [{ type: Input }],
        loading: [{ type: Input }],
        canContinue: [{ type: Input }],
        branchOffice: [{ type: Input }],
        paymentMethods$: [{ type: Input }],
        paymentMethodsByUser: [{ type: Input }],
        accountNumber: [{ type: Input }],
        policyPeriodId: [{ type: Input }],
        feeOptions: [{ type: Input }],
        commercialDiscounts: [{ type: Input }],
        defaultPaymentTypeId: [{ type: Input }],
        defaultFeeKey: [{ type: Input }],
        defaultCommercialDiscountId: [{ type: Input }],
        hasElectronicDocument: [{ type: Input }],
        recalculate: [{ type: Output }],
        applyModal: [{ type: Output }],
        cancelModal: [{ type: Output }],
        formCompleted: [{ type: Output }],
        modalElement: [{ type: ViewChild, args: ['modalElement', { static: false },] }]
    };
    return PaymentInfoComponent;
}());
if (false) {
    /** @type {?} */
    PaymentInfoComponent.prototype.editMode;
    /** @type {?} */
    PaymentInfoComponent.prototype.loading;
    /** @type {?} */
    PaymentInfoComponent.prototype.canContinue;
    /** @type {?} */
    PaymentInfoComponent.prototype.branchOffice;
    /** @type {?} */
    PaymentInfoComponent.prototype.paymentMethods$;
    /** @type {?} */
    PaymentInfoComponent.prototype.paymentMethodsByUser;
    /** @type {?} */
    PaymentInfoComponent.prototype.accountNumber;
    /** @type {?} */
    PaymentInfoComponent.prototype.policyPeriodId;
    /** @type {?} */
    PaymentInfoComponent.prototype.feeOptions;
    /** @type {?} */
    PaymentInfoComponent.prototype.commercialDiscounts;
    /** @type {?} */
    PaymentInfoComponent.prototype.defaultPaymentTypeId;
    /** @type {?} */
    PaymentInfoComponent.prototype.defaultFeeKey;
    /** @type {?} */
    PaymentInfoComponent.prototype.defaultCommercialDiscountId;
    /** @type {?} */
    PaymentInfoComponent.prototype.hasElectronicDocument;
    /** @type {?} */
    PaymentInfoComponent.prototype.recalculate;
    /** @type {?} */
    PaymentInfoComponent.prototype.applyModal;
    /** @type {?} */
    PaymentInfoComponent.prototype.cancelModal;
    /** @type {?} */
    PaymentInfoComponent.prototype.formCompleted;
    /** @type {?} */
    PaymentInfoComponent.prototype.modalElement;
    /** @type {?} */
    PaymentInfoComponent.prototype.formGroup;
    /** @type {?} */
    PaymentInfoComponent.prototype.selectedPaymentMethod;
    /** @type {?} */
    PaymentInfoComponent.prototype.creditCardTypes$;
    /** @type {?} */
    PaymentInfoComponent.prototype.creditCardTypes;
    /** @type {?} */
    PaymentInfoComponent.prototype.paymentMethodsModal$;
    /** @type {?} */
    PaymentInfoComponent.prototype.errorMessages;
    /** @type {?} */
    PaymentInfoComponent.prototype.collectorReadonly;
    /** @type {?} */
    PaymentInfoComponent.prototype.loadingPaymentMethodsByUser;
    /** @type {?} */
    PaymentInfoComponent.prototype.cbuOptions;
    /** @type {?} */
    PaymentInfoComponent.prototype.creditCardOptions;
    /** @type {?} */
    PaymentInfoComponent.prototype.paymentTypeId;
    /** @type {?} */
    PaymentInfoComponent.prototype.sendCouponsByOptions;
    /** @type {?} */
    PaymentInfoComponent.prototype.collectorOptions;
    /**
     * @type {?}
     * @private
     */
    PaymentInfoComponent.prototype.paymentService;
    /**
     * @type {?}
     * @private
     */
    PaymentInfoComponent.prototype.creditCardValidator;
    /**
     * @type {?}
     * @private
     */
    PaymentInfoComponent.prototype.directDebitValidator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-confirm/payment-method-confirm.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodConfirmComponent = /** @class */ (function () {
    function PaymentMethodConfirmComponent() {
        this.changeMethodClicked = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PaymentMethodConfirmComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.paymentTypeId && changes.paymentTypeId.currentValue) {
            var _a = paymentMethodsConfig.find((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return p.paymentTypeId === changes.paymentTypeId.currentValue; })), title = _a.title, icon = _a.icon;
            this.paymentMethodIcon = icon;
            this.paymentMethodTitle = title;
        }
    };
    PaymentMethodConfirmComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-method-confirm',
                    template: "<div class=\"sc-payment-method-confirm\" [class.sc-payment-method-confirm--loading]=\"loading\">\n    <div class=\"sc-payment-method-confirm__header\">\n        <div class=\"sc-payment-method-confirm__method-title\">\n            <sc-icon [icon]=\"paymentMethodIcon\"></sc-icon> {{ paymentMethodTitle }}\n        </div>\n        <div class=\"sc-payment-method-confirm__link\">\n            <sc-button type=\"link\" (onClick)=\"changeMethodClicked.emit()\" [disabled]=\"disabled || loading\" id=\"confirm-payment-method-cambiar\">Cambiar</sc-button>\n        </div>\n    </div>\n    <div class=\"sc-payment-method-confirm__content\" *ngIf=\"!loading\">\n        <div class=\"sc-payment-method-confirm__fee\">\n            {{ paymentFee }} Cuota<ng-container *ngIf=\"paymentFee > 1\">s</ng-container> de\n        </div>\n        <div class=\"sc-payment-method-confirm__cost\">\n            {{ (finalAmount / paymentFee) | scCurrency }}\n        </div>\n        <div *ngIf=\"paymentFee > 1\" class=\"sc-payment-method-confirm__final-cost\">\n            Precio final: {{ finalAmount | scCurrency }}\n        </div>\n    </div>\n    <div class=\"sc-payment-method-confirm__loading\" *ngIf=\"loading\">\n        <sc-icon icon=\"loading\" size=\"2\"></sc-icon>\n    </div>\n</div>\n",
                    styles: [".sc-payment-method-confirm{height:172px;width:329px;border:1px solid #ccd2dd;border-radius:4px;padding:1rem;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:justify;justify-content:space-between}.sc-payment-method-confirm__header{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center}.sc-payment-method-confirm__method-title{height:1rem;color:#424f66;font-family:Roboto,sans-serif;font-size:.875rem;line-height:1rem}.sc-payment-method-confirm__method-title sc-icon{display:inline-block;vertical-align:middle;margin-right:.5rem}.sc-payment-method-confirm__link ::ng-deep sc-button button{text-decoration:none;outline:0}.sc-payment-method-confirm__fee{height:.75rem;color:#424f66;font-family:Roboto,sans-serif;font-size:1rem;line-height:.75rem;margin-bottom:.5rem}.sc-payment-method-confirm__cost{height:3rem;color:#0070cc;font-family:Montserrat,sans-serif;font-size:2.625rem;font-weight:800;line-height:3rem}.sc-payment-method-confirm__final-cost{height:1.5rem;color:#aeb7c8;font-family:Roboto,sans-serif;font-size:.75rem;line-height:1.5rem}.sc-payment-method-confirm__loading{text-align:center;-webkit-box-flex:.65;flex:.65 0}.sc-payment-method-confirm--loading .sc-payment-method-confirm__method-title{opacity:.5}@media (max-width:768px){:host{display:inline-block;width:100%}.sc-payment-method-confirm{width:100%}}"]
                }] }
    ];
    /** @nocollapse */
    PaymentMethodConfirmComponent.ctorParameters = function () { return []; };
    PaymentMethodConfirmComponent.propDecorators = {
        disabled: [{ type: Input }],
        loading: [{ type: Input }],
        paymentTypeId: [{ type: Input }],
        paymentFee: [{ type: Input }],
        finalAmount: [{ type: Input }],
        changeMethodClicked: [{ type: Output }]
    };
    return PaymentMethodConfirmComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.disabled;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.loading;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.paymentTypeId;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.paymentFee;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.finalAmount;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.changeMethodClicked;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.paymentMethodIcon;
    /** @type {?} */
    PaymentMethodConfirmComponent.prototype.paymentMethodTitle;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-confirm/payment-method-confirm.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodConfirmModule = /** @class */ (function () {
    function PaymentMethodConfirmModule() {
    }
    PaymentMethodConfirmModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        IconModule,
                        ScPipesModule
                    ],
                    declarations: [
                        PaymentMethodConfirmComponent
                    ],
                    exports: [PaymentMethodConfirmComponent]
                },] }
    ];
    return PaymentMethodConfirmModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-methods-modal/payment-methods-modal.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodsModalModule = /** @class */ (function () {
    function PaymentMethodsModalModule() {
    }
    PaymentMethodsModalModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        IconModule,
                        ModalModule,
                        TitleModule,
                        SelectModule,
                        FormsModule,
                        ReactiveFormsModule,
                        RadioModule,
                        ScPipesModule,
                        InfoBoxModule
                    ],
                    declarations: [
                        PaymentMethodsModalComponent
                    ],
                    exports: [PaymentMethodsModalComponent]
                },] }
    ];
    return PaymentMethodsModalModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/animations/slide-fade.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var slideFade = trigger('slideFade', [
    state('void', style({
        height: 0,
        overflow: 'hidden'
    })),
    state('out', style({
        height: 0,
        overflow: 'hidden',
        zIndex: -1,
        opacity: 0
    })),
    state('in', style({
        zIndex: 100
    })),
    transition('* <=> *', animate('300ms')),
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-option/credit-cards-map.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var creditCardsMap = {
    'default_data:10001': 'american',
    'default_data:10002': 'argencard',
    'default_data:10003': 'diners',
    'default_data:10004': 'master',
    'default_data:10005': 'patagonia',
    'default_data:10006': 'bbps',
    'default_data:10007': 'cabal',
    'default_data:10008': 'coopeplus',
    'default_data:10009': 'galicia',
    'default_data:10010': 'montemar',
    'default_data:10011': 'naranja',
    'default_data:10012': 'nativa',
    'default_data:10013': 'nativa-master',
    'default_data:10014': 'nevada',
    'default_data:10015': 'italcred',
    'default_data:10016': 'credencial',
    'default_data:10020': 'visa',
    'bc:1002': 'cencosud',
    'bc:1001': 'fava'
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-option/payment-option.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentOptionComponent = /** @class */ (function () {
    function PaymentOptionComponent(creditCardValidator, directDebitValidator) {
        this.creditCardValidator = creditCardValidator;
        this.directDebitValidator = directDebitValidator;
        this.isSelected = false;
        this.creditCardTypeOptions = [];
        this.statusChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PaymentOptionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isCreditType = this.type === 'credit';
        this.imageSource = this.getImageSource();
        this.formattedLabel = this.formatLabel(this.label);
        this.setForm();
    };
    /**
     * @return {?}
     */
    PaymentOptionComponent.prototype.getImageSource = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var paymentMethodIcon;
        if (this.type === 'cbu') {
            paymentMethodIcon = 'cbu';
        }
        else {
            paymentMethodIcon = this.showForm ? 'generica' : creditCardsMap[this.creditCardTypeKey];
        }
        return "/assets/images/credit-cards-images/" + paymentMethodIcon + ".png";
    };
    /**
     * @private
     * @param {?} label
     * @return {?}
     */
    PaymentOptionComponent.prototype.formatLabel = /**
     * @private
     * @param {?} label
     * @return {?}
     */
    function (label) {
        return label && label.replace(/#/g, '•');
    };
    /**
     * @return {?}
     */
    PaymentOptionComponent.prototype.setForm = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var formControls = {
            credit: {
                creditCardType: new FormControl(),
                creditCardNumber: new FormControl()
            },
            cbu: {
                cbuNumber: new FormControl()
            }
        };
        this.formGroup = new FormGroup(formControls[this.type]);
        if (this.isCreditType) {
            this.formGroup.get('creditCardNumber').setValidators([Validators.required, Validators.minLength(15)]);
            this.formGroup.get('creditCardNumber').setAsyncValidators(this.creditCardValidator.create(this.formGroup.get('creditCardType')));
        }
        else {
            this.formGroup.get('cbuNumber').setValidators([Validators.required, Validators.minLength(22)]);
            this.formGroup.get('cbuNumber').setAsyncValidators(this.directDebitValidator.create());
        }
        this.formGroup
            .valueChanges
            .pipe(distinctUntilChanged((/**
         * @param {?} prev
         * @param {?} curr
         * @return {?}
         */
        function (prev, curr) { return JSON.stringify(prev) === JSON.stringify(curr); })), debounceTime(500))
            .subscribe((/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
            if (_this.formGroup.valid) {
                _this.emitSelectedData();
            }
        }));
        this.formGroup.statusChanges
            .pipe(distinctUntilChanged())
            .subscribe((/**
         * @param {?} status
         * @return {?}
         */
        function (status) {
            if (_this.showForm && _this.isSelected) {
                _this.emitSelectedData();
            }
        }));
    };
    /**
     * @param {?} control
     * @return {?}
     */
    PaymentOptionComponent.prototype.setNumberFieldIcon = /**
     * @param {?} control
     * @return {?}
     */
    function (control) {
        /** @type {?} */
        var icon = null;
        if (!control.pristine) {
            icon = control.pending ? 'loading' : (control.valid ? 'check' : null);
        }
        return icon;
    };
    /**
     * @return {?}
     */
    PaymentOptionComponent.prototype.handlePaymentOptionClick = /**
     * @return {?}
     */
    function () {
        this.isSelected = true;
        this.emitSelectedData();
    };
    /**
     * @return {?}
     */
    PaymentOptionComponent.prototype.emitSelectedData = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var creditCardTypeKey = this.creditCardTypeKey;
        /** @type {?} */
        var creditCardTypeName = this.creditCardTypeName;
        /** @type {?} */
        var paymentOptionNumber = (this.isCreditType) ? 'creditCardNumber' : 'cbuNumber';
        if (this.showForm && this.isCreditType) {
            /** @type {?} */
            var cardNameControlValue = this.formGroup.controls['creditCardType'].value;
            creditCardTypeKey = cardNameControlValue && cardNameControlValue.key;
            creditCardTypeName = cardNameControlValue && cardNameControlValue.name;
        }
        this.statusChange.emit({
            id: this.id,
            number: this.formGroup && this.formGroup.controls[paymentOptionNumber].value,
            label: this.label,
            creditCardTypeKey: creditCardTypeKey,
            creditCardTypeName: creditCardTypeName,
            isSelected: this.isSelected,
            isValid: this.showForm ? this.formGroup.valid : true
        });
    };
    /**
     * @param {?} e
     * @return {?}
     */
    PaymentOptionComponent.prototype.onlyNumbers = /**
     * @param {?} e
     * @return {?}
     */
    function (e) {
        e.target.value = e.target.value.replace(/[^0-9]/gi, '');
    };
    /**
     * @param {?} option
     * @return {?}
     */
    PaymentOptionComponent.prototype.handleCreditCardTypeChange = /**
     * @param {?} option
     * @return {?}
     */
    function (option) {
        if (option) {
            this.formGroup.get('creditCardNumber').setValue('');
        }
    };
    PaymentOptionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-option',
                    template: "<div\n    class=\"payment-option\"\n    [ngClass]=\"{'payment-option--extended': showForm && isSelected, 'payment-option--unselected': !isSelected}\"\n    (click)=\"handlePaymentOptionClick()\"\n>\n    <div class=\"info-section\">\n        <div class=\"payment-option__left\">\n            <div class=\"payment-option__circle\">\n                <div class=\"circle__outer\" [class.circle__outer--selected]=\"isSelected\">\n                    <div class=\"circle__inner\" [class.circle__inner--selected]=\"isSelected\"></div>\n                </div>\n            </div>\n            <div class=\"payment-option__label\"\n                [class.payment-option__label--new]=\"showForm\"\n                [class.payment-option__label--new-selected]=\"showForm && isSelected\"\n            >{{ formattedLabel }}</div>\n        </div>\n        <div class=\"payment-option__image-container\">\n            <img [src]=\"imageSource\" alt=\"card\" width=\"48\" height=\"34\" />\n        </div>\n    </div>\n    <div class=\"form-section\" *ngIf=\"showForm\" [@slideFade]=\"(showForm && isSelected) ? 'in' : 'out'\">\n        <form [formGroup]=\"formGroup\">\n            <div class=\"form-controls form-controls--credit\" *ngIf=\"isCreditType\">\n                <sc-select\n                    class=\"form-controls__type\"\n                    formControlName=\"creditCardType\"\n                    label=\"Tarjeta\"\n                    placeholder=\"Seleccion\u00E1 una tarjeta\"\n                    objectValue=\"name\"\n                    [items]=\"creditCardTypeOptions\"\n                    [hideError]=\"true\"\n                    (optionSelected)=\"handleCreditCardTypeChange($event)\"\n                ></sc-select>\n                <div class=\"form-controls__number\">\n                    <label for=\"creditCardNumber__field\">Nro tarjeta</label>\n                    <input\n                        id=\"creditCardNumber__field\"\n                        type=\"text\"\n                        maxlength=\"16\"\n                        formControlName=\"creditCardNumber\"\n                        placeholder=\"0000 0000 0000 0000\"\n                        [readonly]=\"!formGroup.value.creditCardType ? true : null\"\n                        (input)=\"onlyNumbers($event)\">\n                    <sc-icon [icon]=\"setNumberFieldIcon(formGroup.get('creditCardNumber'))\" class=\"form-controls__input-icon\"></sc-icon>\n                </div>\n            </div >\n            <div class=\"form-controls\" *ngIf=\"!isCreditType\">\n                <div class=\"form-controls__number\">\n                    <label for=\"cbuNumber__field\">Nro CBU</label>\n                    <input\n                        id=\"cbuNumber__field\"\n                        type=\"text\"\n                        maxlength=\"22\"\n                        formControlName=\"cbuNumber\"\n                        placeholder=\"00000000000000000000000\"\n                        (input)=\"onlyNumbers($event)\">\n                    <sc-icon [icon]=\"setNumberFieldIcon(formGroup.get('cbuNumber'))\" class=\"form-controls__input-icon\"></sc-icon>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n",
                    animations: [slideFade],
                    styles: [".payment-option{border:1px solid #ccd2dd;height:60px;width:100%;border-radius:4px;padding:10px;-webkit-transition:height .1s;transition:height .1s}.payment-option--unselected{cursor:pointer}.payment-option--extended{height:160px;-webkit-transition:height .1s;transition:height .1s}.payment-option .info-section{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.payment-option .info-section .payment-option__left{padding:8px}.payment-option .info-section .payment-option__left .payment-option__circle{display:inline-block}.payment-option .info-section .payment-option__left .payment-option__circle .circle__outer{border:2px solid #aeb7c8;width:19px;height:19px;border-radius:10px}.payment-option .info-section .payment-option__left .payment-option__circle .circle__outer--selected{border-color:#3dcc98}.payment-option .info-section .payment-option__left .payment-option__circle .circle__inner{background-color:#aeb7c8;height:0;widows:0;border-radius:10px;position:relative;top:2px;left:2px}.payment-option .info-section .payment-option__left .payment-option__circle .circle__inner--selected{background-color:#3dcc98;width:11px;height:11px}.payment-option .info-section .payment-option__left .payment-option__label{display:inline-block;vertical-align:text-bottom;margin-left:10px}.payment-option .info-section .payment-option__left .payment-option__label--new{font-size:14px}.payment-option .info-section .payment-option__left .payment-option__label--new-selected{color:#0070cc}.payment-option .form-section{margin-top:10px}.form-controls{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;padding:0 1.25rem}.form-controls__number{position:relative;width:100%}.form-controls__number input{padding-right:2rem}.form-controls__number input:not(.ng-pristine).ng-invalid{border-color:red}.form-controls__number input:-moz-read-only{background-color:#e0e5ed;border-color:#ccd2dd}.form-controls__number input:read-only{background-color:#e0e5ed;border-color:#ccd2dd}.form-controls__input-icon{position:absolute;top:2rem;right:.75rem}.form-controls--credit .form-controls__type{width:calc(50% - .5rem);margin-right:.5rem}.form-controls--credit .form-controls__number{width:calc(50% - .5rem);margin-left:.5rem}"]
                }] }
    ];
    /** @nocollapse */
    PaymentOptionComponent.ctorParameters = function () { return [
        { type: CreditCardAsyncValidator },
        { type: DirectDebitAsyncValidator }
    ]; };
    PaymentOptionComponent.propDecorators = {
        isSelected: [{ type: Input }],
        type: [{ type: Input }],
        creditCardTypeKey: [{ type: Input }],
        creditCardTypeName: [{ type: Input }],
        creditCardTypeOptions: [{ type: Input }],
        number: [{ type: Input }],
        label: [{ type: Input }],
        id: [{ type: Input }],
        showForm: [{ type: Input }],
        statusChange: [{ type: Output }]
    };
    return PaymentOptionComponent;
}());
if (false) {
    /** @type {?} */
    PaymentOptionComponent.prototype.isSelected;
    /** @type {?} */
    PaymentOptionComponent.prototype.type;
    /** @type {?} */
    PaymentOptionComponent.prototype.creditCardTypeKey;
    /** @type {?} */
    PaymentOptionComponent.prototype.creditCardTypeName;
    /** @type {?} */
    PaymentOptionComponent.prototype.creditCardTypeOptions;
    /** @type {?} */
    PaymentOptionComponent.prototype.number;
    /** @type {?} */
    PaymentOptionComponent.prototype.label;
    /** @type {?} */
    PaymentOptionComponent.prototype.id;
    /** @type {?} */
    PaymentOptionComponent.prototype.showForm;
    /** @type {?} */
    PaymentOptionComponent.prototype.statusChange;
    /** @type {?} */
    PaymentOptionComponent.prototype.imageSource;
    /** @type {?} */
    PaymentOptionComponent.prototype.formGroup;
    /** @type {?} */
    PaymentOptionComponent.prototype.formattedLabel;
    /** @type {?} */
    PaymentOptionComponent.prototype.isCreditType;
    /**
     * @type {?}
     * @private
     */
    PaymentOptionComponent.prototype.creditCardValidator;
    /**
     * @type {?}
     * @private
     */
    PaymentOptionComponent.prototype.directDebitValidator;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/shared-services.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SharedServicesModule = /** @class */ (function () {
    function SharedServicesModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    SharedServicesModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: SharedServicesModule,
            providers: [
                PolicyService,
                {
                    provide: 'envConfig',
                    useValue: config
                }
            ]
        };
    };
    SharedServicesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule
                    ],
                    exports: [],
                    providers: [
                        PolicyService,
                        TypeListService,
                        PaymentService
                    ]
                },] }
    ];
    return SharedServicesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/payment-method-async.validator.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodAsyncValidatorModule = /** @class */ (function () {
    function PaymentMethodAsyncValidatorModule() {
    }
    PaymentMethodAsyncValidatorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        SharedServicesModule
                    ],
                    providers: [
                        CreditCardAsyncValidator,
                        DirectDebitAsyncValidator
                    ]
                },] }
    ];
    return PaymentMethodAsyncValidatorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-option/payment-option.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentOptionModule = /** @class */ (function () {
    function PaymentOptionModule() {
    }
    PaymentOptionModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        RadioModule,
                        InputModule,
                        SelectModule,
                        IconModule,
                        PaymentMethodAsyncValidatorModule
                    ],
                    declarations: [PaymentOptionComponent],
                    exports: [PaymentOptionComponent]
                },] }
    ];
    return PaymentOptionModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/constants/payment-value-accessor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var PAYMENT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    function () { return PaymentMethodSelectorComponent; })),
    multi: true
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-selector/payment-method-selector.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodSelectorComponent = /** @class */ (function () {
    function PaymentMethodSelectorComponent() {
        this.statusChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.isCreditType = this.type === 'credit';
        if (!this.title) {
            this.title = this.isCreditType
                ? 'Pagá con una tarjeta de crédito previamente cargada o agregá una nueva'
                : 'Pagá con un CBU previamente cargado o agregá uno nuevo';
        }
    };
    /**
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (this.options && this.options.length) {
            this.addNewItemOption();
            this.options[0].isValid = true;
            if (!this.noSelectOption) {
                this.handleValueChange(this.options[0]);
            }
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value && value.id) {
            this.updateOptionsSelectedStatus(value);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.registerOnTouched = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} selectedOption
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.handleValueChange = /**
     * @param {?} selectedOption
     * @return {?}
     */
    function (selectedOption) {
        var _this = this;
        if (this.onChange) {
            this.onChange(selectedOption);
        }
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.updateOptionsSelectedStatus(selectedOption);
        }), 0);
    };
    /**
     * @param {?} status
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.handleStatusChange = /**
     * @param {?} status
     * @return {?}
     */
    function (status) {
        this.statusChange.emit(status);
    };
    /**
     * @private
     * @param {?} selectedOption
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.updateOptionsSelectedStatus = /**
     * @private
     * @param {?} selectedOption
     * @return {?}
     */
    function (selectedOption) {
        this.options.forEach((/**
         * @param {?} option
         * @return {?}
         */
        function (option) {
            option.isSelected = (option.id === selectedOption.id);
        }));
    };
    /**
     * @private
     * @return {?}
     */
    PaymentMethodSelectorComponent.prototype.addNewItemOption = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.options && this.options.length && !this.options.find((/**
         * @param {?} option
         * @return {?}
         */
        function (option) { return option.id === null; }))) {
            /** @type {?} */
            var addItemLabel = (this.isCreditType) ? 'Agregar una tarjeta' : 'Agregar un CBU';
            this.options.push({ id: null, label: addItemLabel });
        }
    };
    PaymentMethodSelectorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-method-selector',
                    template: "<div class=\"payment-method-selector\">\n    <h3 class=\"payment-method-selector__title\">{{ title }}</h3>\n    <sc-payment-option\n        class=\"payment-method-selector__option\"\n        *ngFor=\"let option of options\"\n        [id]=\"option.id\"\n        [label]=\"option.label\"\n        [type]=\"type\"\n        [creditCardTypeKey]=\"option.creditCardTypeKey\"\n        [creditCardTypeOptions]=\"creditCardTypeOptions\"\n        [isSelected]=\"option.isSelected\"\n        [showForm]=\"!option.id\"\n        (statusChange)=\"handleValueChange($event)\"\n    ></sc-payment-option>\n</div>",
                    providers: [PAYMENT_CONTROL_VALUE_ACCESSOR],
                    styles: [":host{display:block;width:100%;max-width:500px}:host .payment-method-selector__title{font-size:.875rem;line-height:1.5rem;margin-bottom:.875rem}:host .payment-method-selector__option{display:block;margin-bottom:.875rem}"]
                }] }
    ];
    PaymentMethodSelectorComponent.propDecorators = {
        options: [{ type: Input }],
        type: [{ type: Input }],
        creditCardTypeOptions: [{ type: Input }],
        noSelectOption: [{ type: Input }],
        title: [{ type: Input }],
        statusChange: [{ type: Output }]
    };
    return PaymentMethodSelectorComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.options;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.type;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.creditCardTypeOptions;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.noSelectOption;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.title;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.statusChange;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.isCreditType;
    /** @type {?} */
    PaymentMethodSelectorComponent.prototype.onChange;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-selector/payment-method-selector.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodSelectorModule = /** @class */ (function () {
    function PaymentMethodSelectorModule() {
    }
    PaymentMethodSelectorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        PaymentOptionModule
                    ],
                    declarations: [PaymentMethodSelectorComponent],
                    exports: [PaymentMethodSelectorComponent]
                },] }
    ];
    return PaymentMethodSelectorModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-info/payment-info.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentInfoModule = /** @class */ (function () {
    function PaymentInfoModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    PaymentInfoModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        // El modulo no necesita mas el forRoot
        // Se deja por razones de retrocompatibilidad
        return {
            ngModule: PaymentInfoModule
        };
    };
    PaymentInfoModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TitleModule,
                        InputModule,
                        SelectModule,
                        ButtonModule,
                        IconModule,
                        PaymentMethodConfirmModule,
                        PaymentMethodsModalModule,
                        PaymentMethodSelectorModule,
                        PaymentOptionModule,
                        SharedServicesModule,
                        PaymentMethodAsyncValidatorModule
                    ],
                    declarations: [PaymentInfoComponent],
                    exports: [PaymentInfoComponent]
                },] }
    ];
    return PaymentInfoModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-method.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethod = /** @class */ (function () {
    function PaymentMethod() {
        this.paymentType = null;
        this.paymentTypeId = null;
        this.quoteNro = 0;
        this.cbuNumber = null;
        this.creditCardType = null;
        this.creditCardNumber = null;
        this.firstDueDate = new Date();
        this.collector = {
            code: 0,
            description: null
        };
        this.sendCouponsBy = {
            code: 0,
            description: null
        };
        this.icon = null;
        this.finalAmount = null;
        this.quoteAmount = null;
        this.totalAmount = null;
    }
    return PaymentMethod;
}());
if (false) {
    /** @type {?} */
    PaymentMethod.prototype.paymentTypeId;
    /** @type {?} */
    PaymentMethod.prototype.paymentType;
    /** @type {?} */
    PaymentMethod.prototype.quoteNro;
    /** @type {?} */
    PaymentMethod.prototype.cbuNumber;
    /** @type {?} */
    PaymentMethod.prototype.creditCardType;
    /** @type {?} */
    PaymentMethod.prototype.creditCardNumber;
    /** @type {?} */
    PaymentMethod.prototype.firstDueDate;
    /** @type {?} */
    PaymentMethod.prototype.collector;
    /** @type {?} */
    PaymentMethod.prototype.sendCouponsBy;
    /** @type {?} */
    PaymentMethod.prototype.finalAmount;
    /** @type {?} */
    PaymentMethod.prototype.quoteAmount;
    /** @type {?} */
    PaymentMethod.prototype.totalAmount;
    /** @type {?} */
    PaymentMethod.prototype.icon;
    /** @type {?} */
    PaymentMethod.prototype.title;
    /** @type {?} */
    PaymentMethod.prototype.loading;
    /** @type {?} */
    PaymentMethod.prototype.hideAmount;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-floating/payment-method-floating.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodFloatingComponent = /** @class */ (function () {
    function PaymentMethodFloatingComponent() {
        this.paymentMethod$ = new BehaviorSubject(new PaymentMethod);
        this.linkClicked = new EventEmitter();
        this.primaryButtonClicked = new EventEmitter();
        this.secondaryButtonClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PaymentMethodFloatingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.paymentMethod$.subscribe((/**
         * @param {?} paymentMethod
         * @return {?}
         */
        function (paymentMethod) {
            var _a = paymentMethodsConfig.find((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return p.paymentTypeId === paymentMethod.paymentTypeId; })), title = _a.title, icon = _a.icon;
            paymentMethod.icon = icon;
            paymentMethod.title = title;
        }));
    };
    PaymentMethodFloatingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-method-floating',
                    template: "<div class=\"sc-payment-method-floating\">\n    <div *ngIf=\"loading\" class=\"sc-payment-method-floating__loading\">\n        <sc-icon icon=\"loading\" size=\"2\"></sc-icon>\n        Calculando...\n    </div>\n    <div *ngIf=\"!loading\" class=\"sc-payment-method-floating__content\">\n        <div class=\"sc-payment-method-floating__methods\">\n            <div *ngFor=\"let product of productsData\" class=\"sc-payment-method-floating__method\">\n                <span class=\"sc-payment-method-floating__fee\">\n                    {{ paymentMethod$.value.quoteNro }} Cuota<ng-container *ngIf=\"paymentMethod$.value.quoteNro > 1\">s</ng-container> de\n                </span>\n                <div class=\"sc-payment-method-floating__cost\" [class.disabled]=\"disabled\">{{ (product.finalAmount / paymentMethod$.value.quoteNro) | scCurrency }}</div>\n                <span class=\"sc-payment-method-floating__final-cost\" [class.hidden]=\"paymentMethod$.value.quoteNro == 1\">\n                    Precio final: {{ product.finalAmount | scCurrency }}\n                </span>\n                <div class=\"sc-payment-method-floating__method-title\">\n                    {{ paymentMethod$.value.title }} <span class=\"no-mobile\"><sc-icon [icon]=\"paymentMethod$.value.icon\" size=\"1\"></sc-icon></span>\n                </div>\n            </div>\n        </div>\n        <sc-button\n            type=\"link\"\n            class=\"edit-tarifas\"\n            id=\"floating-tarifas-formas-de-pago\"\n            [disabled]=\"disabled\"\n            (onClick)=\"linkClicked.emit()\">\n            Tarifas y formas de pago\n        </sc-button>\n        <sc-icon\n            class=\"edit-tarifas\"\n            [class.sc-color-primary-brand]=\"!disabled\"\n            icon=\"edit\"\n            (click)=\"!disabled && linkClicked.emit()\"></sc-icon>\n    </div>\n    <div *ngIf=\"!loading\" class=\"sc-payment-method-floating__buttons\">\n        <sc-button\n            id=\"continue-with-submission\"\n            type=\"primary\" \n            [disabled]=\"disabled\"\n            (onClick)=\"primaryButtonClicked.emit()\"\n            >Continuar<span class=\"no-mobile\"> con la emisi\u00F3n</span></sc-button>\n        <sc-button\n            id=\"payment-method-guardar-salir\"\n            type=\"secondary\"\n            [disabled]=\"disabled\"\n            (onClick)=\"secondaryButtonClicked.emit()\"\n            >Guardar y salir</sc-button>\n    </div>\n    <sc-info-box icon=\"info-2-rounded\" class=\"info\" *ngIf=\"infoMessage\">{{infoMessage}}</sc-info-box>\n</div>",
                    styles: [".sc-payment-method-floating{box-sizing:border-box;width:241px;border:1px solid #e0e5ed;border-radius:4px;background-color:#fff;box-shadow:0 2px 6px 0 rgba(0,0,0,.1),0 20px 16px -12px rgba(0,112,204,.15);text-align:center;padding:1rem}.sc-payment-method-floating__loading{height:300px;color:#8993a4;font-family:Roboto,sans-serif;font-size:1.125rem;line-height:1.3125rem;text-align:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center}.sc-payment-method-floating__loading sc-icon{margin-bottom:1rem}.sc-payment-method-floating__fee{height:.75rem;color:#8993a4;font-family:Roboto,sans-serif;font-size:.875rem;line-height:.75rem;text-align:center}.sc-payment-method-floating__cost{height:3rem;color:#0070cc;font-family:Montserrat;font-size:2.625rem;font-weight:800;line-height:3rem;text-align:center}.sc-payment-method-floating__cost.disabled{color:#ccd2dd}.sc-payment-method-floating__final-cost{height:1.5rem;color:#aeb7c8;font-family:Roboto,sans-serif;font-size:.75rem;line-height:1.5rem;text-align:center}.sc-payment-method-floating__method-title{color:#424f66;font-family:Roboto,sans-serif;font-size:16px;line-height:19px;margin-top:1.5rem}.sc-payment-method-floating__method-title sc-icon{display:inline-block;vertical-align:middle;margin-left:6px}.sc-payment-method-floating__buttons{border-top:1px solid #e0e5ed;padding-top:1rem}.sc-payment-method-floating__buttons ::ng-deep button{width:100%}.sc-payment-method-floating__buttons ::ng-deep sc-button:first-of-type{margin-bottom:.5rem;display:-webkit-box;display:flex}.sc-payment-method-floating .hidden{visibility:hidden}.sc-payment-method-floating sc-icon.edit-tarifas{display:none}.sc-payment-method-floating sc-button.edit-tarifas{display:inline-block;margin:1rem 0}@media (max-width:768px){.sc-payment-method-floating{position:fixed;width:100%;bottom:0;left:0;right:0;z-index:10}.sc-payment-method-floating__loading{height:auto}.sc-payment-method-floating__method{display:-webkit-box;display:flex;flex-wrap:wrap}.sc-payment-method-floating__cost,.sc-payment-method-floating__fee{height:auto;font-size:1.5rem;line-height:29px;color:#0070cc;font-weight:800;text-align:left;display:inline-block;-webkit-box-ordinal-group:4;order:3}.sc-payment-method-floating__fee{margin-right:.5rem}.sc-payment-method-floating__final-cost,.sc-payment-method-floating__method-title{font-size:.75rem;line-height:.875rem;height:auto;margin-bottom:.5rem}.sc-payment-method-floating__method-title{-webkit-box-ordinal-group:2;order:1;margin:0}.sc-payment-method-floating__method-title::after{content:\"-\";display:inline-block;padding:0 .3rem 0 .1rem}.sc-payment-method-floating__final-cost{-webkit-box-ordinal-group:3;order:2;-webkit-box-flex:1;flex:1 0 50%;text-align:left}.sc-payment-method-floating__buttons{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;border:none;padding-top:.7rem}.sc-payment-method-floating__buttons sc-button{-webkit-box-flex:0;flex:0 0 48%}.sc-payment-method-floating sc-button.edit-tarifas{display:none}.sc-payment-method-floating sc-icon.edit-tarifas{display:block;position:absolute;top:0;right:0;padding:1rem}.no-mobile{display:none}}.info{border-radius:0 0 4px 4px;border:1px solid #e0e5ed;margin:1rem -1rem -1rem}"]
                }] }
    ];
    /** @nocollapse */
    PaymentMethodFloatingComponent.ctorParameters = function () { return []; };
    PaymentMethodFloatingComponent.propDecorators = {
        loading: [{ type: Input }],
        infoMessage: [{ type: Input }],
        disabled: [{ type: Input }],
        paymentMethod$: [{ type: Input }],
        productsData: [{ type: Input }],
        linkClicked: [{ type: Output }],
        primaryButtonClicked: [{ type: Output }],
        secondaryButtonClicked: [{ type: Output }]
    };
    return PaymentMethodFloatingComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.loading;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.infoMessage;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.disabled;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.paymentMethod$;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.productsData;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.linkClicked;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.primaryButtonClicked;
    /** @type {?} */
    PaymentMethodFloatingComponent.prototype.secondaryButtonClicked;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-method-floating/payment-method-floating.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodFloatingModule = /** @class */ (function () {
    function PaymentMethodFloatingModule() {
    }
    PaymentMethodFloatingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        IconModule,
                        InfoBoxModule,
                        ScPipesModule
                    ],
                    declarations: [
                        PaymentMethodFloatingComponent
                    ],
                    exports: [PaymentMethodFloatingComponent]
                },] }
    ];
    return PaymentMethodFloatingModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-methods-summary/payment-methods-summary.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodsSummaryComponent = /** @class */ (function () {
    function PaymentMethodsSummaryComponent() {
        this.selectedPaymentMethod$ = new BehaviorSubject(null);
        this.paymentMethodFloatingProducts = [];
        this.recalculate = new EventEmitter();
        this.applyChanges = new EventEmitter();
        this.primaryButtonClicked = new EventEmitter();
        this.secondaryButtonClicked = new EventEmitter();
        this.hasUnderWriting = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selectedPaymentMethod$.subscribe((/**
         * @param {?} method
         * @return {?}
         */
        function (method) {
            _this.paymentMethodFloatingProducts.length = 0;
            _this.paymentMethodFloatingProducts = [method];
        }));
        this.setSelectedPaymentMethod();
    };
    /**
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.setSelectedPaymentMethod = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selectedPaymentMethod$.next(this.paymentMethods$.value.find((/**
         * @param {?} p
         * @return {?}
         */
        function (p) { return p.paymentTypeId === _this.defaultPaymentTypeId; })));
    };
    /**
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handleLinkClicked = /**
     * @return {?}
     */
    function () {
        this.modalElement.open();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handleRecalculate = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.recalculate.emit(data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handleApplyModalChanges = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.selectedPaymentMethod$.next(data.paymentMethod);
        if (data.commercialDiscount) {
            this.defaultCommercialDiscountId = data.commercialDiscount.key;
        }
        this.applyChanges.emit(data);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handlePrimaryButtonClicked = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.primaryButtonClicked.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handleSecondaryButtonClicked = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.secondaryButtonClicked.emit(event);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PaymentMethodsSummaryComponent.prototype.handlePaymentModalUnderWriting = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.hasUnderWriting.emit(event);
    };
    PaymentMethodsSummaryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-payment-methods-summary',
                    template: "<div *ngIf=\"hideCommercialDiscount || (!hideCommercialDiscount && commercialDiscounts?.length)\" class=\"sc-payment-methods-summary\">\n    <sc-payment-method-floating\n        [disabled]=\"disabled\"\n        [loading]=\"loading\"\n        [paymentMethod$]=\"selectedPaymentMethod$\"\n        [productsData]=\"paymentMethodFloatingProducts\"\n        (primaryButtonClicked)=\"handlePrimaryButtonClicked($event)\"\n        (secondaryButtonClicked)=\"handleSecondaryButtonClicked($event)\"\n        (linkClicked)=\"handleLinkClicked()\"\n        [infoMessage]=\"infoMessage\"\n    ></sc-payment-method-floating>\n    <sc-payment-methods-modal #modalElement\n        [paymentMethods$]=\"paymentMethods$\"\n        [hideCommercialDiscount]=\"hideCommercialDiscount\"\n        [defaultPaymentTypeId]=\"selectedPaymentMethod$.value.paymentTypeId\"\n        [feeOptions]=\"feeOptions\"\n        [defaultFeeKey]=\"selectedPaymentMethod$.value.quoteNro\"\n        [commercialDiscounts]=\"commercialDiscounts\"\n        [defaultCommercialDiscountId]=\"defaultCommercialDiscountId\"\n        [premiumDiscountLimit]=\"premiumDiscountLimit\"\n        [hasAffinityGroupSelected]=\"hasAffinityGroupSelected\"\n        (recalculate)=\"handleRecalculate($event)\"\n        (applyChanges)=\"handleApplyModalChanges($event)\"\n        (hasUnderWriting)=\"handlePaymentModalUnderWriting($event)\"\n\t></sc-payment-methods-modal>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    PaymentMethodsSummaryComponent.ctorParameters = function () { return []; };
    PaymentMethodsSummaryComponent.propDecorators = {
        loading: [{ type: Input }],
        disabled: [{ type: Input }],
        paymentMethods$: [{ type: Input }],
        defaultPaymentTypeId: [{ type: Input }],
        forceSelectedPaymentMethod: [{ type: Input }],
        feeOptions: [{ type: Input }],
        defaultPaymentFee: [{ type: Input }],
        commercialDiscounts: [{ type: Input }],
        defaultCommercialDiscountId: [{ type: Input }],
        primaryButtonId: [{ type: Input }],
        secondaryButtonId: [{ type: Input }],
        hideCommercialDiscount: [{ type: Input }],
        premiumDiscountLimit: [{ type: Input }],
        hasAffinityGroupSelected: [{ type: Input }],
        infoMessage: [{ type: Input }],
        recalculate: [{ type: Output }],
        applyChanges: [{ type: Output }],
        primaryButtonClicked: [{ type: Output }],
        secondaryButtonClicked: [{ type: Output }],
        hasUnderWriting: [{ type: Output }],
        modalElement: [{ type: ViewChild, args: ['modalElement', { static: false },] }]
    };
    return PaymentMethodsSummaryComponent;
}());
if (false) {
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.loading;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.disabled;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.paymentMethods$;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.defaultPaymentTypeId;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.forceSelectedPaymentMethod;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.feeOptions;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.defaultPaymentFee;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.commercialDiscounts;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.defaultCommercialDiscountId;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.primaryButtonId;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.secondaryButtonId;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.hideCommercialDiscount;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.premiumDiscountLimit;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.hasAffinityGroupSelected;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.infoMessage;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.recalculate;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.applyChanges;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.primaryButtonClicked;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.secondaryButtonClicked;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.hasUnderWriting;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.modalElement;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.selectedPaymentMethod$;
    /** @type {?} */
    PaymentMethodsSummaryComponent.prototype.paymentMethodFloatingProducts;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-methods-summary/payment-methods-summary.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentMethodsSummaryModule = /** @class */ (function () {
    function PaymentMethodsSummaryModule() {
    }
    PaymentMethodsSummaryModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        SelectModule,
                        IconModule,
                        ModalModule,
                        TitleModule,
                        FormsModule,
                        ReactiveFormsModule,
                        PaymentMethodFloatingModule,
                        PaymentMethodsModalModule
                    ],
                    declarations: [PaymentMethodsSummaryComponent],
                    exports: [PaymentMethodsSummaryComponent],
                },] }
    ];
    return PaymentMethodsSummaryModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-base-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
ActivateAccountBaseResponse = /** @class */ (function () {
    function ActivateAccountBaseResponse(data) {
        if (data.httpStatusCode) {
            this.httpStatusCode = data.httpStatusCode;
        }
        if (data.redirectionRoute) {
            this.redirectionRoute = data.redirectionRoute;
        }
    }
    return ActivateAccountBaseResponse;
}());
if (false) {
    /** @type {?} */
    ActivateAccountBaseResponse.prototype.httpStatusCode;
    /** @type {?} */
    ActivateAccountBaseResponse.prototype.redirectionRoute;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/activate-account-errors.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var ActivateAccountError = {
    ActiveAccount: 409,
    InvalidToken: 400,
};
ActivateAccountError[ActivateAccountError.ActiveAccount] = 'ActiveAccount';
ActivateAccountError[ActivateAccountError.InvalidToken] = 'InvalidToken';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-active-account-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountActiveAccountResponse = /** @class */ (function (_super) {
    __extends(ActivateAccountActiveAccountResponse, _super);
    function ActivateAccountActiveAccountResponse(authConfigService) {
        return _super.call(this, {
            redirectionRoute: authConfigService.appRoutes.activateAccount.activeAccount,
            httpStatusCode: ActivateAccountError.ActiveAccount
        }) || this;
    }
    return ActivateAccountActiveAccountResponse;
}(ActivateAccountBaseResponse));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-invalid-token-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountInvalidTokenResponse = /** @class */ (function (_super) {
    __extends(ActivateAccountInvalidTokenResponse, _super);
    function ActivateAccountInvalidTokenResponse(authConfigService) {
        return _super.call(this, {
            redirectionRoute: authConfigService.appRoutes.activateAccount.invalidToken,
            httpStatusCode: ActivateAccountError.InvalidToken
        }) || this;
    }
    return ActivateAccountInvalidTokenResponse;
}(ActivateAccountBaseResponse));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/activate-account-error-classes.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ActivateAccountErrorClasses = new Map([
    [ActivateAccountError.ActiveAccount, ActivateAccountActiveAccountResponse],
    [ActivateAccountError.InvalidToken, ActivateAccountInvalidTokenResponse]
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-success-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountSuccessResponse = /** @class */ (function (_super) {
    __extends(ActivateAccountSuccessResponse, _super);
    function ActivateAccountSuccessResponse(authConfigService) {
        return _super.call(this, { redirectionRoute: authConfigService.appRoutes.home }) || this;
    }
    return ActivateAccountSuccessResponse;
}(ActivateAccountBaseResponse));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-unknown-error-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountUnknownErrorResponse = /** @class */ (function (_super) {
    __extends(ActivateAccountUnknownErrorResponse, _super);
    function ActivateAccountUnknownErrorResponse(authConfigService) {
        return _super.call(this, {
            redirectionRoute: authConfigService.appRoutes.activateAccount.unknownError
        }) || this;
    }
    return ActivateAccountUnknownErrorResponse;
}(ActivateAccountBaseResponse));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/auth-config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthConfigService = /** @class */ (function () {
    function AuthConfigService() {
        this.appname = '';
        this.componentsConfig = {
            sendMail: {
                title: '¡Revisá tu mail!',
                contactEmail: 'portalautogestion@sancristobal.com.ar',
                showHelp: false
            },
            login: {
                userIdLabel: 'Email o Documento',
                isPipedUserId: false,
                userIdPipe: null,
                userIdValidators: [Validators.required, Validators.minLength(3)],
                userIdMaxLength: 30,
                userIdErrorMessages: null,
                showTooltip: false,
                showADLogin: false,
                tooltipText: '',
                passwordMaxLength: 30
            },
            resetPassword: {
                userIdLabel: 'Email o Documento',
                isPipedUserId: false,
                userIdPipe: null,
                userIdValidators: [Validators.required, Validators.minLength(3)],
                userIdMaxLength: 30,
                userIdErrorMessages: null,
                showTooltip: false,
                tooltipText: '',
                passwordMaxLength: 30
            },
            authHeader: {
                showBackButton: true
            }
        };
        this.apiRoutes = {
            base: 'http://api.sc.com/api',
            activateAccount: 'confirmEmail',
            login: 'login',
            resetPassword: 'resetpasword',
            changeResetPassword: 'changeResetPassword'
        };
        this.assets = {
            logo: '/assets/images/logo.svg',
            backgroundImage: '/assets/images/back.jpeg',
            mailSentImage: '',
            successImage: '/assets/images/exitoso.svg'
        };
        this.appRoutes = {
            home: ['/'],
            login: ['/', 'ingresar'],
            logout: ['/', 'salir'],
            signUp: ['/', 'registro'],
            terms: ['/', 'terminos-y-condiciones'],
            resetPassword: ['/', 'resetear-contrasena'],
            recoverPassword: ['/', 'recuperar-contrasena'],
            sendResetPasswordMail: ['/', 'enviar-email-contrasena'],
            recoverPasswordSuccess: ['/', 'recuperar-contrasena-exito'],
            activateAccount: {
                activeAccount: ['/', 'activar-cuenta', 'cuenta-activa'],
                invalidToken: ['/', 'activar-cuenta', 'token-invalido'],
                unknownError: ['/', 'activar-cuenta', 'error-desconocido'],
            },
            user: {
                resetPassword: ['/', 'usuario-migrado', 'resetear-contrasena'],
                missingEmail: ['/', 'usuario-migrado', 'email-erroneo']
            },
        };
        this.unknownErrorMessage = 'Temporalmente el sitio no está disponible. Intentá nuevamente más tarde.';
    }
    AuthConfigService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ AuthConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthConfigService_Factory() { return new AuthConfigService(); }, token: AuthConfigService, providedIn: "root" });
    return AuthConfigService;
}());
if (false) {
    /** @type {?} */
    AuthConfigService.prototype.appname;
    /** @type {?} */
    AuthConfigService.prototype.applicationToken;
    /** @type {?} */
    AuthConfigService.prototype.componentsConfig;
    /** @type {?} */
    AuthConfigService.prototype.apiRoutes;
    /** @type {?} */
    AuthConfigService.prototype.assets;
    /** @type {?} */
    AuthConfigService.prototype.appRoutes;
    /** @type {?} */
    AuthConfigService.prototype.loginAD;
    /** @type {?} */
    AuthConfigService.prototype.lateralHelpComponent;
    /** @type {?} */
    AuthConfigService.prototype.unknownErrorMessage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/activate-account.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountService = /** @class */ (function () {
    function ActivateAccountService(httpClient, authConfigService) {
        this.httpClient = httpClient;
        this.authConfigService = authConfigService;
    }
    /**
     * @param {?} token
     * @param {?} pwd
     * @return {?}
     */
    ActivateAccountService.prototype.activate = /**
     * @param {?} token
     * @param {?} pwd
     * @return {?}
     */
    function (token, pwd) {
        var _this = this;
        /** @type {?} */
        var urlPath = this.authConfigService.apiRoutes.base + "/" + this.authConfigService.apiRoutes.activateAccount;
        /** @type {?} */
        var activateTokenRequest = { token: token, pwd: pwd };
        return this.httpClient
            .post(urlPath, activateTokenRequest)
            .pipe(map((/**
         * @return {?}
         */
        function () { return new ActivateAccountSuccessResponse(_this.authConfigService); })), catchError$1((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            /** @type {?} */
            var ClassToInstantiate = ActivateAccountErrorClasses.get(error.status);
            return throwError(!!ClassToInstantiate ?
                new ClassToInstantiate(_this.authConfigService) :
                new ActivateAccountUnknownErrorResponse(_this.authConfigService));
        })));
    };
    ActivateAccountService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ActivateAccountService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AuthConfigService }
    ]; };
    return ActivateAccountService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ActivateAccountService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountService.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/providers/window.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getWindow() {
    return (typeof window !== 'undefined') ? window : null;
}
var WindowRef = /** @class */ (function (_super) {
    __extends(WindowRef, _super);
    function WindowRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WindowRef;
}(Window));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountComponent = /** @class */ (function () {
    function ActivateAccountComponent(route, router, authConfigService, activateAccountService, window) {
        this.route = route;
        this.router = router;
        this.authConfigService = authConfigService;
        this.activateAccountService = activateAccountService;
        this.window = window;
    }
    /**
     * @return {?}
     */
    ActivateAccountComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var token = this.route.snapshot.queryParamMap.get('token');
        /** @type {?} */
        var pdw = this.route.snapshot.queryParamMap.get('pdw');
        /** @type {?} */
        var redirectTo = this.route.snapshot.queryParamMap.get('urlredirect');
        if (!token || !pdw) {
            this.router.navigate(this.authConfigService.appRoutes.activateAccount.unknownError);
            return;
        }
        this.activateAccountService
            .activate(token, pdw)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return !!redirectTo
            ? _this.window.location.href = redirectTo
            : _this.router.navigate(response.redirectionRoute); }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return _this.router.navigate(error.redirectionRoute); }));
    };
    ActivateAccountComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-activate-account',
                    template: "<sc-auth-page-wrapper mainTitle=\"Activaci\u00F3n de cuenta\">\n  <div class=\"loader-container\" auth-page-wrapper-content>\n    <sc-loading></sc-loading>\n  </div>\n</sc-auth-page-wrapper>"
                }] }
    ];
    /** @nocollapse */
    ActivateAccountComponent.ctorParameters = function () { return [
        { type: ActivatedRoute },
        { type: Router },
        { type: AuthConfigService },
        { type: ActivateAccountService },
        { type: WindowRef }
    ]; };
    return ActivateAccountComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ActivateAccountComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountComponent.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountComponent.prototype.activateAccountService;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountComponent.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account-active-account/activate-account-active-account.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountActiveAccountComponent = /** @class */ (function () {
    function ActivateAccountActiveAccountComponent(authConfigService) {
        this.appRoutes = authConfigService.appRoutes;
    }
    ActivateAccountActiveAccountComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-activate-account-active-account',
                    template: "<sc-activate-account-error-container>\n  Si olvidaste tu contrase\u00F1a, pod\u00E9s <a id=\"go-to-reset-password\" [routerLink]=\"appRoutes.resetPassword\">generar una nueva contrase\u00F1a</a>\n</sc-activate-account-error-container>"
                }] }
    ];
    /** @nocollapse */
    ActivateAccountActiveAccountComponent.ctorParameters = function () { return [
        { type: AuthConfigService }
    ]; };
    return ActivateAccountActiveAccountComponent;
}());
if (false) {
    /** @type {?} */
    ActivateAccountActiveAccountComponent.prototype.appRoutes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account-error-container/activate-account-error-container.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountErrorContainerComponent = /** @class */ (function () {
    function ActivateAccountErrorContainerComponent(route) {
        this.route = route;
    }
    /**
     * @return {?}
     */
    ActivateAccountErrorContainerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initView();
    };
    /**
     * @private
     * @return {?}
     */
    ActivateAccountErrorContainerComponent.prototype.initView = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = this.route.snapshot.data;
        this.imageSource = data.imageSource;
        this.mainTitle = data.mainTitle;
    };
    ActivateAccountErrorContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-activate-account-error-container',
                    template: "<sc-auth-page-wrapper [mainTitle]=\"mainTitle\">\n  <ng-content auth-page-wrapper-subtitle></ng-content>\n  <div class=\"content\" auth-page-wrapper-content *ngIf=\"imageSource\">\n    <img [src]=\"imageSource\" alt=\"Imagen\">\n  </div>\n  <ng-content select=\"[footer]\" auth-page-wrapper-footer></ng-content>\n  <ng-content select=\"[background-content]\" auth-page-wrapper-background-content></ng-content>\n</sc-auth-page-wrapper>\n",
                    styles: [".content{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}"]
                }] }
    ];
    /** @nocollapse */
    ActivateAccountErrorContainerComponent.ctorParameters = function () { return [
        { type: ActivatedRoute }
    ]; };
    return ActivateAccountErrorContainerComponent;
}());
if (false) {
    /** @type {?} */
    ActivateAccountErrorContainerComponent.prototype.imageSource;
    /** @type {?} */
    ActivateAccountErrorContainerComponent.prototype.mainTitle;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountErrorContainerComponent.prototype.route;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account-invalid-token/activate-account-invalid-token.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountInvalidTokenComponent = /** @class */ (function () {
    function ActivateAccountInvalidTokenComponent(authConfigService) {
        this.appRoutes = authConfigService.appRoutes;
    }
    ActivateAccountInvalidTokenComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-activate-account-invalid-token',
                    template: "<sc-activate-account-error-container>\n  El tiempo para activar la cuenta expir\u00F3, <a id=\"go-to-sign-up\" [routerLink]=\"appRoutes.signUp\">cre\u00E1 la cuenta nuevamente</a>\n</sc-activate-account-error-container>"
                }] }
    ];
    /** @nocollapse */
    ActivateAccountInvalidTokenComponent.ctorParameters = function () { return [
        { type: AuthConfigService }
    ]; };
    return ActivateAccountInvalidTokenComponent;
}());
if (false) {
    /** @type {?} */
    ActivateAccountInvalidTokenComponent.prototype.appRoutes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account-unknown-error/activate-account-unknown-error.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountUnknownErrorComponent = /** @class */ (function () {
    function ActivateAccountUnknownErrorComponent(lateralMenuService, authConfigService) {
        this.lateralMenuService = lateralMenuService;
        this.authConfigService = authConfigService;
    }
    /**
     * @return {?}
     */
    ActivateAccountUnknownErrorComponent.prototype.openHelpForm = /**
     * @return {?}
     */
    function () {
        this.lateralMenuService.open(this.authConfigService.lateralHelpComponent);
    };
    ActivateAccountUnknownErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-activate-account-unknown-error',
                    template: "<sc-activate-account-error-container>\n  Estamos experimentando problemas para activar tu cuenta, intent\u00E1 nuevamente m\u00E1s tarde o <button id=\"open-help-form\" class=\"sc-button sc-button--link\" (click)=\"openHelpForm()\">contactate con nosotros</button>\n</sc-activate-account-error-container>"
                }] }
    ];
    /** @nocollapse */
    ActivateAccountUnknownErrorComponent.ctorParameters = function () { return [
        { type: LateralMenuService },
        { type: AuthConfigService }
    ]; };
    return ActivateAccountUnknownErrorComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ActivateAccountUnknownErrorComponent.prototype.lateralMenuService;
    /**
     * @type {?}
     * @private
     */
    ActivateAccountUnknownErrorComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/auth-actions-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var AuthActionsType = {
    SignIn: "SignIn",
    SignUp: "SignUp",
    LogOut: "LogOut",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-actions/auth-actions-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthActionsItem = /** @class */ (function () {
    function AuthActionsItem(spec) {
        Object.assign(this, spec);
    }
    return AuthActionsItem;
}());
if (false) {
    /** @type {?} */
    AuthActionsItem.prototype.id;
    /** @type {?} */
    AuthActionsItem.prototype.label;
    /** @type {?} */
    AuthActionsItem.prototype.action;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-actions/auth-actions.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthActionsComponent = /** @class */ (function () {
    function AuthActionsComponent(router, lateralMenuService, authConfigService) {
        var _a;
        var _this = this;
        this.router = router;
        this.lateralMenuService = lateralMenuService;
        this.authConfigService = authConfigService;
        this.actionItem = null;
        this.actionsType = (_a = {},
            _a[AuthActionsType.SignIn] = {
                id: 'go-to-login',
                label: 'Ingresar',
                action: (/**
                 * @return {?}
                 */
                function () { return _this.router.navigate(_this.authConfigService.appRoutes.login); })
            },
            _a[AuthActionsType.SignUp] = {
                id: 'go-to-sign-up',
                label: 'Crear cuenta',
                action: (/**
                 * @return {?}
                 */
                function () { return _this.router.navigate(_this.authConfigService.appRoutes.signUp); })
            },
            _a[AuthActionsType.LogOut] = {
                id: 'go-to-login',
                label: 'Cerrar sesión',
                action: (/**
                 * @return {?}
                 */
                function () { return _this.router.navigate(_this.authConfigService.appRoutes.logout); })
            },
            _a);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    AuthActionsComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (changes.authAction.currentValue) {
            this.createAction(changes.authAction.currentValue);
        }
    };
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    AuthActionsComponent.prototype.createAction = /**
     * @private
     * @param {?} action
     * @return {?}
     */
    function (action) {
        this.actionItem = new AuthActionsItem(this.actionsType[action]);
    };
    /**
     * @return {?}
     */
    AuthActionsComponent.prototype.openHelp = /**
     * @return {?}
     */
    function () {
        this.lateralMenuService.open(this.authConfigService.lateralHelpComponent);
    };
    AuthActionsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-auth-actions',
                    template: "<div class=\"auth-actions\">\n  <div class=\"auth-actions__buttons\">\n    <sc-button\n      *ngIf=\"actionItem\"\n      type=\"link\"\n      (onClick)=\"actionItem.action()\"\n      id=\"{{actionItem.id}}\">\n      {{actionItem.label}}\n    </sc-button>\n    <span *ngIf=\"actionItem\" class=\"auth-actions__separator\">-</span>\n    <sc-button\n      type=\"link\"\n      (onClick)=\"openHelp()\"\n      id=\"open-help-form\">\n      Ayuda\n    </sc-button>\n  </div>\n</div>\n",
                    styles: [":host{display:block}:host(.footer-action){margin-bottom:1rem}@media (min-width:768px){:host(.footer-action){display:none}}.auth-actions__separator{color:#0070cc;margin:0 3px}"]
                }] }
    ];
    /** @nocollapse */
    AuthActionsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: LateralMenuService },
        { type: AuthConfigService }
    ]; };
    AuthActionsComponent.propDecorators = {
        authAction: [{ type: Input }]
    };
    return AuthActionsComponent;
}());
if (false) {
    /** @type {?} */
    AuthActionsComponent.prototype.authAction;
    /** @type {?} */
    AuthActionsComponent.prototype.actionItem;
    /** @type {?} */
    AuthActionsComponent.prototype.actionsType;
    /**
     * @type {?}
     * @private
     */
    AuthActionsComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    AuthActionsComponent.prototype.lateralMenuService;
    /**
     * @type {?}
     * @private
     */
    AuthActionsComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-actions/auth-actions.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthActionsModule = /** @class */ (function () {
    function AuthActionsModule() {
    }
    AuthActionsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AuthActionsComponent],
                    imports: [
                        CommonModule,
                        ButtonModule
                    ],
                    exports: [AuthActionsComponent]
                },] }
    ];
    return AuthActionsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-page-header/auth-page-header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthPageHeaderComponent = /** @class */ (function () {
    function AuthPageHeaderComponent(authConfigService, window) {
        this.authConfigService = authConfigService;
        this.window = window;
        this.homeUrl = 'https://www.sancristobal.com.ar/institucional';
    }
    /**
     * @return {?}
     */
    AuthPageHeaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logo = this.authConfigService.assets.logo;
        this.showBackButton = this.authConfigService.componentsConfig.authHeader.showBackButton;
    };
    /**
     * @return {?}
     */
    AuthPageHeaderComponent.prototype.goBack = /**
     * @return {?}
     */
    function () {
        this.window.location.href = this.homeUrl;
    };
    AuthPageHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-auth-page-header',
                    template: "<header class=\"header--mobile\">\n  <img [src]=\"logo\" alt=\"San Crist\u00F3bal\" class=\"header__logo\" (click)=\"goBack()\"/>\n</header>\n\n<header class=\"header--desktop\">\n  <img [src]=\"logo\" alt=\"San Crist\u00F3bal\" class=\"header__logo\" (click)=\"goBack()\"/>\n  <sc-auth-actions [authAction]=\"authAction\"></sc-auth-actions>\n</header>\n",
                    styles: [":host{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.header--desktop{display:none}.header--mobile{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between}.header--mobile .header__back-link{color:#0070cc;display:block;z-index:1}.header--mobile .header__logo{max-width:100px;margin:0 auto;cursor:pointer}@media (min-width:768px){.header--mobile{display:none}.header--desktop{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.header--desktop .header__logo{max-width:120px;cursor:pointer}}"]
                }] }
    ];
    /** @nocollapse */
    AuthPageHeaderComponent.ctorParameters = function () { return [
        { type: AuthConfigService },
        { type: WindowRef }
    ]; };
    AuthPageHeaderComponent.propDecorators = {
        authAction: [{ type: Input }]
    };
    return AuthPageHeaderComponent;
}());
if (false) {
    /** @type {?} */
    AuthPageHeaderComponent.prototype.authAction;
    /** @type {?} */
    AuthPageHeaderComponent.prototype.logo;
    /** @type {?} */
    AuthPageHeaderComponent.prototype.homeUrl;
    /** @type {?} */
    AuthPageHeaderComponent.prototype.showBackButton;
    /**
     * @type {?}
     * @private
     */
    AuthPageHeaderComponent.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    AuthPageHeaderComponent.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-page-header/auth-page-header.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthPageHeaderModule = /** @class */ (function () {
    function AuthPageHeaderModule() {
    }
    AuthPageHeaderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AuthPageHeaderComponent],
                    imports: [
                        CommonModule,
                        AuthActionsModule
                    ],
                    exports: [AuthPageHeaderComponent]
                },] }
    ];
    return AuthPageHeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-page-wrapper/auth-page-wrapper.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthPageWrapperComponent = /** @class */ (function () {
    function AuthPageWrapperComponent(authConfigService) {
        this.authConfigService = authConfigService;
    }
    /**
     * @return {?}
     */
    AuthPageWrapperComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.backgroundImage = "url(" + this.authConfigService.assets.backgroundImage + ")";
    };
    AuthPageWrapperComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-auth-page-wrapper',
                    template: "<div class=\"auth-wrapper\">\n  <div class=\"auth-wrapper__main\">\n    <sc-auth-page-header\n      class=\"auth-wrapper__main__header\"\n      [authAction]=\"authAction\"\n    ></sc-auth-page-header>\n    <div class=\"auth-wrapper__main__content\">\n      <div class=\"auth-wrapper__main__content__header\">\n        <h1 class=\"auth-wrapper__main__content__header--title\">{{mainTitle}}</h1>\n        <h3 class=\"auth-wrapper__main__content__header--subtitle\">\n          {{subtitle}}\n          <ng-content select=\"[auth-page-wrapper-subtitle]\"></ng-content>\n        </h3>\n      </div>\n      <div class=\"auth-wrapper__main__content__body\">\n        <ng-content select=\"[auth-page-wrapper-content]\"></ng-content>\n      </div>\n    </div>\n    <div class=\"auth-wrapper__main__footer\">\n      <ng-content select=\"[auth-page-wrapper-footer]\"></ng-content>\n    </div>\n  </div>\n  <div class=\"auth-wrapper-background\" [ngStyle]=\"{'background-image': backgroundImage}\">\n    <ng-content select=\"[auth-page-wrapper-background-content]\"></ng-content>\n  </div>\n  <sc-lateral-menu></sc-lateral-menu>\n</div>\n",
                    encapsulation: ViewEncapsulation.None,
                    styles: [".auth-wrapper{display:-webkit-box;display:flex;min-height:100vh;overflow:hidden;position:relative}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.auth-wrapper{height:800px}}.auth-wrapper-background{background-color:transparent;background-repeat:no-repeat;background-attachment:scroll;background-position:top;background-size:cover;position:relative;-webkit-box-flex:1;flex:1;display:none}.auth-wrapper__main{box-shadow:0 0 20px 0 rgba(0,28,51,.15);display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex:1;padding:1rem}.auth-wrapper__main__header{padding:0 1rem}.auth-wrapper__main__content{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-flex:1;flex:1;-webkit-box-pack:justify;justify-content:space-between;padding:0 1rem}.auth-wrapper__main__content__header{display:-webkit-box;display:flex;padding:2rem 0;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center}.auth-wrapper__main__content__header--title{font:800 2.5rem/3rem Montserrat,sans-serif;line-height:normal!important;margin-bottom:0!important}.auth-wrapper__main__content__header--subtitle{font:400 1.25rem/2rem Montserrat,sans-serif;line-height:initial}.auth-wrapper__main__content__body{-webkit-box-flex:1;flex:1;width:21rem;margin:0 auto}.auth-wrapper__main__footer{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:end;justify-content:flex-end;text-align:center;margin-top:1.5rem}@media (min-width:768px){.auth-wrapper-background{display:initial}.auth-wrapper__main{padding:2rem;-webkit-box-flex:0;flex:0 35%}.auth-wrapper__main__content{padding:0 2rem}.auth-wrapper__main__content__header{padding:2rem 0}.auth-wrapper__main__content__header--title{font-size:1.25rem!important}.auth-wrapper__main__content__header--subtitle{font-size:1rem}.auth-wrapper__main__footer{margin-top:initial}}"]
                }] }
    ];
    /** @nocollapse */
    AuthPageWrapperComponent.ctorParameters = function () { return [
        { type: AuthConfigService }
    ]; };
    AuthPageWrapperComponent.propDecorators = {
        mainTitle: [{ type: Input }],
        subtitle: [{ type: Input }],
        authAction: [{ type: Input }]
    };
    return AuthPageWrapperComponent;
}());
if (false) {
    /** @type {?} */
    AuthPageWrapperComponent.prototype.mainTitle;
    /** @type {?} */
    AuthPageWrapperComponent.prototype.subtitle;
    /** @type {?} */
    AuthPageWrapperComponent.prototype.authAction;
    /** @type {?} */
    AuthPageWrapperComponent.prototype.backgroundImage;
    /**
     * @type {?}
     * @private
     */
    AuthPageWrapperComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-page-wrapper/auth-page-wrapper.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthPageWrapperModule = /** @class */ (function () {
    function AuthPageWrapperModule() {
    }
    AuthPageWrapperModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AuthPageWrapperComponent],
                    imports: [
                        CommonModule,
                        AuthPageHeaderModule,
                        LateralMenuModule
                    ],
                    exports: [AuthPageWrapperComponent]
                },] }
    ];
    return AuthPageWrapperModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/activate-account/activate-account.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0 = getWindow;
var ActivateAccountModule = /** @class */ (function () {
    function ActivateAccountModule() {
    }
    ActivateAccountModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ActivateAccountComponent,
                        ActivateAccountUnknownErrorComponent,
                        ActivateAccountInvalidTokenComponent,
                        ActivateAccountErrorContainerComponent,
                        ActivateAccountActiveAccountComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule.forChild([]),
                        AuthPageWrapperModule,
                        LoadingModule
                    ],
                    exports: [
                        ActivateAccountComponent,
                        ActivateAccountUnknownErrorComponent,
                        ActivateAccountInvalidTokenComponent,
                        ActivateAccountErrorContainerComponent,
                        ActivateAccountActiveAccountComponent
                    ],
                    providers: [
                        {
                            provide: WindowRef,
                            useFactory: ɵ0
                        },
                        ActivateAccountService
                    ]
                },] }
    ];
    return ActivateAccountModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/animations/fade-in-out.animation.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var fadeInOut = trigger('fadeInOut', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
    ]),
    transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms ease-out', style({ opacity: 0 }))
    ])
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-error-messages/auth-error-messages.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthErrorMessagesComponent = /** @class */ (function () {
    function AuthErrorMessagesComponent(authConfigService) {
        this.authConfigService = authConfigService;
        this.error = null;
        this.messages = [];
    }
    /**
     * @return {?}
     */
    AuthErrorMessagesComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        if (!this.error) {
            this.messages = [];
            return;
        }
        if (this.error.error !== null) {
            if (!!this.error.error.message) {
                this.messages = [this.error.error.message];
                return;
            }
            if (Array.isArray(this.error.error.error)) {
                this.messages = this.error.error.error;
                return;
            }
        }
        this.messages = [this.authConfigService.unknownErrorMessage];
    };
    /**
     * @return {?}
     */
    AuthErrorMessagesComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.error = null;
    };
    AuthErrorMessagesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-auth-error-messages',
                    template: "<div class=\"auth__errors-container\" *ngIf=\"error\" @fadeInOut>\n  <button id=\"close-error\" class=\"auth__close-errors\" type=\"button\" (click)=\"close()\">\n    <sc-icon icon=\"close-elipse-flat\"></sc-icon>\n  </button>\n  <div class=\"auth__error-messages\">\n    <div class=\"auth__error-message\" *ngFor=\"let message of messages\">\n      {{ message }}\n      <a *ngIf=\"error?.error?.navigate as navigate\" [routerLink]=\"navigate.link\">{{ navigate.text }}</a>\n    </div>\n  </div>\n</div>\n",
                    animations: [fadeInOut],
                    styles: [".auth__close-errors{background:0 0;border:none}@media (max-width:768px){.auth__close-errors{padding:0}}.auth__errors-container{-webkit-box-align:start;align-items:flex-start;border-radius:3px;display:-webkit-box;display:flex;background-color:#edf0f5;padding:.75rem 1rem;margin-top:1.1rem}.auth__error-messages{margin-left:.875rem}@media (max-width:768px){.auth__error-messages{margin-left:.5rem}}.auth__error-message{color:#424f66;text-align:left;word-break:break-word}:host(.no-margin) .auth__errors-container{margin-top:unset}"]
                }] }
    ];
    /** @nocollapse */
    AuthErrorMessagesComponent.ctorParameters = function () { return [
        { type: AuthConfigService }
    ]; };
    AuthErrorMessagesComponent.propDecorators = {
        error: [{ type: Input }]
    };
    return AuthErrorMessagesComponent;
}());
if (false) {
    /** @type {?} */
    AuthErrorMessagesComponent.prototype.error;
    /** @type {?} */
    AuthErrorMessagesComponent.prototype.messages;
    /**
     * @type {?}
     * @private
     */
    AuthErrorMessagesComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-error-messages/auth-error-messages.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthErrorMessagesModule = /** @class */ (function () {
    function AuthErrorMessagesModule() {
    }
    AuthErrorMessagesModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AuthErrorMessagesComponent],
                    imports: [
                        CommonModule,
                        IconModule,
                        RouterModule.forChild([])
                    ],
                    exports: [AuthErrorMessagesComponent]
                },] }
    ];
    return AuthErrorMessagesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-legal-footer/auth-legal-footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthLegalFooterComponent = /** @class */ (function () {
    function AuthLegalFooterComponent(authConfigService) {
        this.authConfigService = authConfigService;
    }
    /**
     * @return {?}
     */
    AuthLegalFooterComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.siteName = this.authConfigService.appname;
        this.termsLink = this.authConfigService.appRoutes.terms;
    };
    AuthLegalFooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-auth-legal-footer',
                    template: "<span class=\"legal\"> Operar con el {{ siteName }} implica aceptar los\n  <a id=\"go-to-terms-and-conditions\" [routerLink]=\"termsLink\" target=\"_blank\" rel=\"noopener noreferrer\" >t\u00E9rminos y condiciones</a> y <a id=\"go-to-privacy-policy\" href=\"https://www.sancristobal.com.ar/politica-de-privacidad\" target=\"_blank\" rel=\"noopener noreferrer\" >pol\u00EDticas de\n    privacidad</a> en los que se ofrece el servicio.</span>\n",
                    styles: [":host{display:block;line-height:1.1!important}.legal{font-size:.62rem;line-height:1}"]
                }] }
    ];
    /** @nocollapse */
    AuthLegalFooterComponent.ctorParameters = function () { return [
        { type: AuthConfigService }
    ]; };
    return AuthLegalFooterComponent;
}());
if (false) {
    /** @type {?} */
    AuthLegalFooterComponent.prototype.siteName;
    /** @type {?} */
    AuthLegalFooterComponent.prototype.termsLink;
    /**
     * @type {?}
     * @private
     */
    AuthLegalFooterComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/auth-legal-footer/auth-legal-footer.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthLegalFooterModule = /** @class */ (function () {
    function AuthLegalFooterModule() {
    }
    AuthLegalFooterModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AuthLegalFooterComponent],
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    exports: [AuthLegalFooterComponent]
                },] }
    ];
    return AuthLegalFooterModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/form-validator.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormValidatorService = /** @class */ (function () {
    function FormValidatorService() {
    }
    /**
     * @param {?} form
     * @return {?}
     */
    FormValidatorService.prototype.markAsSubmitted = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        /** @type {?} */
        var controls = form.controls;
        for (var controlKey in controls) {
            if (controls.hasOwnProperty(controlKey)) {
                /** @type {?} */
                var control = controls[controlKey];
                control.markAsTouched();
                control.updateValueAndValidity();
            }
        }
    };
    FormValidatorService.decorators = [
        { type: Injectable }
    ];
    return FormValidatorService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/auth-success.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthSuccess = /** @class */ (function () {
    function AuthSuccess(data, redirectionRoute) {
        this._redirectionRoute = !!redirectionRoute ? [redirectionRoute] : ['/'];
        this.authToken = data.auth_Token;
        this.refreshToken = data.refresh_Token;
    }
    /**
     * @return {?}
     */
    AuthSuccess.prototype.getRedirectionRoute = /**
     * @return {?}
     */
    function () {
        return this._redirectionRoute;
    };
    return AuthSuccess;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AuthSuccess.prototype._redirectionRoute;
    /** @type {?} */
    AuthSuccess.prototype.authToken;
    /** @type {?} */
    AuthSuccess.prototype.error;
    /** @type {?} */
    AuthSuccess.prototype.message;
    /** @type {?} */
    AuthSuccess.prototype.refreshToken;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/token.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TokenService = /** @class */ (function () {
    function TokenService(localStorage, jwtService) {
        this.localStorage = localStorage;
        this.jwtService = jwtService;
        this.authTokenKey = 'auth_token';
        this.refreshTokenKey = 'refresh_token';
    }
    /**
     * @template T
     * @param {?} token
     * @return {?}
     */
    TokenService.prototype.decodeToken = /**
     * @template T
     * @param {?} token
     * @return {?}
     */
    function (token) {
        return this.jwtService.decodeToken(token);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.getAuthToken = /**
     * @return {?}
     */
    function () {
        return this.localStorage.getItem(this.authTokenKey);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.getRefreshToken = /**
     * @return {?}
     */
    function () {
        return this.localStorage.getItem(this.refreshTokenKey);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.getAuthTokenExpiration = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var authToken = this.getAuthToken();
        if (!authToken) {
            return null;
        }
        return this.jwtService.getTokenExpirationDate(authToken);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.isAuthTokenExpired = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var authToken = this.getAuthToken();
        if (!authToken) {
            return true;
        }
        return this.isTokenExpired(authToken);
    };
    /**
     * @param {?} token
     * @return {?}
     */
    TokenService.prototype.isTokenExpired = /**
     * @param {?} token
     * @return {?}
     */
    function (token) {
        return this.jwtService.isTokenExpired(token);
    };
    /**
     * @param {?} token
     * @return {?}
     */
    TokenService.prototype.setAuthToken = /**
     * @param {?} token
     * @return {?}
     */
    function (token) {
        this.localStorage.setItem(this.authTokenKey, token);
    };
    /**
     * @param {?} token
     * @return {?}
     */
    TokenService.prototype.setRefreshToken = /**
     * @param {?} token
     * @return {?}
     */
    function (token) {
        this.localStorage.setItem(this.refreshTokenKey, token);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.clean = /**
     * @return {?}
     */
    function () {
        this.localStorage.removeItem(this.authTokenKey);
        this.localStorage.removeItem(this.refreshTokenKey);
    };
    /**
     * @return {?}
     */
    TokenService.prototype.getDecodedAuthToken = /**
     * @return {?}
     */
    function () {
        return this.jwtService.decodeToken(this.getAuthToken());
    };
    TokenService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TokenService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: ['LocalStorage',] }] },
        { type: undefined, decorators: [{ type: Inject, args: ['JwtService',] }] }
    ]; };
    return TokenService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TokenService.prototype.authTokenKey;
    /**
     * @type {?}
     * @private
     */
    TokenService.prototype.refreshTokenKey;
    /**
     * @type {?}
     * @private
     */
    TokenService.prototype.localStorage;
    /**
     * @type {?}
     * @private
     */
    TokenService.prototype.jwtService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/user-id-types.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var UserIdType = {
    Cuit: "Ext_CUIT80",
    Dni: "Ext_DNI96",
    Passport: "Ext_PAS94",
};
/**
 * @record
 */
function Length() { }
if (false) {
    /** @type {?} */
    Length.prototype.minLength;
    /** @type {?} */
    Length.prototype.maxLength;
}
/** @type {?} */
var userIdTypeLength = new Map([
    [UserIdType.Cuit, { minLength: 11, maxLength: 11 }],
    [UserIdType.Dni, { minLength: 7, maxLength: 8 }],
    [UserIdType.Passport, { minLength: 7, maxLength: 25 }]
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/user.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var User = /** @class */ (function () {
    function User(data) {
        this.roles = data.roles;
        if (data.userId) {
            this.userId = data.userId;
        }
        if (data.firstName) {
            this.firstName = data.firstName;
        }
        if (data.email) {
            this.email = data.email;
        }
        if (data.gender) {
            this.gender = data.gender;
        }
        if (data.idType) {
            this.idType = data.idType;
        }
        if (data.lastName) {
            this.lastName = data.lastName;
        }
        if (data.cuitCuil) {
            this.cuitCuil = data.cuitCuil;
        }
        if (data.taxId) {
            this.taxId = data.taxId;
        }
        if (data.key !== undefined) {
            this.key = data.key;
        }
        if (data.permissions) {
            this.permissions = Array.isArray(data.permissions) ? data.permissions : [data.permissions];
        }
        this.isSignedUpDigitalPolicy = data.isSignedUpDigitalPolicy;
    }
    /**
     * @param {?} email
     * @return {?}
     */
    User.obfuscateEmail = /**
     * @param {?} email
     * @return {?}
     */
    function (email) {
        /** @type {?} */
        var splitEmail = email.split('@');
        /** @type {?} */
        var userName = splitEmail[0].slice(0, 3) + "****";
        /** @type {?} */
        var domain = splitEmail[1];
        return userName + "@" + domain;
    };
    /**
     * @return {?}
     */
    User.prototype.getId = /**
     * @return {?}
     */
    function () {
        if (!this.idType) {
            return null;
        }
        return (this.idType === UserIdType.Dni || this.idType === UserIdType.Passport) ? this.taxId : this.cuitCuil;
    };
    /**
     * @return {?}
     */
    User.prototype.getFullName = /**
     * @return {?}
     */
    function () {
        return this.firstName && this.lastName ? this.firstName + " " + this.lastName : null;
    };
    /**
     * @return {?}
     */
    User.prototype.getShortName = /**
     * @return {?}
     */
    function () {
        return this.firstName || this.lastName;
    };
    /**
     * @return {?}
     */
    User.prototype.shouldUpdateProperties = /**
     * @return {?}
     */
    function () {
        return !this.key;
    };
    /**
     * @param {?} permissionsToCheck
     * @return {?}
     */
    User.prototype.hasAllPermissions = /**
     * @param {?} permissionsToCheck
     * @return {?}
     */
    function (permissionsToCheck) {
        var _this = this;
        return permissionsToCheck
            .every((/**
         * @param {?} permission
         * @return {?}
         */
        function (permission) { return _this.permissions.includes(permission); }));
    };
    /**
     * @param {?} permissionsToCheck
     * @return {?}
     */
    User.prototype.hasSomePermission = /**
     * @param {?} permissionsToCheck
     * @return {?}
     */
    function (permissionsToCheck) {
        var _this = this;
        return permissionsToCheck
            .some((/**
         * @param {?} permission
         * @return {?}
         */
        function (permission) { return _this.permissions.includes(permission); }));
    };
    return User;
}());
if (false) {
    /** @type {?} */
    User.prototype.userId;
    /** @type {?} */
    User.prototype.cuitCuil;
    /** @type {?} */
    User.prototype.email;
    /** @type {?} */
    User.prototype.firstName;
    /** @type {?} */
    User.prototype.gender;
    /** @type {?} */
    User.prototype.idType;
    /** @type {?} */
    User.prototype.key;
    /** @type {?} */
    User.prototype.isSignedUpDigitalPolicy;
    /** @type {?} */
    User.prototype.lastName;
    /** @type {?} */
    User.prototype.roles;
    /** @type {?} */
    User.prototype.permissions;
    /** @type {?} */
    User.prototype.taxId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/activate-account-request.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivateAccountRequest = /** @class */ (function () {
    function ActivateAccountRequest() {
    }
    return ActivateAccountRequest;
}());
if (false) {
    /** @type {?} */
    ActivateAccountRequest.prototype.token;
    /** @type {?} */
    ActivateAccountRequest.prototype.pwd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/auth-base.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AuthBase() { }
if (false) {
    /** @type {?} */
    AuthBase.prototype.error;
    /** @type {?} */
    AuthBase.prototype.message;
    /**
     * @return {?}
     */
    AuthBase.prototype.getRedirectionRoute = function () { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/auth-success-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AuthSuccessResponse() { }
if (false) {
    /** @type {?} */
    AuthSuccessResponse.prototype.auth_Token;
    /** @type {?} */
    AuthSuccessResponse.prototype.refresh_Token;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/change-reset-password.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ChangeResetPasswordRequest = /** @class */ (function () {
    function ChangeResetPasswordRequest() {
    }
    return ChangeResetPasswordRequest;
}());
if (false) {
    /** @type {?} */
    ChangeResetPasswordRequest.prototype.token;
    /** @type {?} */
    ChangeResetPasswordRequest.prototype.newPassword;
    /** @type {?} */
    ChangeResetPasswordRequest.prototype.pwd;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/decoded-auth-token.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function DecodedAuthToken() { }
if (false) {
    /** @type {?} */
    DecodedAuthToken.prototype.ApplicationId;
    /** @type {?} */
    DecodedAuthToken.prototype.ApplicationToken;
    /** @type {?} */
    DecodedAuthToken.prototype.AutomationAccess;
    /** @type {?} */
    DecodedAuthToken.prototype.nameid;
    /** @type {?} */
    DecodedAuthToken.prototype.unique_name;
    /** @type {?} */
    DecodedAuthToken.prototype.email;
    /** @type {?} */
    DecodedAuthToken.prototype.FirstName;
    /** @type {?} */
    DecodedAuthToken.prototype.LastName;
    /** @type {?} */
    DecodedAuthToken.prototype.TaxId;
    /** @type {?} */
    DecodedAuthToken.prototype.OfficialIdType;
    /** @type {?} */
    DecodedAuthToken.prototype.gender;
    /** @type {?} */
    DecodedAuthToken.prototype.CuitCuil;
    /** @type {?} */
    DecodedAuthToken.prototype.role;
    /** @type {?|undefined} */
    DecodedAuthToken.prototype.permission;
    /** @type {?} */
    DecodedAuthToken.prototype.nbf;
    /** @type {?} */
    DecodedAuthToken.prototype.exp;
    /** @type {?} */
    DecodedAuthToken.prototype.iat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/login-missing-email.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginMissingEmail = /** @class */ (function () {
    function LoginMissingEmail(error, authConfigService) {
        this.error = error;
        this.authConfigService = authConfigService;
        this.message = error.error.error[0];
    }
    /**
     * @return {?}
     */
    LoginMissingEmail.prototype.getRedirectionRoute = /**
     * @return {?}
     */
    function () {
        return this.authConfigService.appRoutes.user.missingEmail;
    };
    return LoginMissingEmail;
}());
if (false) {
    /** @type {?} */
    LoginMissingEmail.prototype.message;
    /** @type {?} */
    LoginMissingEmail.prototype.error;
    /**
     * @type {?}
     * @private
     */
    LoginMissingEmail.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/login-request.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginRequest = /** @class */ (function () {
    function LoginRequest() {
    }
    return LoginRequest;
}());
if (false) {
    /** @type {?} */
    LoginRequest.prototype.userName;
    /** @type {?} */
    LoginRequest.prototype.password;
    /** @type {?} */
    LoginRequest.prototype.applicationToken;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/login-reset-password.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginResetPassword = /** @class */ (function () {
    function LoginResetPassword(error, authConfigService) {
        this.error = error;
        this.authConfigService = authConfigService;
        this.message = error.error.error[0];
    }
    /**
     * @return {?}
     */
    LoginResetPassword.prototype.getRedirectionRoute = /**
     * @return {?}
     */
    function () {
        return this.authConfigService.appRoutes.user.resetPassword;
    };
    return LoginResetPassword;
}());
if (false) {
    /** @type {?} */
    LoginResetPassword.prototype.message;
    /** @type {?} */
    LoginResetPassword.prototype.error;
    /**
     * @type {?}
     * @private
     */
    LoginResetPassword.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/remember-me.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RememberMe = /** @class */ (function () {
    function RememberMe() {
    }
    return RememberMe;
}());
if (false) {
    /** @type {?} */
    RememberMe.prototype.userId;
    /** @type {?} */
    RememberMe.prototype.rememberMe;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/reset-password-request.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ResetPasswordRequest = /** @class */ (function () {
    function ResetPasswordRequest() {
    }
    return ResetPasswordRequest;
}());
if (false) {
    /** @type {?} */
    ResetPasswordRequest.prototype.recoverCriteria;
    /** @type {?} */
    ResetPasswordRequest.prototype.applicationToken;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/reset-password-response.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ResetPasswordResponse = /** @class */ (function () {
    function ResetPasswordResponse(message) {
        this.message = message;
    }
    return ResetPasswordResponse;
}());
if (false) {
    /** @type {?} */
    ResetPasswordResponse.prototype.message;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/login-error-response.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var LoginErrorStatuses = {
    ResetPassword: 409,
    MissingEmail: 426,
};
LoginErrorStatuses[LoginErrorStatuses.ResetPassword] = 'ResetPassword';
LoginErrorStatuses[LoginErrorStatuses.MissingEmail] = 'MissingEmail';
/** @type {?} */
var loginErrorClasses = new Map([
    [LoginErrorStatuses.ResetPassword, LoginResetPassword],
    [LoginErrorStatuses.MissingEmail, LoginMissingEmail]
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/login.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginService = /** @class */ (function () {
    function LoginService(httpClient, authConfigService, tokenService) {
        this.httpClient = httpClient;
        this.authConfigService = authConfigService;
        this.tokenService = tokenService;
        this.user = this.generateUser(this.tokenService.getDecodedAuthToken());
        this.userSource$ = new BehaviorSubject$1(this.user);
        this.user$ = this.userSource$.asObservable();
    }
    /**
     * @private
     * @param {?} error
     * @return {?}
     */
    LoginService.prototype.getLoginErrorResponse = /**
     * @private
     * @param {?} error
     * @return {?}
     */
    function (error) {
        /** @type {?} */
        var LoginErrorClass = loginErrorClasses.get(error.status);
        return !!LoginErrorClass ? of(new LoginErrorClass(error)) : throwError(error);
    };
    /**
     * @return {?}
     */
    LoginService.prototype.executeAuthentication = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return new AuthSuccess(response, _this.returnUrl); })), tap((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return _this.saveTokens(response); })), tap((/**
         * @return {?}
         */
        function () { return _this.updateUser(_this.generateUser(_this.tokenService.getDecodedAuthToken())); })));
    };
    /**
     * @private
     * @param {?} decodedToken
     * @return {?}
     */
    LoginService.prototype.generateUser = /**
     * @private
     * @param {?} decodedToken
     * @return {?}
     */
    function (decodedToken) {
        return !!decodedToken
            ? new User({
                userId: decodedToken.nameid,
                cuitCuil: decodedToken.CuitCuil,
                email: decodedToken.email,
                firstName: decodedToken.FirstName,
                gender: decodedToken.gender,
                idType: decodedToken.OfficialIdType,
                lastName: decodedToken.LastName,
                roles: decodedToken.role,
                permissions: decodedToken.permission,
                taxId: decodedToken.TaxId,
            })
            : null;
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    LoginService.prototype.saveTokens = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        this.tokenService.setAuthToken(response.authToken);
        this.tokenService.setRefreshToken(response.refreshToken);
    };
    /**
     * @private
     * @param {?} user
     * @return {?}
     */
    LoginService.prototype.updateUser = /**
     * @private
     * @param {?} user
     * @return {?}
     */
    function (user) {
        this.user = user;
        this.userSource$.next(user);
    };
    /**
     * @return {?}
     */
    LoginService.prototype.cleanupUser = /**
     * @return {?}
     */
    function () {
        this.userSource$.next(null);
    };
    /**
     * @param {?} userName
     * @param {?} passwordHash
     * @return {?}
     */
    LoginService.prototype.login = /**
     * @param {?} userName
     * @param {?} passwordHash
     * @return {?}
     */
    function (userName, passwordHash) {
        var _this = this;
        /** @type {?} */
        var urlPath = this.authConfigService.apiRoutes.base + "/" + this.authConfigService.apiRoutes.login;
        /** @type {?} */
        var loginRequest = {
            userName: userName,
            password: passwordHash
        };
        return this.httpClient
            .post(urlPath, loginRequest)
            .pipe(this.executeAuthentication(), catchError$1((/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return _this.getLoginErrorResponse(error); })));
    };
    LoginService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LoginService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AuthConfigService },
        { type: TokenService }
    ]; };
    /** @nocollapse */ LoginService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(ɵɵinject(HttpClient), ɵɵinject(AuthConfigService), ɵɵinject(TokenService)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.user;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.userSource$;
    /** @type {?} */
    LoginService.prototype.user$;
    /** @type {?} */
    LoginService.prototype.returnUrl;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    LoginService.prototype.tokenService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/remember-me.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RememberMeKey = 'rememberMe';
var RememberMeService = /** @class */ (function () {
    function RememberMeService(storage) {
        this.storage = storage;
    }
    /**
     * @param {?} rememberMe
     * @return {?}
     */
    RememberMeService.prototype.set = /**
     * @param {?} rememberMe
     * @return {?}
     */
    function (rememberMe) {
        if (rememberMe.rememberMe) {
            this.storage.removeItem(RememberMeKey);
            this.storage.setItem(RememberMeKey, JSON.stringify(rememberMe));
        }
        else {
            this.storage.removeItem(RememberMeKey);
        }
    };
    /**
     * @return {?}
     */
    RememberMeService.prototype.get = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var value = this.storage.getItem(RememberMeKey);
        if (value === null) {
            return {};
        }
        return JSON.parse(value);
    };
    RememberMeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RememberMeService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: ['LocalStorage',] }] }
    ]; };
    return RememberMeService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RememberMeService.prototype.storage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/providers/location.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getLocation() {
    return (typeof window !== 'undefined') ? window.location : null;
}
var LocationRef = /** @class */ (function (_super) {
    __extends(LocationRef, _super);
    function LocationRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LocationRef;
}(Location));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/login-microsoft.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginMicrosoftService = /** @class */ (function () {
    function LoginMicrosoftService(location) {
        this.location = location;
    }
    /**
     * @param {?} login
     * @return {?}
     */
    LoginMicrosoftService.prototype.login = /**
     * @param {?} login
     * @return {?}
     */
    function (login) {
        // tslint:disable-next-line: max-line-length
        /** @type {?} */
        var url = "https://login.microsoftonline.com/" + login.tenantId + "/oauth2/v2.0/authorize?client_id=" + login.appId + "&response_type=code&redirect_uri=" + login.redirectUri + "&response_mode=query&scope=offline_access%20user.read";
        this.location.assign(url);
    };
    /**
     * @return {?}
     */
    LoginMicrosoftService.prototype.logout = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = 'https://login.microsoftonline.com/common/oauth2/logout';
        this.location.assign(url);
    };
    LoginMicrosoftService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LoginMicrosoftService.ctorParameters = function () { return [
        { type: LocationRef }
    ]; };
    return LoginMicrosoftService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoginMicrosoftService.prototype.location;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/login-ad-identity.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginAdIdentityService = /** @class */ (function () {
    function LoginAdIdentityService(loginMicrosoftService, httpClient, tokenService) {
        this.loginMicrosoftService = loginMicrosoftService;
        this.httpClient = httpClient;
        this.tokenService = tokenService;
        this.userSessionSubject$ = new BehaviorSubject$1(this.generateUser(this.tokenService.getDecodedAuthToken()));
    }
    /**
     * @return {?}
     */
    LoginAdIdentityService.prototype.clean = /**
     * @return {?}
     */
    function () {
        this.userSessionSubject$.next(null);
        this.tokenService.clean();
    };
    /**
     * @return {?}
     */
    LoginAdIdentityService.prototype.getAuthToken = /**
     * @return {?}
     */
    function () {
        return this.tokenService.getAuthToken();
    };
    /**
     * @param {?} login
     * @return {?}
     */
    LoginAdIdentityService.prototype.loginIdentity = /**
     * @param {?} login
     * @return {?}
     */
    function (login) {
        var _this = this;
        return this.httpClient.post(login.url, login).pipe(tap((/**
         * @param {?} res
         * @return {?}
         */
        function (res) { return _this.loginIdentityHandler(res); })));
    };
    /**
     * @return {?}
     */
    LoginAdIdentityService.prototype.isAuthenticated = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var sessionUser = this.userSessionSubject$.value;
        return !!sessionUser && !!sessionUser.userId;
    };
    /**
     * @param {?} role
     * @return {?}
     */
    LoginAdIdentityService.prototype.hasRole = /**
     * @param {?} role
     * @return {?}
     */
    function (role) {
        if (!this.isAuthenticated()) {
            return false;
        }
        /** @type {?} */
        var userSession = this.userSessionSubject$.value;
        return !!userSession && userSession.roles.includes(role);
    };
    /**
     * @param {?} login
     * @return {?}
     */
    LoginAdIdentityService.prototype.login = /**
     * @param {?} login
     * @return {?}
     */
    function (login) {
        this.clean();
        this.loginMicrosoftService.login(login);
    };
    /**
     * @param {?} response
     * @return {?}
     */
    LoginAdIdentityService.prototype.saveTokens = /**
     * @param {?} response
     * @return {?}
     */
    function (response) {
        this.tokenService.setAuthToken(response.authToken);
        this.tokenService.setRefreshToken(response.refreshToken);
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    LoginAdIdentityService.prototype.loginIdentityHandler = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        this.saveTokens(new AuthSuccess(response));
        this.userSessionSubject$.next(this.generateUser(this.tokenService.getDecodedAuthToken()));
    };
    /**
     * @private
     * @param {?} decodedToken
     * @return {?}
     */
    LoginAdIdentityService.prototype.generateUser = /**
     * @private
     * @param {?} decodedToken
     * @return {?}
     */
    function (decodedToken) {
        return !!decodedToken
            ? new User({
                userId: decodedToken.nameid,
                cuitCuil: decodedToken.CuitCuil,
                email: decodedToken.email,
                firstName: decodedToken.FirstName,
                gender: decodedToken.gender,
                idType: decodedToken.OfficialIdType,
                lastName: decodedToken.LastName,
                roles: decodedToken.role,
                permissions: decodedToken.permission,
                taxId: decodedToken.TaxId,
            })
            : null;
    };
    LoginAdIdentityService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LoginAdIdentityService.ctorParameters = function () { return [
        { type: LoginMicrosoftService },
        { type: HttpClient },
        { type: TokenService }
    ]; };
    return LoginAdIdentityService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    LoginAdIdentityService.prototype.userSessionSubject$;
    /**
     * @type {?}
     * @private
     */
    LoginAdIdentityService.prototype.loginMicrosoftService;
    /**
     * @type {?}
     * @private
     */
    LoginAdIdentityService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    LoginAdIdentityService.prototype.tokenService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/login/login.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginComponent = /** @class */ (function () {
    function LoginComponent(router, authConfigService, loginService, rememberMe, formValidator, loginAdIdentityService) {
        this.router = router;
        this.authConfigService = authConfigService;
        this.loginService = loginService;
        this.rememberMe = rememberMe;
        this.formValidator = formValidator;
        this.loginAdIdentityService = loginAdIdentityService;
        this.error = null;
        this.authAction = AuthActionsType.SignUp;
        this.isLoggingIntoAD = false;
        this.appRoutes = authConfigService.appRoutes;
        this.showADLogin = authConfigService.componentsConfig.login.showADLogin;
    }
    /**
     * @return {?}
     */
    LoginComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setupComponent();
        this.initForm();
        this.getRememberMe();
    };
    /**
     * @private
     * @return {?}
     */
    LoginComponent.prototype.initForm = /**
     * @private
     * @return {?}
     */
    function () {
        this.form = new FormGroup({
            userId: new FormControl('', this.authConfigService.componentsConfig.login.userIdValidators),
            password: new FormControl('', [Validators.required]),
            rememberMe: new FormControl(false, [])
        });
    };
    /**
     * @private
     * @return {?}
     */
    LoginComponent.prototype.setupComponent = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var loginConfig = this.authConfigService.componentsConfig.login;
        this.appRoutes = this.authConfigService.appRoutes;
        this.subtitle = "Ingres\u00E1 al " + this.authConfigService.appname;
        this.showTooltip = loginConfig.showTooltip;
        this.tooltipText = loginConfig.tooltipText;
        this.userIdLabel = loginConfig.userIdLabel;
        this.userIdErrorMessages = loginConfig.userIdErrorMessages;
        this.userIdMaxLength = loginConfig.userIdMaxLength;
        this.pipes = loginConfig.isPipedUserId
            ? [{ 'pipe': loginConfig.userIdPipe }]
            : null;
        this.passwordMaxLength = loginConfig.passwordMaxLength;
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.getRememberMe = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var rememberMe = this.rememberMe.get();
        if (!rememberMe.rememberMe) {
            return;
        }
        this.form.controls.userId.setValue(rememberMe.userId);
        this.form.controls.rememberMe.setValue(rememberMe.rememberMe);
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.loginActiveDirectory = /**
     * @return {?}
     */
    function () {
        this.error = null;
        if (this.isLoading) {
            return;
        }
        this.isLoggingIntoAD = true;
        /** @type {?} */
        var loginADConfig = this.authConfigService.loginAD;
        this.loginAdIdentityService.login({
            appId: loginADConfig.appId,
            tenantId: loginADConfig.tenantId,
            redirectUri: loginADConfig.redirectUri
        });
        this.isLoggingIntoAD = false;
    };
    /**
     * @return {?}
     */
    LoginComponent.prototype.login = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.error = null;
        if (this.isLoading) {
            return;
        }
        if (this.form.invalid) {
            this.formValidator.markAsSubmitted(this.form);
            return;
        }
        this.isLoading = true;
        /** @type {?} */
        var formValue = this.form.value;
        this.loginService
            .login(formValue.userId, formValue.password)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            _this.rememberMe.set({
                userId: formValue.userId,
                rememberMe: formValue.rememberMe
            });
            _this.router.navigate(response.getRedirectionRoute(), { state: { message: response.message } })
                .then((/**
             * @return {?}
             */
            function () { return _this.isLoading = false; }));
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.error = error;
            _this.isLoading = false;
        }));
    };
    LoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-login',
                    template: "<sc-auth-page-wrapper mainTitle=\"\u00A1Hola!\" [subtitle]=\"subtitle\" [authAction]=\"authAction\">\n  <form auth-page-wrapper-content [formGroup]=\"form\" class=\"text-center\">\n    <sc-tooltip-input-decorator *ngIf=\"showTooltip\" [tooltipText]=\"tooltipText\" placement=\"bottom\">\n      <sc-input\n        [maxlength]=\"userIdMaxLength\"\n        [pipes]=\"pipes\"\n        [errorMessages]=\"userIdErrorMessages\"\n        [placeholder]=\"userIdLabel\"\n        [label]=\"userIdLabel\"\n        [debounceTime]=\"400\"\n        autocomplete=\"off\"\n        formControlName=\"userId\"\n        icon=\"question-elipse\"\n        type=\"text\"\n      ></sc-input>\n    </sc-tooltip-input-decorator>\n    <sc-input\n      *ngIf=\"!showTooltip\"\n      [maxlength]=\"userIdMaxLength\"\n      [placeholder]=\"userIdLabel\"\n      [pipes]=\"pipes\"\n      [errorMessages]=\"userIdErrorMessages\"\n      [label]=\"userIdLabel\"\n      [debounceTime]=\"400\"\n      autocomplete=\"off\"\n      formControlName=\"userId\"\n      type=\"text\"\n    ></sc-input>\n    <sc-input\n      [maxlength]=\"passwordMaxLength\"\n      [debounceTime]=\"400\"\n      autocomplete=\"off\"\n      formControlName=\"password\"\n      placeholder=\"Contrase\u00F1a\"\n      label=\"Contrase\u00F1a\"\n      type=\"password\"\n      required\n    ></sc-input>\n    <div class=\"login__forgot-password\">\n      <a \n        id=\"go-to-forgotten-password\"\n        class=\"login__forgot-password-link\"\n        [routerLink]=\"appRoutes.resetPassword\"\n      >\u00BFOlvidaste tu contrase\u00F1a?</a>\n      <sc-checkbox class=\"sc-checkbox__small\" formControlName=\"rememberMe\">Recordarme</sc-checkbox>\n    </div>\n    <sc-button type=\"primary\" (onClick)=\"login()\" [loading]=\"isLoading\" [disabled]=\"isLoading || form.invalid || isLoggingIntoAD\" id=\"login-button\">\n      Ingresar\n    </sc-button>\n    <div class=\"login-ad\" *ngIf=\"showADLogin\">\n      <sc-button\n        type=\"link-secondary\"\n        (onClick)=\"loginActiveDirectory()\"\n        [loading]=\"isLoggingIntoAD\"\n        [disabled]=\"isLoading || isLoggingIntoAD\"\n        id=\"loginAD-button\">\n          \u00BFSos usuario interno? Hac\u00E9 click ac\u00E1\n      </sc-button>\n    </div>\n    <sc-auth-error-messages [error]=\"error\"></sc-auth-error-messages>\n  </form>\n  <div auth-page-wrapper-footer>\n    <sc-auth-actions class=\"footer-action\" [authAction]=\"authAction\"></sc-auth-actions>\n    <sc-auth-legal-footer></sc-auth-legal-footer>\n  </div>\n</sc-auth-page-wrapper>",
                    styles: [".login__forgot-password{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:justify;justify-content:space-between;margin-bottom:1rem}.login__forgot-password-link{font-size:.75rem;line-height:1rem;text-decoration:none}.login-ad{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;margin:1rem}"]
                }] }
    ];
    /** @nocollapse */
    LoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: AuthConfigService },
        { type: LoginService },
        { type: RememberMeService },
        { type: FormValidatorService },
        { type: LoginAdIdentityService }
    ]; };
    return LoginComponent;
}());
if (false) {
    /** @type {?} */
    LoginComponent.prototype.form;
    /** @type {?} */
    LoginComponent.prototype.isLoading;
    /** @type {?} */
    LoginComponent.prototype.showTooltip;
    /** @type {?} */
    LoginComponent.prototype.tooltipText;
    /** @type {?} */
    LoginComponent.prototype.userIdLabel;
    /** @type {?} */
    LoginComponent.prototype.subtitle;
    /** @type {?} */
    LoginComponent.prototype.userIdMaxLength;
    /** @type {?} */
    LoginComponent.prototype.passwordMaxLength;
    /** @type {?} */
    LoginComponent.prototype.appRoutes;
    /** @type {?} */
    LoginComponent.prototype.pipes;
    /** @type {?} */
    LoginComponent.prototype.userIdErrorMessages;
    /** @type {?} */
    LoginComponent.prototype.error;
    /** @type {?} */
    LoginComponent.prototype.authAction;
    /** @type {?} */
    LoginComponent.prototype.showADLogin;
    /** @type {?} */
    LoginComponent.prototype.isLoggingIntoAD;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.loginService;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.rememberMe;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.formValidator;
    /**
     * @type {?}
     * @private
     */
    LoginComponent.prototype.loginAdIdentityService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/login/login.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginModule = /** @class */ (function () {
    function LoginModule() {
    }
    LoginModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [LoginComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        RouterModule,
                        ButtonModule,
                        CheckboxModule,
                        InputModule,
                        TooltipInputDecoratorModule,
                        AuthPageWrapperModule,
                        AuthErrorMessagesModule,
                        AuthActionsModule,
                        AuthLegalFooterModule
                    ],
                    exports: [LoginComponent]
                },] }
    ];
    return LoginModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/password.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PasswordService = /** @class */ (function () {
    function PasswordService(httpClient, authConfigService) {
        this.httpClient = httpClient;
        this.authConfigService = authConfigService;
    }
    /**
     * @param {?} recoverCriteria
     * @return {?}
     */
    PasswordService.prototype.resetPassword = /**
     * @param {?} recoverCriteria
     * @return {?}
     */
    function (recoverCriteria) {
        /** @type {?} */
        var apiRoutes = this.authConfigService.apiRoutes;
        /** @type {?} */
        var urlPath = apiRoutes.base + "/" + apiRoutes.resetPassword;
        /** @type {?} */
        var resetPasswordRequest = {
            recoverCriteria: recoverCriteria,
            applicationToken: this.authConfigService.applicationToken
        };
        return this.httpClient
            .post(urlPath, resetPasswordRequest)
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return new ResetPasswordResponse(response.message); })));
    };
    /**
     * @param {?} token
     * @param {?} pwd
     * @param {?} newPassword
     * @return {?}
     */
    PasswordService.prototype.setNewPass = /**
     * @param {?} token
     * @param {?} pwd
     * @param {?} newPassword
     * @return {?}
     */
    function (token, pwd, newPassword) {
        /** @type {?} */
        var apiRoutes = this.authConfigService.apiRoutes;
        /** @type {?} */
        var urlPath = apiRoutes.base + "/" + apiRoutes.changeResetPassword;
        /** @type {?} */
        var changeResetPasswordRequest = { token: token, newPassword: newPassword, pwd: pwd };
        return this.httpClient.post(urlPath, changeResetPasswordRequest);
    };
    PasswordService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PasswordService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: AuthConfigService }
    ]; };
    return PasswordService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    PasswordService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    PasswordService.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/recover-password/recover-password.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RecoverPasswordComponent = /** @class */ (function () {
    function RecoverPasswordComponent(router, route, passwordService, authConfigService, formValidator, window) {
        this.router = router;
        this.route = route;
        this.passwordService = passwordService;
        this.authConfigService = authConfigService;
        this.formValidator = formValidator;
        this.window = window;
        this.loading = false;
        this.error = null;
        this.isLoading = false;
        this.authAction = AuthActionsType.SignIn;
        this.form = new FormGroup({
            password: new FormControl('', [Validators.required, ValidatePassword$1])
        });
    }
    /**
     * @return {?}
     */
    RecoverPasswordComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var queryParamMap = this.route.snapshot.queryParamMap;
        this.token = queryParamMap.get('token');
        this.pdw = queryParamMap.get('pdw');
        this.redirectTo = queryParamMap.get('urlredirect');
        if (!this.token || !this.pdw) {
            this.router.navigate(['/']);
        }
    };
    /**
     * @return {?}
     */
    RecoverPasswordComponent.prototype.recoverPass = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.error = null;
        if (this.form.invalid) {
            this.formValidator.markAsSubmitted(this.form);
            return;
        }
        this.isLoading = true;
        this.passwordService
            .setNewPass(this.token, this.pdw, this.form.controls.password.value)
            .subscribe((/**
         * @return {?}
         */
        function () { return !!_this.redirectTo ?
            _this.window.location.href = _this.redirectTo
            : _this.router.navigate(_this.authConfigService.appRoutes.recoverPasswordSuccess); }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return _this.error = error; }))
            .add((/**
         * @return {?}
         */
        function () { return _this.isLoading = false; }));
    };
    RecoverPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-recover-password',
                    template: "<sc-auth-page-wrapper\n  mainTitle=\"Ingres\u00E1 tu nueva contrase\u00F1a\"\n  [authAction]=\"authAction\">\n  <form auth-page-wrapper-content [formGroup]=\"form\" class=\"text-center\">\n    <sc-input\n      #password\n      autocomplete=\"off\"\n      formControlName=\"password\"\n      placeholder=\"Contrase\u00F1a\"\n      label=\"Contrase\u00F1a\"\n      [debounceTime]=\"400\"\n      required type=\"password\">\n    </sc-input>\n    <sc-password-rules [value]=\"password.value\"></sc-password-rules>\n    <sc-auth-error-messages [error]=\"error\"></sc-auth-error-messages>\n    <sc-button\n      type=\"primary\"\n      (onClick)=\"recoverPass()\"\n      [loading]=\"isLoading\"\n      [disabled]=\"isLoading\"\n      id=\"recover-password\">\n      Recuperar contrase\u00F1a\n    </sc-button>\n  </form>\n  <div auth-page-wrapper-footer>\n    <sc-auth-actions class=\"footer-action\" [authAction]=\"authAction\"></sc-auth-actions>\n    <sc-auth-legal-footer></sc-auth-legal-footer>\n  </div>\n</sc-auth-page-wrapper>\n"
                }] }
    ];
    /** @nocollapse */
    RecoverPasswordComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: PasswordService },
        { type: AuthConfigService },
        { type: FormValidatorService },
        { type: WindowRef }
    ]; };
    return RecoverPasswordComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.token;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.pdw;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.redirectTo;
    /** @type {?} */
    RecoverPasswordComponent.prototype.loading;
    /** @type {?} */
    RecoverPasswordComponent.prototype.form;
    /** @type {?} */
    RecoverPasswordComponent.prototype.error;
    /** @type {?} */
    RecoverPasswordComponent.prototype.isLoading;
    /** @type {?} */
    RecoverPasswordComponent.prototype.authAction;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.passwordService;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.formValidator;
    /**
     * @type {?}
     * @private
     */
    RecoverPasswordComponent.prototype.window;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/recover-password/recover-password.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RecoverPasswordModule = /** @class */ (function () {
    function RecoverPasswordModule() {
    }
    RecoverPasswordModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RecoverPasswordComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        FormsModule,
                        ReactiveFormsModule,
                        AuthPageWrapperModule,
                        PasswordRulesModule,
                        InputModule,
                        ButtonModule,
                        AuthErrorMessagesModule,
                        AuthLegalFooterModule,
                        AuthActionsModule
                    ],
                    exports: [RecoverPasswordComponent]
                },] }
    ];
    return RecoverPasswordModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/reset-password/reset-password.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(router, passwordService, formValidator, authConfigService) {
        this.router = router;
        this.passwordService = passwordService;
        this.formValidator = formValidator;
        this.authConfigService = authConfigService;
        this.error = null;
        this.messages = [];
        this.mailSentMessage = '';
        this.authAction = AuthActionsType.SignIn;
        this.setupComponent();
        this.initForm();
    }
    /**
     * @private
     * @return {?}
     */
    ResetPasswordComponent.prototype.initForm = /**
     * @private
     * @return {?}
     */
    function () {
        this.form = new FormGroup({
            userId: new FormControl('', this.authConfigService.componentsConfig.resetPassword.userIdValidators)
        });
    };
    /**
     * @private
     * @return {?}
     */
    ResetPasswordComponent.prototype.setupComponent = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var resetPasswordConfig = this.authConfigService.componentsConfig.resetPassword;
        this.subtitle = "Ingres\u00E1 tu " + resetPasswordConfig.userIdLabel + " y te enviaremos un\n     mail con instrucciones para poder recuperar la contrase\u00F1a";
        this.showTooltip = resetPasswordConfig.showTooltip;
        this.tooltipText = resetPasswordConfig.tooltipText;
        this.userIdLabel = resetPasswordConfig.userIdLabel;
        this.userIdErrorMessages = resetPasswordConfig.userIdErrorMessages;
        this.userIdMaxLength = resetPasswordConfig.userIdMaxLength;
        this.pipes = resetPasswordConfig.isPipedUserId
            ? [{ 'pipe': resetPasswordConfig.userIdPipe }]
            : null;
    };
    /**
     * @return {?}
     */
    ResetPasswordComponent.prototype.resetPassword = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.cleanError();
        if (this.isLoading) {
            return;
        }
        if (this.form.invalid) {
            this.formValidator.markAsSubmitted(this.form);
            return;
        }
        this.isLoading = true;
        this.mailSentMessage = '';
        this.passwordService
            .resetPassword(this.form.value.userId)
            .subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) { return _this.router.navigate(_this.authConfigService.appRoutes.sendResetPasswordMail, { state: { message: response.message } }); }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) { return _this.error = error; }))
            .add((/**
         * @return {?}
         */
        function () { return _this.isLoading = false; }));
    };
    /**
     * @private
     * @return {?}
     */
    ResetPasswordComponent.prototype.cleanError = /**
     * @private
     * @return {?}
     */
    function () {
        this.error = null;
    };
    ResetPasswordComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-reset-password',
                    template: "<sc-auth-page-wrapper\n  mainTitle=\"\u00BFOlvidaste tu contrase\u00F1a?\"\n  [subtitle]=\"subtitle\"\n  [authAction]=\"authAction\"\n>\n  <form\n    auth-page-wrapper-content\n    [formGroup]=\"form\"\n    class=\"text-center\">\n    <sc-tooltip-input-decorator\n      *ngIf=\"showTooltip\"\n      [tooltipText]=\"tooltipText\"\n      placement=\"bottom\">\n        <sc-input\n          [maxlength]=\"userIdMaxLength\"\n          [pipes]=\"pipes\"\n          [errorMessages]=\"userIdErrorMessages\"\n          [placeholder]=\"userIdLabel\"\n          [label]=\"userIdLabel\"\n          [debounceTime]=\"400\"\n          autocomplete=\"off\"\n          formControlName=\"userId\"\n          icon=\"question-elipse\"\n          type=\"text\">\n        </sc-input>\n    </sc-tooltip-input-decorator>\n    <sc-input\n      *ngIf=\"!showTooltip\"\n      [maxlength]=\"userIdMaxLength\"\n      [placeholder]=\"userIdLabel\"\n      [pipes]=\"pipes\"\n      [errorMessages]=\"userIdErrorMessages\"\n      [label]=\"userIdLabel\"\n      [debounceTime]=\"400\"\n      autocomplete=\"off\"\n      formControlName=\"userId\"\n      type=\"text\"\n    ></sc-input>\n    <sc-button\n      type=\"primary\"\n      (onClick)=\"resetPassword()\"\n      [loading]=\"isLoading\"\n      [disabled]=\"isLoading || form.invalid\"\n      id=\"reset-password\">\n      Recuperar contrase\u00F1a\n    </sc-button>\n    <div>{{mailSentMessage}}</div>\n    <sc-auth-error-messages [error]=\"error\"></sc-auth-error-messages>\n  </form>\n  <div auth-page-wrapper-footer>\n    <sc-auth-actions class=\"footer-action\" [authAction]=\"authAction\"></sc-auth-actions>\n    <sc-auth-legal-footer></sc-auth-legal-footer>\n  </div>\n</sc-auth-page-wrapper>\n"
                }] }
    ];
    /** @nocollapse */
    ResetPasswordComponent.ctorParameters = function () { return [
        { type: Router },
        { type: PasswordService },
        { type: FormValidatorService },
        { type: AuthConfigService }
    ]; };
    return ResetPasswordComponent;
}());
if (false) {
    /** @type {?} */
    ResetPasswordComponent.prototype.form;
    /** @type {?} */
    ResetPasswordComponent.prototype.isLoading;
    /** @type {?} */
    ResetPasswordComponent.prototype.showTooltip;
    /** @type {?} */
    ResetPasswordComponent.prototype.tooltipText;
    /** @type {?} */
    ResetPasswordComponent.prototype.userIdLabel;
    /** @type {?} */
    ResetPasswordComponent.prototype.subtitle;
    /** @type {?} */
    ResetPasswordComponent.prototype.userIdMaxLength;
    /** @type {?} */
    ResetPasswordComponent.prototype.pipes;
    /** @type {?} */
    ResetPasswordComponent.prototype.userIdErrorMessages;
    /** @type {?} */
    ResetPasswordComponent.prototype.error;
    /** @type {?} */
    ResetPasswordComponent.prototype.messages;
    /** @type {?} */
    ResetPasswordComponent.prototype.mailSentMessage;
    /** @type {?} */
    ResetPasswordComponent.prototype.authAction;
    /**
     * @type {?}
     * @private
     */
    ResetPasswordComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    ResetPasswordComponent.prototype.passwordService;
    /**
     * @type {?}
     * @private
     */
    ResetPasswordComponent.prototype.formValidator;
    /**
     * @type {?}
     * @private
     */
    ResetPasswordComponent.prototype.authConfigService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/reset-password/reset-password.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ResetPasswordModule = /** @class */ (function () {
    function ResetPasswordModule() {
    }
    ResetPasswordModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ResetPasswordComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        FormsModule,
                        ReactiveFormsModule,
                        AuthPageWrapperModule,
                        PasswordRulesModule,
                        TooltipInputDecoratorModule,
                        InputModule,
                        ButtonModule,
                        AuthErrorMessagesModule,
                        AuthLegalFooterModule,
                        AuthActionsModule
                    ],
                    exports: [ResetPasswordComponent]
                },] }
    ];
    return ResetPasswordModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/success/success.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SuccessComponent = /** @class */ (function () {
    function SuccessComponent(router, authConfigService) {
        this.router = router;
        this.subtitle = 'La contraseña fue modificada con éxito.';
        this.successImage = authConfigService.assets.successImage;
    }
    /**
     * @return {?}
     */
    SuccessComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.timeoutId = setTimeout((/**
         * @return {?}
         */
        function () { return _this.router.navigate(['/']); }), 5000);
    };
    /**
     * @return {?}
     */
    SuccessComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        clearTimeout(this.timeoutId);
    };
    SuccessComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-success',
                    template: "<sc-auth-page-wrapper mainTitle=\"Genial!\" [subtitle]=\"subtitle\">\n  <div auth-page-wrapper-content class=\"text-center\">\n    <img [src]=\"successImage\" alt=\"Exito\" class=\"success-image\">\n  </div>\n  <sc-auth-legal-footer auth-page-wrapper-footer></sc-auth-legal-footer>\n</sc-auth-page-wrapper>\n",
                    styles: [".success-image{width:calc(70% - 2rem);margin:0 1rem;min-height:200px}"]
                }] }
    ];
    /** @nocollapse */
    SuccessComponent.ctorParameters = function () { return [
        { type: Router },
        { type: AuthConfigService }
    ]; };
    return SuccessComponent;
}());
if (false) {
    /** @type {?} */
    SuccessComponent.prototype.subtitle;
    /** @type {?} */
    SuccessComponent.prototype.successImage;
    /**
     * @type {?}
     * @private
     */
    SuccessComponent.prototype.timeoutId;
    /**
     * @type {?}
     * @private
     */
    SuccessComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/success/success.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SuccessModule = /** @class */ (function () {
    function SuccessModule() {
    }
    SuccessModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SuccessComponent],
                    imports: [
                        CommonModule,
                        RouterModule,
                        ButtonModule,
                        CheckboxModule,
                        InputModule,
                        TooltipInputDecoratorModule,
                        AuthLegalFooterModule,
                        AuthPageWrapperModule
                    ],
                    exports: [SuccessComponent]
                },] }
    ];
    return SuccessModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/send-mail/send-mail.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SendMailComponent = /** @class */ (function () {
    function SendMailComponent(authConfigService, router) {
        this.authConfigService = authConfigService;
        this.router = router;
        this.authAction = AuthActionsType.SignIn;
        /** @type {?} */
        var configs = this.authConfigService.componentsConfig;
        this.mainTitle = configs.sendMail.title;
        this.mailTo = "mailto:" + configs.sendMail.contactEmail;
        this.showHelp = configs.sendMail.showHelp;
        this.subtitle = this.router.getCurrentNavigation().extras.state.message;
        this.mailSentImage = this.authConfigService.assets.mailSentImage;
    }
    SendMailComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-send-mail',
                    template: "<sc-auth-page-wrapper\n  [mainTitle]=\"mainTitle\"\n  [subtitle]=\"subtitle\"\n  [authAction]=\"authAction\">\n  <div auth-page-wrapper-content class=\"text-center\">\n    <img [src]=\"mailSentImage\" alt=\"Email Enviado\">\n    <p *ngIf=\"showHelp\" class=\"mb-1\">\u00BFNo recibiste nada o el mail es incorrecto? Por favor, <a [href]=\"mailTo\">contactate con nosotros</a></p>\n  </div>\n  <div auth-page-wrapper-footer>\n    <sc-auth-actions class=\"footer-action\" [authAction]=\"authAction\"></sc-auth-actions>\n    <sc-auth-legal-footer></sc-auth-legal-footer>\n  </div>\n</sc-auth-page-wrapper>\n"
                }] }
    ];
    /** @nocollapse */
    SendMailComponent.ctorParameters = function () { return [
        { type: AuthConfigService },
        { type: Router }
    ]; };
    return SendMailComponent;
}());
if (false) {
    /** @type {?} */
    SendMailComponent.prototype.mainTitle;
    /** @type {?} */
    SendMailComponent.prototype.subtitle;
    /** @type {?} */
    SendMailComponent.prototype.mailSentImage;
    /** @type {?} */
    SendMailComponent.prototype.authAction;
    /** @type {?} */
    SendMailComponent.prototype.mailTo;
    /** @type {?} */
    SendMailComponent.prototype.showHelp;
    /**
     * @type {?}
     * @private
     */
    SendMailComponent.prototype.authConfigService;
    /**
     * @type {?}
     * @private
     */
    SendMailComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/components/send-mail/send-mail.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SendMailModule = /** @class */ (function () {
    function SendMailModule() {
    }
    SendMailModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [SendMailComponent],
                    imports: [
                        CommonModule,
                        AuthLegalFooterModule,
                        AuthPageWrapperModule,
                        AuthActionsModule
                    ],
                    exports: [SendMailComponent]
                },] }
    ];
    return SendMailModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/providers/jwt-service.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function JwtService() { }
if (false) {
    /**
     * @param {?} token
     * @return {?}
     */
    JwtService.prototype.decodeToken = function (token) { };
    /**
     * @param {?} token
     * @return {?}
     */
    JwtService.prototype.getTokenExpirationDate = function (token) { };
    /**
     * @param {?} token
     * @return {?}
     */
    JwtService.prototype.isTokenExpired = function (token) { };
}
/**
 * @return {?}
 */
function getJwtService() {
    return new JwtHelperService();
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/providers/local-storage.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function getLocalStorage() {
    return (typeof window !== 'undefined') ? window.localStorage : null;
}
var LocalStorageRef = /** @class */ (function (_super) {
    __extends(LocalStorageRef, _super);
    function LocalStorageRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LocalStorageRef;
}(Storage));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/refresh-token.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RefreshTokenService = /** @class */ (function () {
    function RefreshTokenService(httpClient, tokenService) {
        this.httpClient = httpClient;
        this.tokenService = tokenService;
    }
    /**
     * @param {?} refreshToken
     * @return {?}
     */
    RefreshTokenService.prototype.refreshIdentity = /**
     * @param {?} refreshToken
     * @return {?}
     */
    function (refreshToken) {
        var _this = this;
        refreshToken.auth_Token = this.tokenService.getAuthToken();
        refreshToken.refresh_Token = this.tokenService.getRefreshToken();
        return this.httpClient.post(refreshToken.url, refreshToken).pipe(tap((/**
         * @param {?} resp
         * @return {?}
         */
        function (resp) {
            /** @type {?} */
            var authSuccess = new AuthSuccess(resp);
            _this.tokenService.setAuthToken(authSuccess.authToken);
            _this.tokenService.setRefreshToken(authSuccess.refreshToken);
        })));
    };
    RefreshTokenService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RefreshTokenService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: TokenService }
    ]; };
    return RefreshTokenService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RefreshTokenService.prototype.httpClient;
    /**
     * @type {?}
     * @private
     */
    RefreshTokenService.prototype.tokenService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/identity.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var modules = [
    AuthPageHeaderModule,
    AuthPageWrapperModule,
    AuthActionsModule,
    PasswordRulesModule,
    ActivateAccountModule,
    LoadingModule,
    AuthLegalFooterModule,
    SendMailModule,
    AuthErrorMessagesModule
];
var ɵ0$1 = getWindow, ɵ1 = getJwtService, ɵ2 = getLocation, ɵ3 = getLocalStorage;
var IdentityModule = /** @class */ (function () {
    function IdentityModule() {
    }
    IdentityModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: __spread([
                        RouterModule,
                        CommonModule
                    ], modules),
                    providers: [
                        {
                            provide: WindowRef,
                            useFactory: ɵ0$1
                        },
                        TokenService,
                        {
                            provide: 'JwtService',
                            useFactory: ɵ1
                        },
                        RememberMeService,
                        FormValidatorService,
                        PasswordService,
                        {
                            provide: LocationRef,
                            useFactory: ɵ2
                        },
                        {
                            provide: LocalStorageRef,
                            useFactory: ɵ3
                        },
                        LoginAdIdentityService,
                        LoginMicrosoftService,
                        RefreshTokenService
                    ],
                    exports: modules
                },] }
    ];
    return IdentityModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/gender.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Gender = {
    Male: "M",
    Female: "F",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/identity-roles.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var IdentityRole = {
    AccessApplication: "AccessApplication",
    IdentityVerify: "IdentityVerify",
    Migrated: "Migrated",
    Analyst: "Analyst",
    Higher: "Higher",
    Operator: "Operator",
    ViewOnly: "ViewOnly",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/constants/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/services/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/validators/password-validator/password.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ɵ0$2 = /**
 * @param {?} each
 * @return {?}
 */
function (each) { return (__assign({}, each, { ruleRegExp: new RegExp(each.rule) })); };
/** @type {?} */
var passwordRules = ([
    { description: 'Al menos 8 caracteres', rule: '.{8,}' },
    { description: 'Al menos 1 mayúscula', rule: '.*[A-Z].*' },
    { description: 'Al menos 1 minúscula', rule: '.*[a-z].*' },
    { description: 'Al menos 1 número', rule: '.*[0-9].*' },
]).map((ɵ0$2));
/**
 * @param {?} control
 * @return {?}
 */
function ValidatePassword(control) {
    /** @type {?} */
    var value = control.value;
    if (!passwordRules.every((/**
     * @param {?} each
     * @return {?}
     */
    function (each) { return value.match(each.ruleRegExp); }))) {
        return { invalidPassword: true };
    }
    return null;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/identity/validators/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/payment-option/payment-option.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentOption = /** @class */ (function () {
    function PaymentOption() {
    }
    return PaymentOption;
}());
if (false) {
    /** @type {?} */
    PaymentOption.prototype.id;
    /** @type {?} */
    PaymentOption.prototype.label;
    /** @type {?} */
    PaymentOption.prototype.number;
    /** @type {?} */
    PaymentOption.prototype.creditCardTypeKey;
    /** @type {?} */
    PaymentOption.prototype.creditCardTypeName;
    /** @type {?} */
    PaymentOption.prototype.creditCardTypeOptions;
    /** @type {?} */
    PaymentOption.prototype.isSelected;
    /** @type {?} */
    PaymentOption.prototype.isValid;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/approval-request/approval-request.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApprovalRequestComponent = /** @class */ (function () {
    function ApprovalRequestComponent(policyService) {
        this.policyService = policyService;
        this.error = new EventEmitter();
        this.cancel = new EventEmitter();
        this.back = new EventEmitter();
        this.loading = false;
        this.requestSent = false;
    }
    /**
     * @return {?}
     */
    ApprovalRequestComponent.prototype.handleContinue = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.requestSent = false;
        this.loading = true;
        this.policyService.sendApprovalRequestProxy(this.policyPeriodId)
            .pipe(catchError$1((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.loading = false;
            _this.error.emit(error);
            return of();
        })))
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.requestSent = true;
            _this.loading = false;
        }));
    };
    /**
     * @return {?}
     */
    ApprovalRequestComponent.prototype.handleCancel = /**
     * @return {?}
     */
    function () {
        this.resetFlags();
        this.cancel.emit();
    };
    /**
     * @return {?}
     */
    ApprovalRequestComponent.prototype.handleBack = /**
     * @return {?}
     */
    function () {
        this.resetFlags();
        this.back.emit();
    };
    /**
     * @private
     * @return {?}
     */
    ApprovalRequestComponent.prototype.resetFlags = /**
     * @private
     * @return {?}
     */
    function () {
        this.requestSent = false;
        this.loading = false;
    };
    ApprovalRequestComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-approval-request',
                    template: "<ng-container *ngIf=\"loading\">\n    <img src=\"/assets/images/loading_precotizacion.gif\" alt=\"Icon\">\n    <sc-title content=\"Estamos enviando tu solicitud de aprobaci\u00F3n\" type=\"h2\" class=\"approval-request__title\"></sc-title>\n</ng-container>\n<ng-container *ngIf=\"!loading\">\n    <ng-container *ngIf=\"!requestSent\">\n        <img src=\"/assets/images/issue-alert.png\" class=\"approval-request__icon\" alt=\"Icon\">\n        <sc-title content=\"El endoso posee pautas de suscripci\u00F3n que requieren aprobaci\u00F3n\" type=\"h2\" class=\"approval-request__title\"></sc-title>\n        <div class=\"approval-request__underwriting-messages\">\n            <p class=\"approval-request__underwriting-messages__title\">Pautas de suscripci\u00F3n:</p>\n            <ul>\n                <li class=\"approval-request__underwriting-messages__item\" *ngFor=\"let item of underwritingMessages\">{{ item }}</li>\n            </ul>\n        </div>\n        <div class=\"approval-request__buttons\">\n            <sc-button class=\"mr-1\" (onClick)=\"handleContinue()\">Solicitar aprobaci\u00F3n</sc-button>\n            <sc-button type=\"secondary\" (onClick)=\"handleCancel()\">Modificar el endoso</sc-button>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"requestSent\">\n        <img src=\"/assets/images/emision-poliza.png\" class=\"approval-request__icon\" alt=\"Icon\">\n        <sc-title content=\"El endoso se encuentra en revisi\u00F3n\" type=\"h2\" class=\"approval-request__title\"></sc-title>\n        <p class=\"approval-request__sent-message\">\n            Te avisaremos por medio de las notificaciones sobre la aprobaci\u00F3n o rechazo de las pautas de suscripci\u00F3n\n        </p>\n        <div class=\"approval-request__buttons\">\n            <sc-button (onClick)=\"handleBack()\">Volver a la p\u00F3liza</sc-button>\n        </div>\n    </ng-container>\n</ng-container>",
                    styles: [":host{text-align:center;padding:1rem;display:block;max-width:580px;margin:auto}:host .approval-request__title{margin:.5rem auto 2.5rem;display:block}:host .approval-request__underwriting-messages{padding:1rem 1.5rem;background-color:#edf0f5;text-align:left}:host .approval-request__underwriting-messages__title{font-weight:500}:host .approval-request__underwriting-messages__item{list-style:disc}:host .approval-request__buttons{margin-top:2.5rem}:host .approval-request__sent-message{max-width:400px;margin:-1rem auto 0}"]
                }] }
    ];
    /** @nocollapse */
    ApprovalRequestComponent.ctorParameters = function () { return [
        { type: PolicyService }
    ]; };
    ApprovalRequestComponent.propDecorators = {
        policyPeriodId: [{ type: Input }],
        underwritingMessages: [{ type: Input }],
        error: [{ type: Output }],
        cancel: [{ type: Output }],
        back: [{ type: Output }]
    };
    return ApprovalRequestComponent;
}());
if (false) {
    /** @type {?} */
    ApprovalRequestComponent.prototype.policyPeriodId;
    /** @type {?} */
    ApprovalRequestComponent.prototype.underwritingMessages;
    /** @type {?} */
    ApprovalRequestComponent.prototype.error;
    /** @type {?} */
    ApprovalRequestComponent.prototype.cancel;
    /** @type {?} */
    ApprovalRequestComponent.prototype.back;
    /** @type {?} */
    ApprovalRequestComponent.prototype.loading;
    /** @type {?} */
    ApprovalRequestComponent.prototype.requestSent;
    /**
     * @type {?}
     * @private
     */
    ApprovalRequestComponent.prototype.policyService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/approval-request/approval-request.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApprovalRequestModule = /** @class */ (function () {
    function ApprovalRequestModule() {
    }
    ApprovalRequestModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        TitleModule
                    ],
                    declarations: [ApprovalRequestComponent],
                    exports: [ApprovalRequestComponent]
                },] }
    ];
    return ApprovalRequestModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/sc-accident-number.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var separator = ' - ';
var ScAccidentNumberPipe = /** @class */ (function () {
    function ScAccidentNumberPipe() {
    }
    /**
     * @param {?} val
     * @return {?}
     */
    ScAccidentNumberPipe.prototype.transform = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        /** @type {?} */
        var text = this.cleanText(this.toString(val));
        /** @type {?} */
        var firstPart = text.substr(0, 2);
        /** @type {?} */
        var middlePart = text.substr(2, 2);
        /** @type {?} */
        var lastPart = text.substr(4, 8);
        return this.transfromText(firstPart, middlePart, lastPart);
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    ScAccidentNumberPipe.prototype.cleanText = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var result = value.replace(new RegExp(separator, 'g'), '');
        result = result.replace(new RegExp('[a-zA-Z -]', 'g'), '');
        return result;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    ScAccidentNumberPipe.prototype.toString = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value ? value.toString() : '';
    };
    /**
     * @private
     * @param {?} firstPart
     * @param {?} middlePart
     * @param {?} lastPart
     * @return {?}
     */
    ScAccidentNumberPipe.prototype.transfromText = /**
     * @private
     * @param {?} firstPart
     * @param {?} middlePart
     * @param {?} lastPart
     * @return {?}
     */
    function (firstPart, middlePart, lastPart) {
        /** @type {?} */
        var transformed = firstPart;
        if (firstPart.length === 2) {
            transformed += separator;
        }
        transformed += middlePart;
        if (middlePart.length === 2) {
            transformed += separator;
        }
        transformed += lastPart;
        return transformed;
    };
    ScAccidentNumberPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'scAccidentNumber'
                },] }
    ];
    return ScAccidentNumberPipe;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/insurance-pipes.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var pipes = [
    ScAccidentNumberPipe
];
var InsurancePipesModule = /** @class */ (function () {
    function InsurancePipesModule() {
    }
    InsurancePipesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    exports: pipes,
                    declarations: pipes,
                    providers: pipes
                },] }
    ];
    return InsurancePipesModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/payment-instruments.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentInstrument = /** @class */ (function () {
    function PaymentInstrument(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return PaymentInstrument;
}());
if (false) {
    /** @type {?} */
    PaymentInstrument.prototype.cbu;
    /** @type {?} */
    PaymentInstrument.prototype.creditCardNumber;
    /** @type {?} */
    PaymentInstrument.prototype.entity;
    /** @type {?} */
    PaymentInstrument.prototype.paymentMethodKey;
    /** @type {?} */
    PaymentInstrument.prototype.paymentInstrumentId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/city-proxy.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CityProxy = /** @class */ (function () {
    function CityProxy(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    return CityProxy;
}());
if (false) {
    /** @type {?} */
    CityProxy.prototype.name;
    /** @type {?} */
    CityProxy.prototype.stateCode;
    /** @type {?} */
    CityProxy.prototype.stateDescription;
    /** @type {?} */
    CityProxy.prototype.synonymous;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/postal-code-option.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PostalCodeOption = /** @class */ (function () {
    function PostalCodeOption(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    return PostalCodeOption;
}());
if (false) {
    /** @type {?} */
    PostalCodeOption.prototype.key;
    /** @type {?} */
    PostalCodeOption.prototype.name;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/custom-param-encoder.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomHttpParamEncoder = /** @class */ (function () {
    function CustomHttpParamEncoder() {
    }
    /**
     * @param {?} key
     * @return {?}
     */
    CustomHttpParamEncoder.prototype.encodeKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return encodeURIComponent(key);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CustomHttpParamEncoder.prototype.encodeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return encodeURIComponent(value);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    CustomHttpParamEncoder.prototype.decodeKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return decodeURIComponent(key);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CustomHttpParamEncoder.prototype.decodeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return decodeURIComponent(value);
    };
    return CustomHttpParamEncoder;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validators/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/document-container-data.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentContainerData = /** @class */ (function () {
    function DocumentContainerData(data) {
        this.printableDocuments = data.printableDocuments;
        this.hasSubitems = data.hasSubitems;
    }
    return DocumentContainerData;
}());
if (false) {
    /** @type {?} */
    DocumentContainerData.prototype.printableDocuments;
    /** @type {?} */
    DocumentContainerData.prototype.hasSubitems;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/components/download-container/download-container.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadContainerComponent = /** @class */ (function () {
    function DownloadContainerComponent() {
    }
    DownloadContainerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-download-container',
                    template: "<header class=\"header\">\n  <h3 class=\"header__title bold\">Descargas</h3>\n</header>\n<ul class=\"download-items__list\">\n  <li *ngFor=\"let document of data.printableDocuments\" class=\"download-items__item\">\n    <sc-download-item [item]=\"document\"></sc-download-item>\n  </li>\n</ul>\n<sc-info-box *ngIf=\"data.hasSubitems\" class=\"info\">Las descargas pertinentes a cada veh\u00EDculo se pueden encontrar en el listado de incisos</sc-info-box>\n",
                    styles: [":host{display:block;padding:0 2rem}.download-items__list{margin-top:3rem}.download-items__item{list-style:none}.info{display:block;margin-top:3rem}"]
                }] }
    ];
    DownloadContainerComponent.propDecorators = {
        data: [{ type: Input }]
    };
    return DownloadContainerComponent;
}());
if (false) {
    /** @type {?} */
    DownloadContainerComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/base-document.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
BaseDocument = /** @class */ (function () {
    function BaseDocument(data) {
        this.PDF_DOCUMENT_ICON = 'pdf-document';
        this.description = data.description;
        this.documentType = data.documentType;
        this.fileName = this.generateFileName(data);
        this.isAnonymous = !!data.isAnonymous;
        this.icon = this.PDF_DOCUMENT_ICON;
    }
    return BaseDocument;
}());
if (false) {
    /** @type {?} */
    BaseDocument.prototype.description;
    /** @type {?} */
    BaseDocument.prototype.documentType;
    /** @type {?} */
    BaseDocument.prototype.fileName;
    /** @type {?} */
    BaseDocument.prototype.isAnonymous;
    /** @type {?} */
    BaseDocument.prototype.icon;
    /**
     * @type {?}
     * @protected
     */
    BaseDocument.prototype.PDF_DOCUMENT_ICON;
    /**
     * @abstract
     * @param {?} service
     * @return {?}
     */
    BaseDocument.prototype.saveDocuments = function (service) { };
    /**
     * @abstract
     * @return {?}
     */
    BaseDocument.prototype.getIdentifier = function () { };
    /**
     * @abstract
     * @protected
     * @param {?} data
     * @return {?}
     */
    BaseDocument.prototype.generateFileName = function (data) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/document-download-event.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentDownloadEvent = /** @class */ (function () {
    function DocumentDownloadEvent(data) {
        this.id = data.id;
        this.status = data.status;
    }
    return DocumentDownloadEvent;
}());
if (false) {
    /** @type {?} */
    DocumentDownloadEvent.prototype.id;
    /** @type {?} */
    DocumentDownloadEvent.prototype.status;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/document-download-status.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DocumentDownloadStatus = {
    Cancelled: "Cancelled",
    Downloading: "Downloading",
    Error: "Error",
    Saved: "Saved",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/services/download-documents-config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadDocumentsConfigService = /** @class */ (function () {
    function DownloadDocumentsConfigService() {
        this.baseUrl = 'http://api.sancristobal.com.ar/portalpas/api/';
        this.downloadDocumentPath = 'documents';
        this.shareDocumentsPath = 'shareDocuments';
    }
    DownloadDocumentsConfigService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DownloadDocumentsConfigService.ctorParameters = function () { return []; };
    /** @nocollapse */ DownloadDocumentsConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DownloadDocumentsConfigService_Factory() { return new DownloadDocumentsConfigService(); }, token: DownloadDocumentsConfigService, providedIn: "root" });
    return DownloadDocumentsConfigService;
}());
if (false) {
    /** @type {?} */
    DownloadDocumentsConfigService.prototype.baseUrl;
    /** @type {?} */
    DownloadDocumentsConfigService.prototype.downloadDocumentPath;
    /** @type {?} */
    DownloadDocumentsConfigService.prototype.shareDocumentsPath;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/services/documents.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentsService = /** @class */ (function () {
    function DocumentsService(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.savingDocuments = new Map();
        this.documentEventsSource = new Subject();
        this.documentEvents$ = this.documentEventsSource.asObservable();
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    DocumentsService.prototype.cancelSave = /**
     * @param {?} documentId
     * @return {?}
     */
    function (documentId) {
        /** @type {?} */
        var subscription = this.savingDocuments.get(documentId);
        if (!subscription) {
            return;
        }
        subscription.unsubscribe();
        this.savingDocuments.delete(documentId);
        /** @type {?} */
        var status = new DocumentDownloadEvent({
            id: documentId,
            status: DocumentDownloadStatus.Cancelled
        });
        this.documentEventsSource.next(status);
    };
    /**
     * @param {?} documentId
     * @return {?}
     */
    DocumentsService.prototype.isSaving = /**
     * @param {?} documentId
     * @return {?}
     */
    function (documentId) {
        return !!this.savingDocuments.get(documentId);
    };
    /**
     * @param {?} document
     * @return {?}
     */
    DocumentsService.prototype.save = /**
     * @param {?} document
     * @return {?}
     */
    function (document) {
        if (this.savingDocuments.get(document.getIdentifier())) {
            return;
        }
        /** @type {?} */
        var subscription = document.saveDocuments(this);
        this.savingDocuments.set(document.getIdentifier(), subscription);
        /** @type {?} */
        var status = new DocumentDownloadEvent({
            id: document.getIdentifier(),
            status: DocumentDownloadStatus.Downloading
        });
        this.documentEventsSource.next(status);
    };
    /**
     * @param {?} blob
     * @param {?} document
     * @return {?}
     */
    DocumentsService.prototype.saveDocument = /**
     * @param {?} blob
     * @param {?} document
     * @return {?}
     */
    function (blob, document) {
        saveAs(blob, document.fileName);
        this.savingDocuments.delete(document.getIdentifier());
        /** @type {?} */
        var status = new DocumentDownloadEvent({
            id: document.getIdentifier(),
            status: DocumentDownloadStatus.Saved
        });
        this.documentEventsSource.next(status);
    };
    /**
     * @param {?} document
     * @return {?}
     */
    DocumentsService.prototype.onSaveError = /**
     * @param {?} document
     * @return {?}
     */
    function (document) {
        this.savingDocuments.delete(document.getIdentifier());
        /** @type {?} */
        var status = new DocumentDownloadEvent({
            id: document.getIdentifier(),
            status: DocumentDownloadStatus.Error
        });
        this.documentEventsSource.next(status);
    };
    DocumentsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DocumentsService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: DownloadDocumentsConfigService }
    ]; };
    /** @nocollapse */ DocumentsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DocumentsService_Factory() { return new DocumentsService(ɵɵinject(HttpClient), ɵɵinject(DownloadDocumentsConfigService)); }, token: DocumentsService, providedIn: "root" });
    return DocumentsService;
}());
if (false) {
    /** @type {?} */
    DocumentsService.prototype.savingDocuments;
    /**
     * @type {?}
     * @private
     */
    DocumentsService.prototype.documentEventsSource;
    /** @type {?} */
    DocumentsService.prototype.documentEvents$;
    /** @type {?} */
    DocumentsService.prototype.httpClient;
    /** @type {?} */
    DocumentsService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/components/download-item/download-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadItemComponent = /** @class */ (function () {
    function DownloadItemComponent(documentsService) {
        this.documentsService = documentsService;
        this.onDestroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    DownloadItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initIsLoading();
        this.listenForDocumentEvents();
    };
    /**
     * @return {?}
     */
    DownloadItemComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
    };
    Object.defineProperty(DownloadItemComponent.prototype, "isHoverable", {
        get: /**
         * @return {?}
         */
        function () {
            return !this.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DownloadItemComponent.prototype, "id", {
        get: /**
         * @return {?}
         */
        function () {
            return "download-" + this.item.documentType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DownloadItemComponent.prototype.onClick = /**
     * @return {?}
     */
    function () {
        this.errorMessage = null;
        this.documentsService.save(this.item);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    DownloadItemComponent.prototype.cancel = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        // Stop propagation here because we are listening for the click event on the host
        event.stopPropagation();
        this.documentsService.cancelSave(this.item.getIdentifier());
    };
    /**
     * @private
     * @return {?}
     */
    DownloadItemComponent.prototype.initIsLoading = /**
     * @private
     * @return {?}
     */
    function () {
        this.isLoading = this.documentsService.isSaving(this.item.getIdentifier());
    };
    /**
     * @private
     * @return {?}
     */
    DownloadItemComponent.prototype.listenForDocumentEvents = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.documentsService
            .documentEvents$
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        function (event) { return event.id === _this.item.getIdentifier(); })), takeUntil(this.onDestroy$))
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.isLoading = event.status === DocumentDownloadStatus.Downloading;
            _this.errorMessage = event.status === DocumentDownloadStatus.Error && 'Tuvimos un problema. Intentá nuevamente';
        }));
    };
    DownloadItemComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-download-item',
                    template: "<sc-icon class=\"icon\" size=\"1_5\" icon=\"{{ item.icon }}\"></sc-icon>\n<div class=\"item\">\n  <span class=\"item__label\">{{ item.description }}</span>\n  <sc-progress-bar *ngIf=\"isLoading\" class=\"item__progress-bar\" >\n  </sc-progress-bar>\n  <span *ngIf=\"errorMessage\" class=\"item__label item__label--error\">\n    {{ errorMessage }}\n  </span>\n</div>\n<button\n  *ngIf=\"isLoading\"\n  class=\"cancel-button\"\n  @fadeInOut\n  [id]=\"'cancel-download-' + item.getIdentifier()\"\n  (click)=\"cancel($event)\">\n  <sc-icon icon=\"close\" size=\"0_5\"></sc-icon>\n</button>\n",
                    animations: [fadeInOut$1],
                    styles: [":host{-webkit-box-align:center;align-items:center;border-radius:3px;display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;margin-left:-.5rem;min-height:3.5rem;padding:0 .5rem;position:relative;-webkit-transition:background-color .2s ease-in-out;transition:background-color .2s ease-in-out}:host.hoverable:hover{background-color:#ccd2dd;cursor:pointer}.cancel-button{border:none;background:0 0;width:2rem;border-radius:1rem;height:2rem;-webkit-transition:background-color .2s ease-in-out;transition:background-color .2s ease-in-out}.cancel-button:hover{background-color:#ccd2dd}.item{-webkit-box-flex:1;flex:1;padding-left:1.5rem;padding-right:1.5rem}.item__label{display:block;font-size:1rem;line-height:1.5rem}.item__label--error{color:#de350b;font-size:.75rem;line-height:1rem}.item__progress-bar{margin-top:.5rem}"]
                }] }
    ];
    /** @nocollapse */
    DownloadItemComponent.ctorParameters = function () { return [
        { type: DocumentsService }
    ]; };
    DownloadItemComponent.propDecorators = {
        item: [{ type: Input }],
        isHoverable: [{ type: HostBinding, args: ['class.hoverable',] }],
        id: [{ type: HostBinding, args: ['attr.id',] }],
        onClick: [{ type: HostListener, args: ['click',] }]
    };
    return DownloadItemComponent;
}());
if (false) {
    /** @type {?} */
    DownloadItemComponent.prototype.item;
    /** @type {?} */
    DownloadItemComponent.prototype.isLoading;
    /** @type {?} */
    DownloadItemComponent.prototype.errorMessage;
    /**
     * @type {?}
     * @private
     */
    DownloadItemComponent.prototype.onDestroy$;
    /**
     * @type {?}
     * @private
     */
    DownloadItemComponent.prototype.documentsService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/download-documents.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadDocumentsModule = /** @class */ (function () {
    function DownloadDocumentsModule() {
    }
    DownloadDocumentsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DownloadContainerComponent, DownloadItemComponent],
                    imports: [
                        CommonModule,
                        IconModule,
                        InfoBoxModule,
                        ProgressBarModule,
                    ],
                    exports: [DownloadContainerComponent, DownloadItemComponent],
                    providers: [DocumentsService],
                    entryComponents: [DownloadContainerComponent]
                },] }
    ];
    return DownloadDocumentsModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/download-action-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DownloadActionItem = /** @class */ (function (_super) {
    __extends(DownloadActionItem, _super);
    function DownloadActionItem(lateralMenuService, data) {
        return _super.call(this, {
            label: 'Descargar',
            action: (/**
             * @return {?}
             */
            function () { return lateralMenuService.open(DownloadContainerComponent, data); }),
            icon: 'pdf-document'
        }) || this;
    }
    return DownloadActionItem;
}(ActionItem));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/printable-document.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PrintableDocument = /** @class */ (function (_super) {
    __extends(PrintableDocument, _super);
    function PrintableDocument(data) {
        var _this = _super.call(this, data) || this;
        _this.id = data.id;
        return _this;
    }
    /**
     * @param {?} service
     * @return {?}
     */
    PrintableDocument.prototype.saveDocuments = /**
     * @param {?} service
     * @return {?}
     */
    function (service) {
        var _this = this;
        if (service.savingDocuments.get(this.id)) {
            return;
        }
        /** @type {?} */
        var apiBase = "" + service.config.baseUrl;
        /** @type {?} */
        var url = apiBase + "/" + service.config.downloadDocumentPath;
        if (this.isAnonymous) {
            url = url + "/" + service.config.shareDocumentsPath;
        }
        /** @type {?} */
        var params = new HttpParams({ encoder: new CustomHttpParamEncoder() })
            .set('documentType', this.documentType)
            .set('documentId', this.id);
        /** @type {?} */
        var subscription = service.httpClient
            .get(url, { responseType: 'blob', params: params })
            .subscribe((/**
         * @param {?} blob
         * @return {?}
         */
        function (blob) { return service.saveDocument(blob, _this); }), (/**
         * @return {?}
         */
        function () { return service.onSaveError(_this); }));
        return subscription;
    };
    /**
     * @return {?}
     */
    PrintableDocument.prototype.getIdentifier = /**
     * @return {?}
     */
    function () {
        return this.id;
    };
    /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    PrintableDocument.prototype.generateFileName = /**
     * @protected
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var formattedName = this.formatString(data.name);
        /** @type {?} */
        var formatedDescription = this.formatString(this.description);
        return "sc_" + formattedName + "-" + formatedDescription + ".pdf";
    };
    /**
     * @private
     * @param {?} str
     * @return {?}
     */
    PrintableDocument.prototype.formatString = /**
     * @private
     * @param {?} str
     * @return {?}
     */
    function (str) {
        return str.toLowerCase().split(' ').join('_');
    };
    return PrintableDocument;
}(BaseDocument));
if (false) {
    /** @type {?} */
    PrintableDocument.prototype.id;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/testing/documents-service-stub.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DocumentsServiceStub = /** @class */ (function () {
    function DocumentsServiceStub() {
        this.documentEvents$ = new Subject();
    }
    /**
     * @param {?} documentId
     * @return {?}
     */
    DocumentsServiceStub.prototype.isSaving = /**
     * @param {?} documentId
     * @return {?}
     */
    function (documentId) {
        return false;
    };
    /**
     * @param {?} document
     * @return {?}
     */
    DocumentsServiceStub.prototype.save = /**
     * @param {?} document
     * @return {?}
     */
    function (document) { };
    /**
     * @param {?} documentId
     * @return {?}
     */
    DocumentsServiceStub.prototype.cancelSave = /**
     * @param {?} documentId
     * @return {?}
     */
    function (documentId) { };
    return DocumentsServiceStub;
}());
if (false) {
    /** @type {?} */
    DocumentsServiceStub.prototype.documentEvents$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/testing/documents-anonymous-mocker.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} amount
 * @return {?}
 */
function mockPrintableDocumentsAnonymous(amount) {
    /** @type {?} */
    var array = Array.from(Array(amount), (/**
     * @param {?} x
     * @param {?} index
     * @return {?}
     */
    function (x, index) {
        return new PrintableDocument({
            description: 'Poliza',
            id: index.toString(),
            documentType: 'Policy',
            name: "fake-" + index
        });
    }));
    array[0].isAnonymous = true;
    return array;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/testing/documents-mocker.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} amount
 * @return {?}
 */
function mockPrintableDocuments(amount) {
    return Array.from(Array(amount), (/**
     * @param {?} x
     * @param {?} index
     * @return {?}
     */
    function (x, index) {
        return new PrintableDocument({
            description: 'Poliza',
            id: index.toString(),
            documentType: 'Policy',
            name: "fake-" + index
        });
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/documents/download-documents/testing/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-edition/address-edition.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressEditionService = /** @class */ (function () {
    function AddressEditionService(typeListService) {
        this.typeListService = typeListService;
    }
    /**
     * @param {?} postalCode
     * @return {?}
     */
    AddressEditionService.prototype.getCities = /**
     * @param {?} postalCode
     * @return {?}
     */
    function (postalCode) {
        var _this = this;
        return this.typeListService.getCitiesByPostalCode(postalCode)
            .pipe(map((/**
         * @param {?} citiesResponse
         * @return {?}
         */
        function (citiesResponse) {
            return citiesResponse.cities.map((/**
             * @param {?} city
             * @return {?}
             */
            function (city) { return _this.formatPostalCodeOption(city, postalCode); }));
        })));
    };
    /**
     * @param {?} item
     * @param {?} postalCode
     * @return {?}
     */
    AddressEditionService.prototype.formatPostalCodeOption = /**
     * @param {?} item
     * @param {?} postalCode
     * @return {?}
     */
    function (item, postalCode) {
        /** @type {?} */
        var city = new City({
            name: item.name,
            postalCode: postalCode,
            postalSynonym: item.synonymous,
            state: { code: item.stateCode, description: item.stateDescription }
        });
        return { key: city, name: postalCode + " - " + item.name };
    };
    AddressEditionService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AddressEditionService.ctorParameters = function () { return [
        { type: TypeListService }
    ]; };
    return AddressEditionService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    AddressEditionService.prototype.typeListService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-edition/address-edition.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressEditionComponent = /** @class */ (function () {
    function AddressEditionComponent(service) {
        var _this = this;
        this.service = service;
        this.change = new EventEmitter();
        this.postalCodeOptions$ = new BehaviorSubject$1([]);
        this.POSTAL_CODE_MAX_LENGTH = 4;
        this.ARROW_KEYS = [37, 38, 39, 40, 13];
        this.numberErrorMessages = { required: 'Campo requerido' };
        this.form = new FormGroup({
            postalCode: new FormControl(null),
            streetName: new FormControl(null, Validators.required),
            number: new FormControl(null, Validators.required),
            floor: new FormControl(null),
            department: new FormControl(null)
        });
        this.form.valueChanges.pipe(distinctUntilChanged((/**
         * @param {?} previous
         * @param {?} current
         * @return {?}
         */
        function (previous, current) { return isEqual(previous, current); }))).subscribe((/**
         * @param {?} newValue
         * @return {?}
         */
        function (newValue) { return _this.change.emit({ value: newValue, isValid: _this.form.valid }); }));
    }
    /**
     * @return {?}
     */
    AddressEditionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.source && keys(this.source).length) {
            this.form.patchValue(this.source);
            if (this.source.postalCode) {
                this.postalCodeOptions$.next([cloneDeep(this.source.postalCode)]);
            }
            this.markFieldsAsDirty();
        }
        this.form.controls.postalCode.setValidators(this.setPostalCodeValidator(!this.hidePostalCode));
    };
    /**
     * @private
     * @return {?}
     */
    AddressEditionComponent.prototype.markFieldsAsDirty = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        keys(this.form.value).forEach((/**
         * @param {?} fieldName
         * @return {?}
         */
        function (fieldName) {
            _this.form.controls[fieldName].markAsTouched();
            _this.form.controls[fieldName].updateValueAndValidity();
        }));
    };
    /**
     * @return {?}
     */
    AddressEditionComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.postalCodeSubscription$) {
            this.postalCodeSubscription$.unsubscribe();
        }
    };
    /**
     * @return {?}
     */
    AddressEditionComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        if (this.source && this.source.postalCode) {
            this.postalCodeSelector.setSelected(cloneDeep(this.source.postalCode));
            this.form.controls.postalCode.markAsPristine();
        }
    };
    /**
     * @private
     * @param {?=} isRequired
     * @return {?}
     */
    AddressEditionComponent.prototype.setPostalCodeValidator = /**
     * @private
     * @param {?=} isRequired
     * @return {?}
     */
    function (isRequired) {
        if (isRequired === void 0) { isRequired = true; }
        return isRequired ? Validators.required : null;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AddressEditionComponent.prototype.getCitiesOnKeyUp = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var keyCode = event.keyCode;
        /** @type {?} */
        var postalCode = event.target.value.split(' - ')[0];
        if (this.ARROW_KEYS.indexOf(keyCode) < 0) {
            if (postalCode.length === this.POSTAL_CODE_MAX_LENGTH && postalCode !== this.lastPostalCode) {
                this.getCities(postalCode);
            }
        }
    };
    /**
     * @param {?} postalCode
     * @return {?}
     */
    AddressEditionComponent.prototype.getCities = /**
     * @param {?} postalCode
     * @return {?}
     */
    function (postalCode) {
        var _this = this;
        this.loadingPostalCode = true;
        if (this.postalCodeSubscription$) {
            this.postalCodeSubscription$.unsubscribe();
        }
        this.postalCodeSubscription$ = this.service.getCities(postalCode)
            .subscribe((/**
         * @param {?} cities
         * @return {?}
         */
        function (cities) {
            _this.postalCodeOptions$.next(cities);
            _this.lastPostalCode = postalCode;
            if (cities.length === 1) {
                _this.form.controls['postalCode'].setValue(cities[0]);
            }
        }))
            .add((/**
         * @return {?}
         */
        function () { return _this.loadingPostalCode = false; }));
    };
    AddressEditionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-address-edition',
                    template: "<div class=\"address-edition__title\" *ngIf=\"!!title\">{{ title }}</div>\n<form [formGroup]=\"form\" class=\"address-edition__form\">\n    <div class=\"row\" [class.d-none]=\"hidePostalCode\">\n        <div class=\"col-12\">\n            <sc-select formControlName=\"postalCode\" label=\"C\u00F3digo postal\" placeholder=\"Ej: 2000\"\n                enableSearch=\"true\" objectValue=\"name\" [itemsAsync$]=\"postalCodeOptions$\"\n                [maxlength]=\"POSTAL_CODE_MAX_LENGTH\" [loading]=\"loadingPostalCode\" #postalCodeSelector\n                (keyup)=\"getCitiesOnKeyUp($event)\"></sc-select>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <sc-input formControlName=\"streetName\" label=\"Calle\" placeholder=\"Montevideo\"></sc-input>\n        </div>\n        <div class=\"col-md-5\">\n            <sc-input formControlName=\"number\" label=\"N\u00FAmero\" placeholder=\"1123\"\n            [errorMessages]=\"numberErrorMessages\"></sc-input>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-md-7\">\n            <sc-input formControlName=\"floor\" type=\"number\" label=\"Piso (Opcional)\" placeholder=\"Ej: 3\"></sc-input>\n        </div>\n        <div class=\"col-md-5\">\n            <sc-input formControlName=\"department\" label=\"Dpto (Opcional)\" placeholder=\"Ej: D\"></sc-input>\n        </div>\n    </div>\n</form>\n<div class=\"row address-edition__info-box\" *ngIf=\"postalCodeMessage && form.controls.postalCode.dirty\">\n    <sc-info-box>{{ postalCodeMessage }}</sc-info-box>\n</div>",
                    styles: [":host .address-edition__title{color:#424f66;font-size:1rem;font-weight:700;margin:.5rem 0 2rem}:host .address-edition__form{max-width:330px;display:block}@media (max-width:768px){:host .address-edition__form{max-width:100%}}:host .address-edition__info-box{margin:0}:host(.full-width) .address-edition__form{max-width:100%}"]
                }] }
    ];
    /** @nocollapse */
    AddressEditionComponent.ctorParameters = function () { return [
        { type: AddressEditionService }
    ]; };
    AddressEditionComponent.propDecorators = {
        title: [{ type: Input }],
        source: [{ type: Input }],
        hidePostalCode: [{ type: Input }],
        postalCodeMessage: [{ type: Input }],
        change: [{ type: Output }],
        postalCodeSelector: [{ type: ViewChild, args: ['postalCodeSelector', { static: false },] }]
    };
    return AddressEditionComponent;
}());
if (false) {
    /** @type {?} */
    AddressEditionComponent.prototype.title;
    /** @type {?} */
    AddressEditionComponent.prototype.source;
    /** @type {?} */
    AddressEditionComponent.prototype.hidePostalCode;
    /** @type {?} */
    AddressEditionComponent.prototype.postalCodeMessage;
    /** @type {?} */
    AddressEditionComponent.prototype.change;
    /** @type {?} */
    AddressEditionComponent.prototype.postalCodeSelector;
    /** @type {?} */
    AddressEditionComponent.prototype.form;
    /** @type {?} */
    AddressEditionComponent.prototype.postalCodeOptions$;
    /** @type {?} */
    AddressEditionComponent.prototype.lastPostalCode;
    /** @type {?} */
    AddressEditionComponent.prototype.postalCodeSubscription$;
    /** @type {?} */
    AddressEditionComponent.prototype.loadingPostalCode;
    /** @type {?} */
    AddressEditionComponent.prototype.POSTAL_CODE_MAX_LENGTH;
    /** @type {?} */
    AddressEditionComponent.prototype.ARROW_KEYS;
    /** @type {?} */
    AddressEditionComponent.prototype.numberErrorMessages;
    /**
     * @type {?}
     * @private
     */
    AddressEditionComponent.prototype.service;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-edition/address-edition.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressEditionModule = /** @class */ (function () {
    function AddressEditionModule() {
    }
    AddressEditionModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        ButtonModule,
                        InputModule,
                        SelectModule,
                        InfoBoxModule
                    ],
                    declarations: [AddressEditionComponent],
                    exports: [AddressEditionComponent],
                    providers: [AddressEditionService]
                },] }
    ];
    return AddressEditionModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/address-edition/address-edition.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressEdition = /** @class */ (function () {
    function AddressEdition(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    return AddressEdition;
}());
if (false) {
    /** @type {?} */
    AddressEdition.prototype.department;
    /** @type {?} */
    AddressEdition.prototype.floor;
    /** @type {?} */
    AddressEdition.prototype.number;
    /** @type {?} */
    AddressEdition.prototype.postalCode;
    /** @type {?} */
    AddressEdition.prototype.state;
    /** @type {?} */
    AddressEdition.prototype.streetName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/providers/window.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var WINDOW = new InjectionToken('WindowToken');
/**
 * @return {?}
 */
function getWindow$1() { return window; }
/** @type {?} */
var windowProvider = {
    provide: WINDOW,
    useFactory: getWindow$1
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/providers/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagModel = /** @class */ (function () {
    function DamageTagModel() {
    }
    return DamageTagModel;
}());
if (false) {
    /** @type {?} */
    DamageTagModel.prototype.name;
    /** @type {?} */
    DamageTagModel.prototype.customId;
    /** @type {?} */
    DamageTagModel.prototype.optional;
    /** @type {?} */
    DamageTagModel.prototype.metaData;
}
var UploadDetails = /** @class */ (function () {
    function UploadDetails() {
    }
    return UploadDetails;
}());
if (false) {
    /** @type {?} */
    UploadDetails.prototype.width;
    /** @type {?} */
    UploadDetails.prototype.height;
    /** @type {?} */
    UploadDetails.prototype.categories;
    /** @type {?} */
    UploadDetails.prototype.perspective;
    /** @type {?} */
    UploadDetails.prototype.tags;
}
var DamageTagFormModel = /** @class */ (function () {
    function DamageTagFormModel() {
    }
    return DamageTagFormModel;
}());
if (false) {
    /** @type {?} */
    DamageTagFormModel.prototype.damageTag;
    /** @type {?} */
    DamageTagFormModel.prototype.image;
    /** @type {?} */
    DamageTagFormModel.prototype.perspective;
    /** @type {?} */
    DamageTagFormModel.prototype.selectedParts;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag-image.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagImageModel = /** @class */ (function () {
    function DamageTagImageModel() {
    }
    return DamageTagImageModel;
}());
if (false) {
    /** @type {?} */
    DamageTagImageModel.prototype.width;
    /** @type {?} */
    DamageTagImageModel.prototype.height;
    /** @type {?} */
    DamageTagImageModel.prototype.name;
    /** @type {?} */
    DamageTagImageModel.prototype.size;
    /** @type {?} */
    DamageTagImageModel.prototype.imageData;
    /** @type {?} */
    DamageTagImageModel.prototype.customId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag-chip.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagChip = /** @class */ (function () {
    function DamageTagChip() {
    }
    return DamageTagChip;
}());
if (false) {
    /** @type {?} */
    DamageTagChip.prototype.color;
    /** @type {?} */
    DamageTagChip.prototype.number;
    /** @type {?} */
    DamageTagChip.prototype.text;
    /** @type {?} */
    DamageTagChip.prototype.type;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag-selection.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagSelectionModel = /** @class */ (function () {
    function DamageTagSelectionModel() {
    }
    return DamageTagSelectionModel;
}());
if (false) {
    /** @type {?} */
    DamageTagSelectionModel.prototype.type;
    /** @type {?} */
    DamageTagSelectionModel.prototype.coordinates;
    /** @type {?} */
    DamageTagSelectionModel.prototype.color;
    /** @type {?} */
    DamageTagSelectionModel.prototype.isSelecting;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag-selection-coordinate.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagSelectionCoordinateModel = /** @class */ (function () {
    function DamageTagSelectionCoordinateModel() {
    }
    return DamageTagSelectionCoordinateModel;
}());
if (false) {
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.containerHeight;
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.containerWidth;
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.offsetTop;
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.offsetLeft;
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.height;
    /** @type {?} */
    DamageTagSelectionCoordinateModel.prototype.width;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/doc-uploader-item.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagUploaderItem = /** @class */ (function () {
    function DamageTagUploaderItem() {
    }
    return DamageTagUploaderItem;
}());
if (false) {
    /** @type {?} */
    DamageTagUploaderItem.prototype.size;
    /** @type {?} */
    DamageTagUploaderItem.prototype.errorMessage;
    /** @type {?} */
    DamageTagUploaderItem.prototype.loading;
    /** @type {?} */
    DamageTagUploaderItem.prototype.name;
    /** @type {?} */
    DamageTagUploaderItem.prototype.retry;
    /** @type {?} */
    DamageTagUploaderItem.prototype.thumbnail;
    /** @type {?} */
    DamageTagUploaderItem.prototype.thumbnailLoading;
    /** @type {?} */
    DamageTagUploaderItem.prototype.type;
    /** @type {?} */
    DamageTagUploaderItem.prototype.typeImage;
    /** @type {?} */
    DamageTagUploaderItem.prototype.file;
    /** @type {?} */
    DamageTagUploaderItem.prototype.isDelete;
    /** @type {?} */
    DamageTagUploaderItem.prototype.customId;
    /** @type {?} */
    DamageTagUploaderItem.prototype.perspective;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/tag.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TagModel = /** @class */ (function () {
    function TagModel() {
    }
    return TagModel;
}());
if (false) {
    /** @type {?} */
    TagModel.prototype.type;
    /** @type {?} */
    TagModel.prototype.x;
    /** @type {?} */
    TagModel.prototype.y;
    /** @type {?} */
    TagModel.prototype.width;
    /** @type {?} */
    TagModel.prototype.height;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-preview.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamagePreviewModel = /** @class */ (function () {
    function DamagePreviewModel() {
    }
    return DamagePreviewModel;
}());
if (false) {
    /** @type {?} */
    DamagePreviewModel.prototype.perspective;
    /** @type {?} */
    DamagePreviewModel.prototype.perspectiveText;
    /** @type {?} */
    DamagePreviewModel.prototype.fileName;
    /** @type {?} */
    DamagePreviewModel.prototype.customId;
    /** @type {?} */
    DamagePreviewModel.prototype.size;
    /** @type {?} */
    DamagePreviewModel.prototype.imageData;
    /** @type {?} */
    DamagePreviewModel.prototype.optional;
    /** @type {?} */
    DamagePreviewModel.prototype.damageTypes;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/part.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Part() { }
if (false) {
    /** @type {?} */
    Part.prototype.key;
    /** @type {?} */
    Part.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/perspectives.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function PerspectiveCol() { }
if (false) {
    /** @type {?} */
    PerspectiveCol.prototype.positionClass;
    /** @type {?} */
    PerspectiveCol.prototype.items;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/perpective-item.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function PerspectiveItem() { }
if (false) {
    /** @type {?} */
    PerspectiveItem.prototype.key;
    /** @type {?} */
    PerspectiveItem.prototype.description;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/perspective-point.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function PerspectivePoint() { }
if (false) {
    /** @type {?} */
    PerspectivePoint.prototype.key;
    /** @type {?} */
    PerspectivePoint.prototype.selected;
    /** @type {?} */
    PerspectivePoint.prototype.top;
    /** @type {?} */
    PerspectivePoint.prototype.left;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/damage-tag-file.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagFileModel = /** @class */ (function () {
    function DamageTagFileModel(title, optional) {
        if (optional === void 0) { optional = false; }
        this.title = '';
        this.name = '';
        this.optional = false;
        this.validateSmallImage = false;
        this.title = title;
        this.optional = optional;
    }
    return DamageTagFileModel;
}());
if (false) {
    /** @type {?} */
    DamageTagFileModel.prototype.title;
    /** @type {?} */
    DamageTagFileModel.prototype.name;
    /** @type {?} */
    DamageTagFileModel.prototype.optional;
    /** @type {?} */
    DamageTagFileModel.prototype.validateSmallImage;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/recomendations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Recomendations() { }
if (false) {
    /** @type {?} */
    Recomendations.prototype.src;
    /** @type {?} */
    Recomendations.prototype.alt;
    /** @type {?} */
    Recomendations.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/damage-tag-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var DamageTagType = {
    scratch: 0,
    dent: 1,
    breakage: 2,
};
DamageTagType[DamageTagType.scratch] = 'scratch';
DamageTagType[DamageTagType.dent] = 'dent';
DamageTagType[DamageTagType.breakage] = 'breakage';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/damage-tag-type-text.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var DamageTagTypeText = {
    scratch: "Ray\u00F3n",
    dent: "Abolladura",
    breakage: "Rotura / pieza faltante",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/damage-tag.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var DamageTagSteps = {
    firstStep: 0,
    secondStep: 1,
    thirdStep: 2,
};
DamageTagSteps[DamageTagSteps.firstStep] = 'firstStep';
DamageTagSteps[DamageTagSteps.secondStep] = 'secondStep';
DamageTagSteps[DamageTagSteps.thirdStep] = 'thirdStep';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/parts.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var PartsType = {
    crystals: "crystals",
    hood: "hood",
    bumper: "bumper",
    rearBumper: "rearBumper",
    leftOptic: "leftOptic",
    rightOptic: "rightOptic",
    grille: "grille",
    frontDoor: "frontDoor",
    rearDoor: "rearDoor",
    fender: "fender",
    rearfender: "rearFender",
    frontFender: "frontFender",
    trunk: "trunk",
    sideMirror: "sideMirror",
    others: "others",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/perspective.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Perspective = {
    partnerFront: "partnerFront",
    front: "front",
    driverFront: "driverFront",
    partnerSide: "partnerSide",
    driverSide: "driverSide",
    partnerBack: "partnerBack",
    back: "back",
    driverBack: "driverBack",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/perspective-cols.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var perspectiveCols = [
    {
        positionClass: 'edge',
        items: [
            { key: Perspective.partnerFront, description: '45° acompañante' },
            { key: Perspective.front, description: 'Frente' },
            { key: Perspective.driverFront, description: '45° conductor' }
        ]
    },
    {
        positionClass: 'middle',
        items: [
            { key: Perspective.partnerSide, description: 'Perfil acompañante' },
            { key: Perspective.driverSide, description: 'Perfil conductor' }
        ]
    },
    {
        positionClass: 'edge',
        items: [
            { key: Perspective.partnerBack, description: '45° acompañante' },
            { key: Perspective.back, description: 'Atrás' },
            { key: Perspective.driverBack, description: '45° conductor' }
        ]
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/perspective-points.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var perspectivePoints = [
    { key: Perspective.partnerFront, selected: false, top: '96px', left: '195px' },
    { key: Perspective.partnerBack, selected: false, top: '96px', left: '435px' },
    { key: Perspective.partnerSide, selected: false, top: '82px', left: '333px' },
    { key: Perspective.front, selected: false, top: '138px', left: '185px' },
    { key: Perspective.back, selected: false, top: '139px', left: '445px' },
    { key: Perspective.driverFront, selected: false, top: '178px', left: '196px' },
    { key: Perspective.driverBack, selected: false, top: '179px', left: '436px' },
    { key: Perspective.driverSide, selected: false, top: '192px', left: '332px' },
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/perspective-text.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var perspectiveText = new Map([
    [Perspective.front, 'Frente'],
    [Perspective.partnerFront, '45° acompañante (frente)'],
    [Perspective.driverFront, '45° conductor (frente)'],
    [Perspective.back, 'Atrás'],
    [Perspective.partnerSide, 'Perfil acompañante'],
    [Perspective.driverSide, 'Perfil conductor'],
    [Perspective.partnerBack, '45° acompañante (atrás)'],
    [Perspective.driverBack, '45° conductor (atrás)']
]);

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/enums/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/damage-tag-form.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagFormService = /** @class */ (function () {
    function DamageTagFormService(formBuilder) {
        this.formBuilder = formBuilder;
        this.selectedPerspective = new BehaviorSubject$1(null);
        this.currentStep = new BehaviorSubject$1(DamageTagSteps.firstStep);
        this.currentStepFlag = DamageTagSteps.firstStep;
        this.colorMap = new Map([
            [DamageTagType.scratch, 1], [DamageTagType.dent, 2], [DamageTagType.breakage, 3]
        ]);
        this.typeTextMap = new Map([
            [DamageTagType.scratch, DamageTagTypeText.scratch],
            [DamageTagType.dent, DamageTagTypeText.dent],
            [DamageTagType.breakage, DamageTagTypeText.breakage]
        ]);
        this.selectedPerspective$ = this.selectedPerspective.asObservable().pipe(filter((/**
         * @param {?} perspective
         * @return {?}
         */
        function (perspective) { return !!perspective; })));
        this.currentStep$ = this.currentStep.asObservable();
        this.initTagProcessForm();
    }
    /**
     * @return {?}
     */
    DamageTagFormService.prototype.onContinueOrSave = /**
     * @return {?}
     */
    function () {
        if (this.currentStepFlag === DamageTagSteps.firstStep) {
            this.currentStepFlag = DamageTagSteps.secondStep;
            this.currentStep.next(this.currentStepFlag);
            return;
        }
        if (this.currentStepFlag === DamageTagSteps.secondStep) {
            this.currentStepFlag = DamageTagSteps.thirdStep;
            this.currentStep.next(this.currentStepFlag);
            return;
        }
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagFormService.prototype.resetTagProcess = /**
     * @private
     * @return {?}
     */
    function () {
        this.damageTagForm.reset();
        this.currentStepFlag = DamageTagSteps.firstStep;
        this.currentStep.next(this.currentStepFlag);
    };
    /**
     * @return {?}
     */
    DamageTagFormService.prototype.stepIsValid = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var control = this.currentStepFlag === DamageTagSteps.firstStep ? 'selectedParts' : 'damageTag';
        return this.damageTagForm.get(control).valid;
    };
    /**
     * @param {?} image
     * @return {?}
     */
    DamageTagFormService.prototype.setSelectedImage = /**
     * @param {?} image
     * @return {?}
     */
    function (image) {
        this.damageTagForm.patchValue({ image: image });
    };
    /**
     * @param {?} perspective
     * @return {?}
     */
    DamageTagFormService.prototype.setSelectedPerspective = /**
     * @param {?} perspective
     * @return {?}
     */
    function (perspective) {
        this.resetTagProcess();
        this.damageTagForm.patchValue({ perspective: perspective });
        this.selectedPerspective.next(perspective);
    };
    /**
     * @param {?} selectedParts
     * @return {?}
     */
    DamageTagFormService.prototype.setSelectedParts = /**
     * @param {?} selectedParts
     * @return {?}
     */
    function (selectedParts) {
        this.damageTagForm.patchValue({ selectedParts: selectedParts });
    };
    /**
     * @param {?} damageTags
     * @return {?}
     */
    DamageTagFormService.prototype.setDamageTag = /**
     * @param {?} damageTags
     * @return {?}
     */
    function (damageTags) {
        this.damageTagForm.patchValue({ damageTag: damageTags });
    };
    /**
     * @param {?=} item
     * @return {?}
     */
    DamageTagFormService.prototype.getDamagePreviewItem = /**
     * @param {?=} item
     * @return {?}
     */
    function (item) {
        if (item === void 0) { item = null; }
        /** @type {?} */
        var model = new DamagePreviewModel();
        if (!item) {
            /** @type {?} */
            var data = this.damageTagForm.value;
            model.perspective = data.perspective;
            model.perspectiveText = perspectiveText.get(data.perspective);
            model.fileName = data.image.name;
            model.customId = data.image.customId;
            model.size = data.image.size;
            model.imageData = data.image.imageData;
            model.damageTypes = this.damageTypesMap();
        }
        else {
            model.fileName = item.name;
            model.size = item.size;
            model.imageData = item.thumbnail;
            model.customId = item.customId;
            model.optional = true;
            model.perspectiveText = 'Foto opcional';
        }
        return model;
    };
    /**
     * @param {?=} item
     * @return {?}
     */
    DamageTagFormService.prototype.getDamageTagModel = /**
     * @param {?=} item
     * @return {?}
     */
    function (item) {
        if (item === void 0) { item = null; }
        /** @type {?} */
        var model = new DamageTagModel();
        if (!item) {
            /** @type {?} */
            var data = (/** @type {?} */ (this.damageTagForm.value));
            model.name = data.image.name;
            model.customId = data.image.customId;
            model.metaData = {
                width: data.image.width,
                height: data.image.height,
                perspective: data.perspective,
                categories: __spread(data.selectedParts),
                tags: this.damageTagSelectionToTags(data.damageTag)
            };
            model.optional = false;
        }
        else {
            model.name = item.name;
            model.customId = item.customId;
            model.optional = true;
            model.metaData = null;
        }
        return model;
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagFormService.prototype.initTagProcessForm = /**
     * @private
     * @return {?}
     */
    function () {
        this.damageTagForm = this.formBuilder.group({
            image: [null],
            perspective: [null, Validators.required],
            selectedParts: [null, Validators.required],
            damageTag: [null, Validators.required]
        });
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagFormService.prototype.damageTypesMap = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var items = (/** @type {?} */ (this.damageTagForm.get('damageTag').value));
        if (!items) {
            return null;
        }
        /** @type {?} */
        var result = items.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return _this.damageTagSelectionToChipModel(item); }))
            .reduce((/**
         * @param {?} map
         * @param {?} chip
         * @return {?}
         */
        function (map, chip) {
            (map.has(chip.type)) ? map.get(chip.type).number++ : map.set(chip.type, chip);
            return map;
        }), new Map([]));
        return Array.from(result.values());
    };
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    DamageTagFormService.prototype.damageTagSelectionToChipModel = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return {
            type: data.type,
            color: this.colorMap.get(data.type),
            number: 1,
            text: this.typeTextMap.get(data.type)
        };
    };
    /**
     * @private
     * @param {?} selections
     * @return {?}
     */
    DamageTagFormService.prototype.damageTagSelectionToTags = /**
     * @private
     * @param {?} selections
     * @return {?}
     */
    function (selections) {
        return selections.map((/**
         * @param {?} selection
         * @return {?}
         */
        function (selection) {
            return {
                type: (/** @type {?} */ (Object.values(DamageTagType)[selection.type])),
                x: selection.coordinates.offsetLeft,
                y: selection.coordinates.offsetTop,
                width: selection.coordinates.width,
                height: selection.coordinates.height
            };
        }));
    };
    DamageTagFormService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DamageTagFormService.ctorParameters = function () { return [
        { type: FormBuilder }
    ]; };
    /** @nocollapse */ DamageTagFormService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DamageTagFormService_Factory() { return new DamageTagFormService(ɵɵinject(FormBuilder)); }, token: DamageTagFormService, providedIn: "root" });
    return DamageTagFormService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DamageTagFormService.prototype.selectedPerspective;
    /**
     * @type {?}
     * @private
     */
    DamageTagFormService.prototype.currentStep;
    /**
     * @type {?}
     * @private
     */
    DamageTagFormService.prototype.currentStepFlag;
    /** @type {?} */
    DamageTagFormService.prototype.damageTagForm;
    /** @type {?} */
    DamageTagFormService.prototype.selectedPerspective$;
    /** @type {?} */
    DamageTagFormService.prototype.currentStep$;
    /** @type {?} */
    DamageTagFormService.prototype.colorMap;
    /** @type {?} */
    DamageTagFormService.prototype.typeTextMap;
    /**
     * @type {?}
     * @private
     */
    DamageTagFormService.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/damage-tag.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagService = /** @class */ (function () {
    function DamageTagService() {
        this.selection = new BehaviorSubject$1(null);
        this.selectionDeleted = new BehaviorSubject$1(null);
        this.uploadStarted$ = new Subject();
        this.uploadFinished$ = new Subject();
        this.selection$ = this.selection.asObservable().pipe(filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item != null; })));
        this.selectionDeleted$ = this.selectionDeleted.asObservable().pipe(filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item != null; })));
    }
    /**
     * @param {?} item
     * @return {?}
     */
    DamageTagService.prototype.setSelection = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.selection.next(item);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    DamageTagService.prototype.setSelectionDeleted = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        this.selectionDeleted.next(type);
    };
    DamageTagService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DamageTagService.ctorParameters = function () { return []; };
    /** @nocollapse */ DamageTagService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DamageTagService_Factory() { return new DamageTagService(); }, token: DamageTagService, providedIn: "root" });
    return DamageTagService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DamageTagService.prototype.selection;
    /**
     * @type {?}
     * @private
     */
    DamageTagService.prototype.selectionDeleted;
    /** @type {?} */
    DamageTagService.prototype.selection$;
    /** @type {?} */
    DamageTagService.prototype.selectionDeleted$;
    /** @type {?} */
    DamageTagService.prototype.uploadStarted$;
    /** @type {?} */
    DamageTagService.prototype.uploadFinished$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/damage-tag-base-uploader-service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagBaseUploaderService = /** @class */ (function () {
    function DamageTagBaseUploaderService() {
    }
    /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    DamageTagBaseUploaderService.prototype.uploadFile = /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    function (file, owner) {
        return of({});
    };
    DamageTagBaseUploaderService.decorators = [
        { type: Injectable }
    ];
    return DamageTagBaseUploaderService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/services/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-photo-modal/damage-photo-modal.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamagePhotoModalComponent = /** @class */ (function () {
    function DamagePhotoModalComponent(damageTagFormService) {
        this.damageTagFormService = damageTagFormService;
        this.currentStep = DamageTagSteps.firstStep;
        this.isSecondStep = false;
        this.isFirstStep = true;
        this.isValid = false;
        this.clickedOnce = false;
        this.subs = new Subscription();
        this.close = new EventEmitter();
        this.submit = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.initTagProcess();
    };
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subs.unsubscribe();
    };
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.onContinueOrSave = /**
     * @return {?}
     */
    function () {
        this.damageTagFormService.onContinueOrSave();
        if (this.currentStep !== DamageTagSteps.thirdStep) {
            return;
        }
        this.onClose(true);
    };
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.stepIsValid = /**
     * @return {?}
     */
    function () {
        return this.damageTagFormService.stepIsValid();
    };
    /**
     * @param {?=} isSubmit
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.onClose = /**
     * @param {?=} isSubmit
     * @return {?}
     */
    function (isSubmit) {
        if (isSubmit === void 0) { isSubmit = false; }
        this.clickedOnce = false;
        this.close.emit(isSubmit);
        this.modal.close();
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.open = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.image = item;
        this.modal.open();
        this.clear();
    };
    /**
     * @private
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.clear = /**
     * @private
     * @return {?}
     */
    function () {
        this.isFirstStep = true;
        this.isSecondStep = false;
        this.selectionInfo.clear();
    };
    /**
     * @private
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.initTagProcess = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.subs.add(this.damageTagFormService.selectedPerspective$
            .subscribe({ next: (/**
             * @param {?} perspective
             * @return {?}
             */
            function (perspective) {
                if (!_this.partsSelectionForm.form) {
                    return;
                }
                _this.partsSelectionForm.initPartsSelection(perspective);
            }) }))
            .add(this.damageTagFormService.currentStep$
            .subscribe({ next: (/**
             * @param {?} value
             * @return {?}
             */
            function (value) { return _this.setStep(value); }) }));
        if (this.partsSelectionForm && this.partsSelectionForm.form) {
            this.subs.add(this.partsSelectionForm.form.valueChanges
                .subscribe({ next: (/**
                 * @return {?}
                 */
                function () { return _this.damageTagFormService.setSelectedParts(_this.partsSelectionForm.getSelectedParts()); }) }));
        }
    };
    /**
     * @private
     * @param {?} currentStep
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.setStep = /**
     * @private
     * @param {?} currentStep
     * @return {?}
     */
    function (currentStep) {
        this.currentStep = currentStep;
        this.isSecondStep = currentStep === DamageTagSteps.secondStep;
        this.isFirstStep = currentStep === DamageTagSteps.firstStep;
    };
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.onImageClicked = /**
     * @return {?}
     */
    function () {
        this.clickedOnce = this.currentStep === DamageTagSteps.secondStep || this.clickedOnce;
    };
    /**
     * @return {?}
     */
    DamagePhotoModalComponent.prototype.showTooltip = /**
     * @return {?}
     */
    function () {
        return this.currentStep === DamageTagSteps.secondStep && !this.clickedOnce;
    };
    DamagePhotoModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-photo-modal',
                    template: "<sc-modal #modal [closeButton]=\"false\">\n  <div class=\"damage-photo\">\n    <div class=\"damage-photo__preview preview\">\n      <div class=\"damage-photo__tooltip\" *ngIf=\"showTooltip()\">\n        <sc-info-box>Hac\u00E9 click en la imagen donde se encuentra el da\u00F1o </sc-info-box>\n      </div>\n      <sc-damage-tag-selection-tool (click)=\"onImageClicked()\" [isSecondStep]=\"isSecondStep\" [image]=\"image\"></sc-damage-tag-selection-tool>\n    </div>\n    <div class=\"damage-photo__lateral lateral\">\n      <div class=\"lateral__header header\">\n        <div class=\"header__title\">Determinar da\u00F1os en la foto</div>\n        <div class=\"header__close\"><sc-icon icon=\"close\" (click)=\"onClose()\"></sc-icon></div>\n      </div>\n      <div class=\"lateral__content\">\n\n        <sc-damage-tag-parts-selection-form [hidden]=\"!isFirstStep\" #partsSelectionForm></sc-damage-tag-parts-selection-form>\n        <sc-damage-tag-selection-info [hidden]=\"isFirstStep\" #selectionInfo></sc-damage-tag-selection-info>\n\n      </div>\n      <div class=\"lateral__footer footer\">\n        <sc-button type=\"primary\" [disabled]=\"!stepIsValid()\" (onClick)=\"onContinueOrSave()\">\n          {{currentStep ? 'Guardar' : 'Continuar'}}\n        </sc-button>\n        <sc-button type=\"secondary\" id=\"damage-photo-cancel\" (onClick)=\"onClose()\">Cancelar</sc-button>\n      </div>\n    </div>\n  </div>\n</sc-modal>\n",
                    styles: [".damage-photo{width:1015px;min-height:646px;margin:0;display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}.damage-photo__preview{width:670px;background-color:#000;margin:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.damage-photo__lateral{width:345px;margin:0}.damage-photo__tooltip{position:absolute;width:400px;padding:0;margin:0;z-index:1;top:1rem}.preview{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;overflow:hidden}.preview__container{padding:1rem}.preview__thumbnail-image{-o-object-fit:contain;object-fit:contain;width:100%;height:100%}.lateral{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.lateral__content{-webkit-box-flex:1;flex:1 1 auto;padding:1rem}.lateral__footer{padding:1rem}.header{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;-webkit-box-pack:center;justify-content:center;padding:1.125rem;border-bottom:1px solid #ccd2dd}.header__title{font-family:Montserrat,sans-serif;font-size:1.125rem;font-weight:700;color:#424f66}.header__close{-webkit-box-flex:1;flex:1 1 auto;text-align:right}.footer{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;justify-content:space-around}:host ::ng-deep .sc-modal{overflow:hidden}:host ::ng-deep .sc-modal__header-wrapper{padding:0!important}:host ::ng-deep .sc-modal__body{padding:0!important}"]
                }] }
    ];
    /** @nocollapse */
    DamagePhotoModalComponent.ctorParameters = function () { return [
        { type: DamageTagFormService }
    ]; };
    DamagePhotoModalComponent.propDecorators = {
        close: [{ type: Output }],
        submit: [{ type: Output }],
        modal: [{ type: ViewChild, args: ['modal', { static: true },] }],
        partsSelectionForm: [{ type: ViewChild, args: ['partsSelectionForm', { static: false },] }],
        selectionInfo: [{ type: ViewChild, args: ['selectionInfo', { static: false },] }]
    };
    return DamagePhotoModalComponent;
}());
if (false) {
    /** @type {?} */
    DamagePhotoModalComponent.prototype.currentStep;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.image;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.isSecondStep;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.isFirstStep;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.isValid;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.clickedOnce;
    /**
     * @type {?}
     * @private
     */
    DamagePhotoModalComponent.prototype.subs;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.close;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.submit;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.modal;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.partsSelectionForm;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.selectionInfo;
    /** @type {?} */
    DamagePhotoModalComponent.prototype.damageTagFormService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-photo-modal/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-preview/damage-preview.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamagePreviewComponent = /** @class */ (function () {
    function DamagePreviewComponent() {
        this.delete = new EventEmitter();
        this.disabled = false;
    }
    /**
     * @return {?}
     */
    DamagePreviewComponent.prototype.onDelete = /**
     * @return {?}
     */
    function () {
        if (!this.disabled) {
            this.delete.emit(this.index);
        }
    };
    /**
     * @param {?} fileName
     * @return {?}
     */
    DamagePreviewComponent.prototype.getFileNameWithoutExtension = /**
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        return fileName.substr(0, fileName.lastIndexOf('.'));
    };
    /**
     * @param {?} fileName
     * @return {?}
     */
    DamagePreviewComponent.prototype.getFileExtension = /**
     * @param {?} fileName
     * @return {?}
     */
    function (fileName) {
        return fileName.substr(fileName.lastIndexOf('.') + 1);
    };
    DamagePreviewComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-preview',
                    template: "<div class=\"damage-preview\" [ngClass]=\"{ 'damage-preview--disabled': disabled }\">\n  <div class=\"damage-preview__title\">{{ model.perspectiveText }}</div>\n  <div class=\"damage-preview__image image\">\n    <div class=\"image__thumbnail\">\n      <img alt=\"Imagen\" class=\"image__thumbnail-image\" [src]=\"model.imageData\">\n    </div>\n    <div class=\"image__detail text-truncate\">\n      <div class=\"image__info info text-truncate\">\n        <p class=\"info__title m-0\">\n          <span class=\"text-truncate\">{{getFileNameWithoutExtension(model.fileName)}}</span>.{{getFileExtension(model.fileName)}}\n        </p>\n        <p class=\"info__size m-0 text-truncate\">\n          <span *ngIf=\"model.size\">{{model.size | fileSize}}</span>\n        </p>\n      </div>\n      <div class=\"image__delete\">\n        <sc-icon icon=\"trash\" (click)=\"onDelete()\"></sc-icon>\n      </div>\n    </div>\n  </div>\n  <div class=\"damage-preview__chips chips\">\n    <sc-chip *ngFor=\"let item of model.damageTypes\"\n      class=\"chips__item\"\n      color=\"{{ item.color  }}\" number=\"{{ item.number }}\">{{ item.text }}</sc-chip>\n  </div>\n</div>\n",
                    styles: [".damage-preview{padding-bottom:1rem}.damage-preview__title{font-family:Roboto,\"Open Sans\",sans-serif;font-size:.875rem;color:#8993a4}.damage-preview__image{display:-webkit-box;display:flex}.damage-preview__chips{display:-webkit-box;display:flex;flex-wrap:wrap}.damage-preview--disabled{opacity:.4}.image__thumbnail{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;border-radius:.2rem;box-shadow:0 2px 9px 0 rgba(0,0,0,.03);height:48px;width:68px;margin-top:3px}.image__thumbnail-image{border-radius:.2rem;-o-object-fit:cover;object-fit:cover;height:48px;max-height:100%;width:68px;margin:auto;background-color:#aeb7c8;box-shadow:1px 1px 2px 0 rgba(0,0,0,.25)}.image__info{padding-left:1rem;font-family:Roboto,\"Open Sans\",sans-serif;font-size:.875rem;color:#424f66}.image__detail{display:-webkit-box;display:flex;width:312px}.image__delete{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;cursor:pointer}.info{-webkit-box-flex:1;flex:1 auto;padding:.25rem 1rem}.info__title{display:-webkit-box;display:flex;padding-bottom:.25rem}.info__size{color:#8993a4}.chips__item{padding:.25rem .25rem .25rem 0}"]
                }] }
    ];
    DamagePreviewComponent.propDecorators = {
        delete: [{ type: Output }],
        index: [{ type: Input }],
        model: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return DamagePreviewComponent;
}());
if (false) {
    /** @type {?} */
    DamagePreviewComponent.prototype.delete;
    /** @type {?} */
    DamagePreviewComponent.prototype.index;
    /** @type {?} */
    DamagePreviewComponent.prototype.model;
    /** @type {?} */
    DamagePreviewComponent.prototype.disabled;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-preview/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-preview-list/damage-preview-list.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamagePreviewListComponent = /** @class */ (function () {
    function DamagePreviewListComponent() {
        this.items = [];
        this.disabled = false;
        this.delete = new EventEmitter();
    }
    Object.defineProperty(DamagePreviewListComponent.prototype, "enableOverlay", {
        get: /**
         * @return {?}
         */
        function () {
            return this.items && this.items.length > 4;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} index
     * @return {?}
     */
    DamagePreviewListComponent.prototype.onDelete = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.items.splice(index, 1);
        this.delete.emit(index);
    };
    DamagePreviewListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-preview-list',
                    template: "<div class=\"damage-preview-list\">\n  <div class=\"damage-preview-list__info info\" *ngIf=\"items.length === 0\">\n    <p class=\"info__statement\">A\u00FAn no subiste im\u00E1genes.</p>\n    <p class=\"info__hint\">Empez\u00E1 a subir la foto del da\u00F1o en la perspectiva que corresponda.</p>\n  </div>\n  <div class=\"damage-preview-list__content content sc-scroll-bar\">\n    <sc-damage-preview class=\"content__item\" *ngFor=\"let item of items; let itemIndex = index;\"\n      [index]=\"itemIndex\"\n      [model]=\"item\"\n      [disabled]=\"disabled\"\n      (delete)=\"onDelete($event)\">\n    </sc-damage-preview>\n    <div class=\"content__overlay\" *ngIf=\"enableOverlay\"></div>\n  </div>\n</div>\n",
                    styles: [".damage-preview-list{position:relative}.damage-preview-list__info{padding:1.5rem 2rem}.damage-preview-list__content{padding:0 1rem;max-height:609px;overflow-y:auto;margin-top:2rem}.info__statement{color:#8993a4;font-family:Roboto,\"Open Sans\",sans-serif;font-size:1rem;font-weight:700}.info__hint{color:#8993a4;font-family:Roboto,\"Open Sans\",sans-serif;font-size:1rem}.content__overlay{position:absolute;width:98%;height:46px;background:-webkit-gradient(linear,left top,left bottom,from(rgba(255,255,255,0)),to(#fafafa));background:linear-gradient(-180deg,rgba(255,255,255,0) 0,#fafafa 100%);bottom:0;left:0}"]
                }] }
    ];
    DamagePreviewListComponent.propDecorators = {
        items: [{ type: Input }],
        disabled: [{ type: Input }],
        delete: [{ type: Output }]
    };
    return DamagePreviewListComponent;
}());
if (false) {
    /** @type {?} */
    DamagePreviewListComponent.prototype.items;
    /** @type {?} */
    DamagePreviewListComponent.prototype.disabled;
    /** @type {?} */
    DamagePreviewListComponent.prototype.delete;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-preview-list/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/constants/misc.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var imageUploadAllowedExtension = 'image/png,image/x-png,image/jpg,image/jpeg';

var _a;
/** @type {?} */
var parts = (_a = {},
    _a[PartsType.crystals] = { key: 'crystals', description: 'Cristales' },
    _a[PartsType.hood] = { key: 'hood', description: 'Capot' },
    _a[PartsType.bumper] = { key: 'bumper', description: 'Paragolpe' },
    _a[PartsType.rearBumper] = { key: 'rearBumper', description: 'Paragolpe trasero' },
    _a[PartsType.leftOptic] = { key: 'leftOptic', description: 'Óptica izquierda' },
    _a[PartsType.rightOptic] = { key: 'rightOptic', description: 'Óptica derecha' },
    _a[PartsType.grille] = { key: 'grille', description: 'Rejilla' },
    _a[PartsType.frontDoor] = { key: 'frontDoor', description: 'Puerta delantera' },
    _a[PartsType.rearDoor] = { key: 'rearDoor', description: 'Puerta trasera' },
    _a[PartsType.fender] = { key: 'fender', description: 'Guardabarro' },
    _a[PartsType.rearfender] = { key: 'rearFender', description: 'Guardabarro trasero' },
    _a[PartsType.frontFender] = { key: 'frontFender', description: 'Guardabarro delantero' },
    _a[PartsType.trunk] = { key: 'trunk', description: 'Baúl' },
    _a[PartsType.sideMirror] = { key: 'sideMirror', description: 'Espejo lateral' },
    _a[PartsType.others] = { key: 'others', description: 'Otros' },
    _a);

var _a$1;
/** @type {?} */
var perspectiveSelection = Object.freeze((_a$1 = {},
    _a$1[Perspective.partnerFront] = [
        parts[PartsType.crystals],
        parts[PartsType.hood],
        parts[PartsType.bumper],
        parts[PartsType.rightOptic],
        parts[PartsType.leftOptic],
        parts[PartsType.grille],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.fender],
        parts[PartsType.sideMirror],
        parts[PartsType.others]
    ],
    _a$1[Perspective.front] = [
        parts[PartsType.crystals],
        parts[PartsType.hood],
        parts[PartsType.grille],
        parts[PartsType.bumper],
        parts[PartsType.leftOptic],
        parts[PartsType.rightOptic],
        parts[PartsType.others],
    ],
    _a$1[Perspective.driverFront] = [
        parts[PartsType.crystals],
        parts[PartsType.hood],
        parts[PartsType.bumper],
        parts[PartsType.rightOptic],
        parts[PartsType.leftOptic],
        parts[PartsType.grille],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.fender],
        parts[PartsType.sideMirror],
        parts[PartsType.others]
    ],
    _a$1[Perspective.partnerSide] = [
        parts[PartsType.crystals],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.frontFender],
        parts[PartsType.rearfender],
        parts[PartsType.sideMirror],
        parts[PartsType.others],
    ],
    _a$1[Perspective.driverSide] = [
        parts[PartsType.crystals],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.frontFender],
        parts[PartsType.rearfender],
        parts[PartsType.sideMirror],
        parts[PartsType.others],
    ],
    _a$1[Perspective.partnerBack] = [
        parts[PartsType.crystals],
        parts[PartsType.trunk],
        parts[PartsType.bumper],
        parts[PartsType.rightOptic],
        parts[PartsType.leftOptic],
        parts[PartsType.fender],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.others],
    ],
    _a$1[Perspective.back] = [
        parts[PartsType.crystals],
        parts[PartsType.trunk],
        parts[PartsType.rearBumper],
        parts[PartsType.leftOptic],
        parts[PartsType.rightOptic],
        parts[PartsType.others],
    ],
    _a$1[Perspective.driverBack] = [
        parts[PartsType.crystals],
        parts[PartsType.trunk],
        parts[PartsType.bumper],
        parts[PartsType.rightOptic],
        parts[PartsType.leftOptic],
        parts[PartsType.fender],
        parts[PartsType.frontDoor],
        parts[PartsType.rearDoor],
        parts[PartsType.others],
    ],
    _a$1));

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/constants/recomendations.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var recomendations = [
    {
        src: 'assets/damage-tag/icons/damage-tag-selection-info-step-one.svg',
        alt: 'initial_click',
        text: 'Clickeá en la imágen en el lugar del daño'
    },
    {
        src: 'assets/damage-tag/icons/damage-tag-selection-info-step-two.svg',
        alt: 'selection_tool',
        text: 'Aparecerá un cuadrado en el área'
    },
    {
        src: 'assets/damage-tag/icons/damage-tag-selection-info-step-three.svg',
        alt: 'resize_tool',
        text: 'Agrandá o achicá para que entre el daño'
    },
    {
        src: 'assets/damage-tag/icons/damage-tag-selection-info-step-four.svg',
        alt: 'damage_type',
        text: 'Elegí el tipo de daño'
    },
    {
        src: 'assets/damage-tag/icons/damage-tag-selection-info-step-five.svg',
        alt: 'damage_steps',
        text: 'Repetí los pasos para los otros daños'
    }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/constants/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-selection-info/damage-tag-selection-info.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagSelectionInfoComponent = /** @class */ (function () {
    function DamageTagSelectionInfoComponent(damageTagService, damageTagFormService) {
        this.damageTagService = damageTagService;
        this.damageTagFormService = damageTagFormService;
        this.colorMap = new Map([
            [DamageTagType.scratch, 1], [DamageTagType.dent, 2], [DamageTagType.breakage, 3]
        ]);
        this.textMap = new Map([
            [DamageTagType.scratch, DamageTagTypeText.scratch],
            [DamageTagType.dent, DamageTagTypeText.dent],
            [DamageTagType.breakage, DamageTagTypeText.breakage]
        ]);
        this.chipTypeMap = new Map();
        this.damageTagSelections = [];
        this.recomendations = recomendations;
        this.subscription = new Subscription();
    }
    /**
     * @return {?}
     */
    DamageTagSelectionInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription.add(this.damageTagService.selection$.subscribe((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return _this.addDamageType(item); })));
    };
    /**
     * @return {?}
     */
    DamageTagSelectionInfoComponent.prototype.clear = /**
     * @return {?}
     */
    function () {
        this.chipTypeMap.clear();
        this.chips = [];
        this.damageTagSelections = [];
        this.damageTagFormService.setDamageTag(null);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    DamageTagSelectionInfoComponent.prototype.onChipClose = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        this.chipTypeMap.delete(type);
        this.chips = Array.from(this.chipTypeMap.values());
        this.damageTagService.setSelectionDeleted(type);
        this.damageTagSelections = this.damageTagSelections.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.type !== type; }));
        this.damageTagFormService.setDamageTag(this.damageTagSelections);
    };
    /**
     * @private
     * @param {?} item
     * @return {?}
     */
    DamageTagSelectionInfoComponent.prototype.addDamageType = /**
     * @private
     * @param {?} item
     * @return {?}
     */
    function (item) {
        /** @type {?} */
        var type = item.type;
        if (this.chipTypeMap.has(type)) {
            this.chipTypeMap.get(type).number++;
        }
        else {
            this.chipTypeMap.set(type, {
                color: this.colorMap.get(type),
                number: 1,
                text: this.textMap.get(type),
                type: type
            });
        }
        this.chips = Array.from(this.chipTypeMap.values());
        this.damageTagSelections.push(item);
        this.damageTagFormService.setDamageTag(this.damageTagSelections);
    };
    DamageTagSelectionInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-tag-selection-info',
                    template: "<div class=\"sc-damage-tag-selection-info\">\n  <div class=\"sc-damage-tag-selection-info__header\">\n    <h3 class=\"sc-damage-tag-selection-info__title\">\u00BFQu\u00E9 tipo de da\u00F1o?</h3>\n    <p class=\"sc-damage-tag-selection-info__hint\">Seleccion\u00E1 todos los da\u00F1os que veas en la im\u00E1gen.</p>\n  </div>\n  <div class=\"sc-damage-tag-selection-info__chips-container\">\n    <div class=\"sc-damage-tag-selection-info__chips\">\n      <sc-chip *ngFor=\"let item of chips\"\n        style=\"margin: .25rem;\" color=\"{{ item.color  }}\" number=\"{{ item.number }}\"\n        [enableClose]=\"true\"\n        (close)=\"onChipClose(item.type)\">\n        {{ item.text }}\n      </sc-chip>\n    </div>\n  </div>\n  <div class=\"sc-damage-tag-selection-info__recomendations\">\n    <h3 class=\"sc-damage-tag-selection-info__title\">Recomendaciones</h3>\n\n    <div class=\"sc-damage-tag-selection-info__item\" *ngFor=\"let item of recomendations\">\n      <img class=\"sc-damage-tag-selection-info__camera-icon\" [src]=\"item.src\" [alt]=\"item.alt\">\n      <p class=\"sc-damage-tag-selection-info__item-text\">{{item.text}}</p>\n    </div>\n\n  </div>\n</div>\n",
                    styles: [".sc-damage-tag-selection-info{height:100%;padding:0 .5rem;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center}.sc-damage-tag-selection-info__title{font-size:1rem;font-weight:700;font-family:Roboto,\"Open Sans\",sans-serif;color:#424f66}.sc-damage-tag-selection-info__chips-container{width:100%;height:100%}.sc-damage-tag-selection-info__chips{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;flex-wrap:wrap;padding:.25rem}.sc-damage-tag-selection-info__item{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;margin-top:.875rem}.sc-damage-tag-selection-info__camera-icon{margin-right:.5rem}.sc-damage-tag-selection-info__item-text{font-size:.875rem;font-weight:400;margin:0}"]
                }] }
    ];
    /** @nocollapse */
    DamageTagSelectionInfoComponent.ctorParameters = function () { return [
        { type: DamageTagService },
        { type: DamageTagFormService }
    ]; };
    return DamageTagSelectionInfoComponent;
}());
if (false) {
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.colorMap;
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.textMap;
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.chipTypeMap;
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.chips;
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.damageTagSelections;
    /** @type {?} */
    DamageTagSelectionInfoComponent.prototype.recomendations;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionInfoComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionInfoComponent.prototype.damageTagService;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionInfoComponent.prototype.damageTagFormService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-selection-info/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-selection-tool/damage-tag-selection-tool.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagSelectionToolComponent = /** @class */ (function () {
    function DamageTagSelectionToolComponent(damageTagFormService, damageTagService) {
        this.damageTagFormService = damageTagFormService;
        this.damageTagService = damageTagService;
        this.colorMap = new Map([
            [DamageTagType.scratch, 1], [DamageTagType.dent, 2], [DamageTagType.breakage, 3]
        ]);
        this.delayTime = 200;
        this.maxWidth = 601;
        this.maxHeight = 601;
        this.maxSelection = 10;
        this.subscription = new Subscription();
        this.isSelecting = false;
        this.selections = [];
        this.confirmedSelections = [];
        this._isSecondStep = false;
        this.model = new DamageTagImageModel();
    }
    Object.defineProperty(DamageTagSelectionToolComponent.prototype, "image", {
        get: /**
         * @return {?}
         */
        function () { return this.imageFile; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.imageFile = value;
            if (this.imageControl && this.imageControl.nativeElement.naturalWidth > 0) {
                this.setImage(this.imageControl.nativeElement);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DamageTagSelectionToolComponent.prototype, "isSecondStep", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.selections = [];
            this.confirmedSelections = [];
            this.isSelecting = false;
            this._isSecondStep = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.subscription.add(this.damageTagService.selectionDeleted$.subscribe((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return _this.removeSelection(item); })));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.onImageLoad = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        /** @type {?} */
        var image = ((/** @type {?} */ (item.target)));
        this.setImage(image);
    };
    /**
     * @private
     * @param {?} imageElement
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.setImage = /**
     * @private
     * @param {?} imageElement
     * @return {?}
     */
    function (imageElement) {
        this.setImageSize(imageElement.naturalWidth, imageElement.naturalHeight);
        this.model.name = this.image.name;
        this.model.size = this.image.size;
        this.model.imageData = this.image.thumbnail;
        this.model.customId = this.image.customId;
        this.damageTagFormService.setSelectedImage(this.model);
    };
    /**
     * @private
     * @param {?} originalWidth
     * @param {?} originalHeight
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.setImageSize = /**
     * @private
     * @param {?} originalWidth
     * @param {?} originalHeight
     * @return {?}
     */
    function (originalWidth, originalHeight) {
        /** @type {?} */
        var isPortrait = originalHeight > originalWidth;
        /** @type {?} */
        var ratio = isPortrait ? originalWidth / originalHeight : originalHeight / originalWidth;
        this.model.width = isPortrait ? Math.round(this.maxHeight * ratio) : this.maxWidth;
        this.model.height = isPortrait ? this.maxHeight : Math.round(this.maxWidth * ratio);
    };
    /**
     * @param {?} type
     * @param {?} selection
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.onDamageTypeSelected = /**
     * @param {?} type
     * @param {?} selection
     * @return {?}
     */
    function (type, selection) {
        var _this = this;
        selection.color = this.colorMap.get(type);
        selection.type = type;
        selection.isSelecting = false;
        this.confirmedSelections.push(selection);
        timer(this.delayTime).subscribe((/**
         * @return {?}
         */
        function () { return _this.isSelecting = false; }));
        this.damageTagService.setSelection(selection);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.addSelection = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (this.confirmedSelections.length >= this.maxSelection) {
            return;
        }
        if (this.isSelecting || !this._isSecondStep) {
            return;
        }
        this.selections.push({
            type: null,
            coordinates: {
                containerHeight: this.model.height,
                containerWidth: this.model.width,
                offsetTop: $event.offsetY,
                offsetLeft: $event.offsetX,
                height: null,
                width: null
            },
            color: null,
            isSelecting: true
        });
        this.isSelecting = true;
    };
    /**
     * @private
     * @param {?} type
     * @return {?}
     */
    DamageTagSelectionToolComponent.prototype.removeSelection = /**
     * @private
     * @param {?} type
     * @return {?}
     */
    function (type) {
        this.selections = this.selections.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.type !== type; }));
        this.confirmedSelections = this.confirmedSelections.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.type !== type; }));
    };
    DamageTagSelectionToolComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-tag-selection-tool',
                    template: "<section class=\"damage-tag-selection-tool\" #imgContainer (click)=\"addSelection($event)\">\n  <img #imageControl\n    (load)=\"onImageLoad($event)\"\n    alt=\"Imagen subida\"\n    class=\"preview__thumbnail-image\"\n    [ngStyle]=\"{ 'width': model.width + 'px', 'height': model.height + 'px' }\"\n    [src]=\"image?.thumbnail\">\n  <sc-selection-tool *ngFor=\"let selection of selections\" \n    [selection]=\"selection\"\n    [containerRef]=\"imgContainer\">\n    <sc-damage-type-menu (change)=\"onDamageTypeSelected($event, selection)\"></sc-damage-type-menu>\n  </sc-selection-tool>\n</section>\n",
                    styles: [".damage-tag-selection-tool{position:relative}"]
                }] }
    ];
    /** @nocollapse */
    DamageTagSelectionToolComponent.ctorParameters = function () { return [
        { type: DamageTagFormService },
        { type: DamageTagService }
    ]; };
    DamageTagSelectionToolComponent.propDecorators = {
        image: [{ type: Input }],
        isSecondStep: [{ type: Input }],
        imageControl: [{ type: ViewChild, args: ['imageControl', { static: false },] }]
    };
    return DamageTagSelectionToolComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.colorMap;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.delayTime;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.maxWidth;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.maxHeight;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.maxSelection;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.subscription;
    /** @type {?} */
    DamageTagSelectionToolComponent.prototype.isSelecting;
    /** @type {?} */
    DamageTagSelectionToolComponent.prototype.selections;
    /** @type {?} */
    DamageTagSelectionToolComponent.prototype.confirmedSelections;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.imageFile;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype._isSecondStep;
    /** @type {?} */
    DamageTagSelectionToolComponent.prototype.model;
    /** @type {?} */
    DamageTagSelectionToolComponent.prototype.imageControl;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.damageTagFormService;
    /**
     * @type {?}
     * @private
     */
    DamageTagSelectionToolComponent.prototype.damageTagService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-selection-tool/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/components/damage-tag-uploader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@dynamic
 */
var DamageTagUploaderComponent = /** @class */ (function () {
    function DamageTagUploaderComponent(window, damageTagService) {
        this.window = window;
        this.damageTagService = damageTagService;
        this.optional = false;
        this.itemChange = new EventEmitter();
        this.isUploading = new EventEmitter();
        this.extensionAllowed = imageUploadAllowedExtension;
        this.fileMaxSizeErrorMessage = 'Excede los 15MB';
        this.hasError = false;
        this.isDisabled = false;
        this.timeoutMessage = 'Ha tardado en subir';
        this.timeoutLimit = 300000; // 5 minutes
        this.subscription = new Subscription();
    }
    Object.defineProperty(DamageTagUploaderComponent.prototype, "uploadControlId", {
        get: /**
         * @return {?}
         */
        function () {
            return "damage-tag-upload-" + this.tagKey;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.damageTagFileModel = new DamageTagFileModel(this.tagKey, this.optional);
        this.damageTagFileModel.validateSmallImage = !this.optional;
        this.subscription.add(this.damageTagService.uploadStarted$.subscribe((/**
         * @return {?}
         */
        function () {
            _this.resetAndDisable();
            _this.isUploading.emit(true);
        }))).add(this.damageTagService.uploadFinished$.subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.uploadFinished(value);
            _this.isUploading.emit(false);
        })));
    };
    /**
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
    };
    /**
     * @param {?} items
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.onItemsChanged = /**
     * @param {?} items
     * @return {?}
     */
    function (items) {
        if (items.length === 0) {
            return;
        }
        /** @type {?} */
        var item = items[0];
        item.perspective = this.tagKey;
        this.uploaderControl.items = [];
        if (item.errorMessage) {
            this.errorMessage = item.errorMessage;
            this.hasError = true;
            this.damageTagService.uploadFinished$.next(this.damageTagFileModel);
            return;
        }
        this.itemChange.emit(item);
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.resetAndDisable = /**
     * @private
     * @return {?}
     */
    function () {
        this.hasError = false;
        this.errorMessage = '';
        if (!this.uploaderControl.isLoading) {
            this.isDisabled = true;
            return;
        }
        this.setUploadTimeout();
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.uploadFinished = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value && this.damageTagFileModel.title === value.title) {
            return;
        }
        this.errorMessage = '';
        this.hasError = false;
        this.isDisabled = false;
        this.window.clearTimeout(this.timer);
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.setUploadTimeout = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        clearTimeout(this.timer);
        this.timer = this.window.setTimeout((/**
         * @return {?}
         */
        function () {
            _this.setTimeoutError();
        }), this.timeoutLimit);
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagUploaderComponent.prototype.setTimeoutError = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.uploaderControl.isLoading) {
            return;
        }
        /** @type {?} */
        var item = this.uploaderControl.items[0];
        this.uploaderControl.isLoading = false;
        this.uploaderControl.cancelFile(item);
        this.errorMessage = this.timeoutMessage;
        this.hasError = true;
        this.damageTagService.uploadFinished$.next(this.damageTagFileModel);
    };
    DamageTagUploaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-tag-uploader',
                    template: "<div class=\"dt-uploader\">\n\n  <sc-uploader #uploaderControl\n    [id]=\"uploadControlId\"\n    view=\"simple\"\n    [maxFiles]=\"1\"\n    [fileMaxSizeErrorMessage]=\"fileMaxSizeErrorMessage\"\n    [fileMaxSizeBytes]=\"15728640\"\n    [extensionAllowed]=\"extensionAllowed\"\n    (itemsChanged)=\"onItemsChanged($event)\"\n    [optionalData]=\"damageTagFileModel\"\n    [addButtonText]=\"label\"\n    [disabled]=\"disable || isDisabled\">\n  </sc-uploader>\n\n  <span class=\"dt-uploader__error\" [hidden]=\"!hasError\">{{errorMessage}}</span>\n\n</div>\n",
                    styles: [".dt-uploader{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;width:auto}.dt-uploader__error{font-size:.875rem;color:#de350b}"]
                }] }
    ];
    /** @nocollapse */
    DamageTagUploaderComponent.ctorParameters = function () { return [
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
        { type: DamageTagService }
    ]; };
    DamageTagUploaderComponent.propDecorators = {
        optional: [{ type: Input }],
        label: [{ type: Input }],
        tagKey: [{ type: Input }],
        disable: [{ type: Input }],
        itemChange: [{ type: Output }],
        isUploading: [{ type: Output }],
        uploaderControl: [{ type: ViewChild, args: ['uploaderControl', { static: false },] }]
    };
    return DamageTagUploaderComponent;
}());
if (false) {
    /** @type {?} */
    DamageTagUploaderComponent.prototype.optional;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.label;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.tagKey;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.disable;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.itemChange;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.isUploading;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.damageTagFileModel;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.errorMessage;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.extensionAllowed;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.fileMaxSizeErrorMessage;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.hasError;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.isDisabled;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.timeoutMessage;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.timeoutLimit;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.timer;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.subscription;
    /** @type {?} */
    DamageTagUploaderComponent.prototype.uploaderControl;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.window;
    /**
     * @type {?}
     * @private
     */
    DamageTagUploaderComponent.prototype.damageTagService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/components/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/services/uploader.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UploaderService = /** @class */ (function () {
    function UploaderService(damageTagService, damageTagBaseUploaderService) {
        this.damageTagService = damageTagService;
        this.damageTagBaseUploaderService = damageTagBaseUploaderService;
        this.fileImagesMaxSizeMb = 15;
        this.minWidth = 640;
        this.minHeight = 480;
        this.minErrorMessage = 'Imagen muy pequeña';
        this.cancel$ = new Subject();
    }
    /**
     * @return {?}
     */
    UploaderService.prototype.deleteFile = /**
     * @return {?}
     */
    function () {
        return of({});
    };
    /**
     * @param {?} item
     * @param {?=} owner
     * @return {?}
     */
    UploaderService.prototype.cancelFile = /**
     * @param {?} item
     * @param {?=} owner
     * @return {?}
     */
    function (item, owner) {
        this.cancel$.next(item.name);
    };
    /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    UploaderService.prototype.uploadFile = /**
     * @param {?} file
     * @param {?=} owner
     * @return {?}
     */
    function (file, owner) {
        var _this = this;
        /** @type {?} */
        var damageTagFileModel = (/** @type {?} */ (owner.optionalData));
        if (!damageTagFileModel.validateSmallImage) {
            return this.internalUploadFile(file, owner);
        }
        return this.validateSmallImageSize(owner).pipe(mergeMap((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return owner.hasError ? of(item) : _this.internalUploadFile(file, owner); })));
    };
    /**
     * @param {?} file
     * @param {?} owner
     * @return {?}
     */
    UploaderService.prototype.internalUploadFile = /**
     * @param {?} file
     * @param {?} owner
     * @return {?}
     */
    function (file, owner) {
        var _this = this;
        /** @type {?} */
        var lastFile = (/** @type {?} */ (owner.items[owner.items.length - 1]));
        if (!this.validateSize(lastFile)) {
            owner.hasError = true;
            return of({});
        }
        this.damageTagService.uploadStarted$.next();
        return this.damageTagBaseUploaderService.uploadFile(file, owner)
            .pipe(takeUntil(this.cancel$.pipe(filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item === file.name; })))), tap((/**
         * @return {?}
         */
        function () {
            _this.damageTagService.uploadFinished$.next();
        })));
    };
    /**
     * @private
     * @param {?} fileItem
     * @return {?}
     */
    UploaderService.prototype.validateSize = /**
     * @private
     * @param {?} fileItem
     * @return {?}
     */
    function (fileItem) {
        /** @type {?} */
        var fileMaxSizeBytes = this.fileImagesMaxSizeMb * Math.pow(1024, 2);
        if (fileItem.size < fileMaxSizeBytes) {
            return true;
        }
        fileItem.errorMessage = "Excede los " + this.fileImagesMaxSizeMb + "MB";
        return false;
    };
    /**
     * @private
     * @param {?} owner
     * @return {?}
     */
    UploaderService.prototype.validateSmallImageSize = /**
     * @private
     * @param {?} owner
     * @return {?}
     */
    function (owner) {
        var _this = this;
        /** @type {?} */
        var lastFile = (/** @type {?} */ (owner.items[owner.items.length - 1]));
        /** @type {?} */
        var image = new Image();
        image.src = lastFile.thumbnail;
        return fromEvent(image, 'load').pipe(map((/**
         * @return {?}
         */
        function () {
            if (image.width < _this.minWidth || image.height < _this.minHeight) {
                lastFile.errorMessage = _this.minErrorMessage;
                owner.hasError = true;
            }
            return of({});
        })));
    };
    UploaderService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    UploaderService.ctorParameters = function () { return [
        { type: DamageTagService },
        { type: DamageTagBaseUploaderService }
    ]; };
    return UploaderService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.fileImagesMaxSizeMb;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.minWidth;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.minHeight;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.minErrorMessage;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.cancel$;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.damageTagService;
    /**
     * @type {?}
     * @private
     */
    UploaderService.prototype.damageTagBaseUploaderService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/services/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/damage-tag-uploader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagUploaderModule = /** @class */ (function () {
    function DamageTagUploaderModule() {
    }
    DamageTagUploaderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        UploaderModule.setUploader(UploaderService)
                    ],
                    declarations: [
                        DamageTagUploaderComponent
                    ],
                    exports: [
                        DamageTagUploaderComponent
                    ]
                },] }
    ];
    return DamageTagUploaderModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-uploader/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-type-menu/damage-type-menu.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTypeMenuComponent = /** @class */ (function () {
    function DamageTypeMenuComponent() {
        this.typeEnum = DamageTagType;
        this.change = new EventEmitter();
    }
    /**
     * @param {?} key
     * @return {?}
     */
    DamageTypeMenuComponent.prototype.onMenuClick = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.change.emit(key);
    };
    DamageTypeMenuComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-type-menu',
                    template: "<div class=\"damage-type-menu\">\n  <div class=\"damage-type-menu__title\">\n    \u00BFQu\u00E9 tipo de da\u00F1o?\n  </div>\n  <div class=\"damage-type-menu__options\">\n\n    <div class=\"chip-option chip-option--color1\" (click)=\"onMenuClick(typeEnum.scratch)\">Ray\u00F3n</div>\n    <div class=\"chip-option chip-option--color2\" (click)=\"onMenuClick(typeEnum.dent)\">Abolladura</div>\n    <div class=\"chip-option chip-option--color3\" (click)=\"onMenuClick(typeEnum.breakage)\">Rotura/pieza faltante</div>\n\n  </div>\n</div>\n",
                    styles: [".damage-type-menu{width:175px;height:128px;background-color:#fff;border-radius:4px;box-shadow:0 4px 13px 0 rgba(0,0,0,.5);cursor:default}.damage-type-menu__title{text-align:center;font-size:1rem;color:#424f66;border-bottom:1px solid #ccd2dd;padding:.5rem}.damage-type-menu__options{display:-webkit-box;display:flex;flex-wrap:wrap;-webkit-box-pack:space-evenly;justify-content:space-evenly;padding:.25rem}.chip-option{font-size:.875rem;border-radius:4px;background-color:#fff;border:1px solid #ccd2dd;padding:.25rem .5rem;cursor:pointer;outline:0;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;margin:.25rem}.chip-option:hover{background-color:#ccd2dd}.chip-option--color1:hover{border:1px solid #dadcfb;background-color:#dadcfb}.chip-option--color2:hover{border:1px solid #fae6d1;background-color:#fae6d1}.chip-option--color3:hover{border:1px solid #d3f4e8;background-color:#d3f4e8}"]
                }] }
    ];
    DamageTypeMenuComponent.propDecorators = {
        change: [{ type: Output }]
    };
    return DamageTypeMenuComponent;
}());
if (false) {
    /** @type {?} */
    DamageTypeMenuComponent.prototype.typeEnum;
    /** @type {?} */
    DamageTypeMenuComponent.prototype.change;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-type-menu/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-parts-selection-form/damage-tag-parts-selection-form.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagPartsSelectionFormComponent = /** @class */ (function () {
    function DamageTagPartsSelectionFormComponent(formBuilder, changeDetector) {
        this.formBuilder = formBuilder;
        this.changeDetector = changeDetector;
        this.form = null;
        this.parts = null;
        this.initForm();
    }
    /**
     * @param {?} perspective
     * @return {?}
     */
    DamageTagPartsSelectionFormComponent.prototype.initPartsSelection = /**
     * @param {?} perspective
     * @return {?}
     */
    function (perspective) {
        var _this = this;
        if (!perspective) {
            return;
        }
        this.resetPartsSelection();
        this.parts = perspectiveSelection[perspective];
        this.parts.forEach((/**
         * @param {?} part
         * @return {?}
         */
        function (part) {
            _this.form.addControl(part.key, new FormControl(false));
        }));
    };
    /**
     * @return {?}
     */
    DamageTagPartsSelectionFormComponent.prototype.getSelectedParts = /**
     * @return {?}
     */
    function () {
        var _this = this;
        return Object.keys(this.form.value)
            .filter((/**
         * @param {?} key
         * @return {?}
         */
        function (key) { return !!_this.form.value[key]; }));
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagPartsSelectionFormComponent.prototype.resetPartsSelection = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        Object.keys(this.form.controls).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            _this.form.removeControl(key);
        }));
        this.parts = [];
        this.changeDetector.detectChanges();
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagPartsSelectionFormComponent.prototype.initForm = /**
     * @private
     * @return {?}
     */
    function () {
        this.form = this.formBuilder.group({});
    };
    DamageTagPartsSelectionFormComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-tag-parts-selection-form',
                    template: "<form [formGroup]=\"form\" class=\"damage-tag-parts-selection-form\">\n\n  <h3 class=\"damage-tag-parts-selection-form__title\">\u00BFEn qu\u00E9 parte se encuentra el da\u00F1o?</h3>\n\n  <div class=\"damage-tag-parts-selection-form__checkbox\" *ngFor=\"let part of parts\">\n    <sc-checkbox [formControlName]=\"part.key\">{{part.description}}</sc-checkbox>\n  </div>\n</form>\n",
                    styles: [".damage-tag-parts-selection-form{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:1rem}.damage-tag-parts-selection-form__title{font-family:Roboto,\"Open Sans\",sans-serif;color:#424f66;font-size:1rem;font-weight:700;margin-bottom:1.275rem}.damage-tag-parts-selection-form__checkbox{margin-bottom:.875rem}"]
                }] }
    ];
    /** @nocollapse */
    DamageTagPartsSelectionFormComponent.ctorParameters = function () { return [
        { type: FormBuilder },
        { type: ChangeDetectorRef }
    ]; };
    return DamageTagPartsSelectionFormComponent;
}());
if (false) {
    /** @type {?} */
    DamageTagPartsSelectionFormComponent.prototype.form;
    /** @type {?} */
    DamageTagPartsSelectionFormComponent.prototype.parts;
    /**
     * @type {?}
     * @private
     */
    DamageTagPartsSelectionFormComponent.prototype.formBuilder;
    /**
     * @type {?}
     * @private
     */
    DamageTagPartsSelectionFormComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag-parts-selection-form/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag/damage-tag.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagComponent = /** @class */ (function () {
    function DamageTagComponent(damageTagFormService) {
        this.damageTagFormService = damageTagFormService;
        this.maxPerspectiveLength = 10;
        this.maxOptionalLength = 5;
        this.itemChange = new EventEmitter();
        this.uploading = new EventEmitter();
        this.isDisabled = false;
        this.perspectiveCols = perspectiveCols;
        this.perspectivePoints = perspectivePoints;
        this.damagePreviewItems = [];
        this.damageTagData = [];
        this.isUploading = false;
    }
    /**
     * @return {?}
     */
    DamageTagComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.clear();
    };
    /**
     * @return {?}
     */
    DamageTagComponent.prototype.isValid = /**
     * @return {?}
     */
    function () {
        return this.getPerspectiveLength() > 0;
    };
    /**
     * @return {?}
     */
    DamageTagComponent.prototype.isUploaderDisabled = /**
     * @return {?}
     */
    function () {
        return this.getPerspectiveLength() >= this.maxPerspectiveLength;
    };
    /**
     * @return {?}
     */
    DamageTagComponent.prototype.isOptionalUploaderDisabled = /**
     * @return {?}
     */
    function () {
        return !this.isValid() || this.getOptionalLength() >= this.maxOptionalLength;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DamageTagComponent.prototype.onUpload = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.damageTagFormService.setSelectedPerspective(item.perspective);
        this.damagePhotoModal.open(item);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    DamageTagComponent.prototype.onOptionalUpload = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.damageTagData.push(this.damageTagFormService.getDamageTagModel(item));
        this.damagePreviewItems.push(this.damageTagFormService.getDamagePreviewItem(item));
        this.itemChange.emit(this.damageTagData);
    };
    /**
     * @param {?=} isSavingTag
     * @return {?}
     */
    DamageTagComponent.prototype.onModalClose = /**
     * @param {?=} isSavingTag
     * @return {?}
     */
    function (isSavingTag) {
        if (isSavingTag === void 0) { isSavingTag = false; }
        if (!isSavingTag) {
            return;
        }
        this.damageTagData.push(this.damageTagFormService.getDamageTagModel());
        this.damagePreviewItems.push(this.damageTagFormService.getDamagePreviewItem());
        this.setPerspectiveSelection();
        this.itemChange.emit(this.damageTagData);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    DamageTagComponent.prototype.onPreviewDelete = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        this.setPerspectiveSelection();
        this.damageTagData.splice(index, 1);
        this.itemChange.emit(this.damageTagData);
    };
    /**
     * @return {?}
     */
    DamageTagComponent.prototype.setPerspectiveSelection = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var perspectives = this.damagePreviewItems.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.perspective; }));
        this.perspectivePoints.forEach((/**
         * @param {?} point
         * @return {?}
         */
        function (point) { return point.selected = perspectives.some((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return point.key === item; })); }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    DamageTagComponent.prototype.onUploadEvent = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.isUploading = $event;
        this.uploading.emit($event);
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagComponent.prototype.clear = /**
     * @private
     * @return {?}
     */
    function () {
        this.perspectivePoints.forEach((/**
         * @param {?} point
         * @return {?}
         */
        function (point) { return point.selected = false; }));
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagComponent.prototype.getPerspectiveLength = /**
     * @private
     * @return {?}
     */
    function () {
        return this.damagePreviewItems.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !item.optional; })).length;
    };
    /**
     * @private
     * @return {?}
     */
    DamageTagComponent.prototype.getOptionalLength = /**
     * @private
     * @return {?}
     */
    function () {
        return this.damagePreviewItems.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.optional; })).length;
    };
    DamageTagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-damage-tag',
                    template: "<div class=\"damage-tag\">\n  <div class=\"damage-tag__main\">\n    <div class=\"external-damages\">\n      <h3 class=\"damage-tag__title\">Da\u00F1os exteriores</h3>\n      <div class=\"statements\">\n        <div>\n          <img class=\"statements__camera-icon\" src=\"assets/damage-tag/icons/vehicle-perspective-camera.svg\" alt=\"camera_icon\">\n        </div>\n        <div>\n          <p class=\"statements__statement\">Sub\u00ED la foto en la perspectiva que corresponda y seleccion\u00E1 los da\u00F1os</p>\n          <p class=\"statements__hint\">Pod\u00E9s subir hasta 10 fotos  (formato JPG y PNG 15MB)</p>\n        </div>\n      </div>\n\n      <div class=\"perspective-selection\">\n        <div *ngFor=\"let col of perspectiveCols\"\n             class=\"{{'perspective-selection__col ' + 'perspective-selection__col--' + col.positionClass}}\">\n             <sc-damage-tag-uploader\n                *ngFor=\"let item of col.items\"\n                [tagKey]=\"item.key\"\n                [label]=\"item.description\"\n                [disable]=\"isUploaderDisabled() || isDisabled\"\n                (isUploading)=\"onUploadEvent($event)\"\n                (itemChange)=\"onUpload($event)\">\n              </sc-damage-tag-uploader>\n        </div>\n        <div *ngFor=\"let point of perspectivePoints\"\n             class=\"perspective-selection__point\"\n             [ngStyle]=\"{ 'top': point.top, 'left': point.left }\"\n             [class.perspective-selection__point--active]=\"point.selected === true\">\n        </div>\n      </div>\n\n      <h3 class=\"damage-tag__title\">Da\u00F1os Interiores (opcional)</h3>\n      <div class=\"statements\">\n        <div>\n          <img class=\"statements__camera-icon\" src=\"assets/damage-tag/icons/vehicle-perspective-camera.svg\" alt=\"camera_icon\">\n        </div>\n        <div>\n          <p class=\"statements__statement\">Sub\u00ED las fotos de da\u00F1os interiores y otras adicionales</p>\n          <p class=\"statements__hint\">Pod\u00E9s subir hasta 5 fotos (formato JPG y PNG 15MB)</p>\n        </div>\n      </div>\n      <div class=\"damage-tag__optional\">\n        <sc-damage-tag-uploader\n        [optional]=\"true\"\n        tagKey=\"optional\"\n        label=\"Agregar fotos\"\n        [disable]=\"isOptionalUploaderDisabled() || isDisabled\"\n        (itemChange)=\"onOptionalUpload($event)\">\n      </sc-damage-tag-uploader>\n      </div>\n    </div>\n    <div class=\"uploaded-files\">\n      <h3 class=\"uploaded-files__title\">Im\u00E1genes subidas</h3>\n      <div class=\"uploaded-files__preview\">\n        <sc-damage-preview-list [items]=\"damagePreviewItems\" [disabled]=\"isUploading || isDisabled\" (delete)=\"onPreviewDelete($event)\"></sc-damage-preview-list>\n      </div>\n    </div>\n  </div>\n</div>\n\n<sc-damage-photo-modal (close)=\"onModalClose($event)\" #damagePhotoModal></sc-damage-photo-modal>\n",
                    styles: [".damage-tag{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;width:100%;max-width:1015px}.damage-tag__title{color:#424f66;font-family:Montserrat,sans-serif;font-size:1.125rem;font-weight:700}.damage-tag__title--margin{margin-left:2rem}.damage-tag__main{display:-webkit-box;display:flex;margin-bottom:2rem}.damage-tag__main .external-damages{width:700px;padding-right:2rem}.damage-tag__main .external-damages .statements{display:-webkit-box;display:flex;margin-top:1rem}.damage-tag__main .external-damages .statements__camera-icon{margin-top:0;margin-right:10px}.damage-tag__main .external-damages .statements__statement{margin:0;font-size:1rem;font-family:Roboto,\"Open Sans\",sans-serif}.damage-tag__main .external-damages .statements__hint{margin:0;color:#8993a4;font-family:Roboto,\"Open Sans\",sans-serif;font-size:.875rem;font-style:italic;font-weight:400}.damage-tag__main .external-damages .perspective-selection{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;height:300px;background-image:url(~/assets/damage-tag/images/vehicle-perspective.png);background-repeat:no-repeat;background-position:center;margin-top:1.875rem;margin-bottom:4.5rem;position:relative}.damage-tag__main .external-damages .perspective-selection__col{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}.damage-tag__main .external-damages .perspective-selection__col--edge{justify-content:space-around}.damage-tag__main .external-damages .perspective-selection__col--middle{-webkit-box-pack:justify;justify-content:space-between}.damage-tag__main .external-damages .perspective-selection__point{position:absolute;width:31px;height:33px;background-image:url(~/assets/damage-tag/images/vehicle-perspective-point.png)}.damage-tag__main .external-damages .perspective-selection__point--active{background-image:url(~/assets/damage-tag/images/vehicle-perspective-point-active.png)}.damage-tag__main .uploaded-files{width:330px;padding:0;border-left:1px solid #ccd2dd}.damage-tag__main .uploaded-files__title{font-family:Montserrat,sans-serif;color:#424f66;font-size:1.125rem;font-weight:700;margin-left:2rem}.damage-tag__optional{float:left;margin-top:2rem}"]
                }] }
    ];
    /** @nocollapse */
    DamageTagComponent.ctorParameters = function () { return [
        { type: DamageTagFormService }
    ]; };
    DamageTagComponent.propDecorators = {
        itemChange: [{ type: Output }],
        uploading: [{ type: Output }],
        isDisabled: [{ type: Input }],
        damagePhotoModal: [{ type: ViewChild, args: ['damagePhotoModal', { static: false },] }]
    };
    return DamageTagComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DamageTagComponent.prototype.maxPerspectiveLength;
    /**
     * @type {?}
     * @private
     */
    DamageTagComponent.prototype.maxOptionalLength;
    /** @type {?} */
    DamageTagComponent.prototype.itemChange;
    /** @type {?} */
    DamageTagComponent.prototype.uploading;
    /** @type {?} */
    DamageTagComponent.prototype.isDisabled;
    /** @type {?} */
    DamageTagComponent.prototype.perspectiveCols;
    /** @type {?} */
    DamageTagComponent.prototype.perspectivePoints;
    /** @type {?} */
    DamageTagComponent.prototype.damagePreviewItems;
    /** @type {?} */
    DamageTagComponent.prototype.damageTagData;
    /** @type {?} */
    DamageTagComponent.prototype.isUploading;
    /**
     * @type {?}
     * @protected
     */
    DamageTagComponent.prototype.damagePhotoModal;
    /**
     * @type {?}
     * @private
     */
    DamageTagComponent.prototype.damageTagFormService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/damage-tag/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/constants/directives-constants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var LEFT_CLICK_CODE = 0;
/** @type {?} */
var OFFSET_LIMIT = 5;
/** @type {?} */
var MIN_SIZE = 20;
/** @type {?} */
var RESIZE_SIDES = ['top', 'right', 'bottom', 'left'];
/** @type {?} */
var SELECTION_SIDES = Object.freeze(RESIZE_SIDES);
/** @type {?} */
var DEFAULT_SIZE = 100;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/constants/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/components/selection-tool/selection-tool.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectionToolComponent = /** @class */ (function () {
    function SelectionToolComponent(changeDetector) {
        this.changeDetector = changeDetector;
        this.tooltipHeight = 120;
        this.tooltipPadding = 20;
        this.show = false;
        this.showTooltip = true;
        this.isTooltipOverflow = false;
        this.tooltipY = 0;
        this.selectionSides = SELECTION_SIDES;
        this.initialValues = {
            width: null,
            height: null,
            top: null,
            left: null
        };
    }
    /**
     * @return {?}
     */
    SelectionToolComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.calculateInitialValues();
        this.show = true;
        this.changeDetector.detectChanges();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    SelectionToolComponent.prototype.positionUpdate = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.selection.coordinates = $event;
        this.setTooltipPosition($event);
    };
    /**
     * @param {?} userIsPressing
     * @return {?}
     */
    SelectionToolComponent.prototype.showTooltipPopUp = /**
     * @param {?} userIsPressing
     * @return {?}
     */
    function (userIsPressing) {
        this.showTooltip = !userIsPressing;
    };
    /**
     * @private
     * @param {?} coord
     * @return {?}
     */
    SelectionToolComponent.prototype.setTooltipPosition = /**
     * @private
     * @param {?} coord
     * @return {?}
     */
    function (coord) {
        this.isTooltipOverflow = false;
        /** @type {?} */
        var bottomSpace = coord.containerHeight - (coord.offsetTop + coord.height);
        if (bottomSpace < this.tooltipHeight) {
            this.tooltipY = -this.tooltipHeight - this.tooltipPadding;
            this.isTooltipOverflow = true;
            if (coord.offsetTop < this.tooltipHeight) {
                this.tooltipY = this.tooltipPadding / 2;
            }
        }
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolComponent.prototype.calculateInitialValues = /**
     * @private
     * @return {?}
     */
    function () {
        if (!this.selection) {
            return;
        }
        /** @type {?} */
        var x = this.selection.coordinates.offsetLeft;
        /** @type {?} */
        var y = this.selection.coordinates.offsetTop;
        y = (!y || y < OFFSET_LIMIT) ? OFFSET_LIMIT : y;
        x = (!x || x < OFFSET_LIMIT) ? OFFSET_LIMIT : x;
        /** @type {?} */
        var newX = x - (DEFAULT_SIZE / 2);
        /** @type {?} */
        var newY = y - (DEFAULT_SIZE / 2);
        /** @type {?} */
        var containerHeight = this.selection.coordinates.containerHeight;
        /** @type {?} */
        var containerWidth = this.selection.coordinates.containerWidth;
        /** @type {?} */
        var maxY = containerHeight - DEFAULT_SIZE - OFFSET_LIMIT;
        /** @type {?} */
        var maxX = containerWidth - DEFAULT_SIZE - OFFSET_LIMIT;
        newY = (newY >= maxY) ? maxY : (newY < OFFSET_LIMIT) ? OFFSET_LIMIT : newY;
        newX = (newX >= maxX) ? maxX : (newX < OFFSET_LIMIT) ? OFFSET_LIMIT : newX;
        this.initialValues.height = DEFAULT_SIZE + 'px';
        this.initialValues.width = DEFAULT_SIZE + 'px';
        this.initialValues.left = newX + 'px';
        this.initialValues.top = newY + 'px';
    };
    SelectionToolComponent.decorators = [
        { type: Component, args: [{
                    selector: 'sc-selection-tool',
                    template: "<div class=\"selection-box\"\n      [ngClass]=\"{\n        'selection-box--color1': selection.color === 1,\n        'selection-box--color2': selection.color === 2,\n        'selection-box--color3': selection.color === 3,\n        'no-interaction': !selection.isSelecting\n      }\"\n     *ngIf=\"show\"\n     scSelectionTranslate\n     [container]=\"containerRef\"\n     (userIsPressing)=\"showTooltipPopUp($event)\"\n     (positionUpdate)=\"positionUpdate($event)\"\n     [ngStyle]=\"initialValues\">\n  <div *ngFor=\"let side of selectionSides\"\n        class=\"{{'selection-box__square selection-box__square--' + side}}\"\n        [class.no-display]=\"!selection.isSelecting\"\n        scSelectionResize\n        [container]=\"containerRef\"\n        [side]=\"side\"\n        (positionUpdate)=\"positionUpdate($event)\"\n        (userIsPressing)=\"showTooltipPopUp($event)\">\n  </div>\n  <div class=\"tooltip-pop-up\" *ngIf=\"selection.isSelecting && showTooltip\"\n    [ngClass]=\"{ 'tooltip-pop-up--overflow': isTooltipOverflow }\"\n    [ngStyle]=\"{\n      'top': isTooltipOverflow ? tooltipY+'px' : 'calc(100% + 1rem)'\n    }\"\n  >\n    <ng-content></ng-content>\n  </div>\n</div>\n",
                    styles: [".selection-box{position:absolute;height:100px;width:100px;border:2px solid #fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);cursor:move}.selection-box--color1{border:2px solid #5f67ec}.selection-box--color2{border:2px solid #fbac57}.selection-box--color3{border:2px solid #82d4b7}.selection-box__square{border-radius:0;height:7px;width:7px;background:#fff;position:absolute;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.selection-box__square--top{left:50%;-webkit-transform:translate(-50%,-70%);transform:translate(-50%,-70%);cursor:ns-resize}.selection-box__square--right{right:0;top:50%;-webkit-transform:translate(70%,-50%);transform:translate(70%,-50%);cursor:ew-resize}.selection-box__square--bottom{bottom:0;left:50%;-webkit-transform:translate(-50%,70%);transform:translate(-50%,70%);cursor:ns-resize}.selection-box__square--left{bottom:50%;-webkit-transform:translate(-70%,50%);transform:translate(-70%,50%);cursor:ew-resize}.tooltip-pop-up{position:absolute;top:calc(100% + 1rem);left:50%;-webkit-transform:translate(-50%,0);transform:translate(-50%,0);border-radius:4px;box-shadow:0 4px 13px 0 rgba(0,0,0,.5);z-index:3}.no-interaction{pointer-events:none}.no-display{display:none}"]
                }] }
    ];
    /** @nocollapse */
    SelectionToolComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    SelectionToolComponent.propDecorators = {
        containerRef: [{ type: Input }],
        selection: [{ type: Input }]
    };
    return SelectionToolComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SelectionToolComponent.prototype.tooltipHeight;
    /**
     * @type {?}
     * @private
     */
    SelectionToolComponent.prototype.tooltipPadding;
    /** @type {?} */
    SelectionToolComponent.prototype.containerRef;
    /** @type {?} */
    SelectionToolComponent.prototype.selection;
    /** @type {?} */
    SelectionToolComponent.prototype.show;
    /** @type {?} */
    SelectionToolComponent.prototype.showTooltip;
    /** @type {?} */
    SelectionToolComponent.prototype.isTooltipOverflow;
    /** @type {?} */
    SelectionToolComponent.prototype.tooltipY;
    /** @type {?} */
    SelectionToolComponent.prototype.selectionSides;
    /** @type {?} */
    SelectionToolComponent.prototype.initialValues;
    /**
     * @type {?}
     * @private
     */
    SelectionToolComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/components/selection-tool/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/components/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/models/element-dimensions.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ElementDimensions = /** @class */ (function () {
    function ElementDimensions() {
    }
    return ElementDimensions;
}());
if (false) {
    /** @type {?} */
    ElementDimensions.prototype.height;
    /** @type {?} */
    ElementDimensions.prototype.width;
    /** @type {?} */
    ElementDimensions.prototype.offsetTop;
    /** @type {?} */
    ElementDimensions.prototype.offsetLeft;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/models/selection-coordinates.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectionCoordinates = /** @class */ (function () {
    function SelectionCoordinates() {
    }
    return SelectionCoordinates;
}());
if (false) {
    /** @type {?} */
    SelectionCoordinates.prototype.containerHeight;
    /** @type {?} */
    SelectionCoordinates.prototype.containerWidth;
    /** @type {?} */
    SelectionCoordinates.prototype.offsetTop;
    /** @type {?} */
    SelectionCoordinates.prototype.offsetLeft;
    /** @type {?} */
    SelectionCoordinates.prototype.height;
    /** @type {?} */
    SelectionCoordinates.prototype.width;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/models/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/directives/selection-tool-resize.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@dynamic
 */
var SelectionToolResizeDirective = /** @class */ (function () {
    function SelectionToolResizeDirective(document, element) {
        var _this = this;
        this.document = document;
        this.element = element;
        this.positionUpdate = new EventEmitter();
        this.userIsPressing = new EventEmitter();
        this.mouseMoveSub = new Subscription();
        this.box = null;
        this.containerDimensions = new ElementDimensions();
        this.boxDimensions = new ElementDimensions();
        this.isResizing = false;
        this.side = null;
        this.container = null;
        this.onMouseMove = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (!_this.isResizing) {
                return false;
            }
            switch (_this.side) {
                case 'top': {
                    _this.topHandler(event);
                    break;
                }
                case 'right': {
                    _this.rightHandler(event);
                    break;
                }
                case 'bottom': {
                    _this.bottomHandler(event);
                    break;
                }
                case 'left': {
                    _this.leftHandler(event);
                    break;
                }
            }
            _this.updateDimensions();
            event.preventDefault();
        });
    }
    /**
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initializeElement();
        this.positionUpdate.emit(this.getSelectionCoordinates());
        this.mouseMove$ = fromEvent(this.document, 'mousemove');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.onMouseDown = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (!this.side || event.target !== event.currentTarget) {
            return false;
        }
        if (event.button === LEFT_CLICK_CODE) {
            this.updateDimensions();
            this.prevX = event.clientX;
            this.prevY = event.clientY;
            this.isResizing = true;
            this.userIsPressing.emit(true);
            this.setSelectionMove(true);
        }
    };
    /**
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.onMouseUp = /**
     * @return {?}
     */
    function () {
        if (this.isResizing) {
            this.updateDimensions();
            this.positionUpdate.emit(this.getSelectionCoordinates());
            this.userIsPressing.emit(false);
            this.isResizing = false;
            this.setSelectionMove(false);
        }
    };
    /**
     * @private
     * @param {?} enable
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.setSelectionMove = /**
     * @private
     * @param {?} enable
     * @return {?}
     */
    function (enable) {
        this.mouseMoveSub.unsubscribe();
        if (!enable) {
            return;
        }
        this.mouseMoveSub = new Subscription().add(this.mouseMove$.subscribe(this.onMouseMove));
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.bottomHandler = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var newY = event.clientY;
        /** @type {?} */
        var prevHeight = this.boxDimensions.height;
        /** @type {?} */
        var newHeight = prevHeight - (this.prevY - newY);
        if (this.isTooSmall(newHeight) || this.isResizingForbbiden(newHeight, 'bottom')) {
            return;
        }
        this.box.style.height = newHeight + "px";
        this.prevY = newY;
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.rightHandler = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var newX = event.clientX;
        /** @type {?} */
        var prevWidth = this.boxDimensions.width;
        /** @type {?} */
        var newWidth = prevWidth - (this.prevX - newX);
        if (this.isTooSmall(newWidth) || this.isResizingForbbiden(newWidth, 'right')) {
            return;
        }
        this.box.style.width = newWidth + "px";
        this.prevX = newX;
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.leftHandler = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var newX = event.clientX;
        /** @type {?} */
        var newLeft = this.boxDimensions.offsetLeft - (this.prevX - newX);
        /** @type {?} */
        var newWidth = this.boxDimensions.width + (this.prevX - newX);
        if (this.isTooSmall(newWidth) || this.isResizingForbbiden(newLeft, 'left')) {
            return;
        }
        this.box.style.left = newLeft + "px";
        this.box.style.width = newWidth + "px";
        this.prevX = newX;
    };
    /**
     * @private
     * @param {?} event
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.topHandler = /**
     * @private
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var newY = event.clientY;
        /** @type {?} */
        var newTop = this.boxDimensions.offsetTop - (this.prevY - newY);
        /** @type {?} */
        var newHeight = this.boxDimensions.height + (this.prevY - newY);
        if (this.isTooSmall(newHeight) || this.isResizingForbbiden(newTop, 'top')) {
            return;
        }
        this.box.style.top = newTop + "px";
        this.box.style.height = newHeight + "px";
        this.prevY = newY;
    };
    /**
     * @private
     * @param {?} value
     * @param {?} side
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.isResizingForbbiden = /**
     * @private
     * @param {?} value
     * @param {?} side
     * @return {?}
     */
    function (value, side) {
        if (side === 'top' || side === 'left') {
            return value < OFFSET_LIMIT;
        }
        /** @type {?} */
        var containerKey = '';
        /** @type {?} */
        var boxKey = '';
        if (side === 'right') {
            containerKey = 'width';
            boxKey = 'offsetLeft';
        }
        else {
            containerKey = 'height';
            boxKey = 'offsetTop';
        }
        return (this.containerDimensions[containerKey] - (value + this.boxDimensions[boxKey] + OFFSET_LIMIT * 2)) < 0;
    };
    /**
     * @private
     * @param {?} value
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.isTooSmall = /**
     * @private
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value < MIN_SIZE;
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.updateDimensions = /**
     * @private
     * @return {?}
     */
    function () {
        this.containerDimensions.height = this.container.offsetHeight;
        this.containerDimensions.width = this.container.offsetWidth;
        this.boxDimensions.height = this.box.offsetHeight;
        this.boxDimensions.width = this.box.offsetWidth;
        this.boxDimensions.offsetTop = this.box.offsetTop;
        this.boxDimensions.offsetLeft = this.box.offsetLeft;
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.initializeElement = /**
     * @private
     * @return {?}
     */
    function () {
        this.box = this.element.nativeElement.parentNode;
        this.updateDimensions();
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolResizeDirective.prototype.getSelectionCoordinates = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var coordinates = {
            containerHeight: this.containerDimensions.height,
            containerWidth: this.containerDimensions.width,
            offsetLeft: this.boxDimensions.offsetLeft,
            offsetTop: this.boxDimensions.offsetTop,
            height: this.boxDimensions.height,
            width: this.boxDimensions.width
        };
        return coordinates;
    };
    SelectionToolResizeDirective.decorators = [
        { type: Directive, args: [{ selector: '[scSelectionResize]' },] }
    ];
    /** @nocollapse */
    SelectionToolResizeDirective.ctorParameters = function () { return [
        { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: ElementRef }
    ]; };
    SelectionToolResizeDirective.propDecorators = {
        positionUpdate: [{ type: Output }],
        userIsPressing: [{ type: Output }],
        side: [{ type: Input }],
        container: [{ type: Input }],
        onMouseDown: [{ type: HostListener, args: ['mousedown', ['$event'],] }],
        onMouseUp: [{ type: HostListener, args: ['window:mouseup',] }]
    };
    return SelectionToolResizeDirective;
}());
if (false) {
    /** @type {?} */
    SelectionToolResizeDirective.prototype.positionUpdate;
    /** @type {?} */
    SelectionToolResizeDirective.prototype.userIsPressing;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.mouseMoveSub;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.mouseMove$;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.box;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.containerDimensions;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.boxDimensions;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.isResizing;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.prevX;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.prevY;
    /** @type {?} */
    SelectionToolResizeDirective.prototype.side;
    /** @type {?} */
    SelectionToolResizeDirective.prototype.container;
    /** @type {?} */
    SelectionToolResizeDirective.prototype.onMouseMove;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    SelectionToolResizeDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/directives/selection-tool-translate.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * \@dynamic
 */
var SelectionToolTranslateDirective = /** @class */ (function () {
    function SelectionToolTranslateDirective(document, window, element) {
        var _this = this;
        this.document = document;
        this.window = window;
        this.element = element;
        this.positionUpdate = new EventEmitter();
        this.userIsPressing = new EventEmitter();
        this.subscription = new Subscription();
        this.mouseMoveSub = new Subscription();
        this.rightSideOffset = null;
        this.bottomSideOffset = null;
        this.isShifting = false;
        this.box = null;
        this.containerDimensions = new ElementDimensions();
        this.boxDimensions = new ElementDimensions();
        this.container = null;
        this.onMouseDown = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.target !== _this.box) {
                return false;
            }
            if (event.button === LEFT_CLICK_CODE) {
                _this.prevX = event.offsetX;
                _this.prevY = event.offsetY;
                _this.userIsPressing.emit(true);
                _this.isShifting = true;
                _this.setSelectionMove(true);
            }
        });
        this.onMouseUp = (/**
         * @return {?}
         */
        function () {
            _this.calculateParentLimits();
            if (_this.isShifting) {
                _this.positionUpdate.emit(_this.getSelectionCoordinates());
                _this.userIsPressing.emit(false);
                _this.isShifting = false;
            }
            _this.setSelectionMove(false);
        });
        this.onMouseMove = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            if (event.target !== _this.box) {
                return false;
            }
            if (!_this.isShifting) {
                return false;
            }
            /** @type {?} */
            var newX = event.offsetX;
            /** @type {?} */
            var newY = event.offsetY;
            _this.refreshPosition(_this.yCalculatePosition(newY), _this.xCalculatePosition(newX));
            _this.calculateParentLimits();
            event.preventDefault();
        });
    }
    /**
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.initializeElement();
        this.positionUpdate.emit(this.getSelectionCoordinates());
        this.subscription.add(fromEvent(this.document, 'mousedown').subscribe(this.onMouseDown)).add(fromEvent(this.window, 'mouseup').subscribe(this.onMouseUp));
        this.mouseMove$ = fromEvent(this.document, 'mousemove');
    };
    /**
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
        this.mouseMoveSub.unsubscribe();
    };
    /**
     * @private
     * @param {?} enable
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.setSelectionMove = /**
     * @private
     * @param {?} enable
     * @return {?}
     */
    function (enable) {
        this.mouseMoveSub.unsubscribe();
        if (!enable) {
            return;
        }
        this.mouseMoveSub = new Subscription().add(this.mouseMove$.subscribe(this.onMouseMove));
    };
    /**
     * @private
     * @param {?} newX
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.xCalculatePosition = /**
     * @private
     * @param {?} newX
     * @return {?}
     */
    function (newX) {
        /** @type {?} */
        var calc = this.box.offsetLeft - (this.prevX - newX);
        if (calc >= this.rightSideOffset) {
            calc = this.rightSideOffset;
        }
        if (calc < OFFSET_LIMIT) {
            calc = OFFSET_LIMIT;
        }
        return calc;
    };
    /**
     * @private
     * @param {?} newY
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.yCalculatePosition = /**
     * @private
     * @param {?} newY
     * @return {?}
     */
    function (newY) {
        /** @type {?} */
        var calc = this.box.offsetTop - (this.prevY - newY);
        if (calc >= this.bottomSideOffset) {
            calc = this.bottomSideOffset;
        }
        if (calc <= OFFSET_LIMIT) {
            calc = OFFSET_LIMIT;
        }
        return calc;
    };
    /**
     * @private
     * @param {?} top
     * @param {?} left
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.refreshPosition = /**
     * @private
     * @param {?} top
     * @param {?} left
     * @return {?}
     */
    function (top, left) {
        this.box.style.top = top + "px";
        this.box.style.left = left + "px";
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.initializeElement = /**
     * @private
     * @return {?}
     */
    function () {
        this.box = this.element.nativeElement;
        this.calculateParentLimits();
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.calculateParentLimits = /**
     * @private
     * @return {?}
     */
    function () {
        this.containerDimensions.height = this.container.offsetHeight;
        this.containerDimensions.width = this.container.offsetWidth;
        this.boxDimensions.height = this.box.offsetHeight;
        this.boxDimensions.width = this.box.offsetWidth;
        this.boxDimensions.offsetTop = this.box.offsetTop;
        this.boxDimensions.offsetLeft = this.box.offsetLeft;
        this.rightSideOffset = this.containerDimensions.width - this.boxDimensions.width - OFFSET_LIMIT * 2;
        this.bottomSideOffset = this.containerDimensions.height - this.boxDimensions.height - OFFSET_LIMIT * 2;
    };
    /**
     * @private
     * @return {?}
     */
    SelectionToolTranslateDirective.prototype.getSelectionCoordinates = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var coordinates = {
            containerHeight: this.containerDimensions.height,
            containerWidth: this.containerDimensions.width,
            offsetLeft: this.boxDimensions.offsetLeft,
            offsetTop: this.boxDimensions.offsetTop,
            height: this.boxDimensions.height,
            width: this.boxDimensions.width
        };
        return coordinates;
    };
    SelectionToolTranslateDirective.decorators = [
        { type: Directive, args: [{ selector: '[scSelectionTranslate]' },] }
    ];
    /** @nocollapse */
    SelectionToolTranslateDirective.ctorParameters = function () { return [
        { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
        { type: ElementRef }
    ]; };
    SelectionToolTranslateDirective.propDecorators = {
        positionUpdate: [{ type: Output }],
        userIsPressing: [{ type: Output }],
        container: [{ type: Input }]
    };
    return SelectionToolTranslateDirective;
}());
if (false) {
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.positionUpdate;
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.userIsPressing;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.mouseMoveSub;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.mouseMove$;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.rightSideOffset;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.bottomSideOffset;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.isShifting;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.box;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.containerDimensions;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.boxDimensions;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.prevX;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.prevY;
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.container;
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.onMouseDown;
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.onMouseUp;
    /** @type {?} */
    SelectionToolTranslateDirective.prototype.onMouseMove;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.document;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.window;
    /**
     * @type {?}
     * @private
     */
    SelectionToolTranslateDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/directives/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/selection-tool.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectionToolModule = /** @class */ (function () {
    function SelectionToolModule() {
    }
    SelectionToolModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [
                        SelectionToolComponent,
                        SelectionToolTranslateDirective,
                        SelectionToolResizeDirective
                    ],
                    exports: [
                        SelectionToolComponent,
                        SelectionToolTranslateDirective,
                        SelectionToolResizeDirective
                    ],
                    providers: []
                },] }
    ];
    return SelectionToolModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/selection-tool/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/components/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/pipes/file-size.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScFileSizePipe = /** @class */ (function () {
    function ScFileSizePipe() {
        this.units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    }
    /**
     * @param {?=} bytes
     * @param {?=} precision
     * @return {?}
     */
    ScFileSizePipe.prototype.transform = /**
     * @param {?=} bytes
     * @param {?=} precision
     * @return {?}
     */
    function (bytes, precision) {
        if (bytes === void 0) { bytes = 0; }
        if (precision === void 0) { precision = 2; }
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
            return '?';
        }
        /** @type {?} */
        var unit = 0;
        while (bytes >= 1024) {
            bytes /= 1024;
            unit++;
        }
        return bytes.toFixed(+precision) + ' ' + this.units[unit];
    };
    ScFileSizePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'fileSize',
                    pure: false
                },] }
    ];
    return ScFileSizePipe;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ScFileSizePipe.prototype.units;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/pipes/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/damage-tag.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DamageTagModule = /** @class */ (function () {
    function DamageTagModule() {
    }
    /**
     * @param {?} service
     * @return {?}
     */
    DamageTagModule.setDamageTagUploader = /**
     * @param {?} service
     * @return {?}
     */
    function (service) {
        return {
            ngModule: DamageTagModule,
            providers: [
                {
                    provide: DamageTagBaseUploaderService,
                    useClass: service
                }
            ]
        };
    };
    DamageTagModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        ButtonModule,
                        DamageTagUploaderModule,
                        IconModule,
                        ModalModule,
                        TitleModule,
                        CheckboxModule,
                        ReactiveFormsModule,
                        SelectionToolModule,
                        InfoBoxModule,
                        ChipModule
                    ],
                    declarations: [
                        DamagePhotoModalComponent,
                        DamagePreviewComponent,
                        DamagePreviewListComponent,
                        DamageTypeMenuComponent,
                        DamageTagComponent,
                        DamageTagPartsSelectionFormComponent,
                        DamageTagSelectionToolComponent,
                        DamageTagSelectionInfoComponent,
                        ScFileSizePipe
                    ],
                    exports: [
                        DamageTagComponent
                    ],
                    providers: [
                        ScFileSizePipe,
                        windowProvider,
                        DamageTagBaseUploaderService
                    ]
                },] }
    ];
    return DamageTagModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/damage-tag/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: sc-portal.fe.lib.app-components.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AccessoriesListModule, ActivateAccountActiveAccountComponent, ActivateAccountActiveAccountResponse, ActivateAccountBaseResponse, ActivateAccountComponent, ActivateAccountError, ActivateAccountErrorClasses, ActivateAccountErrorContainerComponent, ActivateAccountInvalidTokenComponent, ActivateAccountInvalidTokenResponse, ActivateAccountModule, ActivateAccountRequest, ActivateAccountService, ActivateAccountSuccessResponse, ActivateAccountUnknownErrorComponent, ActivateAccountUnknownErrorResponse, AddressEdition, AddressEditionComponent, AddressEditionModule, AddressLoadModule, ApprovalRequestComponent, ApprovalRequestModule, AuthActionsModule, AuthActionsType, AuthConfigService, AuthErrorMessagesModule, AuthLegalFooterModule, AuthPageHeaderModule, AuthPageWrapperModule, AuthSuccess, BaseDocument, ChangeResetPasswordRequest, City, CityProxy, CreditCardAsyncValidator, CustomHttpParamEncoder, DamagePhotoModalComponent, DamagePreviewComponent, DamagePreviewListComponent, DamagePreviewModel, DamageTagBaseUploaderService, DamageTagChip, DamageTagComponent, DamageTagFileModel, DamageTagFormModel, DamageTagFormService, DamageTagImageModel, DamageTagModel, DamageTagModule, DamageTagPartsSelectionFormComponent, DamageTagSelectionCoordinateModel, DamageTagSelectionInfoComponent, DamageTagSelectionModel, DamageTagSelectionToolComponent, DamageTagService, DamageTagSteps, DamageTagType, DamageTagTypeText, DamageTagUploaderComponent, DamageTagUploaderItem, DamageTagUploaderModule, DamageTypeMenuComponent, DirectDebitAsyncValidator, DocumentContainerData, DocumentDownloadEvent, DocumentDownloadStatus, DocumentsService, DocumentsServiceStub, DownloadActionItem, DownloadContainerComponent, DownloadDocumentsConfigService, DownloadDocumentsModule, DownloadItemComponent, FormValidatorService, Gender, IdentityModule, IdentityRole, InsurancePipesModule, InsuredInfoEmisionModule, InsuredInfoModule, InsuredInfoService, LateralMenuWrapperModule, ListSetModule, LoginAdIdentityService, LoginComponent, LoginErrorStatuses, LoginMicrosoftService, LoginMissingEmail, LoginModule, LoginRequest, LoginResetPassword, LoginService, PartsType, PasSelectorModule, PaymentInfoModule, PaymentInstrument, PaymentMethodAsyncValidatorModule, PaymentMethodConfirmModule, PaymentMethodFloatingModule, PaymentMethodSelectorComponent, PaymentMethodSelectorModule, PaymentMethodsModalModule, PaymentMethodsSummaryModule, PaymentOption, PaymentOptionComponent, PaymentOptionModule, PaymentService, PersonSearchModule, Perspective, PolicyInfoComponent, PolicyInfoModule, PostalCodeOption, PrintableDocument, RecoverPasswordComponent, RecoverPasswordModule, RefreshTokenService, RememberMe, RememberMeService, ResetPasswordComponent, ResetPasswordModule, ResetPasswordRequest, ResetPasswordResponse, ScAccidentNumberPipe, ScFileSizePipe, SelectionToolComponent, SelectionToolModule, SelectionToolResizeDirective, SelectionToolTranslateDirective, SendMailComponent, SendMailModule, SharedServicesModule, State, SuccessComponent, SuccessModule, TagModel, TokenService, UploadDetails, UploaderService, User, UserIdType, ValidatePassword, WINDOW, getWindow$1 as getWindow, imageUploadAllowedExtension, loginErrorClasses, mockPrintableDocuments, mockPrintableDocumentsAnonymous, parts, passwordRules, paymentMethodSelectorValidator, perspectiveCols, perspectivePoints, perspectiveSelection, perspectiveText, recomendations, userIdTypeLength, windowProvider, PersonSearchComponent as ɵa, InsuredInfoComponent as ɵb, WindowRef as ɵba, AuthPageWrapperComponent as ɵbb, AuthPageHeaderComponent as ɵbc, AuthActionsComponent as ɵbd, AuthErrorMessagesComponent as ɵbe, fadeInOut as ɵbf, AuthLegalFooterComponent as ɵbg, LoginService as ɵbh, TokenService as ɵbi, getJwtService as ɵbk, RememberMeService as ɵbl, FormValidatorService as ɵbm, LoginAdIdentityService as ɵbn, LoginMicrosoftService as ɵbo, getLocation as ɵbp, LocationRef as ɵbq, PasswordService as ɵbr, getLocalStorage as ɵbs, LocalStorageRef as ɵbt, RefreshTokenService as ɵbu, ScAccidentNumberPipe as ɵbv, AddressEditionService as ɵbw, LateralMenuWrapperComponent as ɵc, ListSetComponent as ɵd, slideHorizontal as ɵe, PasSelectorComponent as ɵf, AccesoriesListComponent as ɵg, AccessoriesListService as ɵh, AccessoryItemComponent as ɵi, PolicyService as ɵj, AddressLoadComponent as ɵk, InsuredInfoEmisionComponent as ɵl, ElectronicDocumentsAdhesionComponent as ɵm, PaymentMethodConfirmComponent as ɵn, PaymentMethodsModalComponent as ɵo, TypeListService as ɵp, CreditCardAsyncValidator as ɵq, DirectDebitAsyncValidator as ɵr, slideFade as ɵs, PAYMENT_CONTROL_VALUE_ACCESSOR as ɵt, PaymentInfoComponent as ɵu, PaymentMethodFloatingComponent as ɵv, PaymentMethodsSummaryComponent as ɵw, AuthConfigService as ɵx, ActivateAccountService as ɵy, getWindow as ɵz };
//# sourceMappingURL=sc-portal.fe.lib.app-components.js.map
